export const shoeSizeChart = [
  "34 (EU), 2 (UK), 3 (US)",
  "34.5 (EU), 2.5 (UK), 3.5 (US)",
  "35 (EU), 3 (UK), 4 (US)",
  "35.5 (EU), 3.5 (UK), 4.5 (US)",
  "36 (EU), 4 (UK), 5 (US)",
  "36.5 (EU), 4.5 (UK), 5.5 (US)",
  "37 (EU), 5 (UK), 6 (US)",
  "37.5 (EU), 5.5 (UK), 6.5 (US)",
  "38 (EU), 6 (UK), 7 (US)",
  "38.5 (EU), 6.5 (UK), 7.5 (US)",
  "39 (EU), 7 (UK), 8 (US)",
  "39.5 (EU), 7.5 (UK), 8.5 (US)",
  "40 (EU), 8 (UK), 9 (US)",
  "40.5 (EU), 8.5 (UK), 9.5 (US)",
  "41 (EU), 9 (UK), 10 (US)",
  "41.5 (EU), 9.5 (UK), 10.5 (US)",
  "42 (EU), 10 (UK), 11 (US)",
  "42.5 (EU), 10.5 (UK), 11.5 (US)",
  "43 (EU), 11 (UK), 12 (US)",
  "43.5 (EU), 11.5 (UK), 12.5 (US)",
  "44 (EU), 12 (UK), 13 (US)",
  "44.5 (EU), 12.5 (UK), 13.5 (US)",
  "45 (EU), 13 (UK), 14 (US)",
  "45.5 (EU), 13.5 (UK), 14.5 (US)",
  "46 (EU), 14 (UK), 15 (US)",
  "46.5 (EU), 14.5 (UK), 15.5 (US)",
  "47 (EU), 15 (UK), 16 (US)",
  "47.5 (EU), 15.5 (UK), 16.5 (US)",
  "48 (EU), 16 (UK), 17 (US)",
  "48.5 (EU), 16.5 (UK), 17.5 (US)",
  "49 (EU), 17 (UK), 18 (US)",
  "49.5 (EU), 17.5 (UK), 18.5 (US)",
  "50 (EU), 18 (UK), 19 (US)",
  "50.5 (EU), 18.5 (UK), 19.5 (US)",
  "51 (EU), 19 (UK), 20 (US)",
  "51.5 (EU), 19.5 (UK), 20.5 (US)",
  "52 (EU), 20 (UK), 21 (US)",
];

export const clothSizeChart = [
  "34 (EU), 6 (UK), 2 (US)",
  "36 (EU), 8 (UK), 4 (US)",
  "38 (EU), 10 (UK), 6 (US)",
  "40 (EU), 12 (UK), 8 (US)",
  "42 (EU), 14 (UK), 10 (US)",
  "44 (EU), 16 (UK), 12 (US)",
  "46 (EU), 18 (UK), 14 (US)",
  "48 (EU), 20 (UK), 16 (US)",
  "50 (EU), 22 (UK), 18 (US)",
  "52 (EU), 24 (UK), 20 (US)",
  "54 (EU), 26 (UK), 22 (US)",
  "56 (EU), 28 (UK), 24 (US)",
  "58 (EU), 30 (UK), 26 (US)",
  "60 (EU), 32 (UK), 28 (US)",
  "62 (EU), 34 (UK), 30 (US)",
  "64 (EU), 36 (UK), 32 (US)",
  "66 (EU), 38 (UK), 34 (US)",
  "68 (EU), 40 (UK), 36 (US)",
  "70 (EU), 42 (UK), 38 (US)",
];

export const clothesSizesDropdown = [
  { id: "34 (EU)", title: "34 (EU)" },
  { id: "36 (EU)", title: "36 (EU)" },
  { id: "38 (EU)", title: "38 (EU)" },
  { id: "40 (EU)", title: "40 (EU)" },
  { id: "42 (EU)", title: "42 (EU)" },
  { id: "44 (EU)", title: "44 (EU)" },
  { id: "46 (EU)", title: "46 (EU)" },
  { id: "48 (EU)", title: "48 (EU)" },
  { id: "50 (EU)", title: "50 (EU)" },
  { id: "52 (EU)", title: "52 (EU)" },
  { id: "54 (EU)", title: "54 (EU)" },
  { id: "56 (EU)", title: "56 (EU)" },
  { id: "58 (EU)", title: "58 (EU)" },
  { id: "60 (EU)", title: "60 (EU)" },
  { id: "62 (EU)", title: "62 (EU)" },
  { id: "64 (EU)", title: "64 (EU)" },
  { id: "66 (EU)", title: "66 (EU)" },
  { id: "68 (EU)", title: "68 (EU)" },
  { id: "70 (EU)", title: "70 (EU)" },
];

export const shoeSizesDropdown = [
  { id: "34 (EU)", title: "34 (EU)" },
  { id: "34.5 (EU)", title: "34.5 (EU)" },
  { id: "35 (EU)", title: "35 (EU)" },
  { id: "35.5 (EU)", title: "35.5 (EU)" },
  { id: "36 (EU)", title: "36 (EU)" },
  { id: "36.5 (EU)", title: "36.5 (EU)" },
  { id: "37 (EU)", title: "37 (EU)" },
  { id: "37.5 (EU)", title: "37.5 (EU)" },
  { id: "38 (EU)", title: "38 (EU)" },
  { id: "38.5 (EU)", title: "38.5 (EU)" },
  { id: "39 (EU)", title: "39 (EU)" },
  { id: "39.5 (EU)", title: "39.5 (EU)" },
  { id: "40 (EU)", title: "40 (EU)" },
  { id: "40.5 (EU)", title: "40.5 (EU)" },
  { id: "41 (EU)", title: "41 (EU)" },
  { id: "41.5 (EU)", title: "41.5 (EU)" },
  { id: "42 (EU)", title: "42 (EU)" },
  { id: "42.5 (EU)", title: "42.5 (EU)" },
  { id: "43 (EU)", title: "43 (EU)" },
  { id: "43.5 (EU)", title: "43.5 (EU)" },
  { id: "44 (EU)", title: "44 (EU)" },
  { id: "44.5 (EU)", title: "44.5 (EU)" },
  { id: "45 (EU)", title: "45 (EU)" },
  { id: "45.5 (EU)", title: "45.5 (EU)" },
  { id: "46 (EU)", title: "46 (EU)" },
  { id: "46.5 (EU)", title: "46.5 (EU)" },
  { id: "47 (EU)", title: "47 (EU)" },
  { id: "47.5 (EU)", title: "47.5 (EU)" },
  { id: "48 (EU)", title: "48 (EU)" },
  { id: "48.5 (EU)", title: "48.5 (EU)" },
  { id: "49 (EU)", title: "49 (EU)" },
  { id: "49.5 (EU)", title: "49.5 (EU)" },
  { id: "50 (EU)", title: "50 (EU)" },
  { id: "50.5 (EU)", title: "50.5 (EU)" },
  { id: "51 (EU)", title: "51 (EU)" },
  { id: "51.5 (EU)", title: "51.5 (EU)" },
  { id: "52 (EU)", title: "52 (EU)" },
];

export const airportDropdown = [
  {
    iata: "",
    title: "Other Airport",
  },
  {
    iata: "UTK",
    title: "Utirik Airport",
  },
  {
    iata: "KRK",
    title: "Krakow",
  },
  {
    iata: "FIV",
    title: "Five Finger CG Heliport",
  },
  {
    iata: "FAK",
    title: "False Island Seaplane Base",
  },
  {
    iata: "BWS",
    title: "Blaine Municipal Airport",
  },
  {
    iata: "WKK",
    title: "Aleknagik / New Airport",
  },
  {
    iata: "TSS",
    title: "East 34th Street Heliport",
  },
  {
    iata: "FOB",
    title: "Fort Bragg Airport",
  },
  {
    iata: "ABP",
    title: "Atkamba Airport",
  },
  {
    iata: "ALV",
    title: "Andorra la Vella Heliport",
  },
  {
    iata: "ADC",
    title: "Andakombe Airport",
  },
  {
    iata: "TJP",
    title: "Areopuerto Internacional Michael Gonzalez",
  },
  {
    iata: "AEE",
    title: "Adareil Airport",
  },
  {
    iata: "AEI",
    title: "Algeciras Heliport",
  },
  {
    iata: "AEK",
    title: "Aseki Airport",
  },
  {
    iata: "OLR",
    title: "Salerno Landing Zone Airport",
  },
  {
    iata: "AFR",
    title: "Afore Airstrip",
  },
  {
    iata: "AFT",
    title: "Afutara Aerodrome",
  },
  {
    iata: "ATD",
    title: "Uru Harbour Airport",
  },
  {
    iata: "VEV",
    title: "Barakoma Airport",
  },
  {
    iata: "GEF",
    title: "Geva Airport",
  },
  {
    iata: "AGG",
    title: "Angoram Airport",
  },
  {
    iata: "AKS",
    title: "Auki Airport",
  },
  {
    iata: "BAS",
    title: "Ballalae Airport",
  },
  {
    iata: "FRE",
    title: "Fera/Maringe Airport",
  },
  {
    iata: "HIR",
    title: "Honiara International Airport",
  },
  {
    iata: "MBU",
    title: "Babanakira Airport",
  },
  {
    iata: "IRA",
    title: "Ngorangora Airport",
  },
  {
    iata: "SCZ",
    title: "Santa Cruz/Graciosa Bay/Luova Airport",
  },
  {
    iata: "MUA",
    title: "Munda Airport",
  },
  {
    iata: "GZO",
    title: "Nusatupe Airport",
  },
  {
    iata: "MNY",
    title: "Mono Airport",
  },
  {
    iata: "PRS",
    title: "Parasi Airport",
  },
  {
    iata: "OTV",
    title: "Ontong Java Atoll Airstrip",
  },
  {
    iata: "RNL",
    title: "Rennell/Tingoa Airport",
  },
  {
    iata: "EGM",
    title: "Sege Airport",
  },
  {
    iata: "RUS",
    title: "Marau Airport",
  },
  {
    iata: "VAO",
    title: "Suavanao Airport",
  },
  {
    iata: "AGK",
    title: "Kagua Airport",
  },
  {
    iata: "KGE",
    title: "Kagau Island Airport",
  },
  {
    iata: "AGL",
    title: "Wanigela Airport",
  },
  {
    iata: "RIN",
    title: "Ringi Cove Airport",
  },
  {
    iata: "RBV",
    title: "Ramata Airport",
  },
  {
    iata: "AHT",
    title: "Amchitka Army Airfield",
  },
  {
    iata: "AHY",
    title: "Ambatolhy Airport",
  },
  {
    iata: "AIE",
    title: "Aiome Airport",
  },
  {
    iata: "AIH",
    title: "Aiambak Airport",
  },
  {
    iata: "AIP",
    title: "Ailinglaplap Airport",
  },
  {
    iata: "AOS",
    title: "Amook Bay Seaplane Base",
  },
  {
    iata: "AKM",
    title: "Zakuoma Airport",
  },
  {
    iata: "ALZ",
    title: "Alitak Seaplane Base",
  },
  {
    iata: "AME",
    title: "Alto Molocue Airport",
  },
  {
    iata: "AMF",
    title: "AMA Airport",
  },
  {
    iata: "AMU",
    title: "Amanab Airport",
  },
  {
    iata: "AMY",
    title: "Ambatomainty Airport",
  },
  {
    iata: "ANH",
    title: "Anuha Island Resort Airport",
  },
  {
    iata: "INU",
    title: "Nauru International Airport",
  },
  {
    iata: "ANL",
    title: "Andulo Airport",
  },
  {
    iata: "CNZ",
    title: "Cangamba Airport",
  },
  {
    iata: "DRC",
    title: "Dirico Airport",
  },
  {
    iata: "GGC",
    title: "Lumbala Airport",
  },
  {
    iata: "JMB",
    title: "Jamba Airport",
  },
  {
    iata: "KNP",
    title: "Capanda Airport",
  },
  {
    iata: "NDF",
    title: "Ndalatandos Airport",
  },
  {
    iata: "AOB",
    title: "Annanberg Airport",
  },
  {
    iata: "APP",
    title: "Asapa Airport",
  },
  {
    iata: "APR",
    title: "April River Airport",
  },
  {
    iata: "AQY",
    title: "Girdwood Airport",
  },
  {
    iata: "QRF",
    title: "Bragado Airport",
  },
  {
    iata: "CSZ",
    title: "Brigadier Hector Ruiz Airport",
  },
  {
    iata: "CVI",
    title: "Caleta Olivia Airport",
  },
  {
    iata: "CNT",
    title: "Charata Airport",
  },
  {
    iata: "VGS",
    title: "General Villegas Airport",
  },
  {
    iata: "LMD",
    title: "Los Menucos Airport",
  },
  {
    iata: "VCF",
    title: "Valcheta Airport",
  },
  {
    iata: "VME",
    title: "Villa Mercedes Airport",
  },
  {
    iata: "NCJ",
    title: "Sunchales Aeroclub Airport",
  },
  {
    iata: "CPG",
    title: "Carmen De Patagones Airport",
  },
  {
    iata: "PRQ",
    title: "Termal Airport",
  },
  {
    iata: "ARP",
    title: "Aragip Airport",
  },
  {
    iata: "TAV",
    title: "Tau Airport",
  },
  {
    iata: "ASZ",
    title: "Asirim Airport",
  },
  {
    iata: "ATP",
    title: "Aitape Airport",
  },
  {
    iata: "AGW",
    title: "Agnew Airport",
  },
  {
    iata: "AYD",
    title: "Alroy Downs Airport",
  },
  {
    iata: "BCK",
    title: "Bolwarra Airport",
  },
  {
    iata: "BFC",
    title: "Bloomfield Airport",
  },
  {
    iata: "BVW",
    title: "Batavia Downs Airport",
  },
  {
    iata: "BYX",
    title: "Baniyala Airport",
  },
  {
    iata: "COB",
    title: "Coolibah Airport",
  },
  {
    iata: "CQP",
    title: "Cape Flattery Airport",
  },
  {
    iata: "CRJ",
    title: "Coorabie Airport",
  },
  {
    iata: "CRY",
    title: "Carlton Hill Airport",
  },
  {
    iata: "CSD",
    title: "Cresswell Downs Airport",
  },
  {
    iata: "CTR",
    title: "Cattle Creek Airport",
  },
  {
    iata: "DYM",
    title: "Diamantina Lakes Airport",
  },
  {
    iata: "EDD",
    title: "Erldunda Airport",
  },
  {
    iata: "EKD",
    title: "Elkedra Airport",
  },
  {
    iata: "HAT",
    title: "Heathlands Airport",
  },
  {
    iata: "HIG",
    title: "Highbury Airport",
  },
  {
    iata: "HIS",
    title: "Hayman Island Resort Seaplane Base",
  },
  {
    iata: "HLV",
    title: "Helenvale Airport",
  },
  {
    iata: "KBD",
    title: "Kimberley Downs Airport",
  },
  {
    iata: "KGR",
    title: "Kulgera Airport",
  },
  {
    iata: "KOH",
    title: "Koolatah Airport",
  },
  {
    iata: "KYF",
    title: "Yeelirrie Airport",
  },
  {
    iata: "LIB",
    title: "Limbunya Airport",
  },
  {
    iata: "MNW",
    title: "Macdonald Downs Airport",
  },
  {
    iata: "MUP",
    title: "Mulga Park Airport",
  },
  {
    iata: "MWY",
    title: "Miranda Downs Airport",
  },
  {
    iata: "MYO",
    title: "Camballin Airport",
  },
  {
    iata: "NKB",
    title: "Noonkanbah Airport",
  },
  {
    iata: "OKB",
    title: "Orchid Beach Airport",
  },
  {
    iata: "PEP",
    title: "Peppimenarti Airport",
  },
  {
    iata: "RDA",
    title: "Rockhampton Downs Airport",
  },
  {
    iata: "SSK",
    title: "Sturt Creek Airport",
  },
  {
    iata: "SWB",
    title: "Shaw River Airport",
  },
  {
    iata: "TPR",
    title: "Tom Price Airport",
  },
  {
    iata: "TWP",
    title: "Torwood Airport",
  },
  {
    iata: "WRW",
    title: "Warrawagine Airport",
  },
  {
    iata: "WSY",
    title: "Whitsunday Airstrip",
  },
  {
    iata: "ZVG",
    title: "Springvale Airport",
  },
  {
    iata: "AUI",
    title: "Aua Island Airport",
  },
  {
    iata: "AUJ",
    title: "Ambunti Airport",
  },
  {
    iata: "AUP",
    title: "Agaun Airport",
  },
  {
    iata: "AUV",
    title: "Aumo Airport",
  },
  {
    iata: "BUA",
    title: "Buka Airport",
  },
  {
    iata: "CMU",
    title: "Chimbu Airport",
  },
  {
    iata: "DAU",
    title: "Daru Airport",
  },
  {
    iata: "GKA",
    title: "Goroka Airport",
  },
  {
    iata: "GUR",
    title: "Gurney Airport",
  },
  {
    iata: "PNP",
    title: "Girua Airport",
  },
  {
    iata: "HKN",
    title: "Kimbe Airport",
  },
  {
    iata: "LSA",
    title: "Losuia Airport",
  },
  {
    iata: "UNG",
    title: "Kiunga Airport",
  },
  {
    iata: "KRI",
    title: "Kikori Airport",
  },
  {
    iata: "KMA",
    title: "Kerema Airport",
  },
  {
    iata: "KVG",
    title: "Kavieng Airport",
  },
  {
    iata: "LNV",
    title: "Londolovit Airport",
  },
  {
    iata: "MAG",
    title: "Madang Airport",
  },
  {
    iata: "HGU",
    title: "Mount Hagen Kagamuga Airport",
  },
  {
    iata: "MDU",
    title: "Mendi Airport",
  },
  {
    iata: "MAS",
    title: "Momote Airport",
  },
  {
    iata: "MXH",
    title: "Moro Airport",
  },
  {
    iata: "MIS",
    title: "Misima Island Airport",
  },
  {
    iata: "LAE",
    title: "Lae Nadzab Airport",
  },
  {
    iata: "POM",
    title: "Port Moresby Jacksons International Airport",
  },
  {
    iata: "TIZ",
    title: "Tari Airport",
  },
  {
    iata: "TBG",
    title: "Tabubil Airport",
  },
  {
    iata: "RAB",
    title: "Tokua Airport",
  },
  {
    iata: "AYU",
    title: "Aiyura Airport",
  },
  {
    iata: "VAI",
    title: "Vanimo Airport",
  },
  {
    iata: "WBM",
    title: "Wapenamanda Airport",
  },
  {
    iata: "WWK",
    title: "Wewak International Airport",
  },
  {
    iata: "AYY",
    title: "Arugam Bay SPB",
  },
  {
    iata: "AYZ",
    title: "Zahn's Airport",
  },
  {
    iata: "AZB",
    title: "Amazon Bay Airport",
  },
  {
    iata: "BCW",
    title: "Benguera Island Airport",
  },
  {
    iata: "HKV",
    title: "Haskovo Airport",
  },
  {
    iata: "JAM",
    title: "Bezmer Air Base",
  },
  {
    iata: "SZR",
    title: "Stara Zagora Airport",
  },
  {
    iata: "JEG",
    title: "Aasiaat Airport",
  },
  {
    iata: "AAP",
    title: "Aappilattoq (Qaasuitsup) Heliport",
  },
  {
    iata: "AGM",
    title: "Tasiilaq Heliport",
  },
  {
    iata: "LLU",
    title: "Alluitsup Paa Heliport",
  },
  {
    iata: "QUV",
    title: "Aappilattoq (Kujalleq) Heliport",
  },
  {
    iata: "QUW",
    title: "Ammassivik Heliport",
  },
  {
    iata: "QGQ",
    title: "Attu Heliport",
  },
  {
    iata: "UAK",
    title: "Narsarsuaq Airport",
  },
  {
    iata: "JCH",
    title: "Qasigiannguit Heliport",
  },
  {
    iata: "CNP",
    title: "Neerlerit Inaat Airport",
  },
  {
    iata: "QFG",
    title: "Eqalugaarsuit Heliport",
  },
  {
    iata: "QFN",
    title: "Narsaq Kujalleq Heliport",
  },
  {
    iata: "JFR",
    title: "Paamiut Heliport",
  },
  {
    iata: "GOH",
    title: "Godthaab / Nuuk Airport",
  },
  {
    iata: "JGO",
    title: "Qeqertarsuaq Heliport",
  },
  {
    iata: "IKE",
    title: "Ikerasak Heliport",
  },
  {
    iata: "QFI",
    title: "Iginniarfik",
  },
  {
    iata: "XIQ",
    title: "Ilimanaq Heliport",
  },
  {
    iata: "INN",
    title: "Innarsuit Heliport",
  },
  {
    iata: "ISO",
    title: "Isortoq Heliport",
  },
  {
    iata: "QJI",
    title: "Ikamiut Heliport",
  },
  {
    iata: "JJU",
    title: "Qaqortoq Heliport",
  },
  {
    iata: "JAV",
    title: "Ilulissat Airport",
  },
  {
    iata: "QPW",
    title: "Kangaatsiaq Heliport",
  },
  {
    iata: "KUS",
    title: "Kulusuk Airport",
  },
  {
    iata: "UPK",
    title: "Upernavik Kujalleq Heliport",
  },
  {
    iata: "KMT",
    title: "Kuummiut Heliport",
  },
  {
    iata: "KLQ",
    title: "Kullorsuaq Heliport",
  },
  {
    iata: "KAQ",
    title: "Kangersuatsiaq Heliport",
  },
  {
    iata: "QJE",
    title: "Kitsissuarsuit Heliport",
  },
  {
    iata: "ILL",
    title: "Illorsuit Heliport",
  },
  {
    iata: "MOR",
    title: "Moriusaq Heliport",
  },
  {
    iata: "JSU",
    title: "Maniitsoq Airport",
  },
  {
    iata: "QMK",
    title: "Niaqornaarsuk Heliport",
  },
  {
    iata: "JNN",
    title: "Nanortalik Heliport",
  },
  {
    iata: "NUG",
    title: "Nuugaatsiaq Heliport",
  },
  {
    iata: "JNS",
    title: "Narsaq Heliport",
  },
  {
    iata: "NIA",
    title: "Niaqornat Heliport",
  },
  {
    iata: "NUS",
    title: "Nuussuaq Heliport",
  },
  {
    iata: "JFR",
    title: "Paamiut Airport",
  },
  {
    iata: "QQT",
    title: "Qeqertaq Heliport",
  },
  {
    iata: "NAQ",
    title: "Qaanaaq Airport",
  },
  {
    iata: "OBY",
    title: "Ittoqqortoormiit Heliport",
  },
  {
    iata: "SFJ",
    title: "Kangerlussuaq Airport",
  },
  {
    iata: "SMG",
    title: "Sermiligaaq Heliport",
  },
  {
    iata: "SIO",
    title: "Siorapaluk Heliport",
  },
  {
    iata: "QUP",
    title: "Saqqaq Heliport",
  },
  {
    iata: "JHS",
    title: "Sisimiut Airport",
  },
  {
    iata: "SAA",
    title: "Saattut Heliport",
  },
  {
    iata: "SAV",
    title: "Savissivik Heliport",
  },
  {
    iata: "THU",
    title: "Thule Air Base",
  },
  {
    iata: "TNT",
    title: "Tiniteqilaaq Heliport",
  },
  {
    iata: "JUV",
    title: "Upernavik Airport",
  },
  {
    iata: "UMD",
    title: "Uummannaq Heliport",
  },
  {
    iata: "JQA",
    title: "Qaarsut Airport",
  },
  {
    iata: "UKK",
    title: "Ukkusissat Heliport",
  },
  {
    iata: "AEY",
    title: "Akureyri Airport",
  },
  {
    iata: "BIU",
    title: "Bildudalur Airport",
  },
  {
    iata: "BLO",
    title: "Hjaltabakki Airport",
  },
  {
    iata: "HFN",
    title: "Hornafjordur Airport",
  },
  {
    iata: "FLI",
    title: "Holt Airport",
  },
  {
    iata: "HZK",
    title: "Husavik Airport",
  },
  {
    iata: "KEF",
    title: "Keflavik International Airport",
  },
  {
    iata: "PFJ",
    title: "Patreksfjordur Airport",
  },
  {
    iata: "OLI",
    title: "Rif Airport",
  },
  {
    iata: "REK",
    title: "Reykjavik Airport",
  },
  {
    iata: "SIJ",
    title: "Siglufjordur Airport",
  },
  {
    iata: "THO",
    title: "Thorshofn Airport",
  },
  {
    iata: "VEY",
    title: "Vestmannaeyjar Airport",
  },
  {
    iata: "BJE",
    title: "Baleela Airport",
  },
  {
    iata: "BJQ",
    title: "Bahja Airport",
  },
  {
    iata: "BLM",
    title: "Bahia De Los Angelos South",
  },
  {
    iata: "BMQ",
    title: "Bamburi Airport",
  },
  {
    iata: "RBQ",
    title: "Rurenabaque Airport",
  },
  {
    iata: "BVL",
    title: "Baures Airport",
  },
  {
    iata: "ALT",
    title: "Alenquer Airport",
  },
  {
    iata: "SWM",
    title: "Suia-Missu Airport",
  },
  {
    iata: "NSB",
    title: "Bimini North Seaplane Base",
  },
  {
    iata: "HUK",
    title: "Hukuntsi Airport",
  },
  {
    iata: "BYV",
    title: "Beira Lake Seaplane Base",
  },
  {
    iata: "BCV",
    title: "Belmopan Airport",
  },
  {
    iata: "BGK",
    title: "Big Creek Airport",
  },
  {
    iata: "CUK",
    title: "Caye Caulker Airport",
  },
  {
    iata: "CYC",
    title: "Caye Chapel Airport",
  },
  {
    iata: "CZH",
    title: "Corozal Municipal Airport",
  },
  {
    iata: "DGA",
    title: "Dangriga Airport",
  },
  {
    iata: "INB",
    title: "Independence Airport",
  },
  {
    iata: "MDB",
    title: "Melinda Airport",
  },
  {
    iata: "ORZ",
    title: "Orange Walk Airport",
  },
  {
    iata: "PLJ",
    title: "Placencia Airport",
  },
  {
    iata: "PND",
    title: "Punta Gorda Airport",
  },
  {
    iata: "SJX",
    title: "Sartaneja Airport",
  },
  {
    iata: "SPR",
    title: "San Pedro Airport",
  },
  {
    iata: "SQS",
    title: "Matthew Spain Airport",
  },
  {
    iata: "STU",
    title: "Santa Cruz Airport",
  },
  {
    iata: "SVK",
    title: "Silver Creek Airport",
  },
  {
    iata: "TZA",
    title: "Belize City Municipal Airport",
  },
  {
    iata: "BZB",
    title: "Bazaruto Island Airport",
  },
  {
    iata: "YUJ",
    title: "Lady Franklin Point Airport",
  },
  {
    iata: "YWO",
    title: "Lupin Airport",
  },
  {
    iata: "YTJ",
    title: "Terrace Bay Airport",
  },
  {
    iata: "YMV",
    title: "Mary River Aerodrome",
  },
  {
    iata: "YBW",
    title: "Bedwell Harbour Seaplane Base",
  },
  {
    iata: "ZNA",
    title: "Nanaimo Harbour Water Airport",
  },
  {
    iata: "YZZ",
    title: "Trail Airport",
  },
  {
    iata: "YWS",
    title: "Whistler/Green Lake Water Aerodrome",
  },
  {
    iata: "YPT",
    title: "Pender Harbour Seaplane Base",
  },
  {
    iata: "YAA",
    title: "Anahim Lake Airport",
  },
  {
    iata: "JHL",
    title: "Fort MacKay/Albian Aerodrome",
  },
  {
    iata: "YMU",
    title: "Mansons Landing Seaplane Base",
  },
  {
    iata: "YWM",
    title: "Williams Harbour Airport",
  },
  {
    iata: "YFX",
    title: "St. Lewis (Fox Harbour) Airport",
  },
  {
    iata: "YHA",
    title: "Port Hope Simpson Airport",
  },
  {
    iata: "YRG",
    title: "Rigolet Airport",
  },
  {
    iata: "CDK",
    title: "George T Lewis Airport",
  },
  {
    iata: "YCK",
    title: "Colville Lake Airport",
  },
  {
    iata: "EE7",
    title: "Edmonton/Cooking Lake Seaplane Base",
  },
  {
    iata: "NML",
    title: "Fort McMurray / Mildred Lake Airport",
  },
  {
    iata: "DAS",
    title: "Great Bear Lake Airport",
  },
  {
    iata: "YFI",
    title: "Fort Mackay / Firebag",
  },
  {
    iata: "OKG",
    title: "Okoyo Airport",
  },
  {
    iata: "CGA",
    title: "Craig Seaplane Base",
  },
  {
    iata: "SUR",
    title: "Summer Beaver Airport",
  },
  {
    iata: "YAX",
    title: "Wapekeka Airport",
  },
  {
    iata: "WNN",
    title: "Wunnumin Lake Airport",
  },
  {
    iata: "YNO",
    title: "North Spirit Lake Airport",
  },
  {
    iata: "CLG",
    title: "Coalinga Airport",
  },
  {
    iata: "OHE",
    title: "Gu-Lian Airport",
  },
  {
    iata: "FUO",
    title: "Foshan Shadi Airport",
  },
  {
    iata: "HUZ",
    title: "Huizhou Airport",
  },
  {
    iata: "JGS",
    title: "Jinggangshan Airport",
  },
  {
    iata: "AEB",
    title: "Tian Yang Air Base",
  },
  {
    iata: "AAT",
    title: "Altay Air Base",
  },
  {
    iata: "YZY",
    title: "Zhangye Southeast Air Base",
  },
  {
    iata: "DDG",
    title: "Dandong Airport",
  },
  {
    iata: "NTG",
    title: "Nantong Airport",
  },
  {
    iata: "XBE",
    title: "Bearskin Lake Airport",
  },
  {
    iata: "KIF",
    title: "Kingfisher Lake Airport",
  },
  {
    iata: "YOG",
    title: "Ogoki Post Airport",
  },
  {
    iata: "PRM",
    title: "Proma Heliport",
  },
  {
    iata: "ISG",
    title: "Isa Giron Heliport",
  },
  {
    iata: "API",
    title: "Apiay Airport",
  },
  {
    iata: "ARQ",
    title: "El Troncal Airport",
  },
  {
    iata: "LCR",
    title: "La Chorrera Airport",
  },
  {
    iata: "SNT",
    title: "Las Cruces Airport",
  },
  {
    iata: "YEB",
    title: "Bar River Airport",
  },
  {
    iata: "YHP",
    title: "Poplar Hill Airport",
  },
  {
    iata: "YNX",
    title: "Snap Lake Airport",
  },
  {
    iata: "YKU",
    title: "Chisasibi Airport",
  },
  {
    iata: "YAU",
    title: "Donaldson Airport",
  },
  {
    iata: "TR7",
    title: "Ottawa / Rockcliffe Seaplane Base",
  },
  {
    iata: "PST",
    title: "Preston Airport",
  },
  {
    iata: "NIC",
    title: "Nicosia International Airport",
  },
  {
    iata: "YAC",
    title: "Cat Lake Airport",
  },
  {
    iata: "YAG",
    title: "Fort Frances Municipal Airport",
  },
  {
    iata: "YAH",
    title: "La Grande-4 Airport",
  },
  {
    iata: "YAL",
    title: "Alert Bay Airport",
  },
  {
    iata: "YAM",
    title: "Sault Ste Marie Airport",
  },
  {
    iata: "XKS",
    title: "Kasabonika Airport",
  },
  {
    iata: "YKG",
    title: "Kangirsuk Airport",
  },
  {
    iata: "YAT",
    title: "Attawapiskat Airport",
  },
  {
    iata: "YAV",
    title: "Winnipeg / St. Andrews Airport",
  },
  {
    iata: "YAW",
    title: "Halifax / CFB Shearwater Heliport",
  },
  {
    iata: "YAX",
    title: "Lac Du Bonnet Airport",
  },
  {
    iata: "YAY",
    title: "St Anthony Airport",
  },
  {
    iata: "YAZ",
    title: "Tofino / Long Beach Airport",
  },
  {
    iata: "YBB",
    title: "Kugaaruk Airport",
  },
  {
    iata: "YBC",
    title: "Baie Comeau Airport",
  },
  {
    iata: "QBC",
    title: "Bella Coola Airport",
  },
  {
    iata: "YBE",
    title: "Uranium City Airport",
  },
  {
    iata: "YBY",
    title: "Bonnyville Airport",
  },
  {
    iata: "YBG",
    title: "CFB Bagotville",
  },
  {
    iata: "YBK",
    title: "Baker Lake Airport",
  },
  {
    iata: "YBL",
    title: "Campbell River Airport",
  },
  {
    iata: "YBN",
    title: "CFB Borden",
  },
  {
    iata: "XTL",
    title: "Tadoule Lake Airport",
  },
  {
    iata: "YBR",
    title: "Brandon Municipal Airport",
  },
  {
    iata: "YBT",
    title: "Brochet Airport",
  },
  {
    iata: "YBV",
    title: "Berens River Airport",
  },
  {
    iata: "YBX",
    title: "Lourdes de Blanc Sablon Airport",
  },
  {
    iata: "YRF",
    title: "Cartwright Airport",
  },
  {
    iata: "YCB",
    title: "Cambridge Bay Airport",
  },
  {
    iata: "YCC",
    title: "Cornwall Regional Airport",
  },
  {
    iata: "YCD",
    title: "Nanaimo Airport",
  },
  {
    iata: "YCE",
    title: "James T. Field Memorial Aerodrome",
  },
  {
    iata: "YCG",
    title: "Castlegar/West Kootenay Regional Airport",
  },
  {
    iata: "YCH",
    title: "Miramichi Airport",
  },
  {
    iata: "YCL",
    title: "Charlo Airport",
  },
  {
    iata: "YCN",
    title: "Cochrane Airport",
  },
  {
    iata: "YCO",
    title: "Kugluktuk Airport",
  },
  {
    iata: "YCQ",
    title: "Chetwynd Airport",
  },
  {
    iata: "YCR",
    title: "Cross Lake (Charlie Sinclair Memorial) Airport",
  },
  {
    iata: "YCS",
    title: "Chesterfield Inlet Airport",
  },
  {
    iata: "YCV",
    title: "Cartierville Airport",
  },
  {
    iata: "YCX",
    title: "CFB Gagetown Heliport",
  },
  {
    iata: "YCY",
    title: "Clyde River Airport",
  },
  {
    iata: "YCZ",
    title: "Fairmont Hot Springs Airport",
  },
  {
    iata: "YDA",
    title: "Dawson City Airport",
  },
  {
    iata: "YDB",
    title: "Burwash Airport",
  },
  {
    iata: "YDF",
    title: "Deer Lake Airport",
  },
  {
    iata: "YDM",
    title: "Ross River Airport",
  },
  {
    iata: "YDN",
    title: "Dauphin Barker Airport",
  },
  {
    iata: "YDO",
    title: "Dolbeau St Felicien Airport",
  },
  {
    iata: "YDP",
    title: "Nain Airport",
  },
  {
    iata: "YDQ",
    title: "Dawson Creek Airport",
  },
  {
    iata: "YED",
    title: "Edmonton (CFB Namao) Heliport",
  },
  {
    iata: "YEG",
    title: "Edmonton International Airport",
  },
  {
    iata: "YEK",
    title: "Arviat Airport",
  },
  {
    iata: "YEL",
    title: "Elliot Lake Municipal Airport",
  },
  {
    iata: "YEM",
    title: "Manitoulin East Municipal Airport",
  },
  {
    iata: "YEN",
    title: "Estevan Airport",
  },
  {
    iata: "YER",
    title: "Fort Severn Airport",
  },
  {
    iata: "YET",
    title: "Edson Airport",
  },
  {
    iata: "YEU",
    title: "Eureka Airport",
  },
  {
    iata: "YEV",
    title: "Inuvik Mike Zubko Airport",
  },
  {
    iata: "YEY",
    title: "Amos Magny Airport",
  },
  {
    iata: "YFA",
    title: "Fort Albany Airport",
  },
  {
    iata: "YFB",
    title: "Iqaluit Airport",
  },
  {
    iata: "YFC",
    title: "Fredericton Airport",
  },
  {
    iata: "YFE",
    title: "Forestville Airport",
  },
  {
    iata: "YFH",
    title: "Fort Hope Airport",
  },
  {
    iata: "YTM",
    title: "La Macaza / Mont-Tremblant International Inc Airport",
  },
  {
    iata: "YFO",
    title: "Flin Flon Airport",
  },
  {
    iata: "YFR",
    title: "Fort Resolution Airport",
  },
  {
    iata: "YFS",
    title: "Fort Simpson Airport",
  },
  {
    iata: "YMN",
    title: "Makkovik Airport",
  },
  {
    iata: "YGB",
    title: "Texada Gillies Bay Airport",
  },
  {
    iata: "YGD",
    title: "Goderich Airport",
  },
  {
    iata: "YGH",
    title: "Fort Good Hope Airport",
  },
  {
    iata: "YGK",
    title: "Kingston Norman Rogers Airport",
  },
  {
    iata: "YGM",
    title: "Gimli Industrial Park Airport",
  },
  {
    iata: "YGO",
    title: "Gods Lake Narrows Airport",
  },
  {
    iata: "YGQ",
    title: "Geraldton Greenstone Regional Airport",
  },
  {
    iata: "YGT",
    title: "Igloolik Airport",
  },
  {
    iata: "YGV",
    title: "Havre St Pierre Airport",
  },
  {
    iata: "YGW",
    title: "Kuujjuarapik Airport",
  },
  {
    iata: "YGX",
    title: "Gillam Airport",
  },
  {
    iata: "YGZ",
    title: "Grise Fiord Airport",
  },
  {
    iata: "YQC",
    title: "Quaqtaq Airport",
  },
  {
    iata: "CXH",
    title: "Vancouver Harbour Water Aerodrome",
  },
  {
    iata: "YHD",
    title: "Dryden Regional Airport",
  },
  {
    iata: "YHE",
    title: "Hope Airport",
  },
  {
    iata: "YNS",
    title: "Nemiscau Airport",
  },
  {
    iata: "YHI",
    title: "Ulukhaktok Holman Airport",
  },
  {
    iata: "YHK",
    title: "Gjoa Haven Airport",
  },
  {
    iata: "YHM",
    title: "John C. Munro Hamilton International Airport",
  },
  {
    iata: "YHN",
    title: "Hornepayne Municipal Airport",
  },
  {
    iata: "YHO",
    title: "Hopedale Airport",
  },
  {
    iata: "YHR",
    title: "Chevery Airport",
  },
  {
    iata: "YHT",
    title: "Haines Junction Airport",
  },
  {
    iata: "YHY",
    title: "Hay River / Merlyn Carter Airport",
  },
  {
    iata: "YHZ",
    title: "Halifax / Stanfield International Airport",
  },
  {
    iata: "YIB",
    title: "Atikokan Municipal Airport",
  },
  {
    iata: "YDG",
    title: "Digby / Annapolis Regional Airport",
  },
  {
    iata: "YIF",
    title: "St Augustin Airport",
  },
  {
    iata: "YIK",
    title: "Ivujivik Airport",
  },
  {
    iata: "YIO",
    title: "Pond Inlet Airport",
  },
  {
    iata: "YIV",
    title: "Island Lake Airport",
  },
  {
    iata: "YJF",
    title: "Fort Liard Airport",
  },
  {
    iata: "YJN",
    title: "St Jean Airport",
  },
  {
    iata: "YJT",
    title: "Stephenville Airport",
  },
  {
    iata: "YKA",
    title: "Kamloops Airport",
  },
  {
    iata: "LAK",
    title: "Aklavik Airport",
  },
  {
    iata: "YKF",
    title: "Waterloo Airport",
  },
  {
    iata: "YKJ",
    title: "Key Lake Airport",
  },
  {
    iata: "YKL",
    title: "Schefferville Airport",
  },
  {
    iata: "AKV",
    title: "Akulivik Airport",
  },
  {
    iata: "YKQ",
    title: "Waskaganish Airport",
  },
  {
    iata: "YKX",
    title: "Kirkland Lake Airport",
  },
  {
    iata: "YKY",
    title: "Kindersley Airport",
  },
  {
    iata: "YKZ",
    title: "Buttonville Municipal Airport",
  },
  {
    iata: "YPJ",
    title: "Aupaluk Airport",
  },
  {
    iata: "YLC",
    title: "Kimmirut Airport",
  },
  {
    iata: "YLD",
    title: "Chapleau Airport",
  },
  {
    iata: "YLH",
    title: "Lansdowne House Airport",
  },
  {
    iata: "YLJ",
    title: "Meadow Lake Airport",
  },
  {
    iata: "YSG",
    title: "Lutselk'e Airport",
  },
  {
    iata: "YLL",
    title: "Lloydminster Airport",
  },
  {
    iata: "YLR",
    title: "Leaf Rapids Airport",
  },
  {
    iata: "YLT",
    title: "Alert Airport",
  },
  {
    iata: "XGR",
    title: "Kangiqsualujjuaq (Georges River) Airport",
  },
  {
    iata: "YLW",
    title: "Kelowna Airport",
  },
  {
    iata: "YMA",
    title: "Mayo Airport",
  },
  {
    iata: "YME",
    title: "Matane Airport",
  },
  {
    iata: "YMG",
    title: "Manitouwadge Airport",
  },
  {
    iata: "YMH",
    title: "Mary's Harbour Airport",
  },
  {
    iata: "YMJ",
    title: "Moose Jaw Air Vice Marshal C. M. McEwen Airport",
  },
  {
    iata: "YML",
    title: "Charlevoix Airport",
  },
  {
    iata: "YMM",
    title: "Fort McMurray Airport",
  },
  {
    iata: "YMO",
    title: "Moosonee Airport",
  },
  {
    iata: "YMT",
    title: "Chapais Airport",
  },
  {
    iata: "YUD",
    title: "Umiujaq Airport",
  },
  {
    iata: "YMX",
    title: "Montreal International (Mirabel) Airport",
  },
  {
    iata: "YNA",
    title: "Natashquan Airport",
  },
  {
    iata: "YNC",
    title: "Wemindji Airport",
  },
  {
    iata: "YND",
    title: "Ottawa / Gatineau Airport",
  },
  {
    iata: "YNE",
    title: "Norway House Airport",
  },
  {
    iata: "YNL",
    title: "Points North Landing Airport",
  },
  {
    iata: "YNM",
    title: "Matagami Airport",
  },
  {
    iata: "YNN",
    title: "Nejanilini Lake Airport",
  },
  {
    iata: "HZP",
    title: "Fort Mackay / Horizon Airport",
  },
  {
    iata: "YOA",
    title: "Ekati Airport",
  },
  {
    iata: "YOC",
    title: "Old Crow Airport",
  },
  {
    iata: "YOD",
    title: "CFB Cold Lake",
  },
  {
    iata: "YOH",
    title: "Oxford House Airport",
  },
  {
    iata: "YOJ",
    title: "High Level Airport",
  },
  {
    iata: "YOO",
    title: "Oshawa Airport",
  },
  {
    iata: "YOP",
    title: "Rainbow Lake Airport",
  },
  {
    iata: "YOS",
    title: "Owen Sound / Billy Bishop Regional Airport",
  },
  {
    iata: "YOW",
    title: "Ottawa Macdonald-Cartier International Airport",
  },
  {
    iata: "YOY",
    title: "C J.H.L.(Joe) Lecomte) Heliport",
  },
  {
    iata: "YPA",
    title: "Prince Albert Glass Field",
  },
  {
    iata: "YPC",
    title: "Paulatuk (Nora Aliqatchialuk Ruben) Airport",
  },
  {
    iata: "YPS",
    title: "Port Hawkesbury Airport",
  },
  {
    iata: "YPE",
    title: "Peace River Airport",
  },
  {
    iata: "YPG",
    title: "Southport Airport",
  },
  {
    iata: "YPH",
    title: "Inukjuak Airport",
  },
  {
    iata: "YPL",
    title: "Pickle Lake Airport",
  },
  {
    iata: "YPM",
    title: "Pikangikum Airport",
  },
  {
    iata: "YPN",
    title: "Port Menier Airport",
  },
  {
    iata: "YPO",
    title: "Peawanuck Airport",
  },
  {
    iata: "YPQ",
    title: "Peterborough Airport",
  },
  {
    iata: "YPR",
    title: "Prince Rupert Airport",
  },
  {
    iata: "YPW",
    title: "Powell River Airport",
  },
  {
    iata: "YPX",
    title: "Puvirnituq Airport",
  },
  {
    iata: "YPY",
    title: "Fort Chipewyan Airport",
  },
  {
    iata: "YQA",
    title: "Muskoka Airport",
  },
  {
    iata: "YQB",
    title: "Quebec Jean Lesage International Airport",
  },
  {
    iata: "YQD",
    title: "The Pas Airport",
  },
  {
    iata: "YQF",
    title: "Red Deer Regional Airport",
  },
  {
    iata: "YQG",
    title: "Windsor Airport",
  },
  {
    iata: "YQH",
    title: "Watson Lake Airport",
  },
  {
    iata: "YQI",
    title: "Yarmouth Airport",
  },
  {
    iata: "YQK",
    title: "Kenora Airport",
  },
  {
    iata: "YQL",
    title: "Lethbridge County Airport",
  },
  {
    iata: "YQM",
    title: "Greater Moncton International Airport",
  },
  {
    iata: "YQN",
    title: "Nakina Airport",
  },
  {
    iata: "YQQ",
    title: "Comox Airport",
  },
  {
    iata: "YQR",
    title: "Regina International Airport",
  },
  {
    iata: "YQS",
    title: "St Thomas Municipal Airport",
  },
  {
    iata: "YQT",
    title: "Thunder Bay Airport",
  },
  {
    iata: "YQU",
    title: "Grande Prairie Airport",
  },
  {
    iata: "YQV",
    title: "Yorkton Municipal Airport",
  },
  {
    iata: "YQW",
    title: "North Battleford Airport",
  },
  {
    iata: "YQX",
    title: "Gander International Airport",
  },
  {
    iata: "YQY",
    title: "Sydney / J.A. Douglas McCurdy Airport",
  },
  {
    iata: "YQZ",
    title: "Quesnel Airport",
  },
  {
    iata: "YRA",
    title: "Rae Lakes Airport",
  },
  {
    iata: "YRB",
    title: "Resolute Bay Airport",
  },
  {
    iata: "YRJ",
    title: "Roberval Airport",
  },
  {
    iata: "YRL",
    title: "Red Lake Airport",
  },
  {
    iata: "YRO",
    title: "Ottawa / Rockcliffe Airport",
  },
  {
    iata: "YRP",
    title: "Ottawa / Carp Airport",
  },
  {
    iata: "YRS",
    title: "Red Sucker Lake Airport",
  },
  {
    iata: "YRT",
    title: "Rankin Inlet Airport",
  },
  {
    iata: "YRV",
    title: "Revelstoke Airport",
  },
  {
    iata: "YSB",
    title: "Sudbury Airport",
  },
  {
    iata: "YSC",
    title: "Sherbrooke Airport",
  },
  {
    iata: "YSD",
    title: "Suffield Heliport",
  },
  {
    iata: "YSF",
    title: "Stony Rapids Airport",
  },
  {
    iata: "YSH",
    title: "Smiths Falls-Montague (Russ Beach) Airport",
  },
  {
    iata: "YSJ",
    title: "Saint John Airport",
  },
  {
    iata: "YSK",
    title: "Sanikiluaq Airport",
  },
  {
    iata: "YSL",
    title: "St Leonard Airport",
  },
  {
    iata: "YSM",
    title: "Fort Smith Airport",
  },
  {
    iata: "YCM",
    title: "Niagara District Airport",
  },
  {
    iata: "YSP",
    title: "Marathon Airport",
  },
  {
    iata: "YSR",
    title: "Nanisivik Airport",
  },
  {
    iata: "YST",
    title: "St. Theresa Point Airport",
  },
  {
    iata: "YSU",
    title: "Summerside Airport",
  },
  {
    iata: "YSY",
    title: "Sachs Harbour (David Nasogaluak Jr. Saaryuaq) Airport",
  },
  {
    iata: "YTA",
    title: "Pembroke Airport",
  },
  {
    iata: "YTE",
    title: "Cape Dorset Airport",
  },
  {
    iata: "YTF",
    title: "Alma Airport",
  },
  {
    iata: "YTH",
    title: "Thompson Airport",
  },
  {
    iata: "YTL",
    title: "Big Trout Lake Airport",
  },
  {
    iata: "YTQ",
    title: "Tasiujaq Airport",
  },
  {
    iata: "YTR",
    title: "CFB Trenton",
  },
  {
    iata: "YTS",
    title: "Timmins/Victor M. Power",
  },
  {
    iata: "YTZ",
    title: "Billy Bishop Toronto City Centre Airport",
  },
  {
    iata: "YUB",
    title: "Tuktoyaktuk Airport",
  },
  {
    iata: "YUL",
    title: "Montreal / Pierre Elliott Trudeau International Airport",
  },
  {
    iata: "YUT",
    title: "Repulse Bay Airport",
  },
  {
    iata: "YUX",
    title: "Hall Beach Airport",
  },
  {
    iata: "YUY",
    title: "Rouyn Noranda Airport",
  },
  {
    iata: "YVB",
    title: "Bonaventure Airport",
  },
  {
    iata: "YVC",
    title: "La Ronge Airport",
  },
  {
    iata: "YVD",
    title: "Virden/R.J. (Bob) Andrew Field Regional Aerodrome",
  },
  {
    iata: "YVE",
    title: "Vernon Airport",
  },
  {
    iata: "YVM",
    title: "Qikiqtarjuaq Airport",
  },
  {
    iata: "YVO",
    title: "Val-d'Or Airport",
  },
  {
    iata: "YVP",
    title: "Kuujjuaq Airport",
  },
  {
    iata: "YVQ",
    title: "Norman Wells Airport",
  },
  {
    iata: "YVR",
    title: "Vancouver International Airport",
  },
  {
    iata: "YVT",
    title: "Buffalo Narrows Airport",
  },
  {
    iata: "YVV",
    title: "Wiarton Airport",
  },
  {
    iata: "YVZ",
    title: "Deer Lake Airport",
  },
  {
    iata: "YWA",
    title: "Petawawa Airport",
  },
  {
    iata: "YWG",
    title: "Winnipeg / James Armstrong Richardson International Airport",
  },
  {
    iata: "YWH",
    title: "Victoria Harbour Seaplane Base",
  },
  {
    iata: "YWK",
    title: "Wabush Airport",
  },
  {
    iata: "YWL",
    title: "Williams Lake Airport",
  },
  {
    iata: "YWP",
    title: "Webequie Airport",
  },
  {
    iata: "YWY",
    title: "Wrigley Airport",
  },
  {
    iata: "YXC",
    title: "Cranbrook Airport",
  },
  {
    iata: "YXD",
    title: "Edmonton City Centre (Blatchford Field) Airport",
  },
  {
    iata: "YXE",
    title: "Saskatoon John G. Diefenbaker International Airport",
  },
  {
    iata: "YXH",
    title: "Medicine Hat Airport",
  },
  {
    iata: "YXI",
    title: "Bonnechere Airport",
  },
  {
    iata: "YXJ",
    title: "Fort St John Airport",
  },
  {
    iata: "YXK",
    title: "Rimouski Airport",
  },
  {
    iata: "YXL",
    title: "Sioux Lookout Airport",
  },
  {
    iata: "YXN",
    title: "Whale Cove Airport",
  },
  {
    iata: "YXP",
    title: "Pangnirtung Airport",
  },
  {
    iata: "YXQ",
    title: "Beaver Creek Airport",
  },
  {
    iata: "YXR",
    title: "Earlton (Timiskaming Regional) Airport",
  },
  {
    iata: "YXS",
    title: "Prince George Airport",
  },
  {
    iata: "YXT",
    title: "Terrace Airport",
  },
  {
    iata: "YXU",
    title: "London Airport",
  },
  {
    iata: "YXX",
    title: "Abbotsford Airport",
  },
  {
    iata: "YXY",
    title: "Whitehorse / Erik Nielsen International Airport",
  },
  {
    iata: "YXZ",
    title: "Wawa Airport",
  },
  {
    iata: "YYB",
    title: "North Bay Airport",
  },
  {
    iata: "YYC",
    title: "Calgary International Airport",
  },
  {
    iata: "YYD",
    title: "Smithers Airport",
  },
  {
    iata: "YYE",
    title: "Fort Nelson Airport",
  },
  {
    iata: "YYF",
    title: "Penticton Airport",
  },
  {
    iata: "YYG",
    title: "Charlottetown Airport",
  },
  {
    iata: "YYH",
    title: "Taloyoak Airport",
  },
  {
    iata: "YYJ",
    title: "Victoria International Airport",
  },
  {
    iata: "YYL",
    title: "Lynn Lake Airport",
  },
  {
    iata: "YYN",
    title: "Swift Current Airport",
  },
  {
    iata: "YYQ",
    title: "Churchill Airport",
  },
  {
    iata: "YYR",
    title: "Goose Bay Airport",
  },
  {
    iata: "YYT",
    title: "St Johns International Airport",
  },
  {
    iata: "YYU",
    title: "Kapuskasing Airport",
  },
  {
    iata: "YYW",
    title: "Armstrong Airport",
  },
  {
    iata: "YYY",
    title: "Mont Joli Airport",
  },
  {
    iata: "YYZ",
    title: "Lester B. Pearson International Airport",
  },
  {
    iata: "YZD",
    title: "Downsview Airport",
  },
  {
    iata: "YZE",
    title: "Gore Bay Manitoulin Airport",
  },
  {
    iata: "YZF",
    title: "Yellowknife Airport",
  },
  {
    iata: "YZG",
    title: "Salluit Airport",
  },
  {
    iata: "YZH",
    title: "Slave Lake Airport",
  },
  {
    iata: "YZP",
    title: "Sandspit Airport",
  },
  {
    iata: "YZR",
    title: "Chris Hadfield Airport",
  },
  {
    iata: "YZS",
    title: "Coral Harbour Airport",
  },
  {
    iata: "YZT",
    title: "Port Hardy Airport",
  },
  {
    iata: "YZU",
    title: "Whitecourt Airport",
  },
  {
    iata: "YZW",
    title: "Teslin Airport",
  },
  {
    iata: "YZX",
    title: "CFB Greenwood",
  },
  {
    iata: "YZY",
    title: "Mackenzie Airport",
  },
  {
    iata: "ZAC",
    title: "York Landing Airport",
  },
  {
    iata: "YSN",
    title: "Salmon Arm Airport",
  },
  {
    iata: "YDT",
    title: "Burlington Executive",
  },
  {
    iata: "ZBD",
    title: "Boundary Bay Airport",
  },
  {
    iata: "ZBF",
    title: "Ilford Airport",
  },
  {
    iata: "ZBF",
    title: "Bathurst Airport",
  },
  {
    iata: "ZBM",
    title: "Bromont Airport",
  },
  {
    iata: "ZEE",
    title: "Kelsey Airport",
  },
  {
    iata: "ZEM",
    title: "Eastmain River Airport",
  },
  {
    iata: "ZFA",
    title: "Faro Airport",
  },
  {
    iata: "ZFD",
    title: "Fond-Du-Lac Airport",
  },
  {
    iata: "ZFG",
    title: "Pukatawagan Airport",
  },
  {
    iata: "ZFM",
    title: "Fort Mcpherson Airport",
  },
  {
    iata: "ZFN",
    title: "Tulita Airport",
  },
  {
    iata: "ZGF",
    title: "Grand Forks Airport",
  },
  {
    iata: "ZGI",
    title: "Gods River Airport",
  },
  {
    iata: "ZGR",
    title: "Little Grand Rapids Airport",
  },
  {
    iata: "ZJG",
    title: "Jenpeg Airport",
  },
  {
    iata: "ZJN",
    title: "Swan River Airport",
  },
  {
    iata: "ZKE",
    title: "Kashechewan Airport",
  },
  {
    iata: "YTD",
    title: "Thicket Portage Airport",
  },
  {
    iata: "MSA",
    title: "Muskrat Dam Airport",
  },
  {
    iata: "PIW",
    title: "Pikwitonei Airport",
  },
  {
    iata: "ZMT",
    title: "Masset Airport",
  },
  {
    iata: "ZNG",
    title: "Poplar River Airport",
  },
  {
    iata: "ZPB",
    title: "Sachigo Lake Airport",
  },
  {
    iata: "ZRJ",
    title: "Round Lake (Weagamow Lake) Airport",
  },
  {
    iata: "ZSJ",
    title: "Sandy Lake Airport",
  },
  {
    iata: "ZSN",
    title: "South Indian Lake Airport",
  },
  {
    iata: "ZSW",
    title: "Prince Rupert/Seal Cove Seaplane Base",
  },
  {
    iata: "ZTM",
    title: "Shamattawa Airport",
  },
  {
    iata: "ZUC",
    title: "Ignace Municipal Airport",
  },
  {
    iata: "ZUM",
    title: "Churchill Falls Airport",
  },
  {
    iata: "ZWH",
    title: "Lac Brochet Airport",
  },
  {
    iata: "ZWL",
    title: "Wollaston Lake Airport",
  },
  {
    iata: "QLD",
    title: "Blida Airport",
  },
  {
    iata: "BUJ",
    title: "Bou Saada Airport",
  },
  {
    iata: "BJA",
    title: "Soummam Airport",
  },
  {
    iata: "ALG",
    title: "Houari Boumediene Airport",
  },
  {
    iata: "DJG",
    title: "Djanet Inedbirene Airport",
  },
  {
    iata: "QFD",
    title: "Boufarik Airport",
  },
  {
    iata: "VVZ",
    title: "Illizi Takhamalt Airport",
  },
  {
    iata: "QSF",
    title: "Ain Arnat Airport",
  },
  {
    iata: "GJL",
    title: "Jijel Ferhat Abbas Airport",
  },
  {
    iata: "MZW",
    title: "Mecheria Airport",
  },
  {
    iata: "QZN",
    title: "Relizane Airport",
  },
  {
    iata: "AAE",
    title: "Annaba Airport",
  },
  {
    iata: "CZL",
    title: "Mohamed Boudiaf International Airport",
  },
  {
    iata: "BLJ",
    title: "Batna Airport",
  },
  {
    iata: "HRM",
    title: "Hassi R'Mel Airport",
  },
  {
    iata: "TID",
    title: "Bou Chekif Airport",
  },
  {
    iata: "TIN",
    title: "Tindouf Airport",
  },
  {
    iata: "QAS",
    title: "Ech Cheliff Airport",
  },
  {
    iata: "TAF",
    title: "Tafaraoui Airport",
  },
  {
    iata: "ORN",
    title: "Es Senia Airport",
  },
  {
    iata: "MUW",
    title: "Ghriss Airport",
  },
  {
    iata: "EBH",
    title: "El Bayadh Airport",
  },
  {
    iata: "INF",
    title: "In Guezzam Airport",
  },
  {
    iata: "BMW",
    title: "Bordj Badji Mokhtar Airport",
  },
  {
    iata: "AZR",
    title: "Touat Cheikh Sidi Mohamed Belkebir Airport",
  },
  {
    iata: "BSK",
    title: "Biskra Airport",
  },
  {
    iata: "ELG",
    title: "El Golea Airport",
  },
  {
    iata: "HME",
    title: "Oued Irara Airport",
  },
  {
    iata: "INZ",
    title: "In Salah Airport",
  },
  {
    iata: "TGR",
    title: "Touggourt Sidi Madhi Airport",
  },
  {
    iata: "LOO",
    title: "Laghouat Airport",
  },
  {
    iata: "ELU",
    title: "Guemar Airport",
  },
  {
    iata: "TMX",
    title: "Timimoun Airport",
  },
  {
    iata: "OGX",
    title: "Ain el Beida Airport",
  },
  {
    iata: "COO",
    title: "Cadjehoun Airport",
  },
  {
    iata: "KDC",
    title: "Kandi Airport",
  },
  {
    iata: "NAE",
    title: "Natitingou Airport",
  },
  {
    iata: "PKO",
    title: "Parakou Airport",
  },
  {
    iata: "DCG",
    title: "Dubai Creek SPB",
  },
  {
    iata: "XKY",
    title: "Kaya Airport",
  },
  {
    iata: "OUG",
    title: "Ouahigouya Airport",
  },
  {
    iata: "XDJ",
    title: "Djibo Airport",
  },
  {
    iata: "XLU",
    title: "Leo Airport",
  },
  {
    iata: "PUP",
    title: "Po Airport",
  },
  {
    iata: "XBO",
    title: "Boulsa Airport",
  },
  {
    iata: "XBG",
    title: "Bogande Airport",
  },
  {
    iata: "DIP",
    title: "Diapaga Airport",
  },
  {
    iata: "DOR",
    title: "Dori Airport",
  },
  {
    iata: "FNG",
    title: "Fada N'gourma Airport",
  },
  {
    iata: "XGG",
    title: "Gorom-Gorom Airport",
  },
  {
    iata: "XKA",
    title: "Kantchari Airport",
  },
  {
    iata: "TMQ",
    title: "Tambao Airport",
  },
  {
    iata: "XPA",
    title: "Pama Airport",
  },
  {
    iata: "ARL",
    title: "Arly Airport",
  },
  {
    iata: "XSE",
    title: "Sebba Airport",
  },
  {
    iata: "TEG",
    title: "Tenkodogo Airport",
  },
  {
    iata: "OUA",
    title: "Ouagadougou Airport",
  },
  {
    iata: "BNR",
    title: "Banfora Airport",
  },
  {
    iata: "DGU",
    title: "Dedougou Airport",
  },
  {
    iata: "XGA",
    title: "Gaoua Airport",
  },
  {
    iata: "XNU",
    title: "Nouna Airport",
  },
  {
    iata: "BOY",
    title: "Bobo Dioulasso Airport",
  },
  {
    iata: "TUQ",
    title: "Tougan Airport",
  },
  {
    iata: "XDE",
    title: "Diebougou Airport",
  },
  {
    iata: "XAR",
    title: "Aribinda Airport",
  },
  {
    iata: "ACC",
    title: "Kotoka International Airport",
  },
  {
    iata: "TML",
    title: "Tamale Airport",
  },
  {
    iata: "KMS",
    title: "Kumasi Airport",
  },
  {
    iata: "NYI",
    title: "Sunyani Airport",
  },
  {
    iata: "TKD",
    title: "Takoradi Airport",
  },
  {
    iata: "DHB",
    title: "Deer Harbor SPB",
  },
  {
    iata: "ABJ",
    title: "Port Bouet Airport",
  },
  {
    iata: "OGO",
    title: "Abengourou Airport",
  },
  {
    iata: "BXI",
    title: "Boundiali Airport",
  },
  {
    iata: "BQO",
    title: "Bouna Airport",
  },
  {
    iata: "BDK",
    title: "Soko Airport",
  },
  {
    iata: "DIM",
    title: "Dimbokro Airport",
  },
  {
    iata: "DJO",
    title: "Daloa Airport",
  },
  {
    iata: "FEK",
    title: "Ferkessedougou Airport",
  },
  {
    iata: "GGN",
    title: "Gagnoa Airport",
  },
  {
    iata: "GGO",
    title: "Guiglo Airport",
  },
  {
    iata: "HGO",
    title: "Korhogo Airport",
  },
  {
    iata: "MJC",
    title: "Man Airport",
  },
  {
    iata: "KEO",
    title: "Odienne Airport",
  },
  {
    iata: "OFI",
    title: "Ouango Fitini Airport",
  },
  {
    iata: "SEO",
    title: "Seguela Airport",
  },
  {
    iata: "SPY",
    title: "San Pedro Airport",
  },
  {
    iata: "ZSS",
    title: "Sassandra Airport",
  },
  {
    iata: "TXU",
    title: "Tabou Airport",
  },
  {
    iata: "ASK",
    title: "Yamoussoukro Airport",
  },
  {
    iata: "DKA",
    title: "Katsina Airport",
  },
  {
    iata: "ABV",
    title: "Nnamdi Azikiwe International Airport",
  },
  {
    iata: "AKR",
    title: "Akure Airport",
  },
  {
    iata: "ABB",
    title: "Asaba International Airport",
  },
  {
    iata: "BNI",
    title: "Benin Airport",
  },
  {
    iata: "CBQ",
    title: "Margaret Ekpo International Airport",
  },
  {
    iata: "ENU",
    title: "Akanu Ibiam International Airport",
  },
  {
    iata: "QUS",
    title: "Gusau Airport",
  },
  {
    iata: "IBA",
    title: "Ibadan Airport",
  },
  {
    iata: "ILR",
    title: "Ilorin International Airport",
  },
  {
    iata: "QOW",
    title: "Sam Mbakwe International Airport",
  },
  {
    iata: "JOS",
    title: "Yakubu Gowon Airport",
  },
  {
    iata: "KAD",
    title: "Kaduna Airport",
  },
  {
    iata: "KAN",
    title: "Mallam Aminu International Airport",
  },
  {
    iata: "MIU",
    title: "Maiduguri International Airport",
  },
  {
    iata: "MDI",
    title: "Makurdi Airport",
  },
  {
    iata: "LOS",
    title: "Murtala Muhammed International Airport",
  },
  {
    iata: "MXJ",
    title: "Minna Airport",
  },
  {
    iata: "PHC",
    title: "Port Harcourt International Airport",
  },
  {
    iata: "SKO",
    title: "Sadiq Abubakar III International Airport",
  },
  {
    iata: "YOL",
    title: "Yola Airport",
  },
  {
    iata: "ZAR",
    title: "Zaria Airport",
  },
  {
    iata: "STI",
    title: "Santiago Municipal Airport",
  },
  {
    iata: "DQA",
    title: "Saertu Airport",
  },
  {
    iata: "MFQ",
    title: "Maradi Airport",
  },
  {
    iata: "NIM",
    title: "Diori Hamani International Airport",
  },
  {
    iata: "THZ",
    title: "Tahoua Airport",
  },
  {
    iata: "AJY",
    title: "Mano Dayak International Airport",
  },
  {
    iata: "ZND",
    title: "Zinder Airport",
  },
  {
    iata: "TBJ",
    title: "Tabarka 7 Novembre Airport",
  },
  {
    iata: "MIR",
    title: "Monastir Habib Bourguiba International Airport",
  },
  {
    iata: "TUN",
    title: "Tunis Carthage International Airport",
  },
  {
    iata: "OIZ",
    title: "Sidi Ahmed Air Base",
  },
  {
    iata: "GAF",
    title: "Gafsa Ksar International Airport",
  },
  {
    iata: "DJE",
    title: "Djerba Zarzis International Airport",
  },
  {
    iata: "EBM",
    title: "El Borma Airport",
  },
  {
    iata: "SFA",
    title: "Sfax Thyna International Airport",
  },
  {
    iata: "TOE",
    title: "Tozeur Nefta International Airport",
  },
  {
    iata: "DWR",
    title: "Dywer Airbase",
  },
  {
    iata: "LRL",
    title: "Niamtougou International Airport",
  },
  {
    iata: "ANR",
    title: "Antwerp International Airport (Deurne)",
  },
  {
    iata: "BRU",
    title: "Brussels Airport",
  },
  {
    iata: "CRL",
    title: "Brussels South Charleroi Airport",
  },
  {
    iata: "KJK",
    title: "Wevelgem Airport",
  },
  {
    iata: "OST",
    title: "Ostend-Bruges International Airport",
  },
  {
    iata: "QHA",
    title: "Hasselt Airport",
  },
  {
    iata: "OBL",
    title: "Oostmalle Air Base",
  },
  {
    iata: "AOC",
    title: "Altenburg-Nobitz Airport",
  },
  {
    iata: "HDF",
    title: "Heringsdorf Airport",
  },
  {
    iata: "BBH",
    title: "Barth Airport",
  },
  {
    iata: "ZMG",
    title: "Magdeburg Airport",
  },
  {
    iata: "CBU",
    title: "Cottbus-Drewitz Airport",
  },
  {
    iata: "DRS",
    title: "Dresden Airport",
  },
  {
    iata: "ERF",
    title: "Erfurt Airport",
  },
  {
    iata: "FRA",
    title: "Frankfurt am Main International Airport",
  },
  {
    iata: "FMO",
    title: "Muenster Osnabrueck Airport",
  },
  {
    iata: "HAM",
    title: "Hamburg Airport",
  },
  {
    iata: "THF",
    title: "Berlin-Tempelhof International Airport",
  },
  {
    iata: "CGN",
    title: "Cologne Bonn Airport",
  },
  {
    iata: "DUS",
    title: "Dusseldorf International Airport",
  },
  {
    iata: "MUC",
    title: "Munich International Airport",
  },
  {
    iata: "NUE",
    title: "Nuremberg Airport",
  },
  {
    iata: "LEJ",
    title: "Leipzig Halle Airport",
  },
  {
    iata: "STR",
    title: "Stuttgart Airport",
  },
  {
    iata: "TXL",
    title: "Berlin-Tegel International Airport",
  },
  {
    iata: "HAJ",
    title: "Hannover Airport",
  },
  {
    iata: "BRE",
    title: "Bremen Airport",
  },
  {
    iata: "QEF",
    title: "Frankfurt-Egelsbach Airport",
  },
  {
    iata: "HHN",
    title: "Frankfurt-Hahn Airport",
  },
  {
    iata: "MHG",
    title: "Mannheim-City Airport",
  },
  {
    iata: "ZQV",
    title: "Worms Airport",
  },
  {
    iata: "QMZ",
    title: "Mainz-Finthen Airport",
  },
  {
    iata: "SGE",
    title: "Siegerland Airport",
  },
  {
    iata: "XFW",
    title: "Hamburg-Finkenwerder Airport",
  },
  {
    iata: "KEL",
    title: "Kiel-Holtenau Airport",
  },
  {
    iata: "FMM",
    title: "Memmingen Allgau Airport",
  },
  {
    iata: "ESS",
    title: "Essen Mulheim Airport",
  },
  {
    iata: "BFE",
    title: "Bielefeld Airport",
  },
  {
    iata: "PAD",
    title: "Paderborn Lippstadt Airport",
  },
  {
    iata: "NRN",
    title: "Niederrhein Airport",
  },
  {
    iata: "DTM",
    title: "Dortmund Airport",
  },
  {
    iata: "AGB",
    title: "Augsburg Airport",
  },
  {
    iata: "OBF",
    title: "Oberpfaffenhofen Airport",
  },
  {
    iata: "RBM",
    title: "Straubing Airport",
  },
  {
    iata: "FDH",
    title: "Friedrichshafen Airport",
  },
  {
    iata: "FRF",
    title: "Oschersleben Airport",
  },
  {
    iata: "SZW",
    title: "Schwerin Parchim Airport",
  },
  {
    iata: "BYU",
    title: "Bayreuth Airport",
  },
  {
    iata: "QOB",
    title: "Ansbach-Petersdorf Airport",
  },
  {
    iata: "HOQ",
    title: "Hof-Plauen Airport",
  },
  {
    iata: "BBJ",
    title: "Bitburg Airport",
  },
  {
    iata: "FKB",
    title: "Karlsruhe Baden-Baden Airport",
  },
  {
    iata: "ZQL",
    title: "Donaueschingen-Villingen Airport",
  },
  {
    iata: "LHA",
    title: "Lahr Airport",
  },
  {
    iata: "BWE",
    title: "Braunschweig Wolfsburg Airport",
  },
  {
    iata: "KSF",
    title: "Kassel-Calden Airport",
  },
  {
    iata: "BRV",
    title: "Bremerhaven Airport",
  },
  {
    iata: "XLW",
    title: "Lemwerder Airport",
  },
  {
    iata: "EME",
    title: "Emden Airport",
  },
  {
    iata: "AGE",
    title: "Wangerooge Airport",
  },
  {
    iata: "WVN",
    title: "Wilhelmshaven-Mariensiel Airport",
  },
  {
    iata: "JUI",
    title: "Juist Airport",
  },
  {
    iata: "LGO",
    title: "Langeoog Airport",
  },
  {
    iata: "ZOW",
    title: "Nordhorn-Lingen Airport",
  },
  {
    iata: "BMK",
    title: "Borkum Airport",
  },
  {
    iata: "NOD",
    title: "Norden-Norddeich Airport",
  },
  {
    iata: "VAC",
    title: "Varrelbusch Airport",
  },
  {
    iata: "NRD",
    title: "Norderney Airport",
  },
  {
    iata: "BMR",
    title: "Baltrum Airport",
  },
  {
    iata: "PSH",
    title: "St. Peter-Ording Airport",
  },
  {
    iata: "GWT",
    title: "Westerland Sylt Airport",
  },
  {
    iata: "URE",
    title: "Kuressaare Airport",
  },
  {
    iata: "TLL",
    title: "Tallinn Airport",
  },
  {
    iata: "TAY",
    title: "Tartu Airport",
  },
  {
    iata: "ENF",
    title: "Enontekio Airport",
  },
  {
    iata: "QVE",
    title: "Forssa Airport",
  },
  {
    iata: "KEV",
    title: "Halli Airport",
  },
  {
    iata: "HEM",
    title: "Helsinki Malmi Airport",
  },
  {
    iata: "HEL",
    title: "Helsinki Vantaa Airport",
  },
  {
    iata: "HYV",
    title: "Hyvinkaa Airport",
  },
  {
    iata: "KTQ",
    title: "Kitee Airport",
  },
  {
    iata: "IVL",
    title: "Ivalo Airport",
  },
  {
    iata: "JOE",
    title: "Joensuu Airport",
  },
  {
    iata: "JYV",
    title: "Jyvaskyla Airport",
  },
  {
    iata: "KAU",
    title: "Kauhava Airport",
  },
  {
    iata: "KEM",
    title: "Kemi-Tornio Airport",
  },
  {
    iata: "KAJ",
    title: "Kajaani Airport",
  },
  {
    iata: "KHJ",
    title: "Kauhajoki Airport",
  },
  {
    iata: "KOK",
    title: "Kruunupyy Airport",
  },
  {
    iata: "KAO",
    title: "Kuusamo Airport",
  },
  {
    iata: "KTT",
    title: "Kittila Airport",
  },
  {
    iata: "KUO",
    title: "Kuopio Airport",
  },
  {
    iata: "QLF",
    title: "Lahti Vesivehmaa Airport",
  },
  {
    iata: "LPP",
    title: "Lappeenranta Airport",
  },
  {
    iata: "MHQ",
    title: "Mariehamn Airport",
  },
  {
    iata: "MIK",
    title: "Mikkeli Airport",
  },
  {
    iata: "OUL",
    title: "Oulu Airport",
  },
  {
    iata: "POR",
    title: "Pori Airport",
  },
  {
    iata: "RVN",
    title: "Rovaniemi Airport",
  },
  {
    iata: "SVL",
    title: "Savonlinna Airport",
  },
  {
    iata: "SOT",
    title: "Sodankyla Airport",
  },
  {
    iata: "TMP",
    title: "Tampere-Pirkkala Airport",
  },
  {
    iata: "TKU",
    title: "Turku Airport",
  },
  {
    iata: "UTI",
    title: "Utti Air Base",
  },
  {
    iata: "VAA",
    title: "Vaasa Airport",
  },
  {
    iata: "VRK",
    title: "Varkaus Airport",
  },
  {
    iata: "YLI",
    title: "Ylivieska Airport",
  },
  {
    iata: "AUE",
    title: "Abu Rudeis Airport",
  },
  {
    iata: "BFS",
    title: "Belfast International Airport",
  },
  {
    iata: "ENK",
    title: "St Angelo Airport",
  },
  {
    iata: "BHD",
    title: "George Best Belfast City Airport",
  },
  {
    iata: "LDY",
    title: "City of Derry Airport",
  },
  {
    iata: "BHX",
    title: "Birmingham International Airport",
  },
  {
    iata: "CVT",
    title: "Coventry Airport",
  },
  {
    iata: "GLO",
    title: "Gloucestershire Airport",
  },
  {
    iata: "ORM",
    title: "Sywell Aerodrome",
  },
  {
    iata: "NQT",
    title: "Nottingham Airport",
  },
  {
    iata: "MAN",
    title: "Manchester Airport",
  },
  {
    iata: "XXB",
    title: "Manchester Woodford Airport",
  },
  {
    iata: "DSA",
    title: "Robin Hood Doncaster Sheffield Airport",
  },
  {
    iata: "LYE",
    title: "RAF Lyneham",
  },
  {
    iata: "DGX",
    title: "MOD St. Athan",
  },
  {
    iata: "YEO",
    title: "RNAS Yeovilton",
  },
  {
    iata: "CAL",
    title: "Campbeltown Airport",
  },
  {
    iata: "EOI",
    title: "Eday Airport",
  },
  {
    iata: "FIE",
    title: "Fair Isle Airport",
  },
  {
    iata: "WHS",
    title: "Whalsay Airport",
  },
  {
    iata: "COL",
    title: "Coll Airport",
  },
  {
    iata: "NRL",
    title: "North Ronaldsay Airport",
  },
  {
    iata: "OBN",
    title: "Oban Airport",
  },
  {
    iata: "PPW",
    title: "Papa Westray Airport",
  },
  {
    iata: "SOY",
    title: "Stronsay Airport",
  },
  {
    iata: "NDY",
    title: "Sanday Airport",
  },
  {
    iata: "LWK",
    title: "Lerwick / Tingwall Airport",
  },
  {
    iata: "WRY",
    title: "Westray Airport",
  },
  {
    iata: "CSA",
    title: "Colonsay Airstrip",
  },
  {
    iata: "HAW",
    title: "Haverfordwest Airport",
  },
  {
    iata: "CWL",
    title: "Cardiff International Airport",
  },
  {
    iata: "SWS",
    title: "Swansea Airport",
  },
  {
    iata: "BRS",
    title: "Bristol International Airport",
  },
  {
    iata: "LPL",
    title: "Liverpool John Lennon Airport",
  },
  {
    iata: "LTN",
    title: "London Luton Airport",
  },
  {
    iata: "LEQ",
    title: "Land's End Airport",
  },
  {
    iata: "PLH",
    title: "Plymouth City Airport",
  },
  {
    iata: "ISC",
    title: "St. Mary's Airport",
  },
  {
    iata: "BOH",
    title: "Bournemouth Airport",
  },
  {
    iata: "SOU",
    title: "Southampton Airport",
  },
  {
    iata: "BBP",
    title: "Bembridge Airport",
  },
  {
    iata: "PZE",
    title: "Penzance Heliport",
  },
  {
    iata: "QLA",
    title: "Lasham Airport",
  },
  {
    iata: "NQY",
    title: "Newquay Cornwall Airport",
  },
  {
    iata: "QUG",
    title: "Chichester/Goodwood Airport",
  },
  {
    iata: "ACI",
    title: "Alderney Airport",
  },
  {
    iata: "GCI",
    title: "Guernsey Airport",
  },
  {
    iata: "JER",
    title: "Jersey Airport",
  },
  {
    iata: "ESH",
    title: "Shoreham Airport",
  },
  {
    iata: "BQH",
    title: "London Biggin Hill Airport",
  },
  {
    iata: "LGW",
    title: "London Gatwick Airport",
  },
  {
    iata: "KRH",
    title: "Redhill Aerodrome",
  },
  {
    iata: "LCY",
    title: "London City Airport",
  },
  {
    iata: "FAB",
    title: "Farnborough Airport",
  },
  {
    iata: "BBS",
    title: "Blackbushe Airport",
  },
  {
    iata: "LHR",
    title: "London Heathrow Airport",
  },
  {
    iata: "SEN",
    title: "Southend Airport",
  },
  {
    iata: "LYX",
    title: "Lydd Airport",
  },
  {
    iata: "MSE",
    title: "Kent International Airport",
  },
  {
    iata: "CAX",
    title: "Carlisle Airport",
  },
  {
    iata: "BLK",
    title: "Blackpool International Airport",
  },
  {
    iata: "HUY",
    title: "Humberside Airport",
  },
  {
    iata: "BWF",
    title: "Barrow Walney Island Airport",
  },
  {
    iata: "LBA",
    title: "Leeds Bradford Airport",
  },
  {
    iata: "CEG",
    title: "Hawarden Airport",
  },
  {
    iata: "IOM",
    title: "Isle of Man Airport",
  },
  {
    iata: "NCL",
    title: "Newcastle Airport",
  },
  {
    iata: "MME",
    title: "Durham Tees Valley Airport",
  },
  {
    iata: "EMA",
    title: "East Midlands Airport",
  },
  {
    iata: "HLY",
    title: "Anglesey Airport",
  },
  {
    iata: "KOI",
    title: "Kirkwall Airport",
  },
  {
    iata: "LSI",
    title: "Sumburgh Airport",
  },
  {
    iata: "WIC",
    title: "Wick Airport",
  },
  {
    iata: "ABZ",
    title: "Aberdeen Dyce Airport",
  },
  {
    iata: "INV",
    title: "Inverness Airport",
  },
  {
    iata: "GLA",
    title: "Glasgow International Airport",
  },
  {
    iata: "EDI",
    title: "Edinburgh Airport",
  },
  {
    iata: "ILY",
    title: "Islay Airport",
  },
  {
    iata: "PIK",
    title: "Glasgow Prestwick Airport",
  },
  {
    iata: "BEB",
    title: "Benbecula Airport",
  },
  {
    iata: "SCS",
    title: "Scatsta Airport",
  },
  {
    iata: "DND",
    title: "Dundee Airport",
  },
  {
    iata: "SYY",
    title: "Stornoway Airport",
  },
  {
    iata: "BRR",
    title: "Barra Airport",
  },
  {
    iata: "PSL",
    title: "Perth/Scone Airport",
  },
  {
    iata: "TRE",
    title: "Tiree Airport",
  },
  {
    iata: "UNT",
    title: "Unst Airport",
  },
  {
    iata: "BOL",
    title: "Ballykelly Airport",
  },
  {
    iata: "FSS",
    title: "RAF Kinloss",
  },
  {
    iata: "ADX",
    title: "RAF Leuchars",
  },
  {
    iata: "LMO",
    title: "RAF Lossiemouth",
  },
  {
    iata: "CBG",
    title: "Cambridge Airport",
  },
  {
    iata: "NWI",
    title: "Norwich International Airport",
  },
  {
    iata: "STN",
    title: "London Stansted Airport",
  },
  {
    iata: "QFO",
    title: "Duxford Airport",
  },
  {
    iata: "SZE",
    title: "Sheffield City Heliport",
  },
  {
    iata: "EXT",
    title: "Exeter International Airport",
  },
  {
    iata: "FRK",
    title: "Fairoaks Airport",
  },
  {
    iata: "FZO",
    title: "Bristol Filton Airport",
  },
  {
    iata: "OXF",
    title: "Oxford (Kidlington) Airport",
  },
  {
    iata: "RCS",
    title: "Rochester Airport",
  },
  {
    iata: "BEX",
    title: "RAF Benson",
  },
  {
    iata: "LKZ",
    title: "RAF Lakenheath",
  },
  {
    iata: "MHZ",
    title: "RAF Mildenhall",
  },
  {
    iata: "QUY",
    title: "RAF Wyton",
  },
  {
    iata: "FFD",
    title: "RAF Fairford",
  },
  {
    iata: "BZZ",
    title: "RAF Brize Norton",
  },
  {
    iata: "ODH",
    title: "RAF Odiham",
  },
  {
    iata: "WXF",
    title: "Wethersfield Airport",
  },
  {
    iata: "ADV",
    title: "Andover Airfield",
  },
  {
    iata: "NHT",
    title: "RAF Northolt",
  },
  {
    iata: "GSY",
    title: "Binbrook Airfield",
  },
  {
    iata: "QCY",
    title: "RAF Coningsby",
  },
  {
    iata: "BEQ",
    title: "RAF Honington",
  },
  {
    iata: "OKH",
    title: "RAF Cottesmore",
  },
  {
    iata: "SQZ",
    title: "RAF Scampton",
  },
  {
    iata: "HRT",
    title: "RAF Linton-On-Ouse",
  },
  {
    iata: "WTN",
    title: "RAF Waddington",
  },
  {
    iata: "MRH",
    title: "RAF Marham",
  },
  {
    iata: "MPN",
    title: "Mount Pleasant Airport",
  },
  {
    iata: "AMS",
    title: "Amsterdam Airport Schiphol",
  },
  {
    iata: "MST",
    title: "Maastricht Aachen Airport",
  },
  {
    iata: "QAR",
    title: "Deelen Air Base",
  },
  {
    iata: "EIN",
    title: "Eindhoven Airport",
  },
  {
    iata: "GRQ",
    title: "Eelde Airport",
  },
  {
    iata: "GLZ",
    title: "Gilze Rijen Air Base",
  },
  {
    iata: "DHR",
    title: "De Kooy Airport",
  },
  {
    iata: "LEY",
    title: "Lelystad Airport",
  },
  {
    iata: "LWR",
    title: "Leeuwarden Air Base",
  },
  {
    iata: "RTM",
    title: "Rotterdam Airport",
  },
  {
    iata: "UTC",
    title: "Soesterberg Air Base",
  },
  {
    iata: "ENS",
    title: "Twenthe Airport",
  },
  {
    iata: "LID",
    title: "Valkenburg Naval Air Base",
  },
  {
    iata: "UDE",
    title: "Volkel Air Base",
  },
  {
    iata: "WOE",
    title: "Woensdrecht Air Base",
  },
  {
    iata: "BYT",
    title: "Bantry Aerodrome",
  },
  {
    iata: "BLY",
    title: "Belmullet Aerodrome",
  },
  {
    iata: "NNR",
    title: "Connemara Regional Airport",
  },
  {
    iata: "CLB",
    title: "Castlebar Airport",
  },
  {
    iata: "WEX",
    title: "Castlebridge Airport",
  },
  {
    iata: "ORK",
    title: "Cork Airport",
  },
  {
    iata: "GWY",
    title: "Galway Airport",
  },
  {
    iata: "CFN",
    title: "Donegal Airport",
  },
  {
    iata: "DUB",
    title: "Dublin Airport",
  },
  {
    iata: "IOR",
    title: "Inishmore Aerodrome",
  },
  {
    iata: "INQ",
    title: "Inisheer Aerodrome",
  },
  {
    iata: "KKY",
    title: "Kilkenny Airport",
  },
  {
    iata: "NOC",
    title: "Ireland West Knock Airport",
  },
  {
    iata: "KIR",
    title: "Kerry Airport",
  },
  {
    iata: "LTR",
    title: "Letterkenny Airport",
  },
  {
    iata: "IIA",
    title: "Inishmaan Aerodrome",
  },
  {
    iata: "SNN",
    title: "Shannon Airport",
  },
  {
    iata: "SXL",
    title: "Sligo Airport",
  },
  {
    iata: "WAT",
    title: "Waterford Airport",
  },
  {
    iata: "AAR",
    title: "Aarhus Airport",
  },
  {
    iata: "BLL",
    title: "Billund Airport",
  },
  {
    iata: "CPH",
    title: "Copenhagen Kastrup Airport",
  },
  {
    iata: "EBJ",
    title: "Esbjerg Airport",
  },
  {
    iata: "KRP",
    title: "Karup Airport",
  },
  {
    iata: "MRW",
    title: "Lolland Falster Maribo Airport",
  },
  {
    iata: "ODE",
    title: "Odense Airport",
  },
  {
    iata: "RKE",
    title: "Copenhagen Roskilde Airport",
  },
  {
    iata: "RNN",
    title: "Bornholm Airport",
  },
  {
    iata: "CNL",
    title: "Sindal Airport",
  },
  {
    iata: "SKS",
    title: "Vojens Skrydstrup Airport",
  },
  {
    iata: "SQW",
    title: "Skive Airport",
  },
  {
    iata: "TED",
    title: "Thisted Airport",
  },
  {
    iata: "VDP",
    title: "Kolding Vamdrup Airport",
  },
  {
    iata: "FAE",
    title: "Vagar Airport",
  },
  {
    iata: "STA",
    title: "Stauning Airport",
  },
  {
    iata: "AAL",
    title: "Aalborg Airport",
  },
  {
    iata: "LUX",
    title: "Luxembourg-Findel International Airport",
  },
  {
    iata: "ALF",
    title: "Alta Airport",
  },
  {
    iata: "FDE",
    title: "Bringeland Airport",
  },
  {
    iata: "BGO",
    title: "Bergen Airport, Flesland",
  },
  {
    iata: "KRS",
    title: "Kristiansand Airport",
  },
  {
    iata: "DLD",
    title: "Geilo Airport Dagali",
  },
  {
    iata: "BDU",
    title: "Bardufoss Airport",
  },
  {
    iata: "EVE",
    title: "Harstad/Narvik Airport, Evenes",
  },
  {
    iata: "FBU",
    title: "Oslo, Fornebu Airport",
  },
  {
    iata: "VDB",
    title: "Leirin Airport",
  },
  {
    iata: "OSL",
    title: "Oslo Gardermoen Airport",
  },
  {
    iata: "HMR",
    title: "Stafsberg Airport",
  },
  {
    iata: "HAU",
    title: "Haugesund Airport",
  },
  {
    iata: "HFT",
    title: "Hammerfest Airport",
  },
  {
    iata: "HAA",
    title: "Hasvik Airport",
  },
  {
    iata: "HVG",
    title: "Valan Airport",
  },
  {
    iata: "QKX",
    title: "Kautokeino Air Base",
  },
  {
    iata: "KSU",
    title: "Kristiansund Airport, Kvernberget",
  },
  {
    iata: "GLL",
    title: "Gol Airport",
  },
  {
    iata: "FAN",
    title: "Lista Airport",
  },
  {
    iata: "LKN",
    title: "Leknes Airport",
  },
  {
    iata: "MEH",
    title: "Mehamn Airport",
  },
  {
    iata: "MOL",
    title: "Molde Airport",
  },
  {
    iata: "LKL",
    title: "Banak Airport",
  },
  {
    iata: "NVK",
    title: "Narvik Framnes Airport",
  },
  {
    iata: "NTB",
    title: "Notodden Airport",
  },
  {
    iata: "RYG",
    title: "Moss Airport, Rygge",
  },
  {
    iata: "LYR",
    title: "Svalbard Airport, Longyear",
  },
  {
    iata: "SDN",
    title: "Sandane Airport, Anda",
  },
  {
    iata: "SOG",
    title: "Sogndal Airport",
  },
  {
    iata: "SKN",
    title: "Stokmarknes Skagen Airport",
  },
  {
    iata: "SKE",
    title: "Skien Airport",
  },
  {
    iata: "SRP",
    title: "Stord Airport",
  },
  {
    iata: "TRF",
    title: "Sandefjord Airport, Torp",
  },
  {
    iata: "SVG",
    title: "Stavanger Airport, Sola",
  },
  {
    iata: "QYY",
    title: "Bia?ystok-Krywlany Airport",
  },
  {
    iata: "BZG",
    title: "Bydgoszcz Ignacy Jan Paderewski Airport",
  },
  {
    iata: "CZW",
    title: "Cz?stochowa-Rudniki",
  },
  {
    iata: "GDN",
    title: "Gda?sk Lech Wa??sa Airport",
  },
  {
    iata: "QLC",
    title: "Gliwice Glider Airport",
  },
  {
    iata: "OSZ",
    title: "Koszalin Zegrze Airport",
  },
  {
    iata: "KTW",
    title: "Katowice International Airport",
  },
  {
    iata: "QEO",
    title: "Bielsko-Bialo Kaniow Airfield",
  },
  {
    iata: "QLU",
    title: "Lublin Radwiec Airport",
  },
  {
    iata: "QWS",
    title: "Nowy Targ Airport",
  },
  {
    iata: "QYD",
    title: "Gdynia-Babie Do?y Air Base",
  },
  {
    iata: "QPM",
    title: "Opole-Polska Nowa Wie? Airport",
  },
  {
    iata: "POZ",
    title: "Pozna?-?awica Airport",
  },
  {
    iata: "OSP",
    title: "Redzikowo Air Base",
  },
  {
    iata: "SZY",
    title: "Szczytno-Szymany International Airport",
  },
  {
    iata: "WAW",
    title: "Warsaw Chopin Airport",
  },
  {
    iata: "WRO",
    title: "Copernicus Wroc?aw Airport",
  },
  {
    iata: "RNB",
    title: "Ronneby Airport",
  },
  {
    iata: "GOT",
    title: "Gothenburg-Landvetter Airport",
  },
  {
    iata: "GSE",
    title: "Gothenburg City Airport",
  },
  {
    iata: "KSK",
    title: "Karlskoga Airport",
  },
  {
    iata: "MXX",
    title: "Mora Airport",
  },
  {
    iata: "NYO",
    title: "Stockholm Skavsta Airport",
  },
  {
    iata: "KID",
    title: "Kristianstad Airport",
  },
  {
    iata: "OSK",
    title: "Oskarshamn Airport",
  },
  {
    iata: "KLR",
    title: "Kalmar Airport",
  },
  {
    iata: "HAD",
    title: "Halmstad Airport",
  },
  {
    iata: "EVG",
    title: "Sveg Airport",
  },
  {
    iata: "HUV",
    title: "Hudiksvall Airport",
  },
  {
    iata: "LYC",
    title: "Lycksele Airport",
  },
  {
    iata: "KRN",
    title: "Kiruna Airport",
  },
  {
    iata: "VHM",
    title: "Vilhelmina Airport",
  },
  {
    iata: "AJR",
    title: "Arvidsjaur Airport",
  },
  {
    iata: "HFS",
    title: "Hagfors Airport",
  },
  {
    iata: "KSD",
    title: "Karlstad Airport",
  },
  {
    iata: "ARN",
    title: "Stockholm-Arlanda Airport",
  },
  {
    iata: "BMA",
    title: "Stockholm-Bromma Airport",
  },
  {
    iata: "BLE",
    title: "Borlange Airport",
  },
  {
    iata: "HLF",
    title: "Hultsfred Airport",
  },
  {
    iata: "TYF",
    title: "Torsby Airport",
  },
  {
    iata: "EKT",
    title: "Eskilstuna Airport",
  },
  {
    iata: "VBY",
    title: "Visby Airport",
  },
  {
    iata: "SQO",
    title: "Storuman Airport",
  },
  {
    iata: "IDB",
    title: "Idre Airport",
  },
  {
    iata: "PJA",
    title: "Pajala Airport",
  },
  {
    iata: "HMV",
    title: "Hemavan Airport",
  },
  {
    iata: "GLC",
    title: "Geladi Airport",
  },
  {
    iata: "SHC",
    title: "Shire Inda Selassie Airport",
  },
  {
    iata: "SPM",
    title: "Spangdahlem Air Base",
  },
  {
    iata: "RMS",
    title: "Ramstein Air Base",
  },
  {
    iata: "ZCD",
    title: "Bamberg-Breitenau Airport",
  },
  {
    iata: "ZCN",
    title: "Celle Airport",
  },
  {
    iata: "ZPQ",
    title: "Rheine Bentlage Airport",
  },
  {
    iata: "FRZ",
    title: "Fritzlar Airport",
  },
  {
    iata: "ZNF",
    title: "Hanau Army Air Field",
  },
  {
    iata: "QHD",
    title: "Heidelberg Army Heliport",
  },
  {
    iata: "NDZ",
    title: "Nordholz Airport",
  },
  {
    iata: "GKE",
    title: "Geilenkirchen Airport",
  },
  {
    iata: "RLG",
    title: "Rostock-Laage Airport",
  },
  {
    iata: "QOE",
    title: "Norvenich Airport",
  },
  {
    iata: "WBG",
    title: "Schleswig Airport",
  },
  {
    iata: "FNB",
    title: "Neubrandenburg Airport",
  },
  {
    iata: "WIE",
    title: "Wiesbaden Army Airfield",
  },
  {
    iata: "IGS",
    title: "Ingolstadt Manching Airport",
  },
  {
    iata: "BGN",
    title: "Brugge Air Base",
  },
  {
    iata: "LPX",
    title: "Liep?ja International Airport",
  },
  {
    iata: "RIX",
    title: "Riga International Airport",
  },
  {
    iata: "VNT",
    title: "Ventspils International Airport",
  },
  {
    iata: "EXI",
    title: "Excursion Inlet Seaplane Base",
  },
  {
    iata: "KUN",
    title: "Kaunas International Airport",
  },
  {
    iata: "KLJ",
    title: "Klaip?da Airport",
  },
  {
    iata: "PLQ",
    title: "Palanga International Airport",
  },
  {
    iata: "HLJ",
    title: "Barysiai Airport",
  },
  {
    iata: "VNO",
    title: "Vilnius International Airport",
  },
  {
    iata: "ALJ",
    title: "Alexander Bay Airport",
  },
  {
    iata: "AGZ",
    title: "Aggeneys Airport",
  },
  {
    iata: "ADY",
    title: "Alldays Airport",
  },
  {
    iata: "BIY",
    title: "Bisho Airport",
  },
  {
    iata: "BFN",
    title: "J B M Hertzog International Airport",
  },
  {
    iata: "UTE",
    title: "Butterworth Airport",
  },
  {
    iata: "CDO",
    title: "Gradock Airport",
  },
  {
    iata: "CPT",
    title: "Cape Town International Airport",
  },
  {
    iata: "DUK",
    title: "Mubatuba Airport",
  },
  {
    iata: "PZL",
    title: "Zulu Inyala Airport",
  },
  {
    iata: "ELS",
    title: "Ben Schoeman Airport",
  },
  {
    iata: "EMG",
    title: "Empangeni Airport",
  },
  {
    iata: "ELL",
    title: "Ellisras Matimba Airport",
  },
  {
    iata: "FCB",
    title: "Ficksburg Sentraoes Airport",
  },
  {
    iata: "GCJ",
    title: "Grand Central Airport",
  },
  {
    iata: "GRJ",
    title: "George Airport",
  },
  {
    iata: "GIY",
    title: "Giyani Airport",
  },
  {
    iata: "QRA",
    title: "Rand Airport",
  },
  {
    iata: "HLW",
    title: "Hluhluwe Airport",
  },
  {
    iata: "HRS",
    title: "Harrismith Airport",
  },
  {
    iata: "HDS",
    title: "Hoedspruit Air Force Base Airport",
  },
  {
    iata: "JNB",
    title: "OR Tambo International Airport",
  },
  {
    iata: "KXE",
    title: "P C Pelser Airport",
  },
  {
    iata: "KIM",
    title: "Kimberley Airport",
  },
  {
    iata: "MQP",
    title: "Kruger Mpumalanga International Airport",
  },
  {
    iata: "KOF",
    title: "Komatipoort Airport",
  },
  {
    iata: "KMH",
    title: "Johan Pienaar Airport",
  },
  {
    iata: "KLZ",
    title: "Kleinsee Airport",
  },
  {
    iata: "HLA",
    title: "Lanseria Airport",
  },
  {
    iata: "LMR",
    title: "Lime Acres Finsch Mine Airport",
  },
  {
    iata: "LDZ",
    title: "Londolozi Airport",
  },
  {
    iata: "DUR",
    title: "King Shaka International Airport",
  },
  {
    iata: "LUJ",
    title: "Lusikisiki Airport",
  },
  {
    iata: "LCD",
    title: "Louis Trichardt Airport",
  },
  {
    iata: "LGE",
    title: "Langebaanweg Airport",
  },
  {
    iata: "LAY",
    title: "Ladysmith Airport",
  },
  {
    iata: "AAM",
    title: "Malamala Airport",
  },
  {
    iata: "MGH",
    title: "Margate Airport",
  },
  {
    iata: "MBD",
    title: "Mmabatho International Airport",
  },
  {
    iata: "LLE",
    title: "Riverside Airport",
  },
  {
    iata: "MZY",
    title: "Mossel Bay Airport",
  },
  {
    iata: "MEZ",
    title: "Morningside Farm Airport",
  },
  {
    iata: "MZQ",
    title: "Mkuze Airport",
  },
  {
    iata: "NCS",
    title: "Newcastle Airport",
  },
  {
    iata: "NGL",
    title: "Ngala Airport",
  },
  {
    iata: "NLP",
    title: "Nelspruit Airport",
  },
  {
    iata: "OVG",
    title: "Overberg Airport",
  },
  {
    iata: "OUH",
    title: "Oudtshoorn Airport",
  },
  {
    iata: "AFD",
    title: "Port Alfred Airport",
  },
  {
    iata: "PLZ",
    title: "Port Elizabeth Airport",
  },
  {
    iata: "PBZ",
    title: "Plettenberg Bay Airport",
  },
  {
    iata: "PHW",
    title: "Hendrik Van Eck Airport",
  },
  {
    iata: "PTG",
    title: "Pietersburg Municipal Airport",
  },
  {
    iata: "JOH",
    title: "Port St Johns Airport",
  },
  {
    iata: "PRK",
    title: "Prieska Airport",
  },
  {
    iata: "PZB",
    title: "Pietermaritzburg Airport",
  },
  {
    iata: "NTY",
    title: "Pilanesberg International Airport",
  },
  {
    iata: "PTG",
    title: "Polokwane International Airport",
  },
  {
    iata: "PCF",
    title: "Potchefstroom Airport",
  },
  {
    iata: "UTW",
    title: "Queenstown Airport",
  },
  {
    iata: "RCB",
    title: "Richards Bay Airport",
  },
  {
    iata: "RVO",
    title: "Reivilo Airport",
  },
  {
    iata: "ROD",
    title: "Robertson Airport",
  },
  {
    iata: "SBU",
    title: "Springbok Airport",
  },
  {
    iata: "ZEC",
    title: "Secunda Airport",
  },
  {
    iata: "SDB",
    title: "Saldanha /Vredenburg Airport",
  },
  {
    iata: "GSS",
    title: "Sabi Sabi Airport",
  },
  {
    iata: "SIS",
    title: "Sishen Airport",
  },
  {
    iata: "SZK",
    title: "Skukuza Airport",
  },
  {
    iata: "THY",
    title: "Thohoyandou Airport",
  },
  {
    iata: "TCU",
    title: "Thaba Nchu Tar Airport",
  },
  {
    iata: "LTA",
    title: "Tzaneen Airport",
  },
  {
    iata: "ULD",
    title: "Prince Mangosuthu Buthelezi Airport",
  },
  {
    iata: "UTN",
    title: "Pierre Van Ryneveld Airport",
  },
  {
    iata: "UTT",
    title: "K. D. Matanzima Airport",
  },
  {
    iata: "VRU",
    title: "Vryburg Airport",
  },
  {
    iata: "VIR",
    title: "Virginia Airport",
  },
  {
    iata: "VRE",
    title: "Vredendal Airport",
  },
  {
    iata: "VYD",
    title: "Vryheid Airport",
  },
  {
    iata: "PRY",
    title: "Wonderboom Airport",
  },
  {
    iata: "AFB",
    title: "Waterkloof Air Force Base Airport",
  },
  {
    iata: "WEL",
    title: "Welkom Airport",
  },
  {
    iata: "FRW",
    title: "Francistown Airport",
  },
  {
    iata: "GNZ",
    title: "Ghanzi Airport",
  },
  {
    iata: "JWA",
    title: "Jwaneng Airport",
  },
  {
    iata: "BBK",
    title: "Kasane Airport",
  },
  {
    iata: "KHW",
    title: "Khwai River Lodge Airport",
  },
  {
    iata: "MUB",
    title: "Maun Airport",
  },
  {
    iata: "ORP",
    title: "Orapa Airport",
  },
  {
    iata: "QPH",
    title: "Palapye Airport",
  },
  {
    iata: "GBE",
    title: "Sir Seretse Khama International Airport",
  },
  {
    iata: "SXN",
    title: "Sua Pan Airport",
  },
  {
    iata: "PKW",
    title: "Selebi Phikwe Airport",
  },
  {
    iata: "SWX",
    title: "Shakawe Airport",
  },
  {
    iata: "TLD",
    title: "Limpopo Valley Airport",
  },
  {
    iata: "TBY",
    title: "Tshabong Airport",
  },
  {
    iata: "BZV",
    title: "Maya-Maya Airport",
  },
  {
    iata: "DJM",
    title: "Djambala Airport",
  },
  {
    iata: "KNJ",
    title: "Kindamba Airport",
  },
  {
    iata: "LCO",
    title: "Lague Airport",
  },
  {
    iata: "MUY",
    title: "Mouyondzi Airport",
  },
  {
    iata: "SIB",
    title: "Sibiti Airport",
  },
  {
    iata: "NKY",
    title: "Yokangassi Airport",
  },
  {
    iata: "ANJ",
    title: "Zanaga Airport",
  },
  {
    iata: "MSX",
    title: "Mossendjo Airport",
  },
  {
    iata: "BOE",
    title: "Boundji Airport",
  },
  {
    iata: "EWO",
    title: "Ewo Airport",
  },
  {
    iata: "GMM",
    title: "Gamboma Airport",
  },
  {
    iata: "ION",
    title: "Impfondo Airport",
  },
  {
    iata: "KEE",
    title: "Kelle Airport",
  },
  {
    iata: "MKJ",
    title: "Makoua Airport",
  },
  {
    iata: "FTX",
    title: "Owando Airport",
  },
  {
    iata: "SOE",
    title: "Souanke Airport",
  },
  {
    iata: "BTB",
    title: "Betou Airport",
  },
  {
    iata: "OUE",
    title: "Ouesso Airport",
  },
  {
    iata: "KMK",
    title: "Makabana Airport",
  },
  {
    iata: "DIS",
    title: "Loubomo Airport",
  },
  {
    iata: "PNR",
    title: "Pointe Noire Airport",
  },
  {
    iata: "MTS",
    title: "Matsapha Airport",
  },
  {
    iata: "FEA",
    title: "Fetlar Airport",
  },
  {
    iata: "CRF",
    title: "Carnot Airport",
  },
  {
    iata: "BGF",
    title: "Bangui M'Poko International Airport",
  },
  {
    iata: "BGU",
    title: "Bangassou Airport",
  },
  {
    iata: "IRO",
    title: "Birao Airport",
  },
  {
    iata: "BBY",
    title: "Bambari Airport",
  },
  {
    iata: "BOP",
    title: "Bouar Airport",
  },
  {
    iata: "BIV",
    title: "Bria Airport",
  },
  {
    iata: "BSN",
    title: "Bossangoa Airport",
  },
  {
    iata: "ODA",
    title: "Ouadda Airport",
  },
  {
    iata: "AIG",
    title: "Yalinga Airport",
  },
  {
    iata: "IMO",
    title: "Zemio Airport",
  },
  {
    iata: "MKI",
    title: "M'Boki Airport",
  },
  {
    iata: "BTG",
    title: "Batangafo Airport",
  },
  {
    iata: "GDI",
    title: "Gordil Airport",
  },
  {
    iata: "BMF",
    title: "Bakouma Airport",
  },
  {
    iata: "BCF",
    title: "Bouca Airport",
  },
  {
    iata: "BOZ",
    title: "Bozoum Airport",
  },
  {
    iata: "FEW",
    title: "Francis E Warren Air Force Base",
  },
  {
    iata: "BSG",
    title: "Bata Airport",
  },
  {
    iata: "SSG",
    title: "Malabo Airport",
  },
  {
    iata: "ASI",
    title: "RAF Ascension Island",
  },
  {
    iata: "MRU",
    title: "Sir Seewoosagur Ramgoolam International Airport",
  },
  {
    iata: "RRG",
    title: "Sir Charles Gaetan Duval Airport",
  },
  {
    iata: "FIN",
    title: "Finschhafen Airport",
  },
  {
    iata: "NKW",
    title: "Diego Garcia Naval Support Facility",
  },
  {
    iata: "NKS",
    title: "Nkongsamba Airport",
  },
  {
    iata: "KBI",
    title: "Kribi Airport",
  },
  {
    iata: "TKC",
    title: "Tiko Airport",
  },
  {
    iata: "DLA",
    title: "Douala International Airport",
  },
  {
    iata: "MMF",
    title: "Mamfe Airport",
  },
  {
    iata: "OUR",
    title: "Batouri Airport",
  },
  {
    iata: "GXX",
    title: "Yagoua Airport",
  },
  {
    iata: "MVR",
    title: "Salak Airport",
  },
  {
    iata: "FOM",
    title: "Foumban Nkounja Airport",
  },
  {
    iata: "BTA",
    title: "Bertoua Airport",
  },
  {
    iata: "GOU",
    title: "Garoua International Airport",
  },
  {
    iata: "DSC",
    title: "Dschang Airport",
  },
  {
    iata: "BFX",
    title: "Bafoussam Airport",
  },
  {
    iata: "BPC",
    title: "Bamenda Airport",
  },
  {
    iata: "EBW",
    title: "Ebolowa Airport",
  },
  {
    iata: "MMQ",
    title: "Mbala Airport",
  },
  {
    iata: "CIP",
    title: "Chipata Airport",
  },
  {
    iata: "ZKP",
    title: "Kasompe Airport",
  },
  {
    iata: "KLB",
    title: "Kalabo Airport",
  },
  {
    iata: "KMZ",
    title: "Kaoma Airport",
  },
  {
    iata: "KAA",
    title: "Kasama Airport",
  },
  {
    iata: "ZKB",
    title: "Kasaba Bay Airport",
  },
  {
    iata: "LVI",
    title: "Livingstone Airport",
  },
  {
    iata: "LXU",
    title: "Lukulu Airport",
  },
  {
    iata: "LUN",
    title: "Lusaka International Airport",
  },
  {
    iata: "MNS",
    title: "Mansa Airport",
  },
  {
    iata: "MFU",
    title: "Mfuwe Airport",
  },
  {
    iata: "MNR",
    title: "Mongu Airport",
  },
  {
    iata: "ZGM",
    title: "Ngoma Airport",
  },
  {
    iata: "NLA",
    title: "Ndola Airport",
  },
  {
    iata: "SXG",
    title: "Senanga Airport",
  },
  {
    iata: "KIW",
    title: "Southdowns Airport",
  },
  {
    iata: "SJQ",
    title: "Sesheke Airport",
  },
  {
    iata: "SLI",
    title: "Solwesi Airport",
  },
  {
    iata: "BBZ",
    title: "Zambezi Airport",
  },
  {
    iata: "ULI",
    title: "Falalop Island Airport",
  },
  {
    iata: "HAH",
    title: "Prince Said Ibrahim International Airport",
  },
  {
    iata: "YVA",
    title: "Iconi Airport",
  },
  {
    iata: "AJN",
    title: "Ouani Airport",
  },
  {
    iata: "DZA",
    title: "Dzaoudzi Pamandzi International Airport",
  },
  {
    iata: "RUN",
    title: "Roland Garros Airport",
  },
  {
    iata: "ZSE",
    title: "Pierrefonds Airport",
  },
  {
    iata: "WML",
    title: "Malaimbandy Airport",
  },
  {
    iata: "ATJ",
    title: "Antsirabe Airport",
  },
  {
    iata: "WAQ",
    title: "Antsalova Airport",
  },
  {
    iata: "VVB",
    title: "Mahanoro Airport",
  },
  {
    iata: "TNR",
    title: "Ivato Airport",
  },
  {
    iata: "JVA",
    title: "Ankavandra Airport",
  },
  {
    iata: "BMD",
    title: "Belo sur Tsiribihina Airport",
  },
  {
    iata: "ZVA",
    title: "Miandrivazo Airport",
  },
  {
    iata: "MXT",
    title: "Maintirano Airport",
  },
  {
    iata: "ILK",
    title: "Atsinanana Airport",
  },
  {
    iata: "TVA",
    title: "Morafenobe Airport",
  },
  {
    iata: "SMS",
    title: "Sainte Marie Airport",
  },
  {
    iata: "TMM",
    title: "Toamasina Airport",
  },
  {
    iata: "WTA",
    title: "Tambohorano Airport",
  },
  {
    iata: "MOQ",
    title: "Morondava Airport",
  },
  {
    iata: "WTS",
    title: "Tsiroanomandidy Airport",
  },
  {
    iata: "VAT",
    title: "Vatomandry Airport",
  },
  {
    iata: "WAM",
    title: "Ambatondrazaka Airport",
  },
  {
    iata: "DIE",
    title: "Arrachart Airport",
  },
  {
    iata: "WMR",
    title: "Mananara Nord Airport",
  },
  {
    iata: "ZWA",
    title: "Andapa Airport",
  },
  {
    iata: "AMB",
    title: "Ambilobe Airport",
  },
  {
    iata: "WBD",
    title: "Avaratra Airport",
  },
  {
    iata: "ANM",
    title: "Antsirabato Airport",
  },
  {
    iata: "IVA",
    title: "Ambanja Airport",
  },
  {
    iata: "HVA",
    title: "Analalava Airport",
  },
  {
    iata: "MJN",
    title: "Amborovy Airport",
  },
  {
    iata: "NOS",
    title: "Fascene Airport",
  },
  {
    iata: "DWB",
    title: "Soalala Airport",
  },
  {
    iata: "WMP",
    title: "Mampikony Airport",
  },
  {
    iata: "BPY",
    title: "Besalampy Airport",
  },
  {
    iata: "WMN",
    title: "Maroantsetra Airport",
  },
  {
    iata: "SVB",
    title: "Sambava Airport",
  },
  {
    iata: "TTS",
    title: "Tsaratanana Airport",
  },
  {
    iata: "VOH",
    title: "Vohimarina Airport",
  },
  {
    iata: "WAI",
    title: "Ambalabe Airport",
  },
  {
    iata: "WMA",
    title: "Mandritsara Airport",
  },
  {
    iata: "WBO",
    title: "Antsoa Airport",
  },
  {
    iata: "WMD",
    title: "Mandabe Airport",
  },
  {
    iata: "WFI",
    title: "Fianarantsoa Airport",
  },
  {
    iata: "RVA",
    title: "Farafangana Airport",
  },
  {
    iata: "IHO",
    title: "Ihosy Airport",
  },
  {
    iata: "MJA",
    title: "Manja Airport",
  },
  {
    iata: "WVK",
    title: "Manakara Airport",
  },
  {
    iata: "OVA",
    title: "Bekily Airport",
  },
  {
    iata: "MNJ",
    title: "Mananjary Airport",
  },
  {
    iata: "TDV",
    title: "Samangoky Airport",
  },
  {
    iata: "MXM",
    title: "Morombe Airport",
  },
  {
    iata: "TLE",
    title: "Toliara Airport",
  },
  {
    iata: "BKU",
    title: "Betioky Airport",
  },
  {
    iata: "AMP",
    title: "Ampanihy Airport",
  },
  {
    iata: "WAK",
    title: "Ankazoabo Airport",
  },
  {
    iata: "AZZ",
    title: "Ambriz Airport",
  },
  {
    iata: "SSY",
    title: "Mbanza Congo Airport",
  },
  {
    iata: "BUG",
    title: "Benguela Airport",
  },
  {
    iata: "CAB",
    title: "Cabinda Airport",
  },
  {
    iata: "CFF",
    title: "Cafunfo Airport",
  },
  {
    iata: "PGI",
    title: "Chitato Airport",
  },
  {
    iata: "CBT",
    title: "Catumbela Airport",
  },
  {
    iata: "CTI",
    title: "Cuito Cuanavale Airport",
  },
  {
    iata: "CXM",
    title: "Camaxilo Airport",
  },
  {
    iata: "CAV",
    title: "Cazombo Airport",
  },
  {
    iata: "DUE",
    title: "Dundo Airport",
  },
  {
    iata: "VPE",
    title: "Ngjiva Pereira Airport",
  },
  {
    iata: "NOV",
    title: "Nova Lisboa Airport",
  },
  {
    iata: "SVP",
    title: "Kuito Airport",
  },
  {
    iata: "LAD",
    title: "Quatro De Fevereiro Airport",
  },
  {
    iata: "MEG",
    title: "Malanje Airport",
  },
  {
    iata: "SPP",
    title: "Menongue Airport",
  },
  {
    iata: "MSZ",
    title: "Namibe Airport",
  },
  {
    iata: "GXG",
    title: "Negage Airport",
  },
  {
    iata: "PBN",
    title: "Porto Amboim Airport",
  },
  {
    iata: "VHC",
    title: "Saurimo Airport",
  },
  {
    iata: "SZA",
    title: "Soyo Airport",
  },
  {
    iata: "NDD",
    title: "Sumbe Airport",
  },
  {
    iata: "UAL",
    title: "Luau Airport",
  },
  {
    iata: "SDD",
    title: "Lubango Airport",
  },
  {
    iata: "LUO",
    title: "Luena Airport",
  },
  {
    iata: "UGO",
    title: "Uige Airport",
  },
  {
    iata: "CEO",
    title: "Waco Kungo Airport",
  },
  {
    iata: "XGN",
    title: "Xangongo Airport",
  },
  {
    iata: "ARZ",
    title: "N'zeto Airport",
  },
  {
    iata: "BGB",
    title: "Booue Airport",
  },
  {
    iata: "KDN",
    title: "Ndende Airport",
  },
  {
    iata: "FOU",
    title: "Fougamou Airport",
  },
  {
    iata: "MBC",
    title: "M'Bigou Airport",
  },
  {
    iata: "MGX",
    title: "Moabi Airport",
  },
  {
    iata: "KDJ",
    title: "Ville Airport",
  },
  {
    iata: "KOU",
    title: "Koulamoutou Airport",
  },
  {
    iata: "MJL",
    title: "Mouilla Ville Airport",
  },
  {
    iata: "OYE",
    title: "Oyem Airport",
  },
  {
    iata: "OKN",
    title: "Okondja Airport",
  },
  {
    iata: "LBQ",
    title: "Lambarene Airport",
  },
  {
    iata: "MVX",
    title: "Minvoul Airport",
  },
  {
    iata: "BMM",
    title: "Bitam Airport",
  },
  {
    iata: "MFF",
    title: "Moanda Airport",
  },
  {
    iata: "MKB",
    title: "Mekambo Airport",
  },
  {
    iata: "POG",
    title: "Port Gentil Airport",
  },
  {
    iata: "OMB",
    title: "Omboue Hopital Airport",
  },
  {
    iata: "MKU",
    title: "Makokou Airport",
  },
  {
    iata: "LBV",
    title: "Leon M Ba Airport",
  },
  {
    iata: "MZC",
    title: "Mitzic Airport",
  },
  {
    iata: "MVB",
    title: "M'Vengue El Hadj Omar Bongo Ondimba International Airport",
  },
  {
    iata: "LTL",
    title: "Lastourville Airport",
  },
  {
    iata: "ZKM",
    title: "Sette Cama Airport",
  },
  {
    iata: "TCH",
    title: "Tchibanga Airport",
  },
  {
    iata: "MYB",
    title: "Mayumba Airport",
  },
  {
    iata: "PCP",
    title: "Principe Airport",
  },
  {
    iata: "ANO",
    title: "Angoche Airport",
  },
  {
    iata: "BEW",
    title: "Beira Airport",
  },
  {
    iata: "FXO",
    title: "Cuamba Airport",
  },
  {
    iata: "VPY",
    title: "Chimoio Airport",
  },
  {
    iata: "IHC",
    title: "Inhaca Airport",
  },
  {
    iata: "INH",
    title: "Inhambane Airport",
  },
  {
    iata: "VXC",
    title: "Lichinga Airport",
  },
  {
    iata: "MPM",
    title: "Maputo Airport",
  },
  {
    iata: "MUD",
    title: "Mueda Airport",
  },
  {
    iata: "MNC",
    title: "Nacala Airport",
  },
  {
    iata: "APL",
    title: "Nampula Airport",
  },
  {
    iata: "POL",
    title: "Pemba Airport",
  },
  {
    iata: "UEL",
    title: "Quelimane Airport",
  },
  {
    iata: "TET",
    title: "Chingozi Airport",
  },
  {
    iata: "VNX",
    title: "Vilankulo Airport",
  },
  {
    iata: "VJB",
    title: "Xai-Xai Airport",
  },
  {
    iata: "JCA",
    title: "Croisette Heliport",
  },
  {
    iata: "DES",
    title: "Desroches Airport",
  },
  {
    iata: "SEZ",
    title: "Seychelles International Airport",
  },
  {
    iata: "PRI",
    title: "Praslin Airport",
  },
  {
    iata: "BDI",
    title: "Bird Island Airport",
  },
  {
    iata: "DEI",
    title: "Denis Island Airport",
  },
  {
    iata: "SRH",
    title: "Sarh Airport",
  },
  {
    iata: "OGR",
    title: "Bongor Airport",
  },
  {
    iata: "AEH",
    title: "Abeche Airport",
  },
  {
    iata: "MQQ",
    title: "Moundou Airport",
  },
  {
    iata: "LTC",
    title: "Lai Airport",
  },
  {
    iata: "ATV",
    title: "Ati Airport",
  },
  {
    iata: "NDJ",
    title: "N'Djamena International Airport",
  },
  {
    iata: "BKR",
    title: "Bokoro Airport",
  },
  {
    iata: "OTC",
    title: "Bol Airport",
  },
  {
    iata: "MVO",
    title: "Mongo Airport",
  },
  {
    iata: "AMC",
    title: "Am Timan Airport",
  },
  {
    iata: "PLF",
    title: "Pala Airport",
  },
  {
    iata: "OUT",
    title: "Bousso Airport",
  },
  {
    iata: "AMO",
    title: "Mao Airport",
  },
  {
    iata: "FYT",
    title: "Faya Largeau Airport",
  },
  {
    iata: "BUQ",
    title: "Joshua Mqabuko Nkomo International Airport",
  },
  {
    iata: "CHJ",
    title: "Chipinge Airport",
  },
  {
    iata: "BFO",
    title: "Buffalo Range Airport",
  },
  {
    iata: "VFA",
    title: "Victoria Falls International Airport",
  },
  {
    iata: "HRE",
    title: "Harare International Airport",
  },
  {
    iata: "KAB",
    title: "Kariba International Airport",
  },
  {
    iata: "UTA",
    title: "Mutare Airport",
  },
  {
    iata: "MVZ",
    title: "Masvingo International Airport",
  },
  {
    iata: "GWE",
    title: "Thornhill Air Base",
  },
  {
    iata: "HWN",
    title: "Hwange National Park Airport",
  },
  {
    iata: "WKI",
    title: "Hwange Airport",
  },
  {
    iata: "CEH",
    title: "Chelinda Malawi Airport",
  },
  {
    iata: "BLZ",
    title: "Chileka International Airport",
  },
  {
    iata: "CMK",
    title: "Club Makokola Airport",
  },
  {
    iata: "DWA",
    title: "Dwangwa Airport",
  },
  {
    iata: "KGJ",
    title: "Karonga Airport",
  },
  {
    iata: "KBQ",
    title: "Kasungu Airport",
  },
  {
    iata: "LLW",
    title: "Lilongwe International Airport",
  },
  {
    iata: "LIX",
    title: "Likoma Island Airport",
  },
  {
    iata: "MAI",
    title: "Mangochi Airport",
  },
  {
    iata: "MYZ",
    title: "Monkey Bay Airport",
  },
  {
    iata: "LMB",
    title: "Salima Airport",
  },
  {
    iata: "ZZU",
    title: "Mzuzu Airport",
  },
  {
    iata: "LEF",
    title: "Lebakeng Airport",
  },
  {
    iata: "LRB",
    title: "Leribe Airport",
  },
  {
    iata: "LES",
    title: "Lesobeng Airport",
  },
  {
    iata: "MFC",
    title: "Mafeteng Airport",
  },
  {
    iata: "MKH",
    title: "Mokhotlong Airport",
  },
  {
    iata: "MSU",
    title: "Moshoeshoe I International Airport",
  },
  {
    iata: "NKU",
    title: "Nkaus Airport",
  },
  {
    iata: "PEL",
    title: "Pelaneng Airport",
  },
  {
    iata: "UTG",
    title: "Quthing Airport",
  },
  {
    iata: "UNE",
    title: "Qacha's Nek Airport",
  },
  {
    iata: "SHK",
    title: "Sehonghong Airport",
  },
  {
    iata: "SKQ",
    title: "Sekakes Airport",
  },
  {
    iata: "SOK",
    title: "Semonkong Airport",
  },
  {
    iata: "SHZ",
    title: "Seshutes Airport",
  },
  {
    iata: "THB",
    title: "Thaba-Tseka Airport",
  },
  {
    iata: "TKO",
    title: "Tlokoeng Airport",
  },
  {
    iata: "ADI",
    title: "Arandis Airport",
  },
  {
    iata: "GOG",
    title: "Gobabis Airport",
  },
  {
    iata: "GFY",
    title: "Grootfontein Airport",
  },
  {
    iata: "MPA",
    title: "Katima Mulilo Airport",
  },
  {
    iata: "KMP",
    title: "Keetmanshoop Airport",
  },
  {
    iata: "LUD",
    title: "Luderitz Airport",
  },
  {
    iata: "OKU",
    title: "Mokuti Lodge Airport",
  },
  {
    iata: "NNI",
    title: "Namutoni Airport",
  },
  {
    iata: "OND",
    title: "Ondangwa Airport",
  },
  {
    iata: "OMG",
    title: "Omega Airport",
  },
  {
    iata: "OMD",
    title: "Oranjemund Airport",
  },
  {
    iata: "OKF",
    title: "Okaukuejo Airport",
  },
  {
    iata: "NDU",
    title: "Rundu Airport",
  },
  {
    iata: "SWP",
    title: "Swakopmund Airport",
  },
  {
    iata: "TSB",
    title: "Tsumeb Airport",
  },
  {
    iata: "WVB",
    title: "Walvis Bay Airport",
  },
  {
    iata: "ERS",
    title: "Eros Airport",
  },
  {
    iata: "WDH",
    title: "Hosea Kutako International Airport",
  },
  {
    iata: "FIH",
    title: "Ndjili International Airport",
  },
  {
    iata: "NLO",
    title: "Ndolo Airport",
  },
  {
    iata: "MNB",
    title: "Muanda Airport",
  },
  {
    iata: "BOA",
    title: "Boma Airport",
  },
  {
    iata: "LZI",
    title: "Luozi Airport",
  },
  {
    iata: "MAT",
    title: "Tshimpi Airport",
  },
  {
    iata: "NKL",
    title: "Nkolo Fuma Airport",
  },
  {
    iata: "INO",
    title: "Inongo Airport",
  },
  {
    iata: "NIO",
    title: "Nioki Airport",
  },
  {
    iata: "FDU",
    title: "Bandundu Airport",
  },
  {
    iata: "KRZ",
    title: "Basango Mboliasa Airport",
  },
  {
    iata: "KKW",
    title: "Kikwit Airport",
  },
  {
    iata: "IDF",
    title: "Idiofa Airport",
  },
  {
    iata: "LUS",
    title: "Lusanga Airport",
  },
  {
    iata: "MSM",
    title: "Masi Manimba Airport",
  },
  {
    iata: "MDK",
    title: "Mbandaka Airport",
  },
  {
    iata: "BSU",
    title: "Basankusu Airport",
  },
  {
    iata: "LIE",
    title: "Libenge Airport",
  },
  {
    iata: "BDT",
    title: "Gbadolite Airport",
  },
  {
    iata: "GMA",
    title: "Gemena Airport",
  },
  {
    iata: "KLI",
    title: "Kotakoli Airport",
  },
  {
    iata: "BMB",
    title: "Bumbar Airport",
  },
  {
    iata: "LIQ",
    title: "Lisala Airport",
  },
  {
    iata: "BNB",
    title: "Boende Airport",
  },
  {
    iata: "IKL",
    title: "Ikela Airport",
  },
  {
    iata: "FKI",
    title: "Bangoka International Airport",
  },
  {
    iata: "YAN",
    title: "Yangambi Airport",
  },
  {
    iata: "IRP",
    title: "Matari Airport",
  },
  {
    iata: "BUX",
    title: "Bunia Airport",
  },
  {
    iata: "BZU",
    title: "Buta Zega Airport",
  },
  {
    iata: "BKY",
    title: "Bukavu Kavumu Airport",
  },
  {
    iata: "GOM",
    title: "Goma International Airport",
  },
  {
    iata: "BNC",
    title: "Beni Airport",
  },
  {
    iata: "KND",
    title: "Kindu Airport",
  },
  {
    iata: "KLY",
    title: "Kinkungwa Airport",
  },
  {
    iata: "PUN",
    title: "Punia Airport",
  },
  {
    iata: "FBM",
    title: "Lubumbashi International Airport",
  },
  {
    iata: "PWO",
    title: "Pweto Airport",
  },
  {
    iata: "KEC",
    title: "Kasenga Airport",
  },
  {
    iata: "KWZ",
    title: "Kolwezi Airport",
  },
  {
    iata: "MNO",
    title: "Manono Airport",
  },
  {
    iata: "BDV",
    title: "Moba Airport",
  },
  {
    iata: "FMI",
    title: "Kalemie Airport",
  },
  {
    iata: "KBO",
    title: "Kabalo Airport",
  },
  {
    iata: "KOO",
    title: "Kongolo Airport",
  },
  {
    iata: "KMN",
    title: "Kamina Base Airport",
  },
  {
    iata: "KAP",
    title: "Kapanga Airport",
  },
  {
    iata: "KNM",
    title: "Kaniama Airport",
  },
  {
    iata: "KGA",
    title: "Kananga Airport",
  },
  {
    iata: "LZA",
    title: "Luiza Airport",
  },
  {
    iata: "TSH",
    title: "Tshikapa Airport",
  },
  {
    iata: "LJA",
    title: "Lodja Airport",
  },
  {
    iata: "LBO",
    title: "Lusambo Airport",
  },
  {
    iata: "MEW",
    title: "Mweka Airport",
  },
  {
    iata: "BAN",
    title: "Basongo Airport",
  },
  {
    iata: "PFR",
    title: "Ilebo Airport",
  },
  {
    iata: "MJM",
    title: "Mbuji Mayi Airport",
  },
  {
    iata: "GDJ",
    title: "Gandajika Airport",
  },
  {
    iata: "KBN",
    title: "Tunta Airport",
  },
  {
    iata: "AKE",
    title: "Akieni Airport",
  },
  {
    iata: "GAX",
    title: "Gamba Airport",
  },
  {
    iata: "BKO",
    title: "Senou Airport",
  },
  {
    iata: "GUD",
    title: "Goundam Airport",
  },
  {
    iata: "GAQ",
    title: "Gao Airport",
  },
  {
    iata: "KNZ",
    title: "Kenieba Airport",
  },
  {
    iata: "KTX",
    title: "Koutiala Airport",
  },
  {
    iata: "KYS",
    title: "Kayes Dag Dag Airport",
  },
  {
    iata: "MZI",
    title: "Ambodedjo Airport",
  },
  {
    iata: "NRM",
    title: "Nara Airport",
  },
  {
    iata: "NIX",
    title: "Nioro du Sahel Airport",
  },
  {
    iata: "KSS",
    title: "Sikasso Airport",
  },
  {
    iata: "TOM",
    title: "Timbuktu Airport",
  },
  {
    iata: "DOC",
    title: "Dornoch Airport",
  },
  {
    iata: "FLH",
    title: "Flotta Isle Airport",
  },
  {
    iata: "FOA",
    title: "Foula Airport",
  },
  {
    iata: "OUK",
    title: "Outer Skerries Airport",
  },
  {
    iata: "PSV",
    title: "Papa Stour Airport",
  },
  {
    iata: "ULL",
    title: "Glenforsa Airfield",
  },
  {
    iata: "BJL",
    title: "Banjul International Airport",
  },
  {
    iata: "FUE",
    title: "Fuerteventura Airport",
  },
  {
    iata: "GMZ",
    title: "La Gomera Airport",
  },
  {
    iata: "VDE",
    title: "Hierro Airport",
  },
  {
    iata: "SPC",
    title: "La Palma Airport",
  },
  {
    iata: "LPA",
    title: "Gran Canaria Airport",
  },
  {
    iata: "ACE",
    title: "Lanzarote Airport",
  },
  {
    iata: "TFS",
    title: "Tenerife South Airport",
  },
  {
    iata: "TFN",
    title: "Tenerife Norte Airport",
  },
  {
    iata: "JCU",
    title: "Ceuta Heliport",
  },
  {
    iata: "MLN",
    title: "Melilla Airport",
  },
  {
    iata: "BTE",
    title: "Sherbro International Airport",
  },
  {
    iata: "KBS",
    title: "Bo Airport",
  },
  {
    iata: "GBK",
    title: "Gbangbatok Airport",
  },
  {
    iata: "HGS",
    title: "Hastings Airport",
  },
  {
    iata: "KBA",
    title: "Kabala Airport",
  },
  {
    iata: "KEN",
    title: "Kenema Airport",
  },
  {
    iata: "FNA",
    title: "Lungi International Airport",
  },
  {
    iata: "WYE",
    title: "Yengema Airport",
  },
  {
    iata: "BQE",
    title: "Bubaque Airport",
  },
  {
    iata: "OXB",
    title: "Osvaldo Vieira International Airport",
  },
  {
    iata: "JGR",
    title: "Groennedal Heliport",
  },
  {
    iata: "QCU",
    title: "Akunaq Heliport",
  },
  {
    iata: "UCN",
    title: "Buchanan Airport",
  },
  {
    iata: "CPA",
    title: "Cape Palmas Airport",
  },
  {
    iata: "SNI",
    title: "Greenville Sinoe Airport",
  },
  {
    iata: "UCN",
    title: "Lamco Airport",
  },
  {
    iata: "MLW",
    title: "Spriggs Payne Airport",
  },
  {
    iata: "NIA",
    title: "Nimba Airport",
  },
  {
    iata: "ROB",
    title: "Roberts International Airport",
  },
  {
    iata: "SAZ",
    title: "Sasstown Airport",
  },
  {
    iata: "THC",
    title: "Tchien Airport",
  },
  {
    iata: "VOI",
    title: "Voinjama Airport",
  },
  {
    iata: "AGA",
    title: "Al Massira Airport",
  },
  {
    iata: "TTA",
    title: "Tan Tan Airport",
  },
  {
    iata: "OZG",
    title: "Zagora Airport",
  },
  {
    iata: "UAR",
    title: "Bouarfa Airport",
  },
  {
    iata: "ERH",
    title: "Moulay Ali Cherif Airport",
  },
  {
    iata: "MEK",
    title: "Bassatine Airport",
  },
  {
    iata: "OUD",
    title: "Angads Airport",
  },
  {
    iata: "SMW",
    title: "Smara Airport",
  },
  {
    iata: "GMD",
    title: "Ben Slimane Airport",
  },
  {
    iata: "CAS",
    title: "Anfa Airport",
  },
  {
    iata: "SII",
    title: "Sidi Ifni Xx Airport",
  },
  {
    iata: "VIL",
    title: "Dakhla Airport",
  },
  {
    iata: "ESU",
    title: "Mogador Airport",
  },
  {
    iata: "EUN",
    title: "Hassan I Airport",
  },
  {
    iata: "CMN",
    title: "Mohammed V International Airport",
  },
  {
    iata: "SFI",
    title: "Safi Airport",
  },
  {
    iata: "NDR",
    title: "Nador International Airport",
  },
  {
    iata: "RAK",
    title: "Menara Airport",
  },
  {
    iata: "NNA",
    title: "Kenitra Airport",
  },
  {
    iata: "OZZ",
    title: "Ouarzazate Airport",
  },
  {
    iata: "AHU",
    title: "Cherif Al Idrissi Airport",
  },
  {
    iata: "TTU",
    title: "Saniat Rmel Airport",
  },
  {
    iata: "TNG",
    title: "Ibn Batouta Airport",
  },
  {
    iata: "GNU",
    title: "Goodnews Airport",
  },
  {
    iata: "KDA",
    title: "Kolda North Airport",
  },
  {
    iata: "ZIG",
    title: "Ziguinchor Airport",
  },
  {
    iata: "CSK",
    title: "Cap Skirring Airport",
  },
  {
    iata: "KLC",
    title: "Kaolack Airport",
  },
  {
    iata: "MAX",
    title: "Ouro Sogui Airport",
  },
  {
    iata: "POD",
    title: "Podor Airport",
  },
  {
    iata: "RDT",
    title: "Richard Toll Airport",
  },
  {
    iata: "XLS",
    title: "Saint Louis Airport",
  },
  {
    iata: "BXE",
    title: "Bakel Airport",
  },
  {
    iata: "SMY",
    title: "Simenti Airport",
  },
  {
    iata: "TUD",
    title: "Tambacounda Airport",
  },
  {
    iata: "AEO",
    title: "Aioun el Atrouss Airport",
  },
  {
    iata: "OTL",
    title: "Boutilimit Airport",
  },
  {
    iata: "THI",
    title: "Tichitt Airport",
  },
  {
    iata: "TIY",
    title: "Tidjikja Airport",
  },
  {
    iata: "BGH",
    title: "Abbaye Airport",
  },
  {
    iata: "KFA",
    title: "Kiffa Airport",
  },
  {
    iata: "TMD",
    title: "Timbedra Airport",
  },
  {
    iata: "AJJ",
    title: "Akjoujt Airport",
  },
  {
    iata: "MOM",
    title: "Letfotar Airport",
  },
  {
    iata: "NKC",
    title: "Nouakchott International Airport",
  },
  {
    iata: "THT",
    title: "Tamchakett Airport",
  },
  {
    iata: "ATR",
    title: "Atar International Airport",
  },
  {
    iata: "FGD",
    title: "Fderik Airport",
  },
  {
    iata: "NDB",
    title: "Nouadhibou International Airport",
  },
  {
    iata: "OUZ",
    title: "Tazadit Airport",
  },
  {
    iata: "JSS",
    title: "Spetsai Airport",
  },
  {
    iata: "CIQ",
    title: "Chiquimula Airport",
  },
  {
    iata: "DON",
    title: "Dos Lagunas Airport",
  },
  {
    iata: "ENJ",
    title: "El Naranjo Airport",
  },
  {
    iata: "PCG",
    title: "Paso Caballos Airport",
  },
  {
    iata: "LCF",
    title: "Las Vegas Airport",
  },
  {
    iata: "UAX",
    title: "Uaxactun Airport",
  },
  {
    iata: "PKJ",
    title: "Playa Grande Airport",
  },
  {
    iata: "GTZ",
    title: "Kirawira B Aerodrome",
  },
  {
    iata: "CKY",
    title: "Conakry Airport",
  },
  {
    iata: "FIG",
    title: "Fria Airport",
  },
  {
    iata: "FAA",
    title: "Faranah Airport",
  },
  {
    iata: "KSI",
    title: "Kissidougou Airport",
  },
  {
    iata: "LEK",
    title: "Labe Airport",
  },
  {
    iata: "MCA",
    title: "Macenta Airport",
  },
  {
    iata: "NZE",
    title: "Nzerekore Airport",
  },
  {
    iata: "BKJ",
    title: "Boke Airport",
  },
  {
    iata: "SBI",
    title: "Sambailo Airport",
  },
  {
    iata: "GII",
    title: "Siguiri Airport",
  },
  {
    iata: "KNN",
    title: "Kankan Airport",
  },
  {
    iata: "NTO",
    title: "Agostinho Neto Airport",
  },
  {
    iata: "BVC",
    title: "Rabil Airport",
  },
  {
    iata: "MMO",
    title: "Maio Airport",
  },
  {
    iata: "MTI",
    title: "Mosteiros Airport",
  },
  {
    iata: "RAI",
    title: "Praia International Airport",
  },
  {
    iata: "EDG",
    title: "Gatow Airport",
  },
  {
    iata: "BCG",
    title: "Bemichi Airport",
  },
  {
    iata: "BTO",
    title: "Botopasi Airport",
  },
  {
    iata: "DOE",
    title: "Djumu-Djomoe Airport",
  },
  {
    iata: "LDO",
    title: "Ladouanie Airport",
  },
  {
    iata: "WSO",
    title: "Washabo Airport",
  },
  {
    iata: "ADD",
    title: "Bole International Airport",
  },
  {
    iata: "AMH",
    title: "Arba Minch Airport",
  },
  {
    iata: "AXU",
    title: "Axum Airport",
  },
  {
    iata: "BCO",
    title: "Baco Airport",
  },
  {
    iata: "BJR",
    title: "Bahir Dar Airport",
  },
  {
    iata: "BEI",
    title: "Beica Airport",
  },
  {
    iata: "DSE",
    title: "Combolcha Airport",
  },
  {
    iata: "DEM",
    title: "Dembidollo Airport",
  },
  {
    iata: "DBM",
    title: "Debra Marcos Airport",
  },
  {
    iata: "DIR",
    title: "Aba Tenna Dejazmach Yilma International Airport",
  },
  {
    iata: "DBT",
    title: "Debre Tabor Airport",
  },
  {
    iata: "FNH",
    title: "Fincha Airport",
  },
  {
    iata: "GOB",
    title: "Robe Airport",
  },
  {
    iata: "GNN",
    title: "Ghinnir Airport",
  },
  {
    iata: "GMB",
    title: "Gambella Airport",
  },
  {
    iata: "GDQ",
    title: "Gonder Airport",
  },
  {
    iata: "GDE",
    title: "Gode Airport",
  },
  {
    iata: "GOR",
    title: "Gore Airport",
  },
  {
    iata: "QHR",
    title: "Harar Meda Airport",
  },
  {
    iata: "HUE",
    title: "Humera Airport",
  },
  {
    iata: "JIM",
    title: "Jimma Airport",
  },
  {
    iata: "ABK",
    title: "Kabri Dehar Airport",
  },
  {
    iata: "LFO",
    title: "Kelafo East Airport",
  },
  {
    iata: "AWA",
    title: "Awassa Airport",
  },
  {
    iata: "LLI",
    title: "Lalibella Airport",
  },
  {
    iata: "MQX",
    title: "Mekele Airport",
  },
  {
    iata: "NDM",
    title: "Mendi Airport",
  },
  {
    iata: "MTF",
    title: "Mizan Teferi Airport",
  },
  {
    iata: "NEJ",
    title: "Nejjo Airport",
  },
  {
    iata: "NEK",
    title: "Nekemte Airport",
  },
  {
    iata: "SXU",
    title: "Soddu Airport",
  },
  {
    iata: "ASO",
    title: "Asosa Airport",
  },
  {
    iata: "TIE",
    title: "Tippi Airport",
  },
  {
    iata: "WAC",
    title: "Waca Airport",
  },
  {
    iata: "BJM",
    title: "Bujumbura International Airport",
  },
  {
    iata: "GID",
    title: "Gitega Airport",
  },
  {
    iata: "ALU",
    title: "Alula Airport",
  },
  {
    iata: "BIB",
    title: "Baidoa Airport",
  },
  {
    iata: "CXN",
    title: "Candala Airport",
  },
  {
    iata: "HCM",
    title: "Eil Airport",
  },
  {
    iata: "BSA",
    title: "Bosaso Airport",
  },
  {
    iata: "GSR",
    title: "Gardo Airport",
  },
  {
    iata: "HGA",
    title: "Egal International Airport",
  },
  {
    iata: "BBO",
    title: "Berbera Airport",
  },
  {
    iata: "KMU",
    title: "Kisimayu Airport",
  },
  {
    iata: "MGQ",
    title: "Aden Adde International Airport",
  },
  {
    iata: "CMO",
    title: "Obbia Airport",
  },
  {
    iata: "GLK",
    title: "Galcaio Airport",
  },
  {
    iata: "CMS",
    title: "Scusciuban Airport",
  },
  {
    iata: "ERA",
    title: "Erigavo Airport",
  },
  {
    iata: "BUO",
    title: "Burao Airport",
  },
  {
    iata: "JIB",
    title: "Djibouti-Ambouli Airport",
  },
  {
    iata: "AII",
    title: "Ali-Sabieh Airport",
  },
  {
    iata: "MHI",
    title: "Moucha Airport",
  },
  {
    iata: "OBC",
    title: "Obock Airport",
  },
  {
    iata: "TDJ",
    title: "Tadjoura Airport",
  },
  {
    iata: "SEW",
    title: "Siwa Oasis North Airport",
  },
  {
    iata: "DBB",
    title: "El Alamein International Airport",
  },
  {
    iata: "AAC",
    title: "El Arish International Airport",
  },
  {
    iata: "ATZ",
    title: "Assiut International Airport",
  },
  {
    iata: "ALY",
    title: "El Nouzha Airport",
  },
  {
    iata: "HBE",
    title: "Borg El Arab International Airport",
  },
  {
    iata: "ABS",
    title: "Abu Simbel Airport",
  },
  {
    iata: "CAI",
    title: "Cairo International Airport",
  },
  {
    iata: "CWE",
    title: "Cairo West Airport",
  },
  {
    iata: "DAK",
    title: "Dakhla Airport",
  },
  {
    iata: "HRG",
    title: "Hurghada International Airport",
  },
  {
    iata: "EGH",
    title: "El Gora Airport",
  },
  {
    iata: "UVL",
    title: "El Kharga Airport",
  },
  {
    iata: "LXR",
    title: "Luxor International Airport",
  },
  {
    iata: "RMF",
    title: "Marsa Alam International Airport",
  },
  {
    iata: "HMB",
    title: "Sohag International Airport",
  },
  {
    iata: "MUH",
    title: "Mersa Matruh Airport",
  },
  {
    iata: "GSQ",
    title: "Shark El Oweinat International Airport",
  },
  {
    iata: "PSD",
    title: "Port Said Airport",
  },
  {
    iata: "SKV",
    title: "St Catherine International Airport",
  },
  {
    iata: "SSH",
    title: "Sharm El Sheikh International Airport",
  },
  {
    iata: "ASW",
    title: "Aswan International Airport",
  },
  {
    iata: "TCP",
    title: "Taba International Airport",
  },
  {
    iata: "ELT",
    title: "El Tor Airport",
  },
  {
    iata: "HGI",
    title: "Palogue Airport",
  },
  {
    iata: "ASM",
    title: "Asmara International Airport",
  },
  {
    iata: "MSW",
    title: "Massawa International Airport",
  },
  {
    iata: "ASA",
    title: "Assab International Airport",
  },
  {
    iata: "TES",
    title: "Tessenei Airport",
  },
  {
    iata: "HIA",
    title: "Lianshui Airport",
  },
  {
    iata: "HIL",
    title: "Shilavo Airport",
  },
  {
    iata: "ASV",
    title: "Amboseli Airport",
  },
  {
    iata: "EDL",
    title: "Eldoret International Airport",
  },
  {
    iata: "EYS",
    title: "Eliye Springs Airport",
  },
  {
    iata: "KLK",
    title: "Kalokol Airport",
  },
  {
    iata: "GAS",
    title: "Garissa Airport",
  },
  {
    iata: "HOA",
    title: "Hola Airport",
  },
  {
    iata: "NBO",
    title: "Jomo Kenyatta International Airport",
  },
  {
    iata: "GGM",
    title: "Kakamega Airport",
  },
  {
    iata: "KIS",
    title: "Kisumu Airport",
  },
  {
    iata: "ILU",
    title: "Kilaguni Airport",
  },
  {
    iata: "KEY",
    title: "Kericho Airport",
  },
  {
    iata: "KTL",
    title: "Kitale Airport",
  },
  {
    iata: "LKG",
    title: "Lokichoggio Airport",
  },
  {
    iata: "LOK",
    title: "Lodwar Airport",
  },
  {
    iata: "LAU",
    title: "Manda Airstrip",
  },
  {
    iata: "LOY",
    title: "Loyengalani Airport",
  },
  {
    iata: "NDE",
    title: "Mandera Airport",
  },
  {
    iata: "RBT",
    title: "Segel Airport",
  },
  {
    iata: "MYD",
    title: "Malindi Airport",
  },
  {
    iata: "MBA",
    title: "Mombasa Moi International Airport",
  },
  {
    iata: "MRE",
    title: "Mara Serena Lodge Airstrip",
  },
  {
    iata: "OYL",
    title: "Moyale Airport",
  },
  {
    iata: "NYE",
    title: "Nyeri Airport",
  },
  {
    iata: "NUU",
    title: "Nakuru Airport",
  },
  {
    iata: "WIL",
    title: "Nairobi Wilson Airport",
  },
  {
    iata: "NYK",
    title: "Nanyuki Airport",
  },
  {
    iata: "UAS",
    title: "Samburu South Airport",
  },
  {
    iata: "UKA",
    title: "Ukunda Airstrip",
  },
  {
    iata: "WJR",
    title: "Wajir Airport",
  },
  {
    iata: "SRX",
    title: "Gardabya Airport",
  },
  {
    iata: "TOB",
    title: "Gamal Abdel Nasser Airport",
  },
  {
    iata: "GHT",
    title: "Ghat Airport",
  },
  {
    iata: "AKF",
    title: "Kufra Airport",
  },
  {
    iata: "BEN",
    title: "Benina International Airport",
  },
  {
    iata: "MJI",
    title: "Mitiga Airport",
  },
  {
    iata: "LAQ",
    title: "La Abraq Airport",
  },
  {
    iata: "SEB",
    title: "Sabha Airport",
  },
  {
    iata: "TIP",
    title: "Tripoli International Airport",
  },
  {
    iata: "LMQ",
    title: "Marsa Brega Airport",
  },
  {
    iata: "HUQ",
    title: "Hon Airport",
  },
  {
    iata: "LTD",
    title: "Ghadames East Airport",
  },
  {
    iata: "WAX",
    title: "Zwara Airport",
  },
  {
    iata: "GYI",
    title: "Gisenyi Airport",
  },
  {
    iata: "BTQ",
    title: "Butare Airport",
  },
  {
    iata: "KGL",
    title: "Kigali International Airport",
  },
  {
    iata: "RHG",
    title: "Ruhengeri Airport",
  },
  {
    iata: "KME",
    title: "Kamembe Airport",
  },
  {
    iata: "ATB",
    title: "Atbara Airport",
  },
  {
    iata: "EDB",
    title: "El Debba Airport",
  },
  {
    iata: "DOG",
    title: "Dongola Airport",
  },
  {
    iata: "ELF",
    title: "El Fasher Airport",
  },
  {
    iata: "GSU",
    title: "Azaza Airport",
  },
  {
    iata: "DNX",
    title: "Galegu Airport",
  },
  {
    iata: "EGN",
    title: "Geneina Airport",
  },
  {
    iata: "KSL",
    title: "Kassala Airport",
  },
  {
    iata: "GBU",
    title: "Khashm El Girba Airport",
  },
  {
    iata: "KST",
    title: "Kosti Airport",
  },
  {
    iata: "KDX",
    title: "Kadugli Airport",
  },
  {
    iata: "MWE",
    title: "Merowe Airport",
  },
  {
    iata: "NUD",
    title: "En Nahud Airport",
  },
  {
    iata: "UYL",
    title: "Nyala Airport",
  },
  {
    iata: "NHF",
    title: "New Halfa Airport",
  },
  {
    iata: "EBD",
    title: "El Obeid Airport",
  },
  {
    iata: "PZU",
    title: "Port Sudan New International Airport",
  },
  {
    iata: "JUB",
    title: "Juba Airport",
  },
  {
    iata: "MAK",
    title: "Malakal Airport",
  },
  {
    iata: "KRT",
    title: "Khartoum International Airport",
  },
  {
    iata: "WHF",
    title: "Wadi Halfa Airport",
  },
  {
    iata: "WUU",
    title: "Wau Airport",
  },
  {
    iata: "ARK",
    title: "Arusha Airport",
  },
  {
    iata: "BKZ",
    title: "Bukoba Airport",
  },
  {
    iata: "DAR",
    title: "Mwalimu Julius K. Nyerere International Airport",
  },
  {
    iata: "DOD",
    title: "Dodoma Airport",
  },
  {
    iata: "IRI",
    title: "Iringa Airport",
  },
  {
    iata: "TKQ",
    title: "Kigoma Airport",
  },
  {
    iata: "KIY",
    title: "Kilwa Masoko Airport",
  },
  {
    iata: "JRO",
    title: "Kilimanjaro International Airport",
  },
  {
    iata: "LDI",
    title: "Kikwetu Airport",
  },
  {
    iata: "LKY",
    title: "Lake Manyara Airport",
  },
  {
    iata: "MFA",
    title: "Mafia Island Airport",
  },
  {
    iata: "MBI",
    title: "Mbeya Airport",
  },
  {
    iata: "MWN",
    title: "Mwadui Airport",
  },
  {
    iata: "XMI",
    title: "Masasi Airport",
  },
  {
    iata: "QSI",
    title: "Moshi Airport",
  },
  {
    iata: "MYW",
    title: "Mtwara Airport",
  },
  {
    iata: "MUZ",
    title: "Musoma Airport",
  },
  {
    iata: "MWZ",
    title: "Mwanza Airport",
  },
  {
    iata: "NCH",
    title: "Nachingwea Airport",
  },
  {
    iata: "JOM",
    title: "Njombe Airport",
  },
  {
    iata: "PMA",
    title: "Pemba Airport",
  },
  {
    iata: "SEU",
    title: "Seronera Airport",
  },
  {
    iata: "SGX",
    title: "Songea Airport",
  },
  {
    iata: "SUT",
    title: "Sumbawanga Airport",
  },
  {
    iata: "SHY",
    title: "Shinyanga Airport",
  },
  {
    iata: "TBO",
    title: "Tabora Airport",
  },
  {
    iata: "TGT",
    title: "Tanga Airport",
  },
  {
    iata: "ZNZ",
    title: "Zanzibar Airport",
  },
  {
    iata: "RUA",
    title: "Arua Airport",
  },
  {
    iata: "EBB",
    title: "Entebbe International Airport",
  },
  {
    iata: "ULU",
    title: "Gulu Airport",
  },
  {
    iata: "JIN",
    title: "Jinja Airport",
  },
  {
    iata: "KBG",
    title: "Kabalega Falls Airport",
  },
  {
    iata: "KSE",
    title: "Kasese Airport",
  },
  {
    iata: "MBQ",
    title: "Mbarara Airport",
  },
  {
    iata: "KCU",
    title: "Masindi Airport",
  },
  {
    iata: "SRT",
    title: "Soroti Airport",
  },
  {
    iata: "TRY",
    title: "Tororo Airport",
  },
  {
    iata: "IBL",
    title: "Indigo Bay Lodge Airport",
  },
  {
    iata: "PPJ",
    title: "Pulau Panjang Airport",
  },
  {
    iata: "AAS",
    title: "Apalapsili Airport",
  },
  {
    iata: "AGD",
    title: "Anggi Airport",
  },
  {
    iata: "AKQ",
    title: "Gunung Batin Airport",
  },
  {
    iata: "AYW",
    title: "Ayawasi Airport",
  },
  {
    iata: "BJG",
    title: "Boalang Airport",
  },
  {
    iata: "BXM",
    title: "Batom Airport",
  },
  {
    iata: "DRH",
    title: "Dabra Airport",
  },
  {
    iata: "ELR",
    title: "Elelim Airport",
  },
  {
    iata: "EWE",
    title: "Ewer Airport",
  },
  {
    iata: "FOO",
    title: "Kornasoren Airfield",
  },
  {
    iata: "GAV",
    title: "Gag Island Airport",
  },
  {
    iata: "IUL",
    title: "Ilu Airport",
  },
  {
    iata: "KBF",
    title: "Karubaga Airport",
  },
  {
    iata: "KBX",
    title: "Kambuaya Airport",
  },
  {
    iata: "KCD",
    title: "Kamur Airport",
  },
  {
    iata: "KCI",
    title: "Kon Airport",
  },
  {
    iata: "KEA",
    title: "Keisah Airport",
  },
  {
    iata: "KMM",
    title: "Kiman Airport",
  },
  {
    iata: "KOD",
    title: "Kotabangun Airport",
  },
  {
    iata: "KRC",
    title: "Kerinici airport",
  },
  {
    iata: "KWB",
    title: "Karimunjawa Airport",
  },
  {
    iata: "LLN",
    title: "Kelila Airport",
  },
  {
    iata: "LWE",
    title: "Lewoleba Airport",
  },
  {
    iata: "LYK",
    title: "Lunyuk Airport",
  },
  {
    iata: "MJY",
    title: "Mangunjaya Airport",
  },
  {
    iata: "MPT",
    title: "Maliana airport",
  },
  {
    iata: "MSI",
    title: "Masalembo Airport",
  },
  {
    iata: "MUF",
    title: "Muting Airport",
  },
  {
    iata: "NAF",
    title: "Banaina Airport",
  },
  {
    iata: "NDA",
    title: "Bandanaira Airport",
  },
  {
    iata: "OBD",
    title: "Obano Airport",
  },
  {
    iata: "PPJ",
    title: "Pulau Panjang Airport",
  },
  {
    iata: "PUM",
    title: "Pomala Airport",
  },
  {
    iata: "PWL",
    title: "Purwokerto Airport",
  },
  {
    iata: "RAQ",
    title: "Sugimanuru Airport",
  },
  {
    iata: "RKI",
    title: "Rokot Airport",
  },
  {
    iata: "RTI",
    title: "Roti Airport",
  },
  {
    iata: "RUF",
    title: "Yuruf Airport",
  },
  {
    iata: "RZS",
    title: "Sawan Airport",
  },
  {
    iata: "SAE",
    title: "Sangir Airport",
  },
  {
    iata: "TBM",
    title: "Tumbang Samba Airport",
  },
  {
    iata: "TMY",
    title: "Tiom Airport",
  },
  {
    iata: "ZEG",
    title: "Senggo Airport",
  },
  {
    iata: "ZGP",
    title: "Zugapa Airport",
  },
  {
    iata: "IOR",
    title: "Kilronan Airport",
  },
  {
    iata: "CHE",
    title: "Reeroe Airport",
  },
  {
    iata: "VDY",
    title: "Vijayanagar Aerodrome (JSW)",
  },
  {
    iata: "JGB",
    title: "Jagdalpur Airport",
  },
  {
    iata: "NVY",
    title: "Neyveli Airport",
  },
  {
    iata: "RJI",
    title: "Rajouri Airport",
  },
  {
    iata: "TEI",
    title: "Tezu Airport",
  },
  {
    iata: "KHA",
    title: "Khaneh Airport",
  },
  {
    iata: "GSM",
    title: "Gheshm Airport",
  },
  {
    iata: "TQR",
    title: "San Domino Island Heliport",
  },
  {
    iata: "JGD",
    title: "Jiagedaqi Airport",
  },
  {
    iata: "JIC",
    title: "Jinchuan Airport",
  },
  {
    iata: "JIQ",
    title: "Qianjiang Wulingshan Airport",
  },
  {
    iata: "JMC",
    title: "Commodore Center Heliport",
  },
  {
    iata: "JRA",
    title: "West 30th St. Heliport",
  },
  {
    iata: "AMK",
    title: "Animas Air Park",
  },
  {
    iata: "RLA",
    title: "Rolla Downtown Airport",
  },
  {
    iata: "FID",
    title: "Elizabeth Field",
  },
  {
    iata: "AHD",
    title: "Ardmore Downtown Executive Airport",
  },
  {
    iata: "GCW",
    title: "Grand Canyon West Airport",
  },
  {
    iata: "RKC",
    title: "Montague-Yreka Rohrer Field",
  },
  {
    iata: "GNF",
    title: "Gansner Field",
  },
  {
    iata: "AHF",
    title: "Arapahoe Municipal Airport",
  },
  {
    iata: "GTP",
    title: "Grants Pass Airport",
  },
  {
    iata: "GCD",
    title: "Grand Coulee Dam Airport",
  },
  {
    iata: "FPY",
    title: "Perry Foley Airport",
  },
  {
    iata: "FHB",
    title: "Fernandina Beach Municipal Airport",
  },
  {
    iata: "BLD",
    title: "Boulder City Municipal Airport",
  },
  {
    iata: "AAF",
    title: "Apalachicola Regional Airport",
  },
  {
    iata: "ABE",
    title: "Lehigh Valley International Airport",
  },
  {
    iata: "ABI",
    title: "Abilene Regional Airport",
  },
  {
    iata: "ABQ",
    title: "Albuquerque International Sunport Airport",
  },
  {
    iata: "ABR",
    title: "Aberdeen Regional Airport",
  },
  {
    iata: "ABY",
    title: "Southwest Georgia Regional Airport",
  },
  {
    iata: "ACB",
    title: "Antrim County Airport",
  },
  {
    iata: "ACK",
    title: "Nantucket Memorial Airport",
  },
  {
    iata: "ACT",
    title: "Waco Regional Airport",
  },
  {
    iata: "ACV",
    title: "Arcata Airport",
  },
  {
    iata: "ACY",
    title: "Atlantic City International Airport",
  },
  {
    iata: "ADG",
    title: "Lenawee County Airport",
  },
  {
    iata: "ADT",
    title: "Ada Municipal Airport",
  },
  {
    iata: "ADM",
    title: "Ardmore Municipal Airport",
  },
  {
    iata: "ADS",
    title: "Addison Airport",
  },
  {
    iata: "ADW",
    title: "Andrews Air Force Base",
  },
  {
    iata: "KAE",
    title: "Kake Seaplane Base",
  },
  {
    iata: "AEL",
    title: "Albert Lea Municipal Airport",
  },
  {
    iata: "AEX",
    title: "Alexandria International Airport",
  },
  {
    iata: "AFF",
    title: "USAF Academy Airfield",
  },
  {
    iata: "WSG",
    title: "Washington County Airport",
  },
  {
    iata: "AFN",
    title: "Jaffrey Airport Silver Ranch Airport",
  },
  {
    iata: "AFO",
    title: "Afton Municipal Airport",
  },
  {
    iata: "AFW",
    title: "Fort Worth Alliance Airport",
  },
  {
    iata: "AGC",
    title: "Allegheny County Airport",
  },
  {
    iata: "AGO",
    title: "Magnolia Municipal Airport",
  },
  {
    iata: "AGS",
    title: "Augusta Regional At Bush Field",
  },
  {
    iata: "AHC",
    title: "Amedee Army Air Field",
  },
  {
    iata: "AHH",
    title: "Amery Municipal Airport",
  },
  {
    iata: "AHN",
    title: "Athens Ben Epps Airport",
  },
  {
    iata: "AIA",
    title: "Alliance Municipal Airport",
  },
  {
    iata: "AID",
    title: "Anderson Municipal Darlington Field",
  },
  {
    iata: "AIK",
    title: "Aiken Municipal Airport",
  },
  {
    iata: "AIO",
    title: "Atlantic Municipal Airport",
  },
  {
    iata: "AIV",
    title: "George Downer Airport",
  },
  {
    iata: "AIY",
    title: "Atlantic City Municipal Bader Field",
  },
  {
    iata: "AIZ",
    title: "Lee C Fine Memorial Airport",
  },
  {
    iata: "AKO",
    title: "Colorado Plains Regional Airport",
  },
  {
    iata: "AKC",
    title: "Akron Fulton International Airport",
  },
  {
    iata: "ALB",
    title: "Albany International Airport",
  },
  {
    iata: "ALI",
    title: "Alice International Airport",
  },
  {
    iata: "ALM",
    title: "Alamogordo White Sands Regional Airport",
  },
  {
    iata: "ALN",
    title: "St Louis Regional Airport",
  },
  {
    iata: "ALO",
    title: "Waterloo Regional Airport",
  },
  {
    iata: "ALS",
    title: "San Luis Valley Regional Bergman Field",
  },
  {
    iata: "ALW",
    title: "Walla Walla Regional Airport",
  },
  {
    iata: "ALX",
    title: "Thomas C Russell Field",
  },
  {
    iata: "AMA",
    title: "Rick Husband Amarillo International Airport",
  },
  {
    iata: "AMN",
    title: "RPD Airport",
  },
  {
    iata: "AMW",
    title: "Ames Municipal Airport",
  },
  {
    iata: "ANB",
    title: "Anniston Metropolitan Airport",
  },
  {
    iata: "AND",
    title: "Anderson Regional Airport",
  },
  {
    iata: "ANP",
    title: "Lee Airport",
  },
  {
    iata: "ANQ",
    title: "Tri State Steuben County Airport",
  },
  {
    iata: "ANW",
    title: "Ainsworth Municipal Airport",
  },
  {
    iata: "ANY",
    title: "Anthony Municipal Airport",
  },
  {
    iata: "AOH",
    title: "Lima Allen County Airport",
  },
  {
    iata: "AOO",
    title: "Altoona Blair County Airport",
  },
  {
    iata: "APA",
    title: "Centennial Airport",
  },
  {
    iata: "APC",
    title: "Napa County Airport",
  },
  {
    iata: "APF",
    title: "Naples Municipal Airport",
  },
  {
    iata: "APG",
    title: "Phillips Army Air Field",
  },
  {
    iata: "APH",
    title: "A P Hill Aaf (Fort A P Hill) Airport",
  },
  {
    iata: "APN",
    title: "Alpena County Regional Airport",
  },
  {
    iata: "APT",
    title: "Marion County Brown Field",
  },
  {
    iata: "APV",
    title: "Apple Valley Airport",
  },
  {
    iata: "ARA",
    title: "Acadiana Regional Airport",
  },
  {
    iata: "ARB",
    title: "Ann Arbor Municipal Airport",
  },
  {
    iata: "ARG",
    title: "Walnut Ridge Regional Airport",
  },
  {
    iata: "ART",
    title: "Watertown International Airport",
  },
  {
    iata: "ATL",
    title: "Hartsfield Jackson Atlanta International Airport",
  },
  {
    iata: "ATW",
    title: "Outagamie County Regional Airport",
  },
  {
    iata: "ATY",
    title: "Watertown Regional Airport",
  },
  {
    iata: "AUG",
    title: "Augusta State Airport",
  },
  {
    iata: "AUS",
    title: "Austin Bergstrom International Airport",
  },
  {
    iata: "AVL",
    title: "Asheville Regional Airport",
  },
  {
    iata: "AVO",
    title: "Avon Park Executive Airport",
  },
  {
    iata: "AVP",
    title: "Wilkes Barre Scranton International Airport",
  },
  {
    iata: "AWM",
    title: "West Memphis Municipal Airport",
  },
  {
    iata: "AXN",
    title: "Chandler Field",
  },
  {
    iata: "AXS",
    title: "Altus Quartz Mountain Regional Airport",
  },
  {
    iata: "AXV",
    title: "Neil Armstrong Airport",
  },
  {
    iata: "AXX",
    title: "Angel Fire Airport",
  },
  {
    iata: "AYE",
    title: "Ft Devens Moore Army Air Field",
  },
  {
    iata: "AYS",
    title: "Waycross Ware County Airport",
  },
  {
    iata: "AZO",
    title: "Kalamazoo Battle Creek International Airport",
  },
  {
    iata: "BAB",
    title: "Beale Air Force Base",
  },
  {
    iata: "BAD",
    title: "Barksdale Air Force Base",
  },
  {
    iata: "BAF",
    title: "Barnes Municipal Airport",
  },
  {
    iata: "BDL",
    title: "Bradley International Airport",
  },
  {
    iata: "BDR",
    title: "Igor I Sikorsky Memorial Airport",
  },
  {
    iata: "BED",
    title: "Laurence G Hanscom Field",
  },
  {
    iata: "BFD",
    title: "Bradford Regional Airport",
  },
  {
    iata: "BFF",
    title: "Western Neb. Rgnl/William B. Heilig Airport",
  },
  {
    iata: "BFI",
    title: "Boeing Field King County International Airport",
  },
  {
    iata: "BFL",
    title: "Meadows Field",
  },
  {
    iata: "BGM",
    title: "Greater Binghamton/Edwin A Link field",
  },
  {
    iata: "BGR",
    title: "Bangor International Airport",
  },
  {
    iata: "BHB",
    title: "Hancock County-Bar Harbor Airport",
  },
  {
    iata: "BHM",
    title: "Birmingham-Shuttlesworth International Airport",
  },
  {
    iata: "BIL",
    title: "Billings Logan International Airport",
  },
  {
    iata: "BIS",
    title: "Bismarck Municipal Airport",
  },
  {
    iata: "BKL",
    title: "Burke Lakefront Airport",
  },
  {
    iata: "BKW",
    title: "Raleigh County Memorial Airport",
  },
  {
    iata: "BKX",
    title: "Brookings Regional Airport",
  },
  {
    iata: "BLF",
    title: "Mercer County Airport",
  },
  {
    iata: "BLI",
    title: "Bellingham International Airport",
  },
  {
    iata: "BMG",
    title: "Monroe County Airport",
  },
  {
    iata: "BMI",
    title: "Central Illinois Regional Airport at Bloomington-Normal",
  },
  {
    iata: "BMT",
    title: "Beaumont Municipal Airport",
  },
  {
    iata: "BNA",
    title: "Nashville International Airport",
  },
  {
    iata: "BOI",
    title: "Boise Air Terminal/Gowen field",
  },
  {
    iata: "BOS",
    title: "General Edward Lawrence Logan International Airport",
  },
  {
    iata: "BPT",
    title: "Southeast Texas Regional Airport",
  },
  {
    iata: "BQK",
    title: "Brunswick Golden Isles Airport",
  },
  {
    iata: "BRL",
    title: "Southeast Iowa Regional Airport",
  },
  {
    iata: "BRO",
    title: "Brownsville South Padre Island International Airport",
  },
  {
    iata: "BTM",
    title: "Bert Mooney Airport",
  },
  {
    iata: "BTR",
    title: "Baton Rouge Metropolitan, Ryan Field",
  },
  {
    iata: "BTV",
    title: "Burlington International Airport",
  },
  {
    iata: "BTY",
    title: "Beatty Airport",
  },
  {
    iata: "BUB",
    title: "Cram Field",
  },
  {
    iata: "BUF",
    title: "Buffalo Niagara International Airport",
  },
  {
    iata: "BUM",
    title: "Butler Memorial Airport",
  },
  {
    iata: "BUR",
    title: "Bob Hope Airport",
  },
  {
    iata: "BVO",
    title: "Bartlesville Municipal Airport",
  },
  {
    iata: "BVX",
    title: "Batesville Regional Airport",
  },
  {
    iata: "BVY",
    title: "Beverly Municipal Airport",
  },
  {
    iata: "BWC",
    title: "Brawley Municipal Airport",
  },
  {
    iata: "BWD",
    title: "Brownwood Regional Airport",
  },
  {
    iata: "BWG",
    title: "Bowling Green Warren County Regional Airport",
  },
  {
    iata: "BWI",
    title: "Baltimore/Washington International Thurgood Marshal Airport",
  },
  {
    iata: "BXA",
    title: "George R Carr Memorial Air Field",
  },
  {
    iata: "BXK",
    title: "Buckeye Municipal Airport",
  },
  {
    iata: "BYS",
    title: "Bicycle Lake Army Air Field",
  },
  {
    iata: "BZN",
    title: "Gallatin Field",
  },
  {
    iata: "CLG",
    title: "New Coalinga Municipal Airport",
  },
  {
    iata: "CAE",
    title: "Columbia Metropolitan Airport",
  },
  {
    iata: "CAK",
    title: "Akron Canton Regional Airport",
  },
  {
    iata: "CDC",
    title: "Cedar City Regional Airport",
  },
  {
    iata: "CEC",
    title: "Jack Mc Namara Field Airport",
  },
  {
    iata: "CEF",
    title: "Westover ARB/Metropolitan Airport",
  },
  {
    iata: "CGI",
    title: "Cape Girardeau Regional Airport",
  },
  {
    iata: "CGX",
    title: "Chicago Meigs Airport",
  },
  {
    iata: "CHA",
    title: "Lovell Field",
  },
  {
    iata: "CHO",
    title: "Charlottesville Albemarle Airport",
  },
  {
    iata: "CHS",
    title: "Charleston Air Force Base-International Airport",
  },
  {
    iata: "CID",
    title: "The Eastern Iowa Airport",
  },
  {
    iata: "CIU",
    title: "Chippewa County International Airport",
  },
  {
    iata: "CKB",
    title: "North Central West Virginia Airport",
  },
  {
    iata: "KCL",
    title: "Chignik Lagoon Airport",
  },
  {
    iata: "CLE",
    title: "Cleveland Hopkins International Airport",
  },
  {
    iata: "CLL",
    title: "Easterwood Field",
  },
  {
    iata: "CLM",
    title: "William R Fairchild International Airport",
  },
  {
    iata: "CLT",
    title: "Charlotte Douglas International Airport",
  },
  {
    iata: "CMH",
    title: "Port Columbus International Airport",
  },
  {
    iata: "CMI",
    title: "University of Illinois Willard Airport",
  },
  {
    iata: "CMX",
    title: "Houghton County Memorial Airport",
  },
  {
    iata: "CNM",
    title: "Cavern City Air Terminal",
  },
  {
    iata: "COS",
    title: "City of Colorado Springs Municipal Airport",
  },
  {
    iata: "COU",
    title: "Columbia Regional Airport",
  },
  {
    iata: "CPR",
    title: "Casper-Natrona County International Airport",
  },
  {
    iata: "CRO",
    title: "Corcoran Airport",
  },
  {
    iata: "CRP",
    title: "Corpus Christi International Airport",
  },
  {
    iata: "CRW",
    title: "Yeager Airport",
  },
  {
    iata: "CSG",
    title: "Columbus Metropolitan Airport",
  },
  {
    iata: "CVG",
    title: "Cincinnati Northern Kentucky International Airport",
  },
  {
    iata: "KIP",
    title: "Kickapoo Downtown Airport",
  },
  {
    iata: "CWF",
    title: "Chennault International Airport",
  },
  {
    iata: "CYS",
    title: "Cheyenne Regional Jerry Olson Field",
  },
  {
    iata: "DAB",
    title: "Daytona Beach International Airport",
  },
  {
    iata: "DAL",
    title: "Dallas Love Field",
  },
  {
    iata: "DAN",
    title: "Danville Regional Airport",
  },
  {
    iata: "DAY",
    title: "James M Cox Dayton International Airport",
  },
  {
    iata: "DBQ",
    title: "Dubuque Regional Airport",
  },
  {
    iata: "DCA",
    title: "Ronald Reagan Washington National Airport",
  },
  {
    iata: "DDC",
    title: "Dodge City Regional Airport",
  },
  {
    iata: "DEC",
    title: "Decatur Airport",
  },
  {
    iata: "DEN",
    title: "Denver International Airport",
  },
  {
    iata: "DET",
    title: "Coleman A. Young Municipal Airport",
  },
  {
    iata: "DFW",
    title: "Dallas Fort Worth International Airport",
  },
  {
    iata: "DHN",
    title: "Dothan Regional Airport",
  },
  {
    iata: "DLH",
    title: "Duluth International Airport",
  },
  {
    iata: "DNL",
    title: "Daniel Field",
  },
  {
    iata: "DSM",
    title: "Des Moines International Airport",
  },
  {
    iata: "DTW",
    title: "Detroit Metropolitan Wayne County Airport",
  },
  {
    iata: "DUJ",
    title: "DuBois Regional Airport",
  },
  {
    iata: "JJM",
    title: "Mulika Lodge Airport",
  },
  {
    iata: "VPG",
    title: "Vipingo Estate Airport",
  },
  {
    iata: "KRV",
    title: "Kerio Valley Airport",
  },
  {
    iata: "KIU",
    title: "Kiunga Airport",
  },
  {
    iata: "LBK",
    title: "Liboi Airport",
  },
  {
    iata: "LBN",
    title: "Lake Baringo Airport",
  },
  {
    iata: "LKU",
    title: "Lake Rudolf Airport",
  },
  {
    iata: "MRE",
    title: "Mara Lodges Airport",
  },
  {
    iata: "MUM",
    title: "Mumias Airport",
  },
  {
    iata: "ALE",
    title: "Alpine Casparis Municipal Airport",
  },
  {
    iata: "BGT",
    title: "Bagdad Airport",
  },
  {
    iata: "EAR",
    title: "Kearney Regional Airport",
  },
  {
    iata: "EAU",
    title: "Chippewa Valley Regional Airport",
  },
  {
    iata: "ECP",
    title: "Northwest Florida Beaches International Airport",
  },
  {
    iata: "EEN",
    title: "Dillant Hopkins Airport",
  },
  {
    iata: "EGE",
    title: "Eagle County Regional Airport",
  },
  {
    iata: "KEK",
    title: "Ekwok Airport",
  },
  {
    iata: "EKO",
    title: "Elko Regional Airport",
  },
  {
    iata: "ELD",
    title: "South Arkansas Regional At Goodwin Field",
  },
  {
    iata: "ELM",
    title: "Elmira Corning Regional Airport",
  },
  {
    iata: "ELP",
    title: "El Paso International Airport",
  },
  {
    iata: "ERI",
    title: "Erie International Tom Ridge Field",
  },
  {
    iata: "EUG",
    title: "Mahlon Sweet Field",
  },
  {
    iata: "EVV",
    title: "Evansville Regional Airport",
  },
  {
    iata: "EWB",
    title: "New Bedford Regional Airport",
  },
  {
    iata: "EWN",
    title: "Coastal Carolina Regional Airport",
  },
  {
    iata: "EWR",
    title: "Newark Liberty International Airport",
  },
  {
    iata: "EYW",
    title: "Key West International Airport",
  },
  {
    iata: "FAR",
    title: "Hector International Airport",
  },
  {
    iata: "FAT",
    title: "Fresno Yosemite International Airport",
  },
  {
    iata: "FAY",
    title: "Fayetteville Regional Grannis Field",
  },
  {
    iata: "FBG",
    title: "Simmons Army Air Field",
  },
  {
    iata: "FCS",
    title: "Butts AAF (Fort Carson) Air Field",
  },
  {
    iata: "KFE",
    title: "Fortescue - Dave Forrest Aerodrome",
  },
  {
    iata: "FRD",
    title: "Friday Harbor Airport",
  },
  {
    iata: "FHU",
    title: "Sierra Vista Municipal Libby Army Air Field",
  },
  {
    iata: "FLG",
    title: "Flagstaff Pulliam Airport",
  },
  {
    iata: "FLL",
    title: "Fort Lauderdale Hollywood International Airport",
  },
  {
    iata: "FLO",
    title: "Florence Regional Airport",
  },
  {
    iata: "FLU",
    title: "Flushing Airport",
  },
  {
    iata: "FNT",
    title: "Bishop International Airport",
  },
  {
    iata: "FOD",
    title: "Fort Dodge Regional Airport",
  },
  {
    iata: "FOE",
    title: "Forbes Field",
  },
  {
    iata: "FIL",
    title: "Fillmore Municipal Airport",
  },
  {
    iata: "FPR",
    title: "St Lucie County International Airport",
  },
  {
    iata: "FRH",
    title: "French Lick Municipal Airport",
  },
  {
    iata: "FRI",
    title: "Marshall Army Air Field",
  },
  {
    iata: "FRM",
    title: "Fairmont Municipal Airport",
  },
  {
    iata: "FSD",
    title: "Joe Foss Field Airport",
  },
  {
    iata: "FSM",
    title: "Fort Smith Regional Airport",
  },
  {
    iata: "FMS",
    title: "Fort Madison Municipal Airport",
  },
  {
    iata: "FTW",
    title: "Fort Worth Meacham International Airport",
  },
  {
    iata: "FWA",
    title: "Fort Wayne International Airport",
  },
  {
    iata: "FYV",
    title: "Drake Field",
  },
  {
    iata: "GCK",
    title: "Garden City Regional Airport",
  },
  {
    iata: "GCN",
    title: "Grand Canyon National Park Airport",
  },
  {
    iata: "GEG",
    title: "Spokane International Airport",
  },
  {
    iata: "GFK",
    title: "Grand Forks International Airport",
  },
  {
    iata: "GGG",
    title: "East Texas Regional Airport",
  },
  {
    iata: "GGW",
    title: "Wokal Field Glasgow International Airport",
  },
  {
    iata: "GJT",
    title: "Grand Junction Regional Airport",
  },
  {
    iata: "GLH",
    title: "Mid Delta Regional Airport",
  },
  {
    iata: "GLS",
    title: "Scholes International At Galveston Airport",
  },
  {
    iata: "GNV",
    title: "Gainesville Regional Airport",
  },
  {
    iata: "GON",
    title: "Groton New London Airport",
  },
  {
    iata: "FCA",
    title: "Glacier Park International Airport",
  },
  {
    iata: "GPT",
    title: "Gulfport Biloxi International Airport",
  },
  {
    iata: "GRB",
    title: "Austin Straubel International Airport",
  },
  {
    iata: "GRI",
    title: "Central Nebraska Regional Airport",
  },
  {
    iata: "GRK",
    title: "Robert Gray  Army Air Field Airport",
  },
  {
    iata: "GRR",
    title: "Gerald R. Ford International Airport",
  },
  {
    iata: "GSO",
    title: "Piedmont Triad International Airport",
  },
  {
    iata: "GSP",
    title: "Greenville Spartanburg International Airport",
  },
  {
    iata: "GTF",
    title: "Great Falls International Airport",
  },
  {
    iata: "GUP",
    title: "Gallup Municipal Airport",
  },
  {
    iata: "GVT",
    title: "Majors Airport",
  },
  {
    iata: "GVW",
    title: "Richards-Gebaur Air Force Base",
  },
  {
    iata: "GYY",
    title: "Gary Chicago International Airport",
  },
  {
    iata: "HGR",
    title: "Hagerstown Regional Richard A Henson Field",
  },
  {
    iata: "HIB",
    title: "Chisholm Hibbing Airport",
  },
  {
    iata: "HKY",
    title: "Hickory Regional Airport",
  },
  {
    iata: "HLN",
    title: "Helena Regional Airport",
  },
  {
    iata: "HON",
    title: "Huron Regional Airport",
  },
  {
    iata: "HOT",
    title: "Memorial Field",
  },
  {
    iata: "HOU",
    title: "William P Hobby Airport",
  },
  {
    iata: "HPN",
    title: "Westchester County Airport",
  },
  {
    iata: "HRL",
    title: "Valley International Airport",
  },
  {
    iata: "HRO",
    title: "Boone County Airport",
  },
  {
    iata: "HNC",
    title: "Billy Mitchell Airport",
  },
  {
    iata: "HSV",
    title: "Huntsville International Carl T Jones Field",
  },
  {
    iata: "HTS",
    title: "Tri-State/Milton J. Ferguson Field",
  },
  {
    iata: "HUF",
    title: "Terre Haute International Hulman Field",
  },
  {
    iata: "HVN",
    title: "Tweed New Haven Airport",
  },
  {
    iata: "HYA",
    title: "Barnstable Municipal Boardman Polando Field",
  },
  {
    iata: "IAB",
    title: "Mc Connell Air Force Base",
  },
  {
    iata: "IAD",
    title: "Washington Dulles International Airport",
  },
  {
    iata: "IAG",
    title: "Niagara Falls International Airport",
  },
  {
    iata: "IAH",
    title: "George Bush Intercontinental Houston Airport",
  },
  {
    iata: "ICT",
    title: "Wichita Mid Continent Airport",
  },
  {
    iata: "IDA",
    title: "Idaho Falls Regional Airport",
  },
  {
    iata: "IFP",
    title: "Laughlin Bullhead International Airport",
  },
  {
    iata: "IGM",
    title: "Kingman Airport",
  },
  {
    iata: "ILG",
    title: "New Castle Airport",
  },
  {
    iata: "ILM",
    title: "Wilmington International Airport",
  },
  {
    iata: "IND",
    title: "Indianapolis International Airport",
  },
  {
    iata: "INL",
    title: "Falls International Airport",
  },
  {
    iata: "INT",
    title: "Smith Reynolds Airport",
  },
  {
    iata: "IPT",
    title: "Williamsport Regional Airport",
  },
  {
    iata: "IRK",
    title: "Kirksville Regional Airport",
  },
  {
    iata: "ISP",
    title: "Long Island Mac Arthur Airport",
  },
  {
    iata: "ITH",
    title: "Ithaca Tompkins Regional Airport",
  },
  {
    iata: "AZA",
    title: "Phoenix-Mesa-Gateway Airport",
  },
  {
    iata: "JAC",
    title: "Jackson Hole Airport",
  },
  {
    iata: "JAN",
    title: "Jackson Evers International Airport",
  },
  {
    iata: "JAX",
    title: "Jacksonville International Airport",
  },
  {
    iata: "JBR",
    title: "Jonesboro Municipal Airport",
  },
  {
    iata: "JFK",
    title: "John F Kennedy International Airport",
  },
  {
    iata: "JLN",
    title: "Joplin Regional Airport",
  },
  {
    iata: "JMS",
    title: "Jamestown Regional Airport",
  },
  {
    iata: "JST",
    title: "John Murtha Johnstown Cambria County Airport",
  },
  {
    iata: "LAF",
    title: "Purdue University Airport",
  },
  {
    iata: "LAN",
    title: "Capital City Airport",
  },
  {
    iata: "LAR",
    title: "Laramie Regional Airport",
  },
  {
    iata: "LAS",
    title: "McCarran International Airport",
  },
  {
    iata: "LAX",
    title: "Los Angeles International Airport",
  },
  {
    iata: "LBB",
    title: "Lubbock Preston Smith International Airport",
  },
  {
    iata: "LBE",
    title: "Arnold Palmer Regional Airport",
  },
  {
    iata: "LBF",
    title: "North Platte Regional Airport Lee Bird Field",
  },
  {
    iata: "LBL",
    title: "Liberal Mid-America Regional Airport",
  },
  {
    iata: "LCH",
    title: "Lake Charles Regional Airport",
  },
  {
    iata: "LEB",
    title: "Lebanon Municipal Airport",
  },
  {
    iata: "LEX",
    title: "Blue Grass Airport",
  },
  {
    iata: "LFT",
    title: "Lafayette Regional Airport",
  },
  {
    iata: "LGA",
    title: "La Guardia Airport",
  },
  {
    iata: "LGB",
    title: "Long Beach /Daugherty Field/ Airport",
  },
  {
    iata: "LHC",
    title: "Arlington Municipal Airport",
  },
  {
    iata: "LIT",
    title: "Adams Field",
  },
  {
    iata: "LMT",
    title: "Klamath Falls Airport",
  },
  {
    iata: "LNK",
    title: "Lincoln Airport",
  },
  {
    iata: "LNS",
    title: "Lancaster Airport",
  },
  {
    iata: "LRD",
    title: "Laredo International Airport",
  },
  {
    iata: "LRU",
    title: "Las Cruces International Airport",
  },
  {
    iata: "LSE",
    title: "La Crosse Municipal Airport",
  },
  {
    iata: "LUK",
    title: "Cincinnati Municipal Airport Lunken Field",
  },
  {
    iata: "LWS",
    title: "Lewiston Nez Perce County Airport",
  },
  {
    iata: "LWT",
    title: "Lewistown Municipal Airport",
  },
  {
    iata: "LYH",
    title: "Lynchburg Regional Preston Glenn Field",
  },
  {
    iata: "MAF",
    title: "Midland International Airport",
  },
  {
    iata: "MBS",
    title: "MBS International Airport",
  },
  {
    iata: "MCE",
    title: "Merced Regional Macready Field",
  },
  {
    iata: "MCI",
    title: "Kansas City International Airport",
  },
  {
    iata: "MCN",
    title: "Middle Georgia Regional Airport",
  },
  {
    iata: "MCO",
    title: "Orlando International Airport",
  },
  {
    iata: "MDH",
    title: "Southern Illinois Airport",
  },
  {
    iata: "MDT",
    title: "Harrisburg International Airport",
  },
  {
    iata: "MDW",
    title: "Chicago Midway International Airport",
  },
  {
    iata: "MEI",
    title: "Key Field",
  },
  {
    iata: "MEM",
    title: "Memphis International Airport",
  },
  {
    iata: "MFE",
    title: "Mc Allen Miller International Airport",
  },
  {
    iata: "MFR",
    title: "Rogue Valley International Medford Airport",
  },
  {
    iata: "MGM",
    title: "Montgomery Regional (Dannelly Field) Airport",
  },
  {
    iata: "MGW",
    title: "Morgantown Municipal Walter L. Bill Hart Field",
  },
  {
    iata: "MHK",
    title: "Manhattan Regional Airport",
  },
  {
    iata: "MHT",
    title: "Manchester Airport",
  },
  {
    iata: "MIA",
    title: "Miami International Airport",
  },
  {
    iata: "MIE",
    title: "Delaware County Johnson Field",
  },
  {
    iata: "MKC",
    title: "Charles B. Wheeler Downtown Airport",
  },
  {
    iata: "MKE",
    title: "General Mitchell International Airport",
  },
  {
    iata: "MKG",
    title: "Muskegon County Airport",
  },
  {
    iata: "MKL",
    title: "Mc Kellar Sipes Regional Airport",
  },
  {
    iata: "MLB",
    title: "Melbourne International Airport",
  },
  {
    iata: "MLI",
    title: "Quad City International Airport",
  },
  {
    iata: "MLS",
    title: "Frank Wiley Field",
  },
  {
    iata: "MLU",
    title: "Monroe Regional Airport",
  },
  {
    iata: "KMM",
    title: "Kimaam Airport",
  },
  {
    iata: "MMU",
    title: "Morristown Municipal Airport",
  },
  {
    iata: "MOB",
    title: "Mobile Regional Airport",
  },
  {
    iata: "MOD",
    title: "Modesto City Co-Harry Sham Field",
  },
  {
    iata: "MOT",
    title: "Minot International Airport",
  },
  {
    iata: "MRY",
    title: "Monterey Peninsula Airport",
  },
  {
    iata: "MSL",
    title: "Northwest Alabama Regional Airport",
  },
  {
    iata: "MSN",
    title: "Dane County Regional Truax Field",
  },
  {
    iata: "MSO",
    title: "Missoula International Airport",
  },
  {
    iata: "MSP",
    title: "Minneapolis-St Paul International/Wold-Chamberlain Airport",
  },
  {
    iata: "MSS",
    title: "Massena International Richards Field",
  },
  {
    iata: "MSY",
    title: "Louis Armstrong New Orleans International Airport",
  },
  {
    iata: "MVY",
    title: "Martha's Vineyard Airport",
  },
  {
    iata: "MYR",
    title: "Myrtle Beach International Airport",
  },
  {
    iata: "NEL",
    title: "Lakehurst NAES /Maxfield Field",
  },
  {
    iata: "NGZ",
    title: "Alameda Naval Air Station",
  },
  {
    iata: "NOP",
    title: "Floyd Bennett Field",
  },
  {
    iata: "YUM",
    title: "Yuma MCAS/Yuma International Airport",
  },
  {
    iata: "NVN",
    title: "Nervino Airport",
  },
  {
    iata: "ODC",
    title: "Oakdale Airport",
  },
  {
    iata: "OAK",
    title: "Metropolitan Oakland International Airport",
  },
  {
    iata: "OAR",
    title: "Marina Municipal Airport",
  },
  {
    iata: "OKC",
    title: "Will Rogers World Airport",
  },
  {
    iata: "OLD",
    title: "Dewitt Field,Old Town Municipal Airport",
  },
  {
    iata: "OLM",
    title: "Olympia Regional Airport",
  },
  {
    iata: "OMA",
    title: "Eppley Airfield",
  },
  {
    iata: "ONT",
    title: "Ontario International Airport",
  },
  {
    iata: "ORD",
    title: "Chicago O'Hare International Airport",
  },
  {
    iata: "ORF",
    title: "Norfolk International Airport",
  },
  {
    iata: "ORH",
    title: "Worcester Regional Airport",
  },
  {
    iata: "OSH",
    title: "Wittman Regional Airport",
  },
  {
    iata: "OTH",
    title: "Southwest Oregon Regional Airport",
  },
  {
    iata: "OTM",
    title: "Ottumwa Regional Airport",
  },
  {
    iata: "OWB",
    title: "Owensboro Daviess County Airport",
  },
  {
    iata: "DSO",
    title: "Sondok Airport",
  },
  {
    iata: "HBK",
    title: "Holbrook Municipal Airport",
  },
  {
    iata: "CWX",
    title: "Cochise County Airport",
  },
  {
    iata: "PAE",
    title: "Snohomish County (Paine Field) Airport",
  },
  {
    iata: "PAH",
    title: "Barkley Regional Airport",
  },
  {
    iata: "PBG",
    title: "Plattsburgh International Airport",
  },
  {
    iata: "PBI",
    title: "Palm Beach International Airport",
  },
  {
    iata: "PCA",
    title: "Picacho Stagefield Heliport",
  },
  {
    iata: "PDK",
    title: "DeKalb Peachtree Airport",
  },
  {
    iata: "PDX",
    title: "Portland International Airport",
  },
  {
    iata: "PFN",
    title: "Panama City-Bay Co International Airport",
  },
  {
    iata: "PHF",
    title: "Newport News Williamsburg International Airport",
  },
  {
    iata: "ADR",
    title: "Robert F Swinnie Airport",
  },
  {
    iata: "PHL",
    title: "Philadelphia International Airport",
  },
  {
    iata: "PHX",
    title: "Phoenix Sky Harbor International Airport",
  },
  {
    iata: "PIA",
    title: "Greater Peoria Regional Airport",
  },
  {
    iata: "PIB",
    title: "Hattiesburg Laurel Regional Airport",
  },
  {
    iata: "PIE",
    title: "St Petersburg Clearwater International Airport",
  },
  {
    iata: "PIH",
    title: "Pocatello Regional Airport",
  },
  {
    iata: "PIR",
    title: "Pierre Regional Airport",
  },
  {
    iata: "PIT",
    title: "Pittsburgh International Airport",
  },
  {
    iata: "PKB",
    title: "Mid Ohio Valley Regional Airport",
  },
  {
    iata: "PLB",
    title: "Clinton County Airport",
  },
  {
    iata: "PLN",
    title: "Pellston Regional Airport of Emmet County Airport",
  },
  {
    iata: "PMD",
    title: "Palmdale Regional/USAF Plant 42 Airport",
  },
  {
    iata: "PNS",
    title: "Pensacola Regional Airport",
  },
  {
    iata: "POU",
    title: "Dutchess County Airport",
  },
  {
    iata: "PQI",
    title: "Northern Maine Regional Airport at Presque Isle",
  },
  {
    iata: "PRC",
    title: "Ernest A. Love Field",
  },
  {
    iata: "PSC",
    title: "Tri Cities Airport",
  },
  {
    iata: "PSM",
    title: "Portsmouth International at Pease Airport",
  },
  {
    iata: "PSP",
    title: "Palm Springs International Airport",
  },
  {
    iata: "PUB",
    title: "Pueblo Memorial Airport",
  },
  {
    iata: "PUW",
    title: "Pullman Moscow Regional Airport",
  },
  {
    iata: "PVD",
    title: "Theodore Francis Green State Airport",
  },
  {
    iata: "PWM",
    title: "Portland International Jetport Airport",
  },
  {
    iata: "PWT",
    title: "Bremerton National Airport",
  },
  {
    iata: "KQA",
    title: "Akutan Seaplane Base",
  },
  {
    iata: "RAP",
    title: "Rapid City Regional Airport",
  },
  {
    iata: "RDD",
    title: "Redding Municipal Airport",
  },
  {
    iata: "RDG",
    title: "Reading Regional Carl A Spaatz Field",
  },
  {
    iata: "RDM",
    title: "Roberts Field",
  },
  {
    iata: "RDU",
    title: "Raleigh Durham International Airport",
  },
  {
    iata: "RFD",
    title: "Chicago Rockford International Airport",
  },
  {
    iata: "RHI",
    title: "Rhinelander Oneida County Airport",
  },
  {
    iata: "RIC",
    title: "Richmond International Airport",
  },
  {
    iata: "KRJ",
    title: "Karawari Airstrip",
  },
  {
    iata: "RKS",
    title: "Rock Springs Sweetwater County Airport",
  },
  {
    iata: "RNO",
    title: "Reno Tahoe International Airport",
  },
  {
    iata: "ROA",
    title: "Roanoke Regional Woodrum Field",
  },
  {
    iata: "ROC",
    title: "Greater Rochester International Airport",
  },
  {
    iata: "ROW",
    title: "Roswell International Air Center Airport",
  },
  {
    iata: "RQO",
    title: "El Reno Regional Airport",
  },
  {
    iata: "RST",
    title: "Rochester International Airport",
  },
  {
    iata: "RSW",
    title: "Southwest Florida International Airport",
  },
  {
    iata: "RUT",
    title: "Rutland - Southern Vermont Regional Airport",
  },
  {
    iata: "RWI",
    title: "Rocky Mount Wilson Regional Airport",
  },
  {
    iata: "AHM",
    title: "Ashland Municipal Sumner Parker Field",
  },
  {
    iata: "SUO",
    title: "Sunriver Airport",
  },
  {
    iata: "IDH",
    title: "Idaho County Airport",
  },
  {
    iata: "VSK",
    title: "Vista Field",
  },
  {
    iata: "SAN",
    title: "San Diego International Airport",
  },
  {
    iata: "SAT",
    title: "San Antonio International Airport",
  },
  {
    iata: "SAV",
    title: "Savannah Hilton Head International Airport",
  },
  {
    iata: "SBA",
    title: "Santa Barbara Municipal Airport",
  },
  {
    iata: "SBN",
    title: "South Bend Regional Airport",
  },
  {
    iata: "SBP",
    title: "San Luis County Regional Airport",
  },
  {
    iata: "SBY",
    title: "Salisbury Ocean City Wicomico Regional Airport",
  },
  {
    iata: "SDF",
    title: "Louisville International Standiford Field",
  },
  {
    iata: "SEA",
    title: "Seattle Tacoma International Airport",
  },
  {
    iata: "SFB",
    title: "Orlando Sanford International Airport",
  },
  {
    iata: "SFO",
    title: "San Francisco International Airport",
  },
  {
    iata: "SGF",
    title: "Springfield Branson National Airport",
  },
  {
    iata: "SHD",
    title: "Shenandoah Valley Regional Airport",
  },
  {
    iata: "SHR",
    title: "Sheridan County Airport",
  },
  {
    iata: "SHV",
    title: "Shreveport Regional Airport",
  },
  {
    iata: "SJC",
    title: "Norman Y. Mineta San Jose International Airport",
  },
  {
    iata: "SJT",
    title: "San Angelo Regional Mathis Field",
  },
  {
    iata: "SLC",
    title: "Salt Lake City International Airport",
  },
  {
    iata: "SLK",
    title: "Adirondack Regional Airport",
  },
  {
    iata: "SLN",
    title: "Salina Municipal Airport",
  },
  {
    iata: "SMF",
    title: "Sacramento International Airport",
  },
  {
    iata: "SMX",
    title: "Santa Maria Pub/Capt G Allan Hancock Field",
  },
  {
    iata: "SNA",
    title: "John Wayne Airport-Orange County Airport",
  },
  {
    iata: "SPI",
    title: "Abraham Lincoln Capital Airport",
  },
  {
    iata: "SPS",
    title: "Sheppard Air Force Base-Wichita Falls Municipal Airport",
  },
  {
    iata: "SRQ",
    title: "Sarasota Bradenton International Airport",
  },
  {
    iata: "STC",
    title: "St Cloud Regional Airport",
  },
  {
    iata: "STL",
    title: "Lambert St Louis International Airport",
  },
  {
    iata: "STP",
    title: "St Paul Downtown Holman Field",
  },
  {
    iata: "SUN",
    title: "Friedman Memorial Airport",
  },
  {
    iata: "SUX",
    title: "Sioux Gateway Col. Bud Day Field",
  },
  {
    iata: "SVC",
    title: "Grant County Airport",
  },
  {
    iata: "SWF",
    title: "Stewart International Airport",
  },
  {
    iata: "SYR",
    title: "Syracuse Hancock International Airport",
  },
  {
    iata: "TBN",
    title: "Waynesville-St. Robert Regional Forney field",
  },
  {
    iata: "TCL",
    title: "Tuscaloosa Regional Airport",
  },
  {
    iata: "TLH",
    title: "Tallahassee Regional Airport",
  },
  {
    iata: "OTK",
    title: "Tillamook Airport",
  },
  {
    iata: "TOL",
    title: "Toledo Express Airport",
  },
  {
    iata: "TPA",
    title: "Tampa International Airport",
  },
  {
    iata: "TPL",
    title: "Draughon Miller Central Texas Regional Airport",
  },
  {
    iata: "TRI",
    title: "Tri Cities Regional Tn Va Airport",
  },
  {
    iata: "TTN",
    title: "Trenton Mercer Airport",
  },
  {
    iata: "TUL",
    title: "Tulsa International Airport",
  },
  {
    iata: "TUP",
    title: "Tupelo Regional Airport",
  },
  {
    iata: "TUS",
    title: "Tucson International Airport",
  },
  {
    iata: "TVC",
    title: "Cherry Capital Airport",
  },
  {
    iata: "TVL",
    title: "Lake Tahoe Airport",
  },
  {
    iata: "TWF",
    title: "Joslin Field Magic Valley Regional Airport",
  },
  {
    iata: "TXK",
    title: "Texarkana Regional Webb Field",
  },
  {
    iata: "TYR",
    title: "Tyler Pounds Regional Airport",
  },
  {
    iata: "TYS",
    title: "McGhee Tyson Airport",
  },
  {
    iata: "ICS",
    title: "Cascade Airport",
  },
  {
    iata: "UCA",
    title: "Oneida County Airport",
  },
  {
    iata: "UIN",
    title: "Quincy Regional Baldwin Field",
  },
  {
    iata: "UIZ",
    title: "Berz-Macomb Airport",
  },
  {
    iata: "SCE",
    title: "University Park Airport",
  },
  {
    iata: "VCT",
    title: "Victoria Regional Airport",
  },
  {
    iata: "VLD",
    title: "Valdosta Regional Airport",
  },
  {
    iata: "VPS",
    title: "Eglin Air Force Base",
  },
  {
    iata: "VRB",
    title: "Vero Beach Municipal Airport",
  },
  {
    iata: "WRI",
    title: "Mc Guire Air Force Base",
  },
  {
    iata: "WRL",
    title: "Worland Municipal Airport",
  },
  {
    iata: "KWY",
    title: "Kiwayu Airport",
  },
  {
    iata: "YIP",
    title: "Willow Run Airport",
  },
  {
    iata: "YKM",
    title: "Yakima Air Terminal McAllister Field",
  },
  {
    iata: "YNG",
    title: "Youngstown Warren Regional Airport",
  },
  {
    iata: "DZN",
    title: "Dzhezkazgan Airport",
  },
  {
    iata: "TDK",
    title: "Taldykorgan Airport",
  },
  {
    iata: "ATX",
    title: "Atbasar Airport",
  },
  {
    iata: "AVX",
    title: "Pebbly Beach Seaplane Base",
  },
  {
    iata: "LAC",
    title: "Swallow Reef Airstrip",
  },
  {
    iata: "TIA",
    title: "Tirana International Airport Mother Teresa",
  },
  {
    iata: "BOJ",
    title: "Burgas Airport",
  },
  {
    iata: "GOZ",
    title: "Gorna Oryahovitsa Airport",
  },
  {
    iata: "PDV",
    title: "Plovdiv International Airport",
  },
  {
    iata: "PVN",
    title: "Dolna Mitropoliya Air Base",
  },
  {
    iata: "SOF",
    title: "Sofia Airport",
  },
  {
    iata: "SLS",
    title: "Silistra Polkovnik Lambrinovo Airfield",
  },
  {
    iata: "SZR",
    title: "Stara Zagora Airport",
  },
  {
    iata: "VID",
    title: "Vidin Smurdan Airfield",
  },
  {
    iata: "VAR",
    title: "Varna Airport",
  },
  {
    iata: "ECN",
    title: "Ercan International Airport",
  },
  {
    iata: "LCA",
    title: "Larnaca International Airport",
  },
  {
    iata: "LCP",
    title: "Loncopue Airport",
  },
  {
    iata: "PFO",
    title: "Paphos International Airport",
  },
  {
    iata: "AKT",
    title: "RAF Akrotiri",
  },
  {
    iata: "DBV",
    title: "Dubrovnik Airport",
  },
  {
    iata: "OSI",
    title: "Osijek Airport",
  },
  {
    iata: "PUY",
    title: "Pula Airport",
  },
  {
    iata: "RJK",
    title: "Rijeka Airport",
  },
  {
    iata: "BWK",
    title: "Bol Airport",
  },
  {
    iata: "SPU",
    title: "Split Airport",
  },
  {
    iata: "ZAG",
    title: "Zagreb Airport",
  },
  {
    iata: "ZAD",
    title: "Zemunik Airport",
  },
  {
    iata: "ABC",
    title: "Albacete-Los Llanos Airport",
  },
  {
    iata: "ALC",
    title: "Alicante International Airport",
  },
  {
    iata: "OVD",
    title: "Asturias Airport",
  },
  {
    iata: "BIO",
    title: "Bilbao Airport",
  },
  {
    iata: "RGS",
    title: "Burgos Airport",
  },
  {
    iata: "BCN",
    title: "Barcelona International Airport",
  },
  {
    iata: "BJZ",
    title: "Badajoz Airport",
  },
  {
    iata: "CDT",
    title: "Castellon De La Plana Airport",
  },
  {
    iata: "GRO",
    title: "Girona Airport",
  },
  {
    iata: "GRX",
    title: "Federico Garcia Lorca Airport",
  },
  {
    iata: "CCX",
    title: "Guadalupe Airport",
  },
  {
    iata: "IBZ",
    title: "Ibiza Airport",
  },
  {
    iata: "XRY",
    title: "Jerez Airport",
  },
  {
    iata: "MJV",
    title: "San Javier Airport",
  },
  {
    iata: "QSA",
    title: "Sabadell Airport",
  },
  {
    iata: "LEN",
    title: "Leon Airport",
  },
  {
    iata: "MAD",
    title: "Madrid Barajas International Airport",
  },
  {
    iata: "AGP",
    title: "Malaga Airport",
  },
  {
    iata: "MAH",
    title: "Menorca Airport",
  },
  {
    iata: "OZP",
    title: "Moron Air Base",
  },
  {
    iata: "PMI",
    title: "Palma De Mallorca Airport",
  },
  {
    iata: "PNA",
    title: "Pamplona Airport",
  },
  {
    iata: "CQM",
    title: "Ciudad Real Central Airport",
  },
  {
    iata: "REU",
    title: "Reus Air Base",
  },
  {
    iata: "SLM",
    title: "Salamanca Airport",
  },
  {
    iata: "EAS",
    title: "San Sebastian Airport",
  },
  {
    iata: "SCQ",
    title: "Santiago de Compostela Airport",
  },
  {
    iata: "VLC",
    title: "Valencia Airport",
  },
  {
    iata: "VLL",
    title: "Valladolid Airport",
  },
  {
    iata: "VIT",
    title: "Vitoria/Foronda Airport",
  },
  {
    iata: "VGO",
    title: "Vigo Airport",
  },
  {
    iata: "SDR",
    title: "Santander Airport",
  },
  {
    iata: "ZAZ",
    title: "Zaragoza Air Base",
  },
  {
    iata: "SVQ",
    title: "Sevilla Airport",
  },
  {
    iata: "DPE",
    title: "St Aubin Airport",
  },
  {
    iata: "CQF",
    title: "Calais-Dunkerque Airport",
  },
  {
    iata: "XLN",
    title: "Laon - Chambry Airport",
  },
  {
    iata: "XDK",
    title: "Dunkerque les Moeres Airport",
  },
  {
    iata: "BYF",
    title: "Albert-Bray Airport",
  },
  {
    iata: "XVS",
    title: "Valenciennes-Denain Airport",
  },
  {
    iata: "QAM",
    title: "Amiens-Glisy Airport",
  },
  {
    iata: "AGF",
    title: "Agen-La Garenne Airport",
  },
  {
    iata: "PIS",
    title: "Poitiers-Biard Airport",
  },
  {
    iata: "LIG",
    title: "Limoges Airport",
  },
  {
    iata: "XMJ",
    title: "Mont-de-Marsan (BA 118) Air Base",
  },
  {
    iata: "TLS",
    title: "Toulouse-Blagnac Airport",
  },
  {
    iata: "BVE",
    title: "Brive-La Roche Airport",
  },
  {
    iata: "XDA",
    title: "Dax Seyresse Airport",
  },
  {
    iata: "BIQ",
    title: "Biarritz-Anglet-Bayonne Airport",
  },
  {
    iata: "ZAO",
    title: "Cahors-Lalbenque Airport",
  },
  {
    iata: "XAC",
    title: "Arcachon-La Teste-de-Buch Airport",
  },
  {
    iata: "DCM",
    title: "Castres-Mazamet Airport",
  },
  {
    iata: "RDZ",
    title: "Rodez-Marcillac Airport",
  },
  {
    iata: "XMW",
    title: "Montauban Airport",
  },
  {
    iata: "XLR",
    title: "Libourne-Artigues-de-Lussac Airport",
  },
  {
    iata: "RCO",
    title: "Rochefort-Saint-Agnant (BA 721) Airport",
  },
  {
    iata: "XSL",
    title: "Sarlat Domme Airport",
  },
  {
    iata: "CMR",
    title: "Colmar-Houssen Airport",
  },
  {
    iata: "XBV",
    title: "Beaune-Challanges Airport",
  },
  {
    iata: "DLE",
    title: "Dole-Tavaux Airport",
  },
  {
    iata: "XVN",
    title: "Verdun-Le Rozelier Airport",
  },
  {
    iata: "LPY",
    title: "Le Puy-Loudes Airport",
  },
  {
    iata: "AHZ",
    title: "L'alpe D'huez Airport",
  },
  {
    iata: "ETZ",
    title: "Metz-Nancy-Lorraine Airport",
  },
  {
    iata: "ANE",
    title: "Angers-Loire Airport",
  },
  {
    iata: "BIA",
    title: "Bastia-Poretta Airport",
  },
  {
    iata: "CLY",
    title: "Calvi-Sainte-Catherine Airport",
  },
  {
    iata: "FSC",
    title: "Figari Sud-Corse Airport",
  },
  {
    iata: "PRP",
    title: "Propriano Airport",
  },
  {
    iata: "SOZ",
    title: "Solenzara (BA 126) Air Base",
  },
  {
    iata: "AUF",
    title: "Auxerre-Branches Airport",
  },
  {
    iata: "CFE",
    title: "Clermont-Ferrand Auvergne Airport",
  },
  {
    iata: "BOU",
    title: "Bourges Airport",
  },
  {
    iata: "QNJ",
    title: "Annemasse Airport",
  },
  {
    iata: "CVF",
    title: "Courchevel Airport",
  },
  {
    iata: "SYT",
    title: "Saint-Yan Airport",
  },
  {
    iata: "RNE",
    title: "Roanne-Renaison Airport",
  },
  {
    iata: "NCY",
    title: "Annecy-Haute-Savoie-Mont Blanc Airport",
  },
  {
    iata: "VAF",
    title: "Valence-Chabeuil Airport",
  },
  {
    iata: "VHY",
    title: "Vichy-Charmeil Airport",
  },
  {
    iata: "AUR",
    title: "Aurillac Airport",
  },
  {
    iata: "LYN",
    title: "Lyon-Bron Airport",
  },
  {
    iata: "CEQ",
    title: "Cannes-Mandelieu Airport",
  },
  {
    iata: "CCF",
    title: "Carcassonne Airport",
  },
  {
    iata: "MRS",
    title: "Marseille Provence Airport",
  },
  {
    iata: "XOG",
    title: "Orange-Caritat (BA 115) Air Base",
  },
  {
    iata: "CTT",
    title: "Le Castellet Airport",
  },
  {
    iata: "BAE",
    title: "Barcelonnette - Saint-Pons Airport",
  },
  {
    iata: "AVN",
    title: "Avignon-Caumont Airport",
  },
  {
    iata: "GAT",
    title: "Gap - Tallard Airport",
  },
  {
    iata: "MEN",
    title: "Mende-Brenoux Airport",
  },
  {
    iata: "XSU",
    title: "Saumur-Saint-Florent Airport",
  },
  {
    iata: "LEH",
    title: "Le Havre Octeville Airport",
  },
  {
    iata: "XAB",
    title: "Abbeville-Buigny-Saint-Maclou Airport",
  },
  {
    iata: "LSO",
    title: "Les Sables-d'Olonne Talmont Airport",
  },
  {
    iata: "URO",
    title: "Rouen Airport",
  },
  {
    iata: "XBQ",
    title: "Blois-Le Breuil Airport",
  },
  {
    iata: "QTJ",
    title: "Chartres Champhol Airport",
  },
  {
    iata: "TUF",
    title: "Tours-Val-de-Loire Airport",
  },
  {
    iata: "CET",
    title: "Cholet Le Pontreau Airport",
  },
  {
    iata: "LVA",
    title: "Laval-Entrammes Airport",
  },
  {
    iata: "LBG",
    title: "Paris-Le Bourget Airport",
  },
  {
    iata: "CSF",
    title: "Creil Air Base",
  },
  {
    iata: "CDG",
    title: "Charles de Gaulle International Airport",
  },
  {
    iata: "JDP",
    title: "Paris Issy-les-Moulineaux Heliport",
  },
  {
    iata: "TNF",
    title: "Toussus-le-Noble Airport",
  },
  {
    iata: "ORY",
    title: "Paris-Orly Airport",
  },
  {
    iata: "POX",
    title: "Pontoise - Cormeilles-en-Vexin Airport",
  },
  {
    iata: "QYR",
    title: "Troyes-Barberey Airport",
  },
  {
    iata: "NVS",
    title: "Nevers-Fourchambault Airport",
  },
  {
    iata: "LIL",
    title: "Lille-Lesquin Airport",
  },
  {
    iata: "HZB",
    title: "Merville-Calonne Airport",
  },
  {
    iata: "XVO",
    title: "Vesoul-Frotey Airport",
  },
  {
    iata: "BES",
    title: "Brest Bretagne Airport",
  },
  {
    iata: "CER",
    title: "Cherbourg-Maupertus Airport",
  },
  {
    iata: "DNR",
    title: "Dinard-Pleurtuit-Saint-Malo Airport",
  },
  {
    iata: "LBY",
    title: "La Baule-Escoublac Airport",
  },
  {
    iata: "GFR",
    title: "Granville Airport",
  },
  {
    iata: "DOL",
    title: "Deauville-Saint-Gatien Airport",
  },
  {
    iata: "LRT",
    title: "Lorient South Brittany (Bretagne Sud) Airport",
  },
  {
    iata: "EDM",
    title: "La Roche-sur-Yon Airport",
  },
  {
    iata: "LDV",
    title: "Landivisiau Air Base",
  },
  {
    iata: "CFR",
    title: "Caen-Carpiquet Airport",
  },
  {
    iata: "LME",
    title: "Le Mans-Arnage Airport",
  },
  {
    iata: "RNS",
    title: "Rennes-Saint-Jacques Airport",
  },
  {
    iata: "UIP",
    title: "Quimper-Cornouaille Airport",
  },
  {
    iata: "NTE",
    title: "Nantes Atlantique Airport",
  },
  {
    iata: "SBK",
    title: "Saint-Brieuc-Armor Airport",
  },
  {
    iata: "MXN",
    title: "Morlaix-Ploujean Airport",
  },
  {
    iata: "VNE",
    title: "Vannes-Meucon Airport",
  },
  {
    iata: "SNR",
    title: "Saint-Nazaire-Montoir Airport",
  },
  {
    iata: "BSL",
    title: "EuroAirport Basel-Mulhouse-Freiburg Airport",
  },
  {
    iata: "DIJ",
    title: "Dijon-Bourgogne Airport",
  },
  {
    iata: "MZM",
    title: "Metz-Frescaty (BA 128) Air Base",
  },
  {
    iata: "ENC",
    title: "Nancy-Essey Airport",
  },
  {
    iata: "BOR",
    title: "Fontaine Airport",
  },
  {
    iata: "RHE",
    title: "Reims-Champagne (BA 112) Airport",
  },
  {
    iata: "SXB",
    title: "Strasbourg Airport",
  },
  {
    iata: "VTL",
    title: "Vittel Champ De Course Airport",
  },
  {
    iata: "MQC",
    title: "Miquelon Airport",
  },
  {
    iata: "FSP",
    title: "St Pierre Airport",
  },
  {
    iata: "PYR",
    title: "Andravida Airport",
  },
  {
    iata: "AGQ",
    title: "Agrinion Airport",
  },
  {
    iata: "AXD",
    title: "Dimokritos Airport",
  },
  {
    iata: "HEW",
    title: "Athen Helenikon Airport",
  },
  {
    iata: "ATH",
    title: "Eleftherios Venizelos International Airport",
  },
  {
    iata: "VOL",
    title: "Nea Anchialos Airport",
  },
  {
    iata: "JKH",
    title: "Chios Island National Airport",
  },
  {
    iata: "PKH",
    title: "Porto Cheli Airport",
  },
  {
    iata: "JIK",
    title: "Ikaria Airport",
  },
  {
    iata: "IOA",
    title: "Ioannina Airport",
  },
  {
    iata: "HER",
    title: "Heraklion International Nikos Kazantzakis Airport",
  },
  {
    iata: "KSO",
    title: "Kastoria National Airport",
  },
  {
    iata: "KIT",
    title: "Kithira Airport",
  },
  {
    iata: "EFL",
    title: "Kefallinia Airport",
  },
  {
    iata: "KZS",
    title: "Kastelorizo Airport",
  },
  {
    iata: "KLX",
    title: "Kalamata Airport",
  },
  {
    iata: "KGS",
    title: "Kos Airport",
  },
  {
    iata: "AOK",
    title: "Karpathos Airport",
  },
  {
    iata: "CFU",
    title: "Ioannis Kapodistrias International Airport",
  },
  {
    iata: "KSJ",
    title: "Kasos Airport",
  },
  {
    iata: "KVA",
    title: "Alexander the Great International Airport",
  },
  {
    iata: "KZI",
    title: "Filippos Airport",
  },
  {
    iata: "LRS",
    title: "Leros Airport",
  },
  {
    iata: "LXS",
    title: "Limnos Airport",
  },
  {
    iata: "LRA",
    title: "Larisa Airport",
  },
  {
    iata: "JMK",
    title: "Mikonos Airport",
  },
  {
    iata: "MLO",
    title: "Milos Airport",
  },
  {
    iata: "MJT",
    title: "Mytilene International Airport",
  },
  {
    iata: "JNX",
    title: "Naxos Airport",
  },
  {
    iata: "PAS",
    title: "Paros Airport",
  },
  {
    iata: "JTY",
    title: "Astypalaia Airport",
  },
  {
    iata: "PVK",
    title: "Aktion National Airport",
  },
  {
    iata: "RHO",
    title: "Diagoras Airport",
  },
  {
    iata: "GPA",
    title: "Araxos Airport",
  },
  {
    iata: "CHQ",
    title: "Chania International Airport",
  },
  {
    iata: "JSI",
    title: "Skiathos Island National Airport",
  },
  {
    iata: "SMI",
    title: "Samos Airport",
  },
  {
    iata: "JSY",
    title: "Syros Airport",
  },
  {
    iata: "SPJ",
    title: "Sparti Airport",
  },
  {
    iata: "JTR",
    title: "Santorini Airport",
  },
  {
    iata: "JSH",
    title: "Sitia Airport",
  },
  {
    iata: "SKU",
    title: "Skiros Airport",
  },
  {
    iata: "SKG",
    title: "Thessaloniki Macedonia International Airport",
  },
  {
    iata: "ZTH",
    title: "Dionysios Solomos Airport",
  },
  {
    iata: "BUD",
    title: "Budapest Listz Ferenc international Airport",
  },
  {
    iata: "DEB",
    title: "Debrecen International Airport",
  },
  {
    iata: "MCQ",
    title: "Miskolc Airport",
  },
  {
    iata: "QZD",
    title: "Szeged Glider Airport",
  },
  {
    iata: "CRV",
    title: "Crotone Airport",
  },
  {
    iata: "BRI",
    title: "Bari / Palese International Airport",
  },
  {
    iata: "FOG",
    title: "Foggia / Gino Lisa Airport",
  },
  {
    iata: "TAR",
    title: "Taranto / Grottaglie Airport",
  },
  {
    iata: "LCC",
    title: "Lecce Airport",
  },
  {
    iata: "PSR",
    title: "Pescara International Airport",
  },
  {
    iata: "BDS",
    title: "Brindisi / Casale Airport",
  },
  {
    iata: "SUF",
    title: "Lamezia Terme Airport",
  },
  {
    iata: "CIY",
    title: 'Comiso Airport ""Vincenzo Magliocco""',
  },
  {
    iata: "CTA",
    title: "Catania / Fontanarossa Airport",
  },
  {
    iata: "LMP",
    title: "Lampedusa Airport",
  },
  {
    iata: "PNL",
    title: "Pantelleria Airport",
  },
  {
    iata: "PMO",
    title: "Palermo / Punta Raisi Airport",
  },
  {
    iata: "REG",
    title: "Reggio Calabria Airport",
  },
  {
    iata: "TPS",
    title: "Trapani / Birgi Airport",
  },
  {
    iata: "NSY",
    title: "Sigonella Airport",
  },
  {
    iata: "BLX",
    title: "Belluno Airport",
  },
  {
    iata: "RAN",
    title: "Ravenna Airport",
  },
  {
    iata: "ZIA",
    title: "Trento / Mattarello Airport",
  },
  {
    iata: "AHO",
    title: "Alghero / Fertilia Airport",
  },
  {
    iata: "DCI",
    title: "Decimomannu Airport",
  },
  {
    iata: "CAG",
    title: "Cagliari / Elmas Airport",
  },
  {
    iata: "OLB",
    title: "Olbia / Costa Smeralda Airport",
  },
  {
    iata: "TTB",
    title: "Tortoli' / Arbatax Airport",
  },
  {
    iata: "QVA",
    title: "Varese / Venegono Airport",
  },
  {
    iata: "QMM",
    title: "Massa Cinquale Airport",
  },
  {
    iata: "MXP",
    title: "Malpensa International Airport",
  },
  {
    iata: "BGY",
    title: "Bergamo / Orio Al Serio Airport",
  },
  {
    iata: "TRN",
    title: "Torino / Caselle International Airport",
  },
  {
    iata: "ALL",
    title: "Villanova D'Albenga International Airport",
  },
  {
    iata: "GOA",
    title: "Genova / Sestri Cristoforo Colombo Airport",
  },
  {
    iata: "LIN",
    title: "Linate Airport",
  },
  {
    iata: "PMF",
    title: "Parma Airport",
  },
  {
    iata: "QPZ",
    title: "Piacenza Airport",
  },
  {
    iata: "AOT",
    title: "Aosta Airport",
  },
  {
    iata: "CUF",
    title: "Cuneo / Levaldigi Airport",
  },
  {
    iata: "AVB",
    title: "Aviano Air Base",
  },
  {
    iata: "BZO",
    title: "Bolzano Airport",
  },
  {
    iata: "UDN",
    title: "Udine / Campoformido Air Base",
  },
  {
    iata: "BLQ",
    title: "Bologna / Borgo Panigale Airport",
  },
  {
    iata: "TSF",
    title: "Treviso / Sant'Angelo Airport",
  },
  {
    iata: "VBS",
    title: "Brescia / Montichiari Airport",
  },
  {
    iata: "TRS",
    title: "Trieste / Ronchi Dei Legionari",
  },
  {
    iata: "RMI",
    title: "Rimini / Miramare - Federico Fellini International Airport",
  },
  {
    iata: "VIC",
    title: "Vicenza Airport",
  },
  {
    iata: "QPA",
    title: "Padova Airport",
  },
  {
    iata: "VRN",
    title: "Verona / Villafranca Airport",
  },
  {
    iata: "AOI",
    title: "Ancona / Falconara Airport",
  },
  {
    iata: "VCE",
    title: "Venezia / Tessera -  Marco Polo Airport",
  },
  {
    iata: "QZO",
    title: "Arezzo Airport",
  },
  {
    iata: "LCV",
    title: "Lucca / Tassignano Airport",
  },
  {
    iata: "QRT",
    title: "Rieti Airport",
  },
  {
    iata: "SAY",
    title: "Siena / Ampugnano Airport",
  },
  {
    iata: "CIA",
    title: "Ciampino Airport",
  },
  {
    iata: "FCO",
    title: "Leonardo Da Vinci (Fiumicino) International Airport",
  },
  {
    iata: "QFR",
    title: "Frosinone Military Airport",
  },
  {
    iata: "QSR",
    title: "Salerno / Pontecagnano Airport",
  },
  {
    iata: "EBA",
    title: "Marina Di Campo Airport",
  },
  {
    iata: "QLT",
    title: "Latina Airport",
  },
  {
    iata: "PSA",
    title: "Pisa / San Giusto - Galileo Galilei International Airport",
  },
  {
    iata: "FLR",
    title: "Firenze / Peretola Airport",
  },
  {
    iata: "GRS",
    title: "Grosseto Airport",
  },
  {
    iata: "PEG",
    title: "Perugia / San Egidio Airport",
  },
  {
    iata: "MBX",
    title: "Maribor Airport",
  },
  {
    iata: "POW",
    title: "Portoroz Airport",
  },
  {
    iata: "UHE",
    title: "Kunovice Airport",
  },
  {
    iata: "KLV",
    title: "Karlovy Vary International Airport",
  },
  {
    iata: "PED",
    title: "Pardubice Airport",
  },
  {
    iata: "PRV",
    title: "P?erov Air Base",
  },
  {
    iata: "PRG",
    title: "Ruzyn? International Airport",
  },
  {
    iata: "BRQ",
    title: "Brno-Tu?any Airport",
  },
  {
    iata: "ZBE",
    title: "Zabreh Ostrava Airport",
  },
  {
    iata: "GHK",
    title: "Gush Katif Airport",
  },
  {
    iata: "TLV",
    title: "Ben Gurion International Airport",
  },
  {
    iata: "BEV",
    title: "Be'er Sheva (Teyman) Airport",
  },
  {
    iata: "ETH",
    title: "Eilat Airport",
  },
  {
    iata: "EIY",
    title: "Ein Yahav Airfield",
  },
  {
    iata: "HFA",
    title: "Haifa International Airport",
  },
  {
    iata: "RPN",
    title: "Ben Ya'akov Airport",
  },
  {
    iata: "JRS",
    title: "Atarot Airport",
  },
  {
    iata: "KSW",
    title: "Kiryat Shmona Airport",
  },
  {
    iata: "MTZ",
    title: "Bar Yehuda Airfield",
  },
  {
    iata: "VTM",
    title: "Nevatim Air Base",
  },
  {
    iata: "VDA",
    title: "Ovda International Airport",
  },
  {
    iata: "MIP",
    title: "Ramon Air Base",
  },
  {
    iata: "SDV",
    title: "Sde Dov Airport",
  },
  {
    iata: "YOT",
    title: "Yotvata Airfield",
  },
  {
    iata: "GZM",
    title: "Xewkija Heliport",
  },
  {
    iata: "MLA",
    title: "Luqa Airport",
  },
  {
    iata: "HOH",
    title: "Hohenems-Dornbirn Airport",
  },
  {
    iata: "LOR",
    title: "Lowe AHP (Fort Rucker) Heliport",
  },
  {
    iata: "GRZ",
    title: "Graz Airport",
  },
  {
    iata: "INN",
    title: "Innsbruck Airport",
  },
  {
    iata: "KLU",
    title: "Klagenfurt Airport",
  },
  {
    iata: "LNZ",
    title: "Linz Airport",
  },
  {
    iata: "SZG",
    title: "Salzburg Airport",
  },
  {
    iata: "VIE",
    title: "Vienna International Airport",
  },
  {
    iata: "SMA",
    title: "Santa Maria Airport",
  },
  {
    iata: "BGC",
    title: "Braganca Airport",
  },
  {
    iata: "BYJ",
    title: "Beja International Airport",
  },
  {
    iata: "BGZ",
    title: "Braga Municipal Aerodrome",
  },
  {
    iata: "CHV",
    title: "Chaves Airport",
  },
  {
    iata: "CBP",
    title: "Coimbra Airport",
  },
  {
    iata: "CVU",
    title: "Corvo Airport",
  },
  {
    iata: "COV",
    title: "Covilha Airport",
  },
  {
    iata: "FLW",
    title: "Flores Airport",
  },
  {
    iata: "FAO",
    title: "Faro Airport",
  },
  {
    iata: "GRW",
    title: "Graciosa Airport",
  },
  {
    iata: "HOR",
    title: "Horta Airport",
  },
  {
    iata: "TER",
    title: "Lajes Field",
  },
  {
    iata: "FNC",
    title: "Madeira Airport",
  },
  {
    iata: "PAF",
    title: "Montijo Airport",
  },
  {
    iata: "PIX",
    title: "Pico Airport",
  },
  {
    iata: "PRM",
    title: "Portimao Airport",
  },
  {
    iata: "PXO",
    title: "Porto Santo Airport",
  },
  {
    iata: "LIS",
    title: "Lisbon Portela Airport",
  },
  {
    iata: "SIE",
    title: "Sines Airport",
  },
  {
    iata: "VRL",
    title: "Vila Real Airport",
  },
  {
    iata: "VSE",
    title: "Viseu Airport",
  },
  {
    iata: "BNX",
    title: "Banja Luka International Airport",
  },
  {
    iata: "OMO",
    title: "Mostar International Airport",
  },
  {
    iata: "SJJ",
    title: "Sarajevo International Airport",
  },
  {
    iata: "TZL",
    title: "Tuzla International Airport",
  },
  {
    iata: "ARW",
    title: "Arad International Airport",
  },
  {
    iata: "BCM",
    title: "Bac?u Airport",
  },
  {
    iata: "BAY",
    title: "Tautii Magheraus Airport",
  },
  {
    iata: "BBU",
    title: "B?neasa International Airport",
  },
  {
    iata: "CND",
    title: "Mihail Kog?lniceanu International Airport",
  },
  {
    iata: "CLJ",
    title: "Cluj-Napoca International Airport",
  },
  {
    iata: "CSB",
    title: "Caransebe? Airport",
  },
  {
    iata: "CRA",
    title: "Craiova Airport",
  },
  {
    iata: "IAS",
    title: "Ia?i Airport",
  },
  {
    iata: "LRO",
    title: "Sharpe AAF",
  },
  {
    iata: "OMR",
    title: "Oradea International Airport",
  },
  {
    iata: "OTP",
    title: "Henri Coand? International Airport",
  },
  {
    iata: "SBZ",
    title: "Sibiu International Airport",
  },
  {
    iata: "SUJ",
    title: "Satu Mare Airport",
  },
  {
    iata: "SCV",
    title: "Suceava Stefan cel Mare Airport",
  },
  {
    iata: "TCE",
    title: "Tulcea Airport",
  },
  {
    iata: "TSR",
    title: "Timi?oara Traian Vuia Airport",
  },
  {
    iata: "GVA",
    title: "Geneva Cointrin International Airport",
  },
  {
    iata: "QNC",
    title: "Neuchatel Airport",
  },
  {
    iata: "SIR",
    title: "Sion Airport",
  },
  {
    iata: "ZIN",
    title: "Interlaken Air Base",
  },
  {
    iata: "LUG",
    title: "Lugano Airport",
  },
  {
    iata: "BRN",
    title: "Bern Belp Airport",
  },
  {
    iata: "BXO",
    title: "Buochs Airport",
  },
  {
    iata: "ACO",
    title: "Ascona Airport",
  },
  {
    iata: "ZHI",
    title: "Grenchen Airport",
  },
  {
    iata: "ZJI",
    title: "Locarno Airport",
  },
  {
    iata: "ACH",
    title: "St Gallen Altenrhein Airport",
  },
  {
    iata: "SMV",
    title: "Samedan Airport",
  },
  {
    iata: "GKD",
    title: "Imroz Airport",
  },
  {
    iata: "ESB",
    title: "Esenbo?a International Airport",
  },
  {
    iata: "ANK",
    title: "Etimesgut Air Base",
  },
  {
    iata: "ADA",
    title: "Adana Airport",
  },
  {
    iata: "UAB",
    title: "?ncirlik Air Base",
  },
  {
    iata: "AFY",
    title: "Afyon Airport",
  },
  {
    iata: "AYT",
    title: "Antalya International Airport",
  },
  {
    iata: "GZT",
    title: "Gaziantep International Airport",
  },
  {
    iata: "ISK",
    title: "?skenderun Airport",
  },
  {
    iata: "KFS",
    title: "Kastamonu Airport",
  },
  {
    iata: "KYA",
    title: "Konya Airport",
  },
  {
    iata: "MZH",
    title: "Amasya Merzifon Airport",
  },
  {
    iata: "SSX",
    title: "Samsun Samair Airport",
  },
  {
    iata: "VAS",
    title: "Sivas Airport",
  },
  {
    iata: "ONQ",
    title: "Zonguldak Airport",
  },
  {
    iata: "ASR",
    title: "Kayseri Erkilet Airport",
  },
  {
    iata: "TJK",
    title: "Tokat Airport",
  },
  {
    iata: "NAV",
    title: "Nev?ehir Kapadokya International Airport",
  },
  {
    iata: "LTB",
    title: "Latrobe Airport",
  },
  {
    iata: "BTZ",
    title: "Bursa Airport",
  },
  {
    iata: "BZI",
    title: "Bal?kesir Merkez Airport",
  },
  {
    iata: "BDM",
    title: "Band?rma Airport",
  },
  {
    iata: "ESK",
    title: "Eski?ehir Air Base",
  },
  {
    iata: "ADB",
    title: "Adnan Menderes International Airport",
  },
  {
    iata: "USQ",
    title: "U?ak Airport",
  },
  {
    iata: "KCO",
    title: "Cengiz Topel Airport",
  },
  {
    iata: "YEI",
    title: "Bursa Yeni?ehir Airport",
  },
  {
    iata: "DLM",
    title: "Dalaman International Airport",
  },
  {
    iata: "BXN",
    title: "Ims?k Airport",
  },
  {
    iata: "AOE",
    title: "Anadolu University Airport",
  },
  {
    iata: "EZS",
    title: "Elaz?? Airport",
  },
  {
    iata: "DIY",
    title: "Diyarbakir Airport",
  },
  {
    iata: "ERC",
    title: "Erzincan Airport",
  },
  {
    iata: "ERZ",
    title: "Erzurum International Airport",
  },
  {
    iata: "KSY",
    title: "Kars Airport",
  },
  {
    iata: "TZX",
    title: "Trabzon International Airport",
  },
  {
    iata: "SFQ",
    title: "?anl?urfa Airport",
  },
  {
    iata: "VAN",
    title: "Van Ferit Melen Airport",
  },
  {
    iata: "BAL",
    title: "Batman Airport",
  },
  {
    iata: "MSR",
    title: "Mu? Airport",
  },
  {
    iata: "SXZ",
    title: "Siirt Airport",
  },
  {
    iata: "SIC",
    title: "Sinop Airport",
  },
  {
    iata: "KCM",
    title: "Kahramanmara? Airport",
  },
  {
    iata: "AJI",
    title: "A?r? Airport",
  },
  {
    iata: "ADF",
    title: "Ad?yaman Airport",
  },
  {
    iata: "MQM",
    title: "Mardin Airport",
  },
  {
    iata: "GNY",
    title: "?anl?urfa GAP Airport",
  },
  {
    iata: "HTY",
    title: "Hatay Airport",
  },
  {
    iata: "BJV",
    title: "Milas Bodrum International Airport",
  },
  {
    iata: "GZP",
    title: "Gazipa?a Airport",
  },
  {
    iata: "BZY",
    title: "Balti International Airport",
  },
  {
    iata: "KIV",
    title: "Chi?in?u International Airport",
  },
  {
    iata: "GZA",
    title: "Yasser Arafat International Airport",
  },
  {
    iata: "OHD",
    title: "Ohrid St. Paul the Apostle Airport",
  },
  {
    iata: "SKP",
    title: "Skopje Alexander the Great Airport",
  },
  {
    iata: "GIB",
    title: "Gibraltar Airport",
  },
  {
    iata: "BCQ",
    title: "Brack Airport",
  },
  {
    iata: "DNF",
    title: "Martubah Airport",
  },
  {
    iata: "MRA",
    title: "Misratah Airport",
  },
  {
    iata: "QUB",
    title: "Ubari Airport",
  },
  {
    iata: "UZC",
    title: "Ponikve Airport",
  },
  {
    iata: "BEG",
    title: "Belgrade Nikola Tesla Airport",
  },
  {
    iata: "LJB",
    title: "Airport Lisicji Jarak",
  },
  {
    iata: "IVG",
    title: "Berane Airport",
  },
  {
    iata: "BJY",
    title: "Batajnica Air Base",
  },
  {
    iata: "GJA",
    title: "?akovica Airfield",
  },
  {
    iata: "KID",
    title: "Airport Drakslerov salas Kikinda",
  },
  {
    iata: "INI",
    title: "Nis Airport",
  },
  {
    iata: "QND",
    title: "Cenej Airport",
  },
  {
    iata: "TGD",
    title: "Podgorica Airport",
  },
  {
    iata: "TIV",
    title: "Tivat Airport",
  },
  {
    iata: "LUE",
    title: "Lu?enec Airport",
  },
  {
    iata: "SLD",
    title: "Slia? Airport",
  },
  {
    iata: "GLN",
    title: "Goulimime Airport",
  },
  {
    iata: "GDT",
    title: "JAGS McCartney International Airport",
  },
  {
    iata: "MDS",
    title: "Middle Caicos Airport",
  },
  {
    iata: "NCA",
    title: "North Caicos Airport",
  },
  {
    iata: "PIC",
    title: "Pine Cay Airport",
  },
  {
    iata: "PLS",
    title: "Providenciales Airport",
  },
  {
    iata: "XSC",
    title: "South Caicos Airport",
  },
  {
    iata: "SLX",
    title: "Salt Cay Airport",
  },
  {
    iata: "EPS",
    title: "Arroyo Barril International Airport",
  },
  {
    iata: "BRX",
    title: "Maria Montez International Airport",
  },
  {
    iata: "CBJ",
    title: "Cabo Rojo Airport",
  },
  {
    iata: "COZ",
    title: "Constanza Dom Re Airport",
  },
  {
    iata: "HEX",
    title: "Herrera Airport",
  },
  {
    iata: "JBQ",
    title: "La Isabela International Airport",
  },
  {
    iata: "LRM",
    title: "Casa De Campo International Airport",
  },
  {
    iata: "PUJ",
    title: "Punta Cana International Airport",
  },
  {
    iata: "POP",
    title: "Gregorio Luperon International Airport",
  },
  {
    iata: "MDR",
    title: "Medfra Airport",
  },
  {
    iata: "SNX",
    title: "Sabana de Mar Airport",
  },
  {
    iata: "SJM",
    title: "San Juan Airport",
  },
  {
    iata: "STI",
    title: "Cibao International Airport",
  },
  {
    iata: "DOA",
    title: "Doany Airport",
  },
  {
    iata: "CBV",
    title: "Coban Airport",
  },
  {
    iata: "CMM",
    title: "Carmelita Airport",
  },
  {
    iata: "CTF",
    title: "Coatepeque Airport",
  },
  {
    iata: "GUA",
    title: "La Aurora Airport",
  },
  {
    iata: "HUG",
    title: "Huehuetenango Airport",
  },
  {
    iata: "MCR",
    title: "Melchor de Mencos Airport",
  },
  {
    iata: "PBR",
    title: "Puerto Barrios Airport",
  },
  {
    iata: "AQB",
    title: "Santa Cruz del Quiche Airport",
  },
  {
    iata: "AAZ",
    title: "Quezaltenango Airport",
  },
  {
    iata: "RUV",
    title: "Rubelsanto Airport",
  },
  {
    iata: "RER",
    title: "Retalhuleu Airport",
  },
  {
    iata: "FRS",
    title: "Mundo Maya International Airport",
  },
  {
    iata: "AIM",
    title: "Ailuk Airport",
  },
  {
    iata: "AUL",
    title: "Aur Island Airport",
  },
  {
    iata: "BII",
    title: "Enyu Airfield",
  },
  {
    iata: "EBN",
    title: "Ebadon Airport",
  },
  {
    iata: "JAT",
    title: "Jabot Airport",
  },
  {
    iata: "JEJ",
    title: "Jeh Airport",
  },
  {
    iata: "KBT",
    title: "Kaben Airport",
  },
  {
    iata: "LIK",
    title: "Likiep Airport",
  },
  {
    iata: "LML",
    title: "Lae Island Airport",
  },
  {
    iata: "MAV",
    title: "Maloelap Island Airport",
  },
  {
    iata: "MJB",
    title: "Mejit Atoll Airport",
  },
  {
    iata: "MJE",
    title: "Majkin Airport",
  },
  {
    iata: "NDK",
    title: "Namorik Atoll Airport",
  },
  {
    iata: "RNP",
    title: "Rongelap Island Airport",
  },
  {
    iata: "TIC",
    title: "Tinak Airport",
  },
  {
    iata: "UIT",
    title: "Jaluit Airport",
  },
  {
    iata: "WJA",
    title: "Woja Airport",
  },
  {
    iata: "WTE",
    title: "Wotje Atoll Airport",
  },
  {
    iata: "WTO",
    title: "Wotho Island Airport",
  },
  {
    iata: "AHS",
    title: "Ahuas Airport",
  },
  {
    iata: "BHG",
    title: "Brus Laguna Airport",
  },
  {
    iata: "CAA",
    title: "Catacamas Airport",
  },
  {
    iata: "CDD",
    title: "Cauquira Airport",
  },
  {
    iata: "JUT",
    title: "Jutigalpa airport",
  },
  {
    iata: "LCE",
    title: "Goloson International Airport",
  },
  {
    iata: "LEZ",
    title: "La Esperanza Airport",
  },
  {
    iata: "GJA",
    title: "La Laguna Airport",
  },
  {
    iata: "PEU",
    title: "Puerto Lempira Airport",
  },
  {
    iata: "RTB",
    title: "Juan Manuel Galvez International Airport",
  },
  {
    iata: "RUY",
    title: "Copan Ruinas Airport",
  },
  {
    iata: "XPL",
    title: "Coronel Enrique Soto Cano Air Base",
  },
  {
    iata: "TEA",
    title: "Tela Airport",
  },
  {
    iata: "TJI",
    title: "Trujillo Airport",
  },
  {
    iata: "SCD",
    title: "Sulaco Airport",
  },
  {
    iata: "UII",
    title: "Utila Airport",
  },
  {
    iata: "MJG",
    title: "Areopuerto Internacional Michael Gonzalez",
  },
  {
    iata: "OCJ",
    title: "Boscobel Aerodrome",
  },
  {
    iata: "KIN",
    title: "Norman Manley International Airport",
  },
  {
    iata: "MBJ",
    title: "Sangster International Airport",
  },
  {
    iata: "POT",
    title: "Ken Jones Airport",
  },
  {
    iata: "NEG",
    title: "Negril Airport",
  },
  {
    iata: "KTP",
    title: "Tinson Pen Airport",
  },
  {
    iata: "MIJ",
    title: "Mili Island Airport",
  },
  {
    iata: "HEB",
    title: "Henzada Airport",
  },
  {
    iata: "ACA",
    title: "General Juan N Alvarez International Airport",
  },
  {
    iata: "NTR",
    title: "Del Norte International Airport",
  },
  {
    iata: "AGU",
    title: "Jesus Teran International Airport",
  },
  {
    iata: "CNA",
    title: "Cananea Airport",
  },
  {
    iata: "CVJ",
    title: "General Mariano Matamoros Airport",
  },
  {
    iata: "CME",
    title: "Ciudad del Carmen International Airport",
  },
  {
    iata: "NCG",
    title: "Nuevo Casas Grandes Airport",
  },
  {
    iata: "CUL",
    title: "Federal de Bachigualato International Airport",
  },
  {
    iata: "CTM",
    title: "Chetumal International Airport",
  },
  {
    iata: "CJT",
    title: "Comitan Airport",
  },
  {
    iata: "CZA",
    title: "Chichen Itza International Airport",
  },
  {
    iata: "CUU",
    title: "General Roberto Fierro Villalobos International Airport",
  },
  {
    iata: "CVM",
    title: "General Pedro Jose Mendez International Airport",
  },
  {
    iata: "CYW",
    title: "Captain Rogelio Castillo National Airport",
  },
  {
    iata: "CZM",
    title: "Cozumel International Airport",
  },
  {
    iata: "MMC",
    title: "Ciudad Mante National Airport",
  },
  {
    iata: "DGO",
    title: "General Guadalupe Victoria International Airport",
  },
  {
    iata: "TPQ",
    title: "Amado Nervo National Airport",
  },
  {
    iata: "ESE",
    title: "Ensenada Airport",
  },
  {
    iata: "GDL",
    title: "Don Miguel Hidalgo Y Costilla International Airport",
  },
  {
    iata: "GUB",
    title: "Guerrero Negro Airport",
  },
  {
    iata: "TCN",
    title: "Tehuacan Airport",
  },
  {
    iata: "HMO",
    title: "General Ignacio P. Garcia International Airport",
  },
  {
    iata: "CLQ",
    title: "Lic. Miguel de la Madrid Airport",
  },
  {
    iata: "ISJ",
    title: "Isla Mujeres Airport",
  },
  {
    iata: "SLW",
    title: "Plan De Guadalupe International Airport",
  },
  {
    iata: "IZT",
    title: "Ixtepec Airport",
  },
  {
    iata: "JAL",
    title: "El Lencero Airport",
  },
  {
    iata: "AZP",
    title: "Atizapan De Zaragoza Airport",
  },
  {
    iata: "LMM",
    title: "Valle del Fuerte International Airport",
  },
  {
    iata: "LTO",
    title: "Loreto International Airport",
  },
  {
    iata: "MAM",
    title: "General Servando Canales International Airport",
  },
  {
    iata: "MID",
    title: "Licenciado Manuel Crescencio Rejon Int Airport",
  },
  {
    iata: "MUG",
    title: "Mulege Airport",
  },
  {
    iata: "MLM",
    title: "General Francisco J. Mujica International Airport",
  },
  {
    iata: "LOV",
    title: "Monclova International Airport",
  },
  {
    iata: "MEX",
    title: "Licenciado Benito Juarez International Airport",
  },
  {
    iata: "MTY",
    title: "General Mariano Escobedo International Airport",
  },
  {
    iata: "MZT",
    title: "General Rafael Buelna International Airport",
  },
  {
    iata: "NOG",
    title: "Nogales International Airport",
  },
  {
    iata: "PPE",
    title: "Puerto Penasco Airport",
  },
  {
    iata: "PDS",
    title: "Piedras Negras International Airport",
  },
  {
    iata: "UPN",
    title: "Licenciado y General Ignacio Lopez Rayon Airport",
  },
  {
    iata: "PQM",
    title: "Palenque International Airport",
  },
  {
    iata: "PXM",
    title: "Puerto Escondido International Airport",
  },
  {
    iata: "REX",
    title: "General Lucio Blanco International Airport",
  },
  {
    iata: "SZT",
    title: "San Cristobal De Las Casas Airport",
  },
  {
    iata: "SJD",
    title: "Los Cabos International Airport",
  },
  {
    iata: "SFH",
    title: "San Felipe International Airport",
  },
  {
    iata: "SLP",
    title: "Ponciano Arriaga International Airport",
  },
  {
    iata: "TRC",
    title: "Francisco Sarabia International Airport",
  },
  {
    iata: "TAM",
    title: "General Francisco Javier Mina International Airport",
  },
  {
    iata: "TSL",
    title: "Tamuin Airport",
  },
  {
    iata: "TLC",
    title: "Licenciado Adolfo Lopez Mateos International Airport",
  },
  {
    iata: "TAP",
    title: "Tapachula International Airport",
  },
  {
    iata: "WIX",
    title: "Tuxpan Airport",
  },
  {
    iata: "VER",
    title: "General Heriberto Jara International Airport",
  },
  {
    iata: "ZCL",
    title: "General Leobardo C. Ruiz International Airport",
  },
  {
    iata: "ZIH",
    title: "Ixtapa Zihuatanejo International Airport",
  },
  {
    iata: "ZMM",
    title: "Zamora Airport",
  },
  {
    iata: "ZLO",
    title: "Playa De Oro International Airport",
  },
  {
    iata: "MXW",
    title: "Mandalgobi Airport",
  },
  {
    iata: "ULZ",
    title: "Jibhalanta Airport",
  },
  {
    iata: "BEF",
    title: "Bluefields Airport",
  },
  {
    iata: "BZA",
    title: "San Pedro Airport",
  },
  {
    iata: "RNI",
    title: "Corn Island",
  },
  {
    iata: "MGA",
    title: "Augusto C. Sandino (Managua) International Airport",
  },
  {
    iata: "NVG",
    title: "Nueva Guinea Airport",
  },
  {
    iata: "PUZ",
    title: "Puerto Cabezas Airport",
  },
  {
    iata: "RFS",
    title: "Rosita Airport",
  },
  {
    iata: "NCR",
    title: "San Carlos",
  },
  {
    iata: "SIU",
    title: "Siuna",
  },
  {
    iata: "WSP",
    title: "Waspam Airport",
  },
  {
    iata: "BOC",
    title: "Bocas Del Toro International Airport",
  },
  {
    iata: "CTD",
    title: "Alonso Valderrama Airport",
  },
  {
    iata: "DAV",
    title: "Enrique Malek International Airport",
  },
  {
    iata: "ONX",
    title: "Enrique Adolfo Jimenez Airport",
  },
  {
    iata: "BLB",
    title: "Howard Airport",
  },
  {
    iata: "PLP",
    title: "Captain Ramon Xatruch Airport",
  },
  {
    iata: "PAC",
    title: "Marcos A. Gelabert International Airport",
  },
  {
    iata: "SYP",
    title: "Ruben Cantu Airport",
  },
  {
    iata: "PTY",
    title: "Tocumen International Airport",
  },
  {
    iata: "NBL",
    title: "San Blas Airport",
  },
  {
    iata: "FON",
    title: "Arenal Airport",
  },
  {
    iata: "TTQ",
    title: "Aerotortuguero Airport",
  },
  {
    iata: "BAI",
    title: "Buenos Aires Airport",
  },
  {
    iata: "BCL",
    title: "Barra del Colorado Airport",
  },
  {
    iata: "CSC",
    title: "Codela Airport",
  },
  {
    iata: "OTR",
    title: "Coto 47 Airport",
  },
  {
    iata: "RIK",
    title: "Carrillo Airport",
  },
  {
    iata: "TNO",
    title: "Cabo Velas Airport",
  },
  {
    iata: "FMG",
    title: "Flamingo Airport",
  },
  {
    iata: "GLF",
    title: "Golfito Airport",
  },
  {
    iata: "GPL",
    title: "Guapiles Airport",
  },
  {
    iata: "PBP",
    title: "Islita Airport",
  },
  {
    iata: "LIR",
    title: "Daniel Oduber Quiros International Airport",
  },
  {
    iata: "LSL",
    title: "Los Chiles Airport",
  },
  {
    iata: "LIO",
    title: "Limon International Airport",
  },
  {
    iata: "NCT",
    title: "Guanacaste Airport",
  },
  {
    iata: "NOM",
    title: "Nosara Airport",
  },
  {
    iata: "SJO",
    title: "Juan Santamaria International Airport",
  },
  {
    iata: "PJM",
    title: "Puerto Jimenez Airport",
  },
  {
    iata: "PMZ",
    title: "Palmar Sur Airport",
  },
  {
    iata: "SYQ",
    title: "Tobias Bolanos International Airport",
  },
  {
    iata: "XQP",
    title: "Quepos Managua Airport",
  },
  {
    iata: "RFR",
    title: "Rio Frio / Progreso Airport",
  },
  {
    iata: "PLD",
    title: "Playa Samara Airport",
  },
  {
    iata: "TOO",
    title: "San Vito De Java Airport",
  },
  {
    iata: "TNO",
    title: "Tamarindo De Santa Cruz Airport",
  },
  {
    iata: "TMU",
    title: "Tambor Airport",
  },
  {
    iata: "UPL",
    title: "Upala Airport",
  },
  {
    iata: "SAL",
    title: "El Salvador International Airport",
  },
  {
    iata: "CYA",
    title: "Les Cayes Airport",
  },
  {
    iata: "CAP",
    title: "Cap Haitien International Airport",
  },
  {
    iata: "JAK",
    title: "Jacmel Airport",
  },
  {
    iata: "PAP",
    title: "Toussaint Louverture International Airport",
  },
  {
    iata: "PAX",
    title: "Port-de-Paix Airport",
  },
  {
    iata: "MTU",
    title: "Montepuez Airport",
  },
  {
    iata: "BCA",
    title: "Gustavo Rizo Airport",
  },
  {
    iata: "BWW",
    title: "Las Brujas Airport",
  },
  {
    iata: "BYM",
    title: "Carlos Manuel de Cespedes Airport",
  },
  {
    iata: "AVI",
    title: "Maximo Gomez Airport",
  },
  {
    iata: "CCC",
    title: "Jardines Del Rey Airport",
  },
  {
    iata: "CFG",
    title: "Jaime Gonzalez Airport",
  },
  {
    iata: "CYO",
    title: "Vilo Acuna International Airport",
  },
  {
    iata: "CMW",
    title: "Ignacio Agramonte International Airport",
  },
  {
    iata: "SCU",
    title: "Antonio Maceo International Airport",
  },
  {
    iata: "NBW",
    title: "Leeward Point Field",
  },
  {
    iata: "GAO",
    title: "Mariana Grajales Airport",
  },
  {
    iata: "HOG",
    title: "Frank Pais International Airport",
  },
  {
    iata: "VRO",
    title: "Kawama Airport",
  },
  {
    iata: "LCL",
    title: "La Coloma Airport",
  },
  {
    iata: "UMA",
    title: "Punta de Maisi Airport",
  },
  {
    iata: "MJG",
    title: "Mayajigua Airport",
  },
  {
    iata: "MOA",
    title: "Orestes Acosta Airport",
  },
  {
    iata: "MZO",
    title: "Sierra Maestra Airport",
  },
  {
    iata: "QSN",
    title: "San Nicolas De Bari Airport",
  },
  {
    iata: "ICR",
    title: "Nicaro Airport",
  },
  {
    iata: "GER",
    title: "Rafael Cabrera Airport",
  },
  {
    iata: "UPB",
    title: "Playa Baracoa Airport",
  },
  {
    iata: "QPD",
    title: "Pinar Del Rio Airport",
  },
  {
    iata: "SNU",
    title: "Abel Santamaria Airport",
  },
  {
    iata: "SNJ",
    title: "San Julian Air Base",
  },
  {
    iata: "SZJ",
    title: "Siguanea Airport",
  },
  {
    iata: "USS",
    title: "Sancti Spiritus Airport",
  },
  {
    iata: "TND",
    title: "Alberto Delgado Airport",
  },
  {
    iata: "VRA",
    title: "Juan Gualberto Gomez International Airport",
  },
  {
    iata: "VTU",
    title: "Hermanos Ameijeiras Airport",
  },
  {
    iata: "CYB",
    title: "Gerrard Smith International Airport",
  },
  {
    iata: "LYB",
    title: "Edward Bodden Airfield",
  },
  {
    iata: "GCM",
    title: "Owen Roberts International Airport",
  },
  {
    iata: "AJS",
    title: "Abreojos Airport",
  },
  {
    iata: "AZG",
    title: "Pablo L. Sidar Airport",
  },
  {
    iata: "CEO",
    title: "El Crucero Airport",
  },
  {
    iata: "NVJ",
    title: "Navojoa Airport",
  },
  {
    iata: "PCM",
    title: "Playa del Carmen Airport",
  },
  {
    iata: "PCV",
    title: "Punta Chivato Airport",
  },
  {
    iata: "PNO",
    title: "Pinotepa Nacional Airport",
  },
  {
    iata: "SCX",
    title: "Salina Cruz Naval Air Station",
  },
  {
    iata: "SGM",
    title: "San Ignacio Airport",
  },
  {
    iata: "TUY",
    title: "Tulum Naval Air Station",
  },
  {
    iata: "GTB",
    title: "Genting Airport",
  },
  {
    iata: "GTK",
    title: "Sungei Tekai Airport",
  },
  {
    iata: "LBP",
    title: "Long Banga Airport",
  },
  {
    iata: "LLM",
    title: "Long Lama Airport",
  },
  {
    iata: "MZS",
    title: "Mostyn Airport",
  },
  {
    iata: "SPT",
    title: "Sipitang Airport",
  },
  {
    iata: "MAY",
    title: "Clarence A. Bain Airport",
  },
  {
    iata: "ASD",
    title: "Andros Town Airport",
  },
  {
    iata: "COX",
    title: "Congo Town Airport",
  },
  {
    iata: "MHH",
    title: "Marsh Harbour International Airport",
  },
  {
    iata: "SAQ",
    title: "San Andros Airport",
  },
  {
    iata: "AXP",
    title: "Spring Point Airport",
  },
  {
    iata: "TCB",
    title: "Treasure Cay Airport",
  },
  {
    iata: "WKR",
    title: "Abaco I Walker C Airport",
  },
  {
    iata: "CCZ",
    title: "Chub Cay Airport",
  },
  {
    iata: "GHC",
    title: "Great Harbour Cay Airport",
  },
  {
    iata: "BIM",
    title: "South Bimini Airport",
  },
  {
    iata: "ATC",
    title: "Arthur's Town Airport",
  },
  {
    iata: "CAT",
    title: "New Bight Airport",
  },
  {
    iata: "CXY",
    title: "Cat Cay Airport",
  },
  {
    iata: "CRI",
    title: "Colonel Hill Airport",
  },
  {
    iata: "PWN",
    title: "Pitts Town Airport",
  },
  {
    iata: "GGT",
    title: "Exuma International Airport",
  },
  {
    iata: "ELH",
    title: "North Eleuthera Airport",
  },
  {
    iata: "GHB",
    title: "Governor's Harbour Airport",
  },
  {
    iata: "NMC",
    title: "Normans Cay Airport",
  },
  {
    iata: "RSD",
    title: "Rock Sound Airport",
  },
  {
    iata: "TYM",
    title: "Staniel Cay Airport",
  },
  {
    iata: "FPO",
    title: "Grand Bahama International Airport",
  },
  {
    iata: "WTD",
    title: "West End Airport",
  },
  {
    iata: "IGA",
    title: "Inagua Airport",
  },
  {
    iata: "LGI",
    title: "Deadman's Cay Airport",
  },
  {
    iata: "SML",
    title: "Stella Maris Airport",
  },
  {
    iata: "MYG",
    title: "Mayaguana Airport",
  },
  {
    iata: "NAS",
    title: "Lynden Pindling International Airport",
  },
  {
    iata: "PID",
    title: "Nassau Paradise Island Airport",
  },
  {
    iata: "DCT",
    title: "Duncan Town Airport",
  },
  {
    iata: "RCY",
    title: "Rum Cay Airport",
  },
  {
    iata: "ZSA",
    title: "San Salvador Airport",
  },
  {
    iata: "MFW",
    title: "Magaruque Airport",
  },
  {
    iata: "BZE",
    title: "Philip S. W. Goldson International Airport",
  },
  {
    iata: "NBS",
    title: "Changbaishan Airport",
  },
  {
    iata: "AIT",
    title: "Aitutaki Airport",
  },
  {
    iata: "AIU",
    title: "Enua Airport",
  },
  {
    iata: "MGS",
    title: "Mangaia Island Airport",
  },
  {
    iata: "MHX",
    title: "Manihiki Island Airport",
  },
  {
    iata: "MUK",
    title: "Mauke Airport",
  },
  {
    iata: "MOI",
    title: "Mitiaro Island Airport",
  },
  {
    iata: "PYE",
    title: "Tongareva Airport",
  },
  {
    iata: "RAR",
    title: "Rarotonga International Airport",
  },
  {
    iata: "ICI",
    title: "Cicia Airport",
  },
  {
    iata: "NAN",
    title: "Nadi International Airport",
  },
  {
    iata: "PTF",
    title: "Malolo Lailai Island Airport",
  },
  {
    iata: "KDV",
    title: "Vunisea Airport",
  },
  {
    iata: "MNF",
    title: "Mana Island Airport",
  },
  {
    iata: "MFJ",
    title: "Moala Airport",
  },
  {
    iata: "SUV",
    title: "Nausori International Airport",
  },
  {
    iata: "LEV",
    title: "Levuka Airfield",
  },
  {
    iata: "NGI",
    title: "Ngau Airport",
  },
  {
    iata: "LUC",
    title: "Laucala Island Airport",
  },
  {
    iata: "LKB",
    title: "Lakeba Island Airport",
  },
  {
    iata: "LBS",
    title: "Labasa Airport",
  },
  {
    iata: "TVU",
    title: "Matei Airport",
  },
  {
    iata: "KXF",
    title: "Koro Island Airport",
  },
  {
    iata: "RTA",
    title: "Rotuma Airport",
  },
  {
    iata: "SVU",
    title: "Savusavu Airport",
  },
  {
    iata: "VAU",
    title: "Vatukoula Airport",
  },
  {
    iata: "KAY",
    title: "Wakaya Island Airport",
  },
  {
    iata: "ONU",
    title: "Ono-I-Lau Airport",
  },
  {
    iata: "YAS",
    title: "Yasawa Island Airport",
  },
  {
    iata: "EUA",
    title: "Kaufana Airport",
  },
  {
    iata: "TBU",
    title: "Fua'amotu International Airport",
  },
  {
    iata: "HPA",
    title: "Lifuka Island Airport",
  },
  {
    iata: "NFO",
    title: "Mata'aho Airport",
  },
  {
    iata: "NTT",
    title: "Kuini Lavenia Airport",
  },
  {
    iata: "VAV",
    title: "Vava'u International Airport",
  },
  {
    iata: "VBV",
    title: "Vanua Balavu Airport",
  },
  {
    iata: "VTF",
    title: "Vatulele Airport",
  },
  {
    iata: "GMO",
    title: "Gombe Lawanti International Airport",
  },
  {
    iata: "PHG",
    title: "Port Harcourt City Airport",
  },
  {
    iata: "BCU",
    title: "Bauchi Airport",
  },
  {
    iata: "QRW",
    title: "Warri Airport",
  },
  {
    iata: "ABF",
    title: "Abaiang Airport",
  },
  {
    iata: "BEZ",
    title: "Beru Airport",
  },
  {
    iata: "FUN",
    title: "Funafuti International Airport",
  },
  {
    iata: "KUC",
    title: "Kuria Airport",
  },
  {
    iata: "MNK",
    title: "Maiana Airport",
  },
  {
    iata: "MZK",
    title: "Marakei Airport",
  },
  {
    iata: "MTK",
    title: "Makin Island Airport",
  },
  {
    iata: "NIG",
    title: "Nikunau Airport",
  },
  {
    iata: "OOT",
    title: "Onotoa Airport",
  },
  {
    iata: "TRW",
    title: "Bonriki International Airport",
  },
  {
    iata: "AEA",
    title: "Abemama Atoll Airport",
  },
  {
    iata: "TBF",
    title: "Tabiteuea North Airport",
  },
  {
    iata: "TMN",
    title: "Tamana Island Airport",
  },
  {
    iata: "NON",
    title: "Nonouti Airport",
  },
  {
    iata: "AIS",
    title: "Arorae Island Airport",
  },
  {
    iata: "TSU",
    title: "Tabiteuea South Airport",
  },
  {
    iata: "BBG",
    title: "Butaritari Atoll Airport",
  },
  {
    iata: "AAK",
    title: "Buariki Airport",
  },
  {
    iata: "IUE",
    title: "Niue International Airport",
  },
  {
    iata: "FUT",
    title: "Pointe Vele Airport",
  },
  {
    iata: "WLS",
    title: "Hihifo Airport",
  },
  {
    iata: "MWP",
    title: "Mountain Airport",
  },
  {
    iata: "TPJ",
    title: "Taplejung Airport",
  },
  {
    iata: "OFU",
    title: "Ofu Village Airport",
  },
  {
    iata: "AAU",
    title: "Asau Airport",
  },
  {
    iata: "APW",
    title: "Faleolo International Airport",
  },
  {
    iata: "FGI",
    title: "Fagali'i Airport",
  },
  {
    iata: "FAQ",
    title: "Fitiuta Airport",
  },
  {
    iata: "MXS",
    title: "Maota Airport",
  },
  {
    iata: "PPG",
    title: "Pago Pago International Airport",
  },
  {
    iata: "PPT",
    title: "Faa'a International Airport",
  },
  {
    iata: "RUR",
    title: "Rurutu Airport",
  },
  {
    iata: "TUB",
    title: "Tubuai Airport",
  },
  {
    iata: "AAA",
    title: "Anaa Airport",
  },
  {
    iata: "FGU",
    title: "Fangatau Airport",
  },
  {
    iata: "TIH",
    title: "Tikehau Airport",
  },
  {
    iata: "APK",
    title: "Apataki Airport",
  },
  {
    iata: "REA",
    title: "Reao Airport",
  },
  {
    iata: "FAV",
    title: "Fakarava Airport",
  },
  {
    iata: "HHZ",
    title: "Hikueru Atoll Airport",
  },
  {
    iata: "XMH",
    title: "Manihi Airport",
  },
  {
    iata: "GMR",
    title: "Totegegie Airport",
  },
  {
    iata: "KKR",
    title: "Kaukura Airport",
  },
  {
    iata: "MKP",
    title: "Makemo Airport",
  },
  {
    iata: "NAU",
    title: "Napuka Island Airport",
  },
  {
    iata: "TKV",
    title: "Tatakoto Airport",
  },
  {
    iata: "PKP",
    title: "Puka Puka Airport",
  },
  {
    iata: "PUK",
    title: "Pukarua Airport",
  },
  {
    iata: "TKP",
    title: "Takapoto Airport",
  },
  {
    iata: "AXR",
    title: "Arutua Airport",
  },
  {
    iata: "MVT",
    title: "Mataiva Airport",
  },
  {
    iata: "NUK",
    title: "Nukutavake Airport",
  },
  {
    iata: "ZTA",
    title: "Tureia Airport",
  },
  {
    iata: "AHE",
    title: "Ahe Airport",
  },
  {
    iata: "KHZ",
    title: "Kauehi Airport",
  },
  {
    iata: "FAC",
    title: "Faaite Airport",
  },
  {
    iata: "FHZ",
    title: "Fakahina Airport",
  },
  {
    iata: "TKX",
    title: "Takaroa Airport",
  },
  {
    iata: "NHV",
    title: "Nuku Hiva Airport",
  },
  {
    iata: "AUQ",
    title: "Hiva Oa-Atuona Airport",
  },
  {
    iata: "UAP",
    title: "Ua Pou Airport",
  },
  {
    iata: "UAH",
    title: "Ua Huka Airport",
  },
  {
    iata: "BOB",
    title: "Bora Bora Airport",
  },
  {
    iata: "TTI",
    title: "Tetiaroa Airport",
  },
  {
    iata: "RGI",
    title: "Rangiroa Airport",
  },
  {
    iata: "HUH",
    title: "Huahine-Fare Airport",
  },
  {
    iata: "MOZ",
    title: "Moorea Airport",
  },
  {
    iata: "HOI",
    title: "Hao Airport",
  },
  {
    iata: "MAU",
    title: "Maupiti Airport",
  },
  {
    iata: "RFP",
    title: "Raiatea Airport",
  },
  {
    iata: "VHZ",
    title: "Vahitahi Airport",
  },
  {
    iata: "MTV",
    title: "Mota Lava Airport",
  },
  {
    iata: "SLH",
    title: "Sola Airport",
  },
  {
    iata: "TOH",
    title: "Torres Airstrip",
  },
  {
    iata: "EAE",
    title: "Sangafa Airport",
  },
  {
    iata: "CCV",
    title: "Craig Cove Airport",
  },
  {
    iata: "LOD",
    title: "Longana Airport",
  },
  {
    iata: "SSR",
    title: "Sara Airport",
  },
  {
    iata: "PBJ",
    title: "Tavie Airport",
  },
  {
    iata: "LPM",
    title: "Lamap Airport",
  },
  {
    iata: "LNB",
    title: "Lamen Bay Airport",
  },
  {
    iata: "MWF",
    title: "Naone Airport",
  },
  {
    iata: "LNE",
    title: "Lonorore Airport",
  },
  {
    iata: "NUS",
    title: "Norsup Airport",
  },
  {
    iata: "ZGU",
    title: "Gaua Island Airport",
  },
  {
    iata: "RCL",
    title: "Redcliffe Airport",
  },
  {
    iata: "SON",
    title: "Santo Pekoa International Airport",
  },
  {
    iata: "TGH",
    title: "Tongoa Island Airport",
  },
  {
    iata: "VLS",
    title: "Valesdir Airport",
  },
  {
    iata: "WLH",
    title: "Walaha Airport",
  },
  {
    iata: "SWJ",
    title: "Southwest Bay Airport",
  },
  {
    iata: "OLJ",
    title: "North West Santo Airport",
  },
  {
    iata: "AUY",
    title: "Anelghowhat Airport",
  },
  {
    iata: "AWD",
    title: "Aniwa Airport",
  },
  {
    iata: "DLY",
    title: "Dillon's Bay Airport",
  },
  {
    iata: "FTA",
    title: "Futuna Airport",
  },
  {
    iata: "IPA",
    title: "Ipota Airport",
  },
  {
    iata: "UIQ",
    title: "Quion Hill Airport",
  },
  {
    iata: "VLI",
    title: "Port Vila Bauerfield Airport",
  },
  {
    iata: "TAH",
    title: "Tanna Airport",
  },
  {
    iata: "TGJ",
    title: "Tiga Airport",
  },
  {
    iata: "HLU",
    title: "Nesson Airport",
  },
  {
    iata: "KOC",
    title: "Koumac Airport",
  },
  {
    iata: "LIF",
    title: "Lifou Airport",
  },
  {
    iata: "PUV",
    title: "Poum Airport",
  },
  {
    iata: "PDC",
    title: "Mueo Airport",
  },
  {
    iata: "TOU",
    title: "Touho Airport",
  },
  {
    iata: "NOU",
    title: "La Tontouta International Airport",
  },
  {
    iata: "AKL",
    title: "Auckland International Airport",
  },
  {
    iata: "TUO",
    title: "Taupo Airport",
  },
  {
    iata: "AMZ",
    title: "Ardmore Airport",
  },
  {
    iata: "ASG",
    title: "Ashburton Aerodrome",
  },
  {
    iata: "CHC",
    title: "Christchurch International Airport",
  },
  {
    iata: "CHT",
    title: "Chatham Islands-Tuuta Airport",
  },
  {
    iata: "CMV",
    title: "Coromandel Aerodrome",
  },
  {
    iata: "DGR",
    title: "Dargaville Aerodrome",
  },
  {
    iata: "DUD",
    title: "Dunedin Airport",
  },
  {
    iata: "FGL",
    title: "Fox Heliport",
  },
  {
    iata: "WHO",
    title: "Franz Josef Aerodrome",
  },
  {
    iata: "GBZ",
    title: "Great Barrier Aerodrome",
  },
  {
    iata: "GMN",
    title: "Greymouth Airport",
  },
  {
    iata: "GIS",
    title: "Gisborne Airport",
  },
  {
    iata: "GTN",
    title: "Glentanner Airport",
  },
  {
    iata: "HKK",
    title: "Hokitika Airfield",
  },
  {
    iata: "HLZ",
    title: "Hamilton International Airport",
  },
  {
    iata: "WIK",
    title: "Waiheke Reeve Airport",
  },
  {
    iata: "KBZ",
    title: "Kaikoura Airport",
  },
  {
    iata: "KKE",
    title: "Kerikeri Airport",
  },
  {
    iata: "KKO",
    title: "Kaikohe Airport",
  },
  {
    iata: "KAT",
    title: "Kaitaia Airport",
  },
  {
    iata: "ALR",
    title: "Alexandra Airport",
  },
  {
    iata: "MTA",
    title: "Matamata Glider Airport",
  },
  {
    iata: "MON",
    title: "Mount Cook Airport",
  },
  {
    iata: "MFN",
    title: "Milford Sound Airport",
  },
  {
    iata: "MZP",
    title: "Motueka Airport",
  },
  {
    iata: "TEU",
    title: "Manapouri Airport",
  },
  {
    iata: "MRO",
    title: "Hood Airport",
  },
  {
    iata: "NPL",
    title: "New Plymouth Airport",
  },
  {
    iata: "NPE",
    title: "Napier Airport",
  },
  {
    iata: "NSN",
    title: "Nelson Airport",
  },
  {
    iata: "IVC",
    title: "Invercargill Airport",
  },
  {
    iata: "OHA",
    title: "RNZAF Base Ohakea",
  },
  {
    iata: "OAM",
    title: "Oamaru Airport",
  },
  {
    iata: "PMR",
    title: "Palmerston North Airport",
  },
  {
    iata: "PCN",
    title: "Picton Aerodrome",
  },
  {
    iata: "PPQ",
    title: "Paraparaumu Airport",
  },
  {
    iata: "ZQN",
    title: "Queenstown International Airport",
  },
  {
    iata: "RAG",
    title: "Raglan Airfield",
  },
  {
    iata: "SZS",
    title: "Ryans Creek Aerodrome",
  },
  {
    iata: "ROT",
    title: "Rotorua Regional Airport",
  },
  {
    iata: "TRG",
    title: "Tauranga Airport",
  },
  {
    iata: "TMZ",
    title: "Thames Aerodrome",
  },
  {
    iata: "KTF",
    title: "Takaka Airport",
  },
  {
    iata: "TKZ",
    title: "Tokoroa Airfield",
  },
  {
    iata: "THH",
    title: "Taharoa Aerodrome",
  },
  {
    iata: "TIU",
    title: "Timaru Airport",
  },
  {
    iata: "TWZ",
    title: "Pukaki Airport",
  },
  {
    iata: "BHE",
    title: "Woodbourne Airport",
  },
  {
    iata: "WKA",
    title: "Wanaka Airport",
  },
  {
    iata: "WHK",
    title: "Whakatane Airport",
  },
  {
    iata: "WLG",
    title: "Wellington International Airport",
  },
  {
    iata: "WIR",
    title: "Wairoa Airport",
  },
  {
    iata: "WRE",
    title: "Whangarei Airport",
  },
  {
    iata: "WSZ",
    title: "Westport Airport",
  },
  {
    iata: "WTZ",
    title: "Whitianga Airport",
  },
  {
    iata: "WAG",
    title: "Wanganui Airport",
  },
  {
    iata: "O62",
    title: "Carmel Valley",
  },
  {
    iata: "BZF",
    title: "Benton Field",
  },
  {
    iata: "OAA",
    title: "Shank Air Base",
  },
  {
    iata: "BIN",
    title: "Bamiyan Airport",
  },
  {
    iata: "BST",
    title: "Bost Airport",
  },
  {
    iata: "CCN",
    title: "Chakcharan Airport",
  },
  {
    iata: "DAZ",
    title: "Darwaz Airport",
  },
  {
    iata: "FAH",
    title: "Farah Airport",
  },
  {
    iata: "FBD",
    title: "Faizabad Airport",
  },
  {
    iata: "KWH",
    title: "Khwahan Airport",
  },
  {
    iata: "HEA",
    title: "Herat Airport",
  },
  {
    iata: "OAI",
    title: "Bagram Air Base",
  },
  {
    iata: "JAA",
    title: "Jalalabad Airport",
  },
  {
    iata: "KBL",
    title: "Kabul International Airport",
  },
  {
    iata: "KDH",
    title: "Kandahar Airport",
  },
  {
    iata: "KHT",
    title: "Khost Airport",
  },
  {
    iata: "MMZ",
    title: "Maimana Airport",
  },
  {
    iata: "MZR",
    title: "Mazar I Sharif Airport",
  },
  {
    iata: "LQN",
    title: "Qala-I-Naw Airport",
  },
  {
    iata: "OAS",
    title: "Sharana Airstrip",
  },
  {
    iata: "OAH",
    title: "Shindand Airport",
  },
  {
    iata: "SGA",
    title: "Sheghnan Airport",
  },
  {
    iata: "TII",
    title: "Tereen Airport",
  },
  {
    iata: "UND",
    title: "Konduz Airport",
  },
  {
    iata: "OAZ",
    title: "Camp Bastion Airport",
  },
  {
    iata: "ZAJ",
    title: "Zaranj Airport",
  },
  {
    iata: "BAH",
    title: "Bahrain International Airport",
  },
  {
    iata: "OBK",
    title: "Sky Harbor Airport",
  },
  {
    iata: "AHB",
    title: "Abha Regional Airport",
  },
  {
    iata: "HOF",
    title: "Al Ahsa Airport",
  },
  {
    iata: "ABT",
    title: "Al Baha Airport",
  },
  {
    iata: "BHH",
    title: "Bisha Airport",
  },
  {
    iata: "DMM",
    title: "King Fahd International Airport",
  },
  {
    iata: "DHA",
    title: "King Abdulaziz Air Base",
  },
  {
    iata: "DWD",
    title: "Dawadmi Domestic Airport",
  },
  {
    iata: "GIZ",
    title: "Jizan Regional Airport",
  },
  {
    iata: "ELQ",
    title: "Gassim Airport",
  },
  {
    iata: "URY",
    title: "Guriat Domestic Airport",
  },
  {
    iata: "HAS",
    title: "Hail Airport",
  },
  {
    iata: "QJB",
    title: "Jubail Airport",
  },
  {
    iata: "JED",
    title: "King Abdulaziz International Airport",
  },
  {
    iata: "HBT",
    title: "King Khaled Military City Airport",
  },
  {
    iata: "KMX",
    title: "King Khaled Air Base",
  },
  {
    iata: "MED",
    title: "Prince Mohammad Bin Abdulaziz Airport",
  },
  {
    iata: "EAM",
    title: "Nejran Airport",
  },
  {
    iata: "AQI",
    title: "Hafr Al Batin Airport",
  },
  {
    iata: "AKH",
    title: "Prince Sultan Air Base",
  },
  {
    iata: "RAH",
    title: "Rafha Domestic Airport",
  },
  {
    iata: "RUH",
    title: "King Khaled International Airport",
  },
  {
    iata: "RAE",
    title: "Arar Domestic Airport",
  },
  {
    iata: "XXN",
    title: "Riyadh Air Base",
  },
  {
    iata: "SHW",
    title: "Sharurah Airport",
  },
  {
    iata: "AJF",
    title: "Al-Jawf Domestic Airport",
  },
  {
    iata: "SLF",
    title: "Sulayel Airport",
  },
  {
    iata: "TUU",
    title: "Tabuk Airport",
  },
  {
    iata: "TIF",
    title: "Taif Airport",
  },
  {
    iata: "TUI",
    title: "Turaif Domestic Airport",
  },
  {
    iata: "EWD",
    title: "Wadi Al Dawasir Airport",
  },
  {
    iata: "EJH",
    title: "Al Wajh Domestic Airport",
  },
  {
    iata: "YNB",
    title: "Yenbo Airport",
  },
  {
    iata: "ZUL",
    title: "Zilfi Airport",
  },
  {
    iata: "OHE",
    title: "Gu-Lian Airport",
  },
  {
    iata: "ABD",
    title: "Abadan Airport",
  },
  {
    iata: "OMI",
    title: "Omidiyeh Airport",
  },
  {
    iata: "MRX",
    title: "Mahshahr Airport",
  },
  {
    iata: "AWZ",
    title: "Ahwaz Airport",
  },
  {
    iata: "AEU",
    title: "Abumusa Island Airport",
  },
  {
    iata: "BUZ",
    title: "Bushehr Airport",
  },
  {
    iata: "AOY",
    title: "Asaloyeh Airport",
  },
  {
    iata: "KNR",
    title: "Jam Airport",
  },
  {
    iata: "KIH",
    title: "Kish International Airport",
  },
  {
    iata: "BDH",
    title: "Bandar Lengeh Airport",
  },
  {
    iata: "YEH",
    title: "Persian Gulf International Airport",
  },
  {
    iata: "KHK",
    title: "Khark Island Airport",
  },
  {
    iata: "SXI",
    title: "Sirri Island Airport",
  },
  {
    iata: "LVP",
    title: "Lavan Island Airport",
  },
  {
    iata: "KSH",
    title: "Shahid Ashrafi Esfahani Airport",
  },
  {
    iata: "IIL",
    title: "Ilam Airport",
  },
  {
    iata: "KHD",
    title: "Khoram Abad Airport",
  },
  {
    iata: "SDG",
    title: "Sanandaj Airport",
  },
  {
    iata: "IFH",
    title: "Hesa Airport",
  },
  {
    iata: "IFN",
    title: "Esfahan Shahid Beheshti International Airport",
  },
  {
    iata: "CQD",
    title: "Shahrekord Airport",
  },
  {
    iata: "RAS",
    title: "Rasht Airport",
  },
  {
    iata: "HDM",
    title: "Hamadan Airport",
  },
  {
    iata: "AJK",
    title: "Arak Airport",
  },
  {
    iata: "IKA",
    title: "Imam Khomeini International Airport",
  },
  {
    iata: "THR",
    title: "Mehrabad International Airport",
  },
  {
    iata: "BND",
    title: "Bandar Abbas International Airport",
  },
  {
    iata: "KER",
    title: "Kerman Airport",
  },
  {
    iata: "BXR",
    title: "Bam Airport",
  },
  {
    iata: "HDR",
    title: "Havadarya Airport",
  },
  {
    iata: "RJN",
    title: "Rafsanjan Airport",
  },
  {
    iata: "SYJ",
    title: "Sirjan Airport",
  },
  {
    iata: "XBJ",
    title: "Birjand Airport",
  },
  {
    iata: "CKT",
    title: "Sarakhs Airport",
  },
  {
    iata: "MHD",
    title: "Mashhad International Airport",
  },
  {
    iata: "BJB",
    title: "Bojnord Airport",
  },
  {
    iata: "AFZ",
    title: "Sabzevar National Airport",
  },
  {
    iata: "TCX",
    title: "Tabas Airport",
  },
  {
    iata: "BBL",
    title: "Babolsar Airport",
  },
  {
    iata: "GBT",
    title: "Gorgan Airport",
  },
  {
    iata: "BSM",
    title: "Bishe Kola Air Base",
  },
  {
    iata: "NSH",
    title: "Noshahr Airport",
  },
  {
    iata: "RZR",
    title: "Ramsar Airport",
  },
  {
    iata: "SRY",
    title: "Dasht-e Naz Airport",
  },
  {
    iata: "FAZ",
    title: "Fasa Airport",
  },
  {
    iata: "LRR",
    title: "Lar Airport",
  },
  {
    iata: "SYZ",
    title: "Shiraz Shahid Dastghaib International Airport",
  },
  {
    iata: "KHY",
    title: "Khoy Airport",
  },
  {
    iata: "ADU",
    title: "Ardabil Airport",
  },
  {
    iata: "ACP",
    title: "Sahand Airport",
  },
  {
    iata: "PFQ",
    title: "Parsabade Moghan Airport",
  },
  {
    iata: "OMH",
    title: "Urmia Airport",
  },
  {
    iata: "TBZ",
    title: "Tabriz International Airport",
  },
  {
    iata: "AZD",
    title: "Shahid Sadooghi Airport",
  },
  {
    iata: "ACZ",
    title: "Zabol Airport",
  },
  {
    iata: "ZBR",
    title: "Konarak Airport",
  },
  {
    iata: "ZAH",
    title: "Zahedan International Airport",
  },
  {
    iata: "AMM",
    title: "Queen Alia International Airport",
  },
  {
    iata: "ADJ",
    title: "Amman-Marka International Airport",
  },
  {
    iata: "AQJ",
    title: "Aqaba King Hussein International Airport",
  },
  {
    iata: "JRS",
    title: "Jerusalem Airport",
  },
  {
    iata: "OMF",
    title: "King Hussein Air College",
  },
  {
    iata: "KWI",
    title: "Kuwait International Airport",
  },
  {
    iata: "BEY",
    title: "Beirut Rafic Hariri International Airport",
  },
  {
    iata: "KYE",
    title: "Rene Mouawad Air Base",
  },
  {
    iata: "BYB",
    title: "Dibba Airport",
  },
  {
    iata: "AOM",
    title: "Adam Airport",
  },
  {
    iata: "AUH",
    title: "Abu Dhabi International Airport",
  },
  {
    iata: "AZI",
    title: "Bateen Airport",
  },
  {
    iata: "AAN",
    title: "Al Ain International Airport",
  },
  {
    iata: "DXB",
    title: "Dubai International Airport",
  },
  {
    iata: "NHD",
    title: "Al Minhad Air Base",
  },
  {
    iata: "DWC",
    title: "Al Maktoum International Airport",
  },
  {
    iata: "FJR",
    title: "Fujairah International Airport",
  },
  {
    iata: "RKT",
    title: "Ras Al Khaimah International Airport",
  },
  {
    iata: "SHJ",
    title: "Sharjah International Airport",
  },
  {
    iata: "RMB",
    title: "Buraimi Airport",
  },
  {
    iata: "KHS",
    title: "Khasab Air Base",
  },
  {
    iata: "MSH",
    title: "Masirah Air Base",
  },
  {
    iata: "MCT",
    title: "Muscat International Airport",
  },
  {
    iata: "OMM",
    title: "Marmul Airport",
  },
  {
    iata: "SLL",
    title: "Salalah Airport",
  },
  {
    iata: "SUH",
    title: "Sur Airport",
  },
  {
    iata: "TTH",
    title: "Thumrait Air Base",
  },
  {
    iata: "DDU",
    title: "Dadu West Airport",
  },
  {
    iata: "AAW",
    title: "Abbottabad Airport",
  },
  {
    iata: "BNP",
    title: "Bannu Airport",
  },
  {
    iata: "WGB",
    title: "Bahawalnagar Airport",
  },
  {
    iata: "BHV",
    title: "Bahawalpur Airport",
  },
  {
    iata: "CJL",
    title: "Chitral Airport",
  },
  {
    iata: "CHB",
    title: "Chilas Airport",
  },
  {
    iata: "DBA",
    title: "Dalbandin Airport",
  },
  {
    iata: "DDU",
    title: "Dadu Airport",
  },
  {
    iata: "DEA",
    title: "Dera Ghazi Khan Airport",
  },
  {
    iata: "DSK",
    title: "Dera Ismael Khan Airport",
  },
  {
    iata: "LYP",
    title: "Faisalabad International Airport",
  },
  {
    iata: "GWD",
    title: "Gwadar International Airport",
  },
  {
    iata: "GIL",
    title: "Gilgit Airport",
  },
  {
    iata: "JAG",
    title: "Shahbaz Air Base",
  },
  {
    iata: "JIW",
    title: "Jiwani Airport",
  },
  {
    iata: "KHI",
    title: "Jinnah International Airport",
  },
  {
    iata: "HDD",
    title: "Hyderabad Airport",
  },
  {
    iata: "KDD",
    title: "Khuzdar Airport",
  },
  {
    iata: "KBH",
    title: "Kalat Airport",
  },
  {
    iata: "OHT",
    title: "Kohat Airport",
  },
  {
    iata: "LHE",
    title: "Alama Iqbal International Airport",
  },
  {
    iata: "LRG",
    title: "Loralai Airport",
  },
  {
    iata: "XJM",
    title: "Mangla Airport",
  },
  {
    iata: "MFG",
    title: "Muzaffarabad Airport",
  },
  {
    iata: "MWD",
    title: "Mianwali Air Base",
  },
  {
    iata: "MJD",
    title: "Moenjodaro Airport",
  },
  {
    iata: "MPD",
    title: "Mirpur Khas Air Base",
  },
  {
    iata: "MPD",
    title: "Sindhri Tharparkar Airport",
  },
  {
    iata: "MUX",
    title: "Multan International Airport",
  },
  {
    iata: "WNS",
    title: "Nawabshah Airport",
  },
  {
    iata: "NHS",
    title: "Nushki Airport",
  },
  {
    iata: "ORW",
    title: "Ormara Airport",
  },
  {
    iata: "PAJ",
    title: "Parachinar Airport",
  },
  {
    iata: "PJG",
    title: "Panjgur Airport",
  },
  {
    iata: "PSI",
    title: "Pasni Airport",
  },
  {
    iata: "PEW",
    title: "Peshawar International Airport",
  },
  {
    iata: "UET",
    title: "Quetta International Airport",
  },
  {
    iata: "RYK",
    title: "Shaikh Zaid Airport",
  },
  {
    iata: "ISB",
    title: "Benazir Bhutto International Airport",
  },
  {
    iata: "RAZ",
    title: "Rawalakot Airport",
  },
  {
    iata: "SBQ",
    title: "Sibi Airport",
  },
  {
    iata: "KDU",
    title: "Skardu Airport",
  },
  {
    iata: "SKZ",
    title: "Sukkur Airport",
  },
  {
    iata: "SYW",
    title: "Sehwan Sharif Airport",
  },
  {
    iata: "SGI",
    title: "Mushaf Air Base",
  },
  {
    iata: "SDT",
    title: "Saidu Sharif Airport",
  },
  {
    iata: "SKT",
    title: "Sialkot Airport",
  },
  {
    iata: "SUL",
    title: "Sui Airport",
  },
  {
    iata: "SWN",
    title: "Sahiwal Airport",
  },
  {
    iata: "TLB",
    title: "Tarbela Dam Airport",
  },
  {
    iata: "BDN",
    title: "Talhar Airport",
  },
  {
    iata: "TFT",
    title: "Taftan Airport",
  },
  {
    iata: "TUK",
    title: "Turbat International Airport",
  },
  {
    iata: "WAF",
    title: "Wana Airport",
  },
  {
    iata: "PZH",
    title: "Zhob Airport",
  },
  {
    iata: "IQA",
    title: "Al Asad Air Base",
  },
  {
    iata: "BMN",
    title: "Bamarni Airport",
  },
  {
    iata: "SDA",
    title: "Baghdad International Airport",
  },
  {
    iata: "OSB",
    title: "Mosul International Airport",
  },
  {
    iata: "EBL",
    title: "Erbil International Airport",
  },
  {
    iata: "KIK",
    title: "Kirkuk Air Base",
  },
  {
    iata: "BSR",
    title: "Basrah International Airport",
  },
  {
    iata: "OSO",
    title: "Sulaymaniyah International Airport",
  },
  {
    iata: "ALP",
    title: "Aleppo International Airport",
  },
  {
    iata: "DAM",
    title: "Damascus International Airport",
  },
  {
    iata: "DEZ",
    title: "Deir ez-Zor Airport",
  },
  {
    iata: "KAC",
    title: "Kamishly Airport",
  },
  {
    iata: "LTK",
    title: "Bassel Al-Assad International Airport",
  },
  {
    iata: "PMS",
    title: "Palmyra Airport",
  },
  {
    iata: "DOH",
    title: "Doha International Airport",
  },
  {
    iata: "IUD",
    title: "Al Udeid Air Base",
  },
  {
    iata: "OTT",
    title: "Andre Maggi Airport",
  },
  {
    iata: "ADE",
    title: "Aden International Airport",
  },
  {
    iata: "EAB",
    title: "Abbse Airport",
  },
  {
    iata: "AXK",
    title: "Ataq Airport",
  },
  {
    iata: "BHN",
    title: "Beihan Airport",
  },
  {
    iata: "AAY",
    title: "Al Ghaidah International Airport",
  },
  {
    iata: "HOD",
    title: "Hodeidah International Airport",
  },
  {
    iata: "MYN",
    title: "Mareb Airport",
  },
  {
    iata: "IHN",
    title: "Qishn Airport",
  },
  {
    iata: "RIY",
    title: "Mukalla International Airport",
  },
  {
    iata: "SYE",
    title: "Sadah Airport",
  },
  {
    iata: "SAH",
    title: "Sana'a International Airport",
  },
  {
    iata: "SCT",
    title: "Socotra International Airport",
  },
  {
    iata: "GXF",
    title: "Sayun International Airport",
  },
  {
    iata: "TAI",
    title: "Ta'izz International Airport",
  },
  {
    iata: "ACU",
    title: "Achutupo Airport",
  },
  {
    iata: "AIL",
    title: "Alligandi Airport",
  },
  {
    iata: "AML",
    title: "Puerto Armuelles Airport",
  },
  {
    iata: "ELE",
    title: "EL Real Airport",
  },
  {
    iata: "OTD",
    title: "Contadora Airport",
  },
  {
    iata: "SAX",
    title: "Sambu Airport",
  },
  {
    iata: "AKB",
    title: "Atka Airport",
  },
  {
    iata: "PTD",
    title: "Port Alexander Seaplane Base",
  },
  {
    iata: "PAQ",
    title: "Palmer Municipal Airport",
  },
  {
    iata: "BTI",
    title: "Barter Island Lrrs Airport",
  },
  {
    iata: "BET",
    title: "Bethel Airport",
  },
  {
    iata: "BVU",
    title: "Beluga Airport",
  },
  {
    iata: "BIG",
    title: "Allen Army Airfield",
  },
  {
    iata: "BKC",
    title: "Buckland Airport",
  },
  {
    iata: "BRW",
    title: "Wiley Post Will Rogers Memorial Airport",
  },
  {
    iata: "BTT",
    title: "Bettles Airport",
  },
  {
    iata: "CDB",
    title: "Cold Bay Airport",
  },
  {
    iata: "CLF",
    title: "Clear Airport",
  },
  {
    iata: "CDV",
    title: "Merle K (Mudhole) Smith Airport",
  },
  {
    iata: "CZF",
    title: "Cape Romanzof Lrrs Airport",
  },
  {
    iata: "DRG",
    title: "Deering Airport",
  },
  {
    iata: "ADK",
    title: "Adak Airport",
  },
  {
    iata: "DLG",
    title: "Dillingham Airport",
  },
  {
    iata: "ADQ",
    title: "Kodiak Airport",
  },
  {
    iata: "DUT",
    title: "Unalaska Airport",
  },
  {
    iata: "EDF",
    title: "Elmendorf Air Force Base",
  },
  {
    iata: "EEK",
    title: "Eek Airport",
  },
  {
    iata: "EHM",
    title: "Cape Newenham Lrrs Airport",
  },
  {
    iata: "EIL",
    title: "Eielson Air Force Base",
  },
  {
    iata: "ENM",
    title: "Emmonak Airport",
  },
  {
    iata: "ENA",
    title: "Kenai Municipal Airport",
  },
  {
    iata: "FAI",
    title: "Fairbanks International Airport",
  },
  {
    iata: "FBK",
    title: "Ladd AAF Airfield",
  },
  {
    iata: "AFE",
    title: "Kake Airport",
  },
  {
    iata: "ABL",
    title: "Ambler Airport",
  },
  {
    iata: "FRN",
    title: "Bryant Army Air Force Airport",
  },
  {
    iata: "FMC",
    title: "Five Mile Airport",
  },
  {
    iata: "GAL",
    title: "Edward G. Pitka Sr Airport",
  },
  {
    iata: "GKN",
    title: "Gulkana Airport",
  },
  {
    iata: "GAM",
    title: "Gambell Airport",
  },
  {
    iata: "AGN",
    title: "Angoon Seaplane Base",
  },
  {
    iata: "GST",
    title: "Gustavus Airport",
  },
  {
    iata: "SGY",
    title: "Skagway Airport",
  },
  {
    iata: "HCR",
    title: "Holy Cross Airport",
  },
  {
    iata: "HNS",
    title: "Haines Airport",
  },
  {
    iata: "HOM",
    title: "Homer Airport",
  },
  {
    iata: "HPB",
    title: "Hooper Bay Airport",
  },
  {
    iata: "HYG",
    title: "Hydaburg Seaplane Base",
  },
  {
    iata: "IGG",
    title: "Igiugig Airport",
  },
  {
    iata: "EII",
    title: "Egegik Airport",
  },
  {
    iata: "IAN",
    title: "Bob Baker Memorial Airport",
  },
  {
    iata: "ILI",
    title: "Iliamna Airport",
  },
  {
    iata: "UTO",
    title: "Indian Mountain Lrrs Airport",
  },
  {
    iata: "JNU",
    title: "Juneau International Airport",
  },
  {
    iata: "KFP",
    title: "False Pass Airport",
  },
  {
    iata: "AKK",
    title: "Akhiok Airport",
  },
  {
    iata: "AKN",
    title: "King Salmon Airport",
  },
  {
    iata: "IKO",
    title: "Nikolski Air Station",
  },
  {
    iata: "AKP",
    title: "Anaktuvuk Pass Airport",
  },
  {
    iata: "KTN",
    title: "Ketchikan International Airport",
  },
  {
    iata: "KAL",
    title: "Kaltag Airport",
  },
  {
    iata: "AKW",
    title: "Klawock Airport",
  },
  {
    iata: "KLG",
    title: "Kalskag Airport",
  },
  {
    iata: "LUR",
    title: "Cape Lisburne Lrrs Airport",
  },
  {
    iata: "MCG",
    title: "McGrath Airport",
  },
  {
    iata: "MOU",
    title: "Mountain Village Airport",
  },
  {
    iata: "MRI",
    title: "Merrill Field",
  },
  {
    iata: "MYU",
    title: "Mekoryuk Airport",
  },
  {
    iata: "WNA",
    title: "Napakiak Airport",
  },
  {
    iata: "ANC",
    title: "Ted Stevens Anchorage International Airport",
  },
  {
    iata: "ANI",
    title: "Aniak Airport",
  },
  {
    iata: "ENN",
    title: "Nenana Municipal Airport",
  },
  {
    iata: "ANN",
    title: "Annette Island Airport",
  },
  {
    iata: "ANV",
    title: "Anvik Airport",
  },
  {
    iata: "KNW",
    title: "New Stuyahok Airport",
  },
  {
    iata: "PCA",
    title: "Portage Creek Airport",
  },
  {
    iata: "HNH",
    title: "Hoonah Airport",
  },
  {
    iata: "OME",
    title: "Nome Airport",
  },
  {
    iata: "ORT",
    title: "Northway Airport",
  },
  {
    iata: "OTZ",
    title: "Ralph Wien Memorial Airport",
  },
  {
    iata: "PBV",
    title: "St George Airport",
  },
  {
    iata: "KPC",
    title: "Port Clarence Coast Guard Station",
  },
  {
    iata: "PSG",
    title: "Petersburg James A Johnson Airport",
  },
  {
    iata: "PTH",
    title: "Port Heiden Airport",
  },
  {
    iata: "PTU",
    title: "Platinum Airport",
  },
  {
    iata: "PHO",
    title: "Point Hope Airport",
  },
  {
    iata: "NUI",
    title: "Nuiqsut Airport",
  },
  {
    iata: "ARC",
    title: "Arctic Village Airport",
  },
  {
    iata: "RBY",
    title: "Ruby Airport",
  },
  {
    iata: "SVA",
    title: "Savoonga Airport",
  },
  {
    iata: "SCC",
    title: "Deadhorse Airport",
  },
  {
    iata: "SDP",
    title: "Sand Point Airport",
  },
  {
    iata: "SHH",
    title: "Shishmaref Airport",
  },
  {
    iata: "SIT",
    title: "Sitka Rocky Gutierrez Airport",
  },
  {
    iata: "KSM",
    title: "St Mary's Airport",
  },
  {
    iata: "SNP",
    title: "St Paul Island Airport",
  },
  {
    iata: "SVW",
    title: "Sparrevohn Lrrs Airport",
  },
  {
    iata: "SXQ",
    title: "Soldotna Airport",
  },
  {
    iata: "SYA",
    title: "Eareckson Air Station",
  },
  {
    iata: "TOG",
    title: "Togiak Airport",
  },
  {
    iata: "TKJ",
    title: "Tok Airport",
  },
  {
    iata: "TLJ",
    title: "Tatalina LRRS Airport",
  },
  {
    iata: "ATK",
    title: "Atqasuk Edward Burnell Sr Memorial Airport",
  },
  {
    iata: "VAK",
    title: "Chevak Airport",
  },
  {
    iata: "KVC",
    title: "King Cove Airport",
  },
  {
    iata: "VDZ",
    title: "Valdez Pioneer Field",
  },
  {
    iata: "KVL",
    title: "Kivalina Airport",
  },
  {
    iata: "SWD",
    title: "Seward Airport",
  },
  {
    iata: "WRG",
    title: "Wrangell Airport",
  },
  {
    iata: "AIN",
    title: "Wainwright Airport",
  },
  {
    iata: "WTK",
    title: "Noatak Airport",
  },
  {
    iata: "IYS",
    title: "Wasilla Airport",
  },
  {
    iata: "CIS",
    title: "Canton Airport",
  },
  {
    iata: "PCQ",
    title: "Bounneau Airport",
  },
  {
    iata: "MFT",
    title: "Machu Pichu Airport",
  },
  {
    iata: "AKI",
    title: "Akiak Airport",
  },
  {
    iata: "AET",
    title: "Allakaket Airport",
  },
  {
    iata: "FYU",
    title: "Fort Yukon Airport",
  },
  {
    iata: "AKG",
    title: "Anguganak Airport",
  },
  {
    iata: "AWB",
    title: "Awaba Airport",
  },
  {
    iata: "BAA",
    title: "Bialla Airport",
  },
  {
    iata: "CVB",
    title: "Chungribu Airport",
  },
  {
    iata: "GMI",
    title: "Gasmata Island Airport",
  },
  {
    iata: "GVI",
    title: "Green River Airport",
  },
  {
    iata: "HYF",
    title: "Hayfields Airport",
  },
  {
    iata: "IHU",
    title: "Ihu Airport",
  },
  {
    iata: "IIS",
    title: "Nissan Island Airport",
  },
  {
    iata: "JAQ",
    title: "Jacquinot Bay Airport",
  },
  {
    iata: "KDR",
    title: "Kandrian Airport",
  },
  {
    iata: "KKD",
    title: "Kokoda Airport",
  },
  {
    iata: "KUY",
    title: "Kamusi Airport",
  },
  {
    iata: "KWO",
    title: "Kawito Airport",
  },
  {
    iata: "KXR",
    title: "Karoola Airport",
  },
  {
    iata: "LMI",
    title: "Lumi Airport",
  },
  {
    iata: "LMY",
    title: "Lake Murray Airport",
  },
  {
    iata: "OBX",
    title: "Obo Airport",
  },
  {
    iata: "OPU",
    title: "Balimo Airport",
  },
  {
    iata: "SKC",
    title: "Suki Airport",
  },
  {
    iata: "TFI",
    title: "Tufi Airport",
  },
  {
    iata: "TFM",
    title: "Telefomin Airport",
  },
  {
    iata: "TLO",
    title: "Tol Airport",
  },
  {
    iata: "UKU",
    title: "Nuku Airport",
  },
  {
    iata: "ULE",
    title: "Sule Airport",
  },
  {
    iata: "VMU",
    title: "Baimuru Airport",
  },
  {
    iata: "WPM",
    title: "Wipim Airport",
  },
  {
    iata: "ROP",
    title: "Rota International Airport",
  },
  {
    iata: "SPN",
    title: "Francisco C. Ada Saipan International Airport",
  },
  {
    iata: "UAM",
    title: "Andersen Air Force Base",
  },
  {
    iata: "GUM",
    title: "Antonio B. Won Pat International Airport",
  },
  {
    iata: "TIQ",
    title: "Tinian International Airport",
  },
  {
    iata: "ENI",
    title: "El Nido Airport",
  },
  {
    iata: "BKH",
    title: "Barking Sands Airport",
  },
  {
    iata: "HDH",
    title: "Dillingham Airfield",
  },
  {
    iata: "PHG",
    title: "Port Harcourt City Airport",
  },
  {
    iata: "HHI",
    title: "Wheeler Army Airfield",
  },
  {
    iata: "HNM",
    title: "Hana Airport",
  },
  {
    iata: "JHM",
    title: "Kapalua Airport",
  },
  {
    iata: "JRF",
    title: "Kalaeloa (John Rodgers Field) Airport",
  },
  {
    iata: "KOA",
    title: "Kona International At Keahole Airport",
  },
  {
    iata: "LIH",
    title: "Lihue Airport",
  },
  {
    iata: "LUP",
    title: "Kalaupapa Airport",
  },
  {
    iata: "MKK",
    title: "Molokai Airport",
  },
  {
    iata: "MUE",
    title: "Waimea Kohala Airport",
  },
  {
    iata: "HNL",
    title: "Honolulu International Airport",
  },
  {
    iata: "LNY",
    title: "Lanai Airport",
  },
  {
    iata: "OGG",
    title: "Kahului Airport",
  },
  {
    iata: "ITO",
    title: "Hilo International Airport",
  },
  {
    iata: "UPP",
    title: "Upolu Airport",
  },
  {
    iata: "JON",
    title: "Johnston Atoll Airport",
  },
  {
    iata: "BHC",
    title: "Bhurban Heliport",
  },
  {
    iata: "CWP",
    title: "Campbellpore Airport",
  },
  {
    iata: "GRT",
    title: "Gujrat Airport",
  },
  {
    iata: "HRA",
    title: "Mansehra Airport",
  },
  {
    iata: "KCF",
    title: "Kadanwari Airport",
  },
  {
    iata: "REQ",
    title: "Reko Diq Airport",
  },
  {
    iata: "RZS",
    title: "Sawan Airport",
  },
  {
    iata: "SWV",
    title: "Shikapur Airport",
  },
  {
    iata: "ENT",
    title: "Eniwetok Airport",
  },
  {
    iata: "MAJ",
    title: "Marshall Islands International Airport",
  },
  {
    iata: "KIA",
    title: "Kaieteur International Airport",
  },
  {
    iata: "KWA",
    title: "Bucholz Army Air Field",
  },
  {
    iata: "CXI",
    title: "Cassidy International Airport",
  },
  {
    iata: "TNV",
    title: "Tabuaeran Island Airport",
  },
  {
    iata: "MDY",
    title: "Henderson Field",
  },
  {
    iata: "PIZ",
    title: "Point Lay Lrrs Airport",
  },
  {
    iata: "PQD",
    title: "Passikudah Helipad",
  },
  {
    iata: "DDP",
    title: "Dorado Beach Airport",
  },
  {
    iata: "HUC",
    title: "Humacao Airport",
  },
  {
    iata: "PPD",
    title: "Palmas del Mar Airstrip",
  },
  {
    iata: "TKK",
    title: "Chuuk International Airport",
  },
  {
    iata: "PNI",
    title: "Pohnpei International Airport",
  },
  {
    iata: "ROR",
    title: "Babelthuap Airport",
  },
  {
    iata: "KSA",
    title: "Kosrae International Airport",
  },
  {
    iata: "YAP",
    title: "Yap International Airport",
  },
  {
    iata: "AWK",
    title: "Wake Island Airfield",
  },
  {
    iata: "OLK",
    title: "Fuerte Olimpo Airport",
  },
  {
    iata: "PBT",
    title: "Puerto Leda Airport",
  },
  {
    iata: "PCJ",
    title: "Puerto La Victoria Airport",
  },
  {
    iata: "KIO",
    title: "Kili Airport",
  },
  {
    iata: "QFX",
    title: "Igaliku Heliport",
  },
  {
    iata: "RAW",
    title: "Arawa Airport",
  },
  {
    iata: "KNH",
    title: "Kinmen Airport",
  },
  {
    iata: "LZN",
    title: "Matsu Nangan Airport",
  },
  {
    iata: "TTT",
    title: "Taitung Airport",
  },
  {
    iata: "GNI",
    title: "Lyudao Airport",
  },
  {
    iata: "KHH",
    title: "Kaohsiung International Airport",
  },
  {
    iata: "CYI",
    title: "Chiayi Airport",
  },
  {
    iata: "HCN",
    title: "Hengchun Airport",
  },
  {
    iata: "TXG",
    title: "Taichung Airport",
  },
  {
    iata: "KYD",
    title: "Lanyu Airport",
  },
  {
    iata: "RMQ",
    title: "Taichung Ching Chuang Kang Airport",
  },
  {
    iata: "MFK",
    title: "Matsu Beigan Airport",
  },
  {
    iata: "TNN",
    title: "Tainan Airport",
  },
  {
    iata: "MZG",
    title: "Makung Airport",
  },
  {
    iata: "PIF",
    title: "Pingtung North Airport",
  },
  {
    iata: "TSA",
    title: "Taipei Songshan Airport",
  },
  {
    iata: "TPE",
    title: "Taiwan Taoyuan International Airport",
  },
  {
    iata: "WOT",
    title: "Wang-an Airport",
  },
  {
    iata: "HUN",
    title: "Hualien Airport",
  },
  {
    iata: "NRT",
    title: "Narita International Airport",
  },
  {
    iata: "MMJ",
    title: "Matsumoto Airport",
  },
  {
    iata: "IBR",
    title: "Hyakuri Airport",
  },
  {
    iata: "MUS",
    title: "Minami Torishima Airport",
  },
  {
    iata: "IWO",
    title: "Iwo Jima Airport",
  },
  {
    iata: "KIX",
    title: "Kansai International Airport",
  },
  {
    iata: "SHM",
    title: "Nanki Shirahama Airport",
  },
  {
    iata: "UKB",
    title: "Kobe Airport",
  },
  {
    iata: "HIW",
    title: "Hiroshimanishi Airport",
  },
  {
    iata: "TJH",
    title: "Tajima Airport",
  },
  {
    iata: "OBO",
    title: "Tokachi-Obihiro Airport",
  },
  {
    iata: "CTS",
    title: "New Chitose Airport",
  },
  {
    iata: "HKD",
    title: "Hakodate Airport",
  },
  {
    iata: "KUH",
    title: "Kushiro Airport",
  },
  {
    iata: "MMB",
    title: "Memanbetsu Airport",
  },
  {
    iata: "SHB",
    title: "Nakashibetsu Airport",
  },
  {
    iata: "OKD",
    title: "Okadama Airport",
  },
  {
    iata: "RBJ",
    title: "Rebun Airport Airport",
  },
  {
    iata: "WKJ",
    title: "Wakkanai Airport",
  },
  {
    iata: "IKI",
    title: "Iki Airport",
  },
  {
    iata: "UBJ",
    title: "Yamaguchi Ube Airport",
  },
  {
    iata: "TSJ",
    title: "Tsushima Airport",
  },
  {
    iata: "MBE",
    title: "Monbetsu Airport",
  },
  {
    iata: "AKJ",
    title: "Asahikawa Airport",
  },
  {
    iata: "OIR",
    title: "Okushiri Airport",
  },
  {
    iata: "RIS",
    title: "Rishiri Airport",
  },
  {
    iata: "KUM",
    title: "Yakushima Airport",
  },
  {
    iata: "FUJ",
    title: "Fukue Airport",
  },
  {
    iata: "FUK",
    title: "Fukuoka Airport",
  },
  {
    iata: "TNE",
    title: "New Tanegashima Airport",
  },
  {
    iata: "KOJ",
    title: "Kagoshima Airport",
  },
  {
    iata: "KMI",
    title: "Miyazaki Airport",
  },
  {
    iata: "OIT",
    title: "Oita Airport",
  },
  {
    iata: "KKJ",
    title: "Kitaky?sh? Airport",
  },
  {
    iata: "HSG",
    title: "Saga Airport",
  },
  {
    iata: "KMJ",
    title: "Kumamoto Airport",
  },
  {
    iata: "NGS",
    title: "Nagasaki Airport",
  },
  {
    iata: "NGO",
    title: "Chubu Centrair International Airport",
  },
  {
    iata: "ASJ",
    title: "Amami Airport",
  },
  {
    iata: "OKE",
    title: "Okierabu Airport",
  },
  {
    iata: "KKX",
    title: "Kikai Airport",
  },
  {
    iata: "TKN",
    title: "Tokunoshima Airport",
  },
  {
    iata: "NKM",
    title: "Nagoya Airport",
  },
  {
    iata: "FKJ",
    title: "Fukui Airport",
  },
  {
    iata: "QGU",
    title: "Gifu Airport",
  },
  {
    iata: "KMQ",
    title: "Komatsu Airport",
  },
  {
    iata: "OKI",
    title: "Oki Airport",
  },
  {
    iata: "TOY",
    title: "Toyama Airport",
  },
  {
    iata: "NTQ",
    title: "Noto Airport",
  },
  {
    iata: "HIJ",
    title: "Hiroshima Airport",
  },
  {
    iata: "OKJ",
    title: "Okayama Airport",
  },
  {
    iata: "IZO",
    title: "Izumo Airport",
  },
  {
    iata: "YGJ",
    title: "Miho Yonago Airport",
  },
  {
    iata: "KCZ",
    title: "K?chi Ry?ma Airport",
  },
  {
    iata: "MYJ",
    title: "Matsuyama Airport",
  },
  {
    iata: "ITM",
    title: "Osaka International Airport",
  },
  {
    iata: "TTJ",
    title: "Tottori Airport",
  },
  {
    iata: "TKS",
    title: "Tokushima Airport",
  },
  {
    iata: "TAK",
    title: "Takamatsu Airport",
  },
  {
    iata: "IWJ",
    title: "Iwami Airport",
  },
  {
    iata: "AOJ",
    title: "Aomori Airport",
  },
  {
    iata: "GAJ",
    title: "Yamagata Airport",
  },
  {
    iata: "SDS",
    title: "Sado Airport",
  },
  {
    iata: "FKS",
    title: "Fukushima Airport",
  },
  {
    iata: "HHE",
    title: "Hachinohe Airport",
  },
  {
    iata: "HNA",
    title: "Hanamaki Airport",
  },
  {
    iata: "AXT",
    title: "Akita Airport",
  },
  {
    iata: "MSJ",
    title: "Misawa Air Base",
  },
  {
    iata: "KIJ",
    title: "Niigata Airport",
  },
  {
    iata: "ONJ",
    title: "Odate Noshiro Airport",
  },
  {
    iata: "SDJ",
    title: "Sendai Airport",
  },
  {
    iata: "SYO",
    title: "Shonai Airport",
  },
  {
    iata: "NJA",
    title: "Atsugi Naval Air Facility",
  },
  {
    iata: "HAC",
    title: "Hachijojima Airport",
  },
  {
    iata: "OIM",
    title: "Oshima Airport",
  },
  {
    iata: "MYE",
    title: "Miyakejima Airport",
  },
  {
    iata: "HND",
    title: "Tokyo International Airport",
  },
  {
    iata: "QUT",
    title: "Utsunomiya Airport",
  },
  {
    iata: "OKO",
    title: "Yokota Air Base",
  },
  {
    iata: "KWJ",
    title: "Gwangju Airport",
  },
  {
    iata: "KUV",
    title: "Kunsan Air Base",
  },
  {
    iata: "MPK",
    title: "Mokpo Airport",
  },
  {
    iata: "CHN",
    title: "Jeon Ju Airport",
  },
  {
    iata: "RSU",
    title: "Yeosu Airport",
  },
  {
    iata: "QUN",
    title: "A-306 Airport",
  },
  {
    iata: "SHO",
    title: "Sokcho Airport",
  },
  {
    iata: "KAG",
    title: "Gangneung Airport",
  },
  {
    iata: "WJU",
    title: "Wonju Airport",
  },
  {
    iata: "YNY",
    title: "Yangyang International Airport",
  },
  {
    iata: "CJU",
    title: "Jeju International Airport",
  },
  {
    iata: "CHF",
    title: "Jinhae Airport",
  },
  {
    iata: "PUS",
    title: "Gimhae International Airport",
  },
  {
    iata: "HIN",
    title: "Sacheon Air Base",
  },
  {
    iata: "USN",
    title: "Ulsan Airport",
  },
  {
    iata: "ICN",
    title: "Incheon International Airport",
  },
  {
    iata: "SSN",
    title: "Seoul Air Base",
  },
  {
    iata: "OSN",
    title: "Osan Air Base",
  },
  {
    iata: "GMP",
    title: "Gimpo International Airport",
  },
  {
    iata: "SWU",
    title: "Suwon Airport",
  },
  {
    iata: "KPO",
    title: "Pohang Airport",
  },
  {
    iata: "TAE",
    title: "Daegu Airport",
  },
  {
    iata: "CJJ",
    title: "Cheongju International Airport",
  },
  {
    iata: "YEC",
    title: "Yecheon Airport",
  },
  {
    iata: "OKA",
    title: "Naha Airport",
  },
  {
    iata: "DNA",
    title: "Kadena Air Base",
  },
  {
    iata: "ISG",
    title: "Ishigaki Airport",
  },
  {
    iata: "UEO",
    title: "Kumejima Airport",
  },
  {
    iata: "KJP",
    title: "Kerama Airport",
  },
  {
    iata: "MMD",
    title: "Minami Daito Airport",
  },
  {
    iata: "MMY",
    title: "Miyako Airport",
  },
  {
    iata: "AGJ",
    title: "Aguni Airport",
  },
  {
    iata: "IEJ",
    title: "Ie Jima Airport",
  },
  {
    iata: "HTR",
    title: "Hateruma Airport",
  },
  {
    iata: "KTD",
    title: "Kitadaito Airport",
  },
  {
    iata: "SHI",
    title: "Shimojishima Airport",
  },
  {
    iata: "TRA",
    title: "Tarama Airport",
  },
  {
    iata: "RNJ",
    title: "Yoron Airport",
  },
  {
    iata: "OGN",
    title: "Yonaguni Airport",
  },
  {
    iata: "SFS",
    title: "Subic Bay International Airport",
  },
  {
    iata: "CRK",
    title: "Diosdado Macapagal International Airport",
  },
  {
    iata: "LAO",
    title: "Laoag International Airport",
  },
  {
    iata: "MNL",
    title: "Ninoy Aquino International Airport",
  },
  {
    iata: "CYU",
    title: "Cuyo Airport",
  },
  {
    iata: "LGP",
    title: "Legazpi City International Airport",
  },
  {
    iata: "NSP",
    title: "Sangley Point Air Base",
  },
  {
    iata: "LBX",
    title: "Lubang Airport",
  },
  {
    iata: "AAV",
    title: "Allah Valley Airport",
  },
  {
    iata: "GES",
    title: "General Santos International Airport",
  },
  {
    iata: "CBO",
    title: "Awang Airport",
  },
  {
    iata: "DVO",
    title: "Francisco Bangoy International Airport",
  },
  {
    iata: "BXU",
    title: "Bancasi Airport",
  },
  {
    iata: "BPH",
    title: "Bislig Airport",
  },
  {
    iata: "DPL",
    title: "Dipolog Airport",
  },
  {
    iata: "CGM",
    title: "Camiguin Airport",
  },
  {
    iata: "IGN",
    title: "Iligan Airport",
  },
  {
    iata: "JOL",
    title: "Jolo Airport",
  },
  {
    iata: "CGY",
    title: "Cagayan De Oro Airport",
  },
  {
    iata: "MLP",
    title: "Malabang Airport",
  },
  {
    iata: "SGS",
    title: "Sanga Sanga Airport",
  },
  {
    iata: "OZC",
    title: "Labo Airport",
  },
  {
    iata: "PAG",
    title: "Pagadian Airport",
  },
  {
    iata: "MXI",
    title: "Mati National Airport",
  },
  {
    iata: "SUG",
    title: "Surigao Airport",
  },
  {
    iata: "CDY",
    title: "Cagayan de Sulu Airport",
  },
  {
    iata: "IPE",
    title: "Ipil Airport",
  },
  {
    iata: "TDG",
    title: "Tandag Airport",
  },
  {
    iata: "ZAM",
    title: "Zamboanga International Airport",
  },
  {
    iata: "IAO",
    title: "Siargao Airport",
  },
  {
    iata: "BAG",
    title: "Loakan Airport",
  },
  {
    iata: "DTE",
    title: "Daet Airport",
  },
  {
    iata: "SJI",
    title: "San Jose Airport",
  },
  {
    iata: "MBO",
    title: "Mamburao Airport",
  },
  {
    iata: "WNP",
    title: "Naga Airport",
  },
  {
    iata: "BSO",
    title: "Basco Airport",
  },
  {
    iata: "BQA",
    title: "Dr.Juan C. Angara Airport",
  },
  {
    iata: "SFE",
    title: "San Fernando Airport",
  },
  {
    iata: "TUG",
    title: "Tuguegarao Airport",
  },
  {
    iata: "VRC",
    title: "Virac Airport",
  },
  {
    iata: "MRQ",
    title: "Marinduque Airport",
  },
  {
    iata: "CYZ",
    title: "Cauayan Airport",
  },
  {
    iata: "TAC",
    title: "Daniel Z. Romualdez Airport",
  },
  {
    iata: "BCD",
    title: "Bacolod-Silay City International Airport",
  },
  {
    iata: "CYP",
    title: "Calbayog Airport",
  },
  {
    iata: "DGT",
    title: "Sibulan Airport",
  },
  {
    iata: "MPH",
    title: "Godofredo P. Ramos Airport",
  },
  {
    iata: "CRM",
    title: "Catarman National Airport",
  },
  {
    iata: "GUI",
    title: "Guiuan Airport",
  },
  {
    iata: "ILO",
    title: "Iloilo International Airport",
  },
  {
    iata: "MBT",
    title: "Moises R. Espinosa Airport",
  },
  {
    iata: "KLO",
    title: "Kalibo International Airport",
  },
  {
    iata: "CEB",
    title: "Mactan Cebu International Airport",
  },
  {
    iata: "OMC",
    title: "Ormoc Airport",
  },
  {
    iata: "PPS",
    title: "Puerto Princesa Airport",
  },
  {
    iata: "RXS",
    title: "Roxas Airport",
  },
  {
    iata: "EUQ",
    title: "Evelio Javier Airport",
  },
  {
    iata: "TAG",
    title: "Tagbilaran Airport",
  },
  {
    iata: "TBH",
    title: "Romblon Airport",
  },
  {
    iata: "USU",
    title: "Francisco B. Reyes Airport",
  },
  {
    iata: "BPR",
    title: "Borongan Airport",
  },
  {
    iata: "NGK",
    title: "Nogliki Airport",
  },
  {
    iata: "GRV",
    title: "Grozny North Airport",
  },
  {
    iata: "LNX",
    title: "Smolensk South Airport",
  },
  {
    iata: "VUS",
    title: "Velikiy Ustyug Airport",
  },
  {
    iata: "LPS",
    title: "Lopez Island Airport",
  },
  {
    iata: "MJR",
    title: "Miramar Airport",
  },
  {
    iata: "CCT",
    title: "Colonia Catriel Airport",
  },
  {
    iata: "COC",
    title: "Comodoro Pierrestegui Airport",
  },
  {
    iata: "GHU",
    title: "Gualeguaychu Airport",
  },
  {
    iata: "JNI",
    title: "Junin Airport",
  },
  {
    iata: "PRA",
    title: "General Urquiza Airport",
  },
  {
    iata: "ROS",
    title: "Islas Malvinas Airport",
  },
  {
    iata: "SFN",
    title: "Sauce Viejo Airport",
  },
  {
    iata: "AEP",
    title: "Jorge Newbery Airpark",
  },
  {
    iata: "LCM",
    title: "La Cumbre Airport",
  },
  {
    iata: "COR",
    title: "Ingeniero Ambrosio Taravella Airport",
  },
  {
    iata: "FDO",
    title: "San Fernando Airport",
  },
  {
    iata: "LPG",
    title: "La Plata Airport",
  },
  {
    iata: "EPA",
    title: "El Palomar Airport",
  },
  {
    iata: "EZE",
    title: "Ministro Pistarini International Airport",
  },
  {
    iata: "HOS",
    title: "Chos Malal Airport",
  },
  {
    iata: "CVH",
    title: "Caviahue Airport",
  },
  {
    iata: "GNR",
    title: "Dr. Arturo H. Illia Airport",
  },
  {
    iata: "RDS",
    title: "Rincon De Los Sauces Airport",
  },
  {
    iata: "APZ",
    title: "Zapala Airport",
  },
  {
    iata: "MDZ",
    title: "El Plumerillo Airport",
  },
  {
    iata: "AFA",
    title: "Suboficial Ay Santiago Germano Airport",
  },
  {
    iata: "CTC",
    title: "Catamarca Airport",
  },
  {
    iata: "RHD",
    title: "Las Termas Airport",
  },
  {
    iata: "IRJ",
    title: "Capitan V A Almonacid Airport",
  },
  {
    iata: "TUC",
    title: "Teniente Benjamin Matienzo Airport",
  },
  {
    iata: "UAQ",
    title: "Domingo Faustino Sarmiento Airport",
  },
  {
    iata: "CRR",
    title: "Ceres Airport",
  },
  {
    iata: "RCU",
    title: "Area De Material Airport",
  },
  {
    iata: "VDR",
    title: "Villa Dolores Airport",
  },
  {
    iata: "VME",
    title: "Villa Reynolds Airport",
  },
  {
    iata: "RLO",
    title: "Valle Del Conlara International Airport",
  },
  {
    iata: "LUQ",
    title: "Brigadier Mayor D Cesar Raul Ojeda Airport",
  },
  {
    iata: "CNQ",
    title: "Corrientes Airport",
  },
  {
    iata: "RES",
    title: "Resistencia International Airport",
  },
  {
    iata: "FMA",
    title: "Formosa Airport",
  },
  {
    iata: "AOL",
    title: "Paso De Los Libres Airport",
  },
  {
    iata: "MCS",
    title: "Monte Caseros Airport",
  },
  {
    iata: "PSS",
    title: "Libertador Gral D Jose De San Martin Airport",
  },
  {
    iata: "PSV",
    title: "Rovere Airport",
  },
  {
    iata: "SLA",
    title: "Martin Miguel De Guemes International Airport",
  },
  {
    iata: "JUJ",
    title: "Gobernador Horacio Guzman International Airport",
  },
  {
    iata: "TTG",
    title: "General Enrique Mosconi Airport",
  },
  {
    iata: "CLX",
    title: "Clorinda Airport",
  },
  {
    iata: "ELO",
    title: "El Dorado Airport",
  },
  {
    iata: "OYA",
    title: "Goya Airport",
  },
  {
    iata: "LLS",
    title: "Alferez Armando Rodriguez Airport",
  },
  {
    iata: "MDX",
    title: "Mercedes Airport",
  },
  {
    iata: "RCQ",
    title: "Reconquista Airport",
  },
  {
    iata: "UZU",
    title: "Curuzu Cuatia Airport",
  },
  {
    iata: "EHL",
    title: "El Bolson Airport",
  },
  {
    iata: "CRD",
    title: "General E. Mosconi Airport",
  },
  {
    iata: "EMX",
    title: "El Maiten Airport",
  },
  {
    iata: "EQS",
    title: "Brigadier Antonio Parodi Airport",
  },
  {
    iata: "LHS",
    title: "Las Heras Airport",
  },
  {
    iata: "OES",
    title: "Antoine De St Exupery Airport",
  },
  {
    iata: "MQD",
    title: "Maquinchao Airport",
  },
  {
    iata: "ARR",
    title: "D. Casimiro Szlapelis Airport",
  },
  {
    iata: "SGV",
    title: "Sierra Grande Airport",
  },
  {
    iata: "REL",
    title: "Almirante Marco Andres Zar Airport",
  },
  {
    iata: "VDM",
    title: "Gobernador Castello Airport",
  },
  {
    iata: "PMY",
    title: "El Tehuelche Airport",
  },
  {
    iata: "ING",
    title: "Lago Argentino Airport",
  },
  {
    iata: "FTE",
    title: "El Calafate Airport",
  },
  {
    iata: "PUD",
    title: "Puerto Deseado Airport",
  },
  {
    iata: "RGA",
    title: "Hermes Quijada International Airport",
  },
  {
    iata: "USH",
    title: "Malvinas Argentinas Airport",
  },
  {
    iata: "ULA",
    title: "Capitan D Daniel Vazquez Airport",
  },
  {
    iata: "ROY",
    title: "Rio Mayo Airport",
  },
  {
    iata: "PMQ",
    title: "Perito Moreno Airport",
  },
  {
    iata: "GGS",
    title: "Gobernador Gregores Airport",
  },
  {
    iata: "JSM",
    title: "Jose De San Martin Airport",
  },
  {
    iata: "RYO",
    title: "28 De Noviembre Airport",
  },
  {
    iata: "RZA",
    title: "Santa Cruz Airport",
  },
  {
    iata: "BHI",
    title: "Comandante Espora Airport",
  },
  {
    iata: "CSZ",
    title: "Brigadier D.H.E. Ruiz Airport",
  },
  {
    iata: "OVR",
    title: "Olavarria Airport",
  },
  {
    iata: "GPO",
    title: "General Pico Airport",
  },
  {
    iata: "OYO",
    title: "Tres Arroyos Airport",
  },
  {
    iata: "SST",
    title: "Santa Teresita Airport",
  },
  {
    iata: "NQN",
    title: "Presidente Peron Airport",
  },
  {
    iata: "NEC",
    title: "Necochea Airport",
  },
  {
    iata: "PEH",
    title: "Comodoro Pedro Zanni Airport",
  },
  {
    iata: "RSA",
    title: "Santa Rosa Airport",
  },
  {
    iata: "BRC",
    title: "San Carlos De Bariloche Airport",
  },
  {
    iata: "VLG",
    title: "Villa Gesell Airport",
  },
  {
    iata: "CUT",
    title: "Cutral-Co Airport",
  },
  {
    iata: "CPC",
    title: "Aviador C. Campos Airport",
  },
  {
    iata: "VIU",
    title: "Viru Harbour Airstrip",
  },
  {
    iata: "SB0",
    title: "Pirenopolis Centeral Airport",
  },
  {
    iata: "SB2",
    title: "Fazenda Bela Vista Airport",
  },
  {
    iata: "AQA",
    title: "Araraquara Airport",
  },
  {
    iata: "AJU",
    title: "Santa Maria Airport",
  },
  {
    iata: "AFL",
    title: "Alta Floresta Airport",
  },
  {
    iata: "ARU",
    title: "Dario Guarita Airport",
  },
  {
    iata: "BEL",
    title: "Val de Cans International Airport",
  },
  {
    iata: "BGX",
    title: "Comandante Gustavo Kraemer Airport",
  },
  {
    iata: "PLU",
    title: "Pampulha - Carlos Drummond de Andrade Airport",
  },
  {
    iata: "QAK",
    title: "Major Brigadeiro Doorgal Borges Airport",
  },
  {
    iata: "BSB",
    title: "Presidente Juscelino Kubistschek International Airport",
  },
  {
    iata: "BAT",
    title: "Chafei Amsei Airport",
  },
  {
    iata: "BAU",
    title: "Bauru Airport",
  },
  {
    iata: "BVB",
    title: "Atlas Brasil Cantanhede Airport",
  },
  {
    iata: "BZC",
    title: "Umberto Modiano Airport",
  },
  {
    iata: "CAC",
    title: "Cascavel Airport",
  },
  {
    iata: "CFB",
    title: "Cabo Frio Airport",
  },
  {
    iata: "ITB",
    title: "Cachimbo Airport",
  },
  {
    iata: "CNF",
    title: "Tancredo Neves International Airport",
  },
  {
    iata: "CGR",
    title: "Campo Grande Airport",
  },
  {
    iata: "XAP",
    title: "Serafin Enoss Bertaso Airport",
  },
  {
    iata: "CLN",
    title: "Brig. Lysias Augusto Rodrigues Airport",
  },
  {
    iata: "CKS",
    title: "Carajas Airport",
  },
  {
    iata: "CCM",
    title: "Diomicio Freitas Airport",
  },
  {
    iata: "CLV",
    title: "Caldas Novas Airport",
  },
  {
    iata: "QNS",
    title: "Canoas Airport",
  },
  {
    iata: "CAW",
    title: "Bartolomeu Lisandro Airport",
  },
  {
    iata: "CMG",
    title: "Corumbá International Airport",
  },
  {
    iata: "CWB",
    title: "Afonso Pena Airport",
  },
  {
    iata: "CRQ",
    title: "Caravelas Airport",
  },
  {
    iata: "CXJ",
    title: "Campo dos Bugres Airport",
  },
  {
    iata: "CGB",
    title: "Marechal Rondon Airport",
  },
  {
    iata: "CZS",
    title: "Cruzeiro do Sul Airport",
  },
  {
    iata: "PPB",
    title: "Presidente Prudente Airport",
  },
  {
    iata: "MAO",
    title: "Eduardo Gomes International Airport",
  },
  {
    iata: "JCR",
    title: "Jacareacanga Airport",
  },
  {
    iata: "IGU",
    title: "Cataratas International Airport",
  },
  {
    iata: "FLN",
    title: "Hercílio Luz International Airport",
  },
  {
    iata: "FEN",
    title: "Fernando de Noronha Airport",
  },
  {
    iata: "FOR",
    title: "Pinto Martins International Airport",
  },
  {
    iata: "GIG",
    title: "Tom Jobim International Airport",
  },
  {
    iata: "GJM",
    title: "Guajara-Mirim Airport",
  },
  {
    iata: "GYN",
    title: "Santa Genoveva Airport",
  },
  {
    iata: "GRU",
    title: "São Paulo International Airport",
  },
  {
    iata: "GPB",
    title: "Tancredo Thomas de Faria Airport",
  },
  {
    iata: "GVR",
    title: "Governador Valadares Airport",
  },
  {
    iata: "GUJ",
    title: "Guaratingueta Airport",
  },
  {
    iata: "ATM",
    title: "Altamira Airport",
  },
  {
    iata: "ITA",
    title: "Itacoatiara Airport",
  },
  {
    iata: "ITB",
    title: "Itaituba Airport",
  },
  {
    iata: "IOS",
    title: "Bahia - Jorge Amado Airport",
  },
  {
    iata: "IPN",
    title: "Usiminas Airport",
  },
  {
    iata: "IMP",
    title: "Prefeito Renato Moreira Airport",
  },
  {
    iata: "JDF",
    title: "Francisco de Assis Airport",
  },
  {
    iata: "JPA",
    title: "Presidente Castro Pinto Airport",
  },
  {
    iata: "JDO",
    title: "Orlando Bezerra de Menezes Airport",
  },
  {
    iata: "JOI",
    title: "Lauro Carneiro de Loyola Airport",
  },
  {
    iata: "CPV",
    title: "Campina Grande Airport",
  },
  {
    iata: "VCP",
    title: "Viracopos International Airport",
  },
  {
    iata: "LEC",
    title: "Chapada Diamantina Airport",
  },
  {
    iata: "LAJ",
    title: "Lages Airport",
  },
  {
    iata: "LIP",
    title: "Lins Airport",
  },
  {
    iata: "LDB",
    title: "Governador José Richa Airport",
  },
  {
    iata: "LAZ",
    title: "Bom Jesus da Lapa Airport",
  },
  {
    iata: "MAB",
    title: "João Correa da Rocha Airport",
  },
  {
    iata: "MQH",
    title: "Minaçu Airport",
  },
  {
    iata: "MEU",
    title: "Monte Dourado Airport",
  },
  {
    iata: "MEA",
    title: "Benedito Lacerda Airport",
  },
  {
    iata: "PLL",
    title: "Ponta Pelada Airport",
  },
  {
    iata: "MCZ",
    title: "Zumbi dos Palmares Airport",
  },
  {
    iata: "MCP",
    title: "Alberto Alcolumbre Airport",
  },
  {
    iata: "MVF",
    title: "Dix-Sept Rosado Airport",
  },
  {
    iata: "SAO",
    title: "Campo de Marte Airport",
  },
  {
    iata: "NVT",
    title: "Ministro Victor Konder International Airport",
  },
  {
    iata: "NAT",
    title: "Augusto Severo Airport",
  },
  {
    iata: "OYK",
    title: "Oiapoque Airport",
  },
  {
    iata: "POA",
    title: "Salgado Filho Airport",
  },
  {
    iata: "PFB",
    title: "Lauro Kurtz Airport",
  },
  {
    iata: "PMW",
    title: "Brigadeiro Lysias Rodrigues Airport",
  },
  {
    iata: "PET",
    title: "Pelotas Airport",
  },
  {
    iata: "PNZ",
    title: "Senador Nilo Coelho Airport",
  },
  {
    iata: "PNB",
    title: "Porto Nacional Airport",
  },
  {
    iata: "BPS",
    title: "Porto Seguro Airport",
  },
  {
    iata: "PVH",
    title: "Governador Jorge Teixeira de Oliveira Airport",
  },
  {
    iata: "RBR",
    title: "Plácido de Castro International Airport",
  },
  {
    iata: "REC",
    title: "Guararapes - Gilberto Freyre International Airport",
  },
  {
    iata: "SDU",
    title: "Santos Dumont Airport",
  },
  {
    iata: "RAO",
    title: "Leite Lopes Airport",
  },
  {
    iata: "BRB",
    title: "Barreirinhas Airport",
  },
  {
    iata: "SNZ",
    title: "Santa Cruz Airport",
  },
  {
    iata: "SJK",
    title: "Professor Urbano Ernesto Stumpf Airport",
  },
  {
    iata: "SLZ",
    title: "Marechal Cunha Machado International Airport",
  },
  {
    iata: "RIA",
    title: "Santa Maria Airport",
  },
  {
    iata: "STM",
    title: "Maestro Wilson Fonseca Airport",
  },
  {
    iata: "CGH",
    title: "Congonhas Airport",
  },
  {
    iata: "SSA",
    title: "Deputado Luís Eduardo Magalhães International Airport",
  },
  {
    iata: "TMT",
    title: "Trombetas Airport",
  },
  {
    iata: "TOW",
    title: "Toledo Airport",
  },
  {
    iata: "TBT",
    title: "Tabatinga Airport",
  },
  {
    iata: "PAV",
    title: "Paulo Afonso Airport",
  },
  {
    iata: "URG",
    title: "Rubem Berta Airport",
  },
  {
    iata: "VAG",
    title: "Major Brigadeiro Trompowsky Airport",
  },
  {
    iata: "BVH",
    title: "Vilhena Airport",
  },
  {
    iata: "VIX",
    title: "Eurico de Aguiar Salles Airport",
  },
  {
    iata: "QPS",
    title: "Campo Fontenelle Airport",
  },
  {
    iata: "PRI",
    title: "Praslin Island Airport",
  },
  {
    iata: "PRI",
    title: "Praslin Island Airport",
  },
  {
    iata: "ZUD",
    title: "Pupelde Airport",
  },
  {
    iata: "LOB",
    title: "San Rafael Airport",
  },
  {
    iata: "WAP",
    title: "Alto Palena Airport",
  },
  {
    iata: "ARI",
    title: "Chacalluta Airport",
  },
  {
    iata: "DAT",
    title: "Desierto de Atacama Airport",
  },
  {
    iata: "BBA",
    title: "Balmaceda Airport",
  },
  {
    iata: "TOQ",
    title: "Barriles Airport",
  },
  {
    iata: "CCH",
    title: "Chile Chico Airport",
  },
  {
    iata: "CJC",
    title: "El Loa Airport",
  },
  {
    iata: "GXQ",
    title: "Teniente Vidal Airport",
  },
  {
    iata: "IQQ",
    title: "Diego Aracena Airport",
  },
  {
    iata: "FRT",
    title: "El Avellano Airport",
  },
  {
    iata: "ANF",
    title: "Cerro Moreno Airport",
  },
  {
    iata: "WPR",
    title: "Capitan Fuentes Martinez Airport Airport",
  },
  {
    iata: "CPO",
    title: "Chamonate Airport",
  },
  {
    iata: "LGR",
    title: "Cochrane Airport",
  },
  {
    iata: "CCP",
    title: "Carriel Sur Airport",
  },
  {
    iata: "IPC",
    title: "Mataveri Airport",
  },
  {
    iata: "VLR",
    title: "Vallenar Airport",
  },
  {
    iata: "ZLR",
    title: "Municipal de Linares Airport",
  },
  {
    iata: "PNT",
    title: "Tte. Julio Gallardo Airport",
  },
  {
    iata: "OVL",
    title: "El Tuqui Airport",
  },
  {
    iata: "PUX",
    title: "El Mirador Airport",
  },
  {
    iata: "VAP",
    title: "Rodelillo Airport",
  },
  {
    iata: "QRC",
    title: "De La Independencia Airport",
  },
  {
    iata: "SMB",
    title: "Franco Bianco Airport",
  },
  {
    iata: "LSC",
    title: "La Florida Airport",
  },
  {
    iata: "WCA",
    title: "Gamboa Airport",
  },
  {
    iata: "ZCO",
    title: "Maquehue Airport",
  },
  {
    iata: "PMC",
    title: "El Tepual Airport",
  },
  {
    iata: "ULC",
    title: "Los Cerrillos Airport",
  },
  {
    iata: "TLX",
    title: "Panguilemo Airport",
  },
  {
    iata: "ZIC",
    title: "Victoria Airport",
  },
  {
    iata: "TTC",
    title: "Las Breas Airport",
  },
  {
    iata: "ZAL",
    title: "Pichoy Airport",
  },
  {
    iata: "CPQ",
    title: "Amarais Airport",
  },
  {
    iata: "QCJ",
    title: "Botucatu Airport",
  },
  {
    iata: "OLC",
    title: "Senadora Eunice Micheles Airport",
  },
  {
    iata: "SOD",
    title: "Sorocaba Airport",
  },
  {
    iata: "QDC",
    title: "Dracena Airport",
  },
  {
    iata: "JLS",
    title: "Jales Airport",
  },
  {
    iata: "QOA",
    title: "Mococa Airport",
  },
  {
    iata: "QNV",
    title: "Aeroclube Airport",
  },
  {
    iata: "OUS",
    title: "Ourinhos Airport",
  },
  {
    iata: "QHB",
    title: "Piracicaba Airport",
  },
  {
    iata: "QIQ",
    title: "Rio Claro Airport",
  },
  {
    iata: "QRZ",
    title: "Resende Airport",
  },
  {
    iata: "UBT",
    title: "Ubatuba Airport",
  },
  {
    iata: "QGS",
    title: "Alagoinhas Airport",
  },
  {
    iata: "VOT",
    title: "Votuporanga Airport",
  },
  {
    iata: "QGB",
    title: "Limeira Airport",
  },
  {
    iata: "IZA",
    title: "Zona da Mata Regional Airport",
  },
  {
    iata: "OCC",
    title: "Francisco De Orellana Airport",
  },
  {
    iata: "CUE",
    title: "Mariscal Lamar Airport",
  },
  {
    iata: "GPS",
    title: "Seymour Airport",
  },
  {
    iata: "GYE",
    title: "Simon Bolivar International Airport",
  },
  {
    iata: "IBB",
    title: "General Villamil Airport",
  },
  {
    iata: "JIP",
    title: "Jipijapa Airport",
  },
  {
    iata: "LTX",
    title: "Cotopaxi International Airport",
  },
  {
    iata: "MRR",
    title: "Jose Maria Velasco Ibarra Airport",
  },
  {
    iata: "XMS",
    title: "Coronel E Carvajal Airport",
  },
  {
    iata: "MCH",
    title: "General Manuel Serrano Airport",
  },
  {
    iata: "MEC",
    title: "Eloy Alfaro International Airport",
  },
  {
    iata: "LGQ",
    title: "Nueva Loja Airport",
  },
  {
    iata: "PYO",
    title: "Putumayo Airport",
  },
  {
    iata: "PVO",
    title: "Reales Tamarindos Airport",
  },
  {
    iata: "UIO",
    title: "Mariscal Sucre International Airport",
  },
  {
    iata: "ETR",
    title: "Coronel Artilleria Victor Larrea Airport",
  },
  {
    iata: "SNC",
    title: "General Ulpiano Paez Airport",
  },
  {
    iata: "SUQ",
    title: "Sucua Airport",
  },
  {
    iata: "PTZ",
    title: "Rio Amazonas Airport",
  },
  {
    iata: "BHA",
    title: "Los Perales Airport",
  },
  {
    iata: "TSC",
    title: "Taisha Airport",
  },
  {
    iata: "TPN",
    title: "Tiputini Airport",
  },
  {
    iata: "LOH",
    title: "Camilo Ponce Enriquez Airport",
  },
  {
    iata: "ESM",
    title: "General Rivadeneira Airport",
  },
  {
    iata: "TPC",
    title: "Tarapoa Airport",
  },
  {
    iata: "TUA",
    title: "Teniente Coronel Luis a Mantilla Airport",
  },
  {
    iata: "PSY",
    title: "Stanley Airport",
  },
  {
    iata: "ASU",
    title: "Silvio Pettirossi International Airport",
  },
  {
    iata: "AYO",
    title: "Juan De Ayolas Airport",
  },
  {
    iata: "CIO",
    title: "Teniente Col Carmelo Peralta Airport",
  },
  {
    iata: "AGT",
    title: "Guarani International Airport",
  },
  {
    iata: "FLM",
    title: "Filadelfia Airport",
  },
  {
    iata: "PIL",
    title: "Carlos Miguel Gimenez Airport",
  },
  {
    iata: "PJC",
    title: "Dr Augusto Roberto Fuster International Airport",
  },
  {
    iata: "LVR",
    title: "Municipal Bom Futuro Airport",
  },
  {
    iata: "FRC",
    title: "Franca Airport",
  },
  {
    iata: "CFO",
    title: "Confresa Airport",
  },
  {
    iata: "JTC",
    title: "Bauru - Arealva Airport",
  },
  {
    iata: "ARS",
    title: "Usina Santa Cruz Airport",
  },
  {
    iata: "ACM",
    title: "Arica Airport",
  },
  {
    iata: "ACL",
    title: "Aguaclara Airport",
  },
  {
    iata: "NBB",
    title: "Barranco Minas Airport",
  },
  {
    iata: "AZT",
    title: "Zapatoca Airport",
  },
  {
    iata: "SQB",
    title: "Santa Ana Airport",
  },
  {
    iata: "ARF",
    title: "Acaricuara Airport",
  },
  {
    iata: "ACR",
    title: "Araracuara Airport",
  },
  {
    iata: "AFI",
    title: "Amalfi Airport",
  },
  {
    iata: "ADN",
    title: "Andes Airport",
  },
  {
    iata: "APY",
    title: "Gomez Nino Apiay Air Base",
  },
  {
    iata: "AXM",
    title: "El Eden Airport",
  },
  {
    iata: "PUU",
    title: "Tres De Mayo Airport",
  },
  {
    iata: "ELB",
    title: "Las Flores Airport",
  },
  {
    iata: "BGA",
    title: "Palonegro Airport",
  },
  {
    iata: "BOG",
    title: "El Dorado International Airport",
  },
  {
    iata: "BAQ",
    title: "Ernesto Cortissoz International Airport",
  },
  {
    iata: "CUC",
    title: "Camilo Daza International Airport",
  },
  {
    iata: "COG",
    title: "Mandinga Airport",
  },
  {
    iata: "CCO",
    title: "Carimagua Airport",
  },
  {
    iata: "CLO",
    title: "Alfonso Bonilla Aragon International Airport",
  },
  {
    iata: "CIM",
    title: "Cimitarra Airport",
  },
  {
    iata: "RAV",
    title: "Cravo Norte Airport",
  },
  {
    iata: "TCO",
    title: "La Florida Airport",
  },
  {
    iata: "CAQ",
    title: "Juan H White Airport",
  },
  {
    iata: "CZU",
    title: "Las Brujas Airport",
  },
  {
    iata: "EBG",
    title: "El Bagre Airport",
  },
  {
    iata: "FLA",
    title: "Gustavo Artunduaga Paredes Airport",
  },
  {
    iata: "GIR",
    title: "Santiago Vila Airport",
  },
  {
    iata: "CRC",
    title: "Santa Ana Airport",
  },
  {
    iata: "GPI",
    title: "Juan Casiano Airport",
  },
  {
    iata: "CPL",
    title: "Chaparral Airport",
  },
  {
    iata: "HTZ",
    title: "Hato Corozal Airport",
  },
  {
    iata: "IBE",
    title: "Perales Airport",
  },
  {
    iata: "MMP",
    title: "Cicuco Airport",
  },
  {
    iata: "IPI",
    title: "San Luis Airport",
  },
  {
    iata: "LQM",
    title: "Caucaya Airport",
  },
  {
    iata: "MCJ",
    title: "Jorge Isaac Airport",
  },
  {
    iata: "LPD",
    title: "La Pedrera Airport",
  },
  {
    iata: "EOH",
    title: "Enrique Olaya Herrera Airport",
  },
  {
    iata: "MFS",
    title: "Miraflores Airport",
  },
  {
    iata: "MGN",
    title: "Baracoa Airport",
  },
  {
    iata: "MCJ",
    title: "Maicao Airport",
  },
  {
    iata: "MTB",
    title: "Montelibano Airport",
  },
  {
    iata: "MTR",
    title: "Los Garzones Airport",
  },
  {
    iata: "MVP",
    title: "Fabio Alberto Leon Bentley Airport",
  },
  {
    iata: "MZL",
    title: "La Nubia Airport",
  },
  {
    iata: "NCI",
    title: "Necocli Airport",
  },
  {
    iata: "NQU",
    title: "Reyes Murillo Airport",
  },
  {
    iata: "NVA",
    title: "Benito Salas Airport",
  },
  {
    iata: "OCV",
    title: "Aguas Claras Airport",
  },
  {
    iata: "ORC",
    title: "Orocue Airport",
  },
  {
    iata: "PCR",
    title: "German Olano Airport",
  },
  {
    iata: "PDA",
    title: "Obando Airport",
  },
  {
    iata: "PTX",
    title: "Pitalito Airport",
  },
  {
    iata: "PLT",
    title: "Plato Airport",
  },
  {
    iata: "NAR",
    title: "Puerto Nare Airport",
  },
  {
    iata: "PQE",
    title: "German Olano Air Base",
  },
  {
    iata: "PBE",
    title: "Puerto Berrio Airport",
  },
  {
    iata: "PSO",
    title: "Antonio Narino Airport",
  },
  {
    iata: "PVA",
    title: "El Embrujo Airport",
  },
  {
    iata: "PZA",
    title: "Paz De Ariporo Airport",
  },
  {
    iata: "MQU",
    title: "Jose Celestino Mutis Airport",
  },
  {
    iata: "RCH",
    title: "Almirante Padilla Airport",
  },
  {
    iata: "SJE",
    title: "Jorge E. Gonzalez Torres Airport",
  },
  {
    iata: "SOX",
    title: "Alberto Lleras Camargo Airport",
  },
  {
    iata: "ADZ",
    title: "Gustavo Rojas Pinilla International Airport",
  },
  {
    iata: "SVI",
    title: "Eduardo Falla Solano Airport",
  },
  {
    iata: "TDA",
    title: "Trinidad Airport",
  },
  {
    iata: "TME",
    title: "Gustavo Vargas Airport",
  },
  {
    iata: "TQS",
    title: "Tres Esquinas Air Base",
  },
  {
    iata: "AUC",
    title: "Santiago Perez Airport",
  },
  {
    iata: "ULQ",
    title: "Farfan Airport",
  },
  {
    iata: "URR",
    title: "Urrao Airport",
  },
  {
    iata: "VVC",
    title: "Vanguardia Airport",
  },
  {
    iata: "AYG",
    title: "Yaguara Airport",
  },
  {
    iata: "EYP",
    title: "El Yopal Airport",
  },
  {
    iata: "MHW",
    title: "Monteagudo Airport",
  },
  {
    iata: "APB",
    title: "Apolo Airport",
  },
  {
    iata: "BJO",
    title: "Bermejo Airport",
  },
  {
    iata: "CAM",
    title: "Camiri Airport",
  },
  {
    iata: "CBB",
    title: "Jorge Wilsterman International Airport",
  },
  {
    iata: "SRZ",
    title: "El Trompillo Airport",
  },
  {
    iata: "BVK",
    title: "Huacaraje Airport",
  },
  {
    iata: "SJV",
    title: "San Javier Airport",
  },
  {
    iata: "LPB",
    title: "El Alto International Airport",
  },
  {
    iata: "MGD",
    title: "Magdalena Airport",
  },
  {
    iata: "ORU",
    title: "Juan Mendoza Airport",
  },
  {
    iata: "POI",
    title: "Capitan Nicolas Rojas Airport",
  },
  {
    iata: "PUR",
    title: "Puerto Rico Airport",
  },
  {
    iata: "REY",
    title: "Reyes Airport",
  },
  {
    iata: "SBL",
    title: "Santa Ana Del Yacuma Airport",
  },
  {
    iata: "SNM",
    title: "San Ignacio de Moxos Airport",
  },
  {
    iata: "SRB",
    title: "Santa Rosa De Yacuma Airport",
  },
  {
    iata: "SRE",
    title: "Juana Azurduy De Padilla Airport",
  },
  {
    iata: "TJA",
    title: "Capitan Oriel Lea Plaza Airport",
  },
  {
    iata: "TDD",
    title: "Teniente Av. Jorge Henrich Arauz Airport",
  },
  {
    iata: "UYU",
    title: "Uyuni Airport",
  },
  {
    iata: "VVI",
    title: "Viru Viru International Airport",
  },
  {
    iata: "BYC",
    title: "Yacuiba Airport",
  },
  {
    iata: "ABN",
    title: "Albina Airport",
  },
  {
    iata: "TOT",
    title: "Totness Airport",
  },
  {
    iata: "DRJ",
    title: "Drietabbetje Airport",
  },
  {
    iata: "PBM",
    title: "Johan Adolf Pengel International Airport",
  },
  {
    iata: "ICK",
    title: "Nieuw Nickerie Airport",
  },
  {
    iata: "OEM",
    title: "Vincent Fayks Airport",
  },
  {
    iata: "SMZ",
    title: "Stoelmanseiland Airport",
  },
  {
    iata: "AGI",
    title: "Wageningen Airport Airport",
  },
  {
    iata: "ORG",
    title: "Zorg en Hoop Airport",
  },
  {
    iata: "APQ",
    title: "Arapiraca Airport",
  },
  {
    iata: "AIF",
    title: "Marcelo Pires Halzhausen Airport",
  },
  {
    iata: "BDC",
    title: "Barra do Corda Airport",
  },
  {
    iata: "BVM",
    title: "Belmonte Airport",
  },
  {
    iata: "BRA",
    title: "Barreiras Airport",
  },
  {
    iata: "BSS",
    title: "Balsas Airport",
  },
  {
    iata: "BQQ",
    title: "Barra Airport",
  },
  {
    iata: "CTP",
    title: "Carutapera Airport",
  },
  {
    iata: "CPU",
    title: "Cururupu Airport",
  },
  {
    iata: "QCH",
    title: "Colatina Airport",
  },
  {
    iata: "LEP",
    title: "Leopoldina Airport",
  },
  {
    iata: "CNV",
    title: "Canavieiras Airport",
  },
  {
    iata: "ODL",
    title: "Guarapari Airport",
  },
  {
    iata: "GDP",
    title: "Guadalupe Airport",
  },
  {
    iata: "GNM",
    title: "Guanambi Airport",
  },
  {
    iata: "QGP",
    title: "Garanhuns Airport",
  },
  {
    iata: "ITN",
    title: "Itabuna Airport",
  },
  {
    iata: "QIG",
    title: "Iguatu Airport",
  },
  {
    iata: "QIT",
    title: "Itapetinga Airport",
  },
  {
    iata: "JCM",
    title: "Jacobina Airport",
  },
  {
    iata: "CMP",
    title: "Santana do Araguaia Airport",
  },
  {
    iata: "QDF",
    title: "Conselheiro Lafaiete Airport",
  },
  {
    iata: "QXD",
    title: "Cachoeiro do Itapemirim Airport",
  },
  {
    iata: "QCP",
    title: "Currais Novos Airport",
  },
  {
    iata: "LVB",
    title: "Livramento do Brumado Airport",
  },
  {
    iata: "MTE",
    title: "Monte Alegre Airport",
  },
  {
    iata: "MVS",
    title: "Mucuri Airport",
  },
  {
    iata: "PTQ",
    title: "Porto de Moz Airport",
  },
  {
    iata: "NNU",
    title: "Nanuque Airport",
  },
  {
    iata: "QBX",
    title: "Sobral Airport",
  },
  {
    iata: "PCS",
    title: "Picos Airport",
  },
  {
    iata: "POJ",
    title: "Patos de Minas Airport",
  },
  {
    iata: "PIV",
    title: "Pirapora Airport",
  },
  {
    iata: "FLB",
    title: "Cangapara Airport",
  },
  {
    iata: "JDO",
    title: "Colina Verde Heliport",
  },
  {
    iata: "PDF",
    title: "Prado Airport",
  },
  {
    iata: "CAU",
    title: "Caruaru Airport",
  },
  {
    iata: "SFK",
    title: "Soure Airport",
  },
  {
    iata: "TFL",
    title: "Juscelino Kubitscheck Airport",
  },
  {
    iata: "BVS",
    title: "Breves Airport",
  },
  {
    iata: "CMC",
    title: "Camocim Airport",
  },
  {
    iata: "PHI",
    title: "Pinheiro Airport",
  },
  {
    iata: "PPY",
    title: "Pouso Alegre Airport",
  },
  {
    iata: "BXX",
    title: "Boorama Airport",
  },
  {
    iata: "GTA",
    title: "Gatokae Airport",
  },
  {
    iata: "CAY",
    title: "Cayenne-Rochambeau Airport",
  },
  {
    iata: "MPY",
    title: "Maripasoula Airport",
  },
  {
    iata: "OXP",
    title: "Saint-Georges-de-l'Oyapock Airport",
  },
  {
    iata: "LDX",
    title: "Saint-Laurent-du-Maroni Airport",
  },
  {
    iata: "REI",
    title: "Regina Airport",
  },
  {
    iata: "APE",
    title: "San Juan Aposento Airport",
  },
  {
    iata: "ALD",
    title: "Alerta Airport",
  },
  {
    iata: "AOP",
    title: "Alferez FAP Alfredo Vladimir Sara Bauer Airport",
  },
  {
    iata: "MBP",
    title: "Moyobamba Airport",
  },
  {
    iata: "LHC",
    title: "Caballococha Airport",
  },
  {
    iata: "BLP",
    title: "Huallaga Airport",
  },
  {
    iata: "IBP",
    title: "Iberia Airport",
  },
  {
    iata: "TCG",
    title: "Tocache Airport",
  },
  {
    iata: "PCL",
    title: "Cap FAP David Abenzur Rengifo International Airport",
  },
  {
    iata: "CTF",
    title: "Contamana Airport",
  },
  {
    iata: "CHM",
    title: "Teniente FAP Jaime A De Montreuil Morales Airport",
  },
  {
    iata: "TGI",
    title: "Tingo Maria Airport",
  },
  {
    iata: "CIX",
    title: "Capitan FAP Jose A Quinones Gonzales International Airport",
  },
  {
    iata: "AYP",
    title: "Coronel FAP Alfredo Mendivil Duarte Airport",
  },
  {
    iata: "ANS",
    title: "Andahuaylas Airport",
  },
  {
    iata: "ATA",
    title: "Comandante FAP German Arias Graziani Airport",
  },
  {
    iata: "UMI",
    title: "Quince Air Base",
  },
  {
    iata: "SFK",
    title: "Satipo Airport",
  },
  {
    iata: "UCZ",
    title: "Uchiza Airport",
  },
  {
    iata: "RIJ",
    title: "Juan Simons Vela Airport",
  },
  {
    iata: "JJI",
    title: "Juanjui Airport",
  },
  {
    iata: "JAU",
    title: "Francisco Carle Airport",
  },
  {
    iata: "JUL",
    title: "Inca Manco Capac International Airport",
  },
  {
    iata: "SJA",
    title: "San Juan de Marcona Airport",
  },
  {
    iata: "CJA",
    title: "Mayor General FAP Armando Revoredo Iglesias Airport",
  },
  {
    iata: "RIM",
    title: "San Nicolas Airport",
  },
  {
    iata: "ILQ",
    title: "Ilo Airport",
  },
  {
    iata: "LIM",
    title: "Las Palmas Airport",
  },
  {
    iata: "TBP",
    title: "Capitan FAP Pedro Canga Rodriguez Airport",
  },
  {
    iata: "CHM",
    title: "Manuel Prado Ugarteche Airport",
  },
  {
    iata: "SMG",
    title: "Santa Maria Airport",
  },
  {
    iata: "YMS",
    title: "Moises Benzaquen Rengifo Airport",
  },
  {
    iata: "HUU",
    title: "Alferez Fap David Figueroa Fernandini Airport",
  },
  {
    iata: "SQU",
    title: "Saposoa Airport",
  },
  {
    iata: "SYC",
    title: "Shiringayoc/Hacienda Hda Mejia Airport",
  },
  {
    iata: "CHH",
    title: "Chachapoyas Airport",
  },
  {
    iata: "REQ",
    title: "Requena Airport",
  },
  {
    iata: "IQT",
    title: "Coronel FAP Francisco Secada Vignetta International Airport",
  },
  {
    iata: "TRU",
    title: "Capitan FAP Carlos Martinez De Pinillos International Airport",
  },
  {
    iata: "SQD",
    title: "San Francisco Airport",
  },
  {
    iata: "TPP",
    title: "Cadete FAP Guillermo Del Castillo Paredes Airport",
  },
  {
    iata: "SYC",
    title: "Shiringayoc Airport",
  },
  {
    iata: "TCQ",
    title: "Coronel FAP Carlos Ciriani Santa Rosa International Airport",
  },
  {
    iata: "PEM",
    title: "Padre Aldamiz International Airport",
  },
  {
    iata: "TYL",
    title: "Capitan Montes Airport",
  },
  {
    iata: "NZA",
    title: "Maria Reiche Neuman Airport",
  },
  {
    iata: "CUZ",
    title: "Alejandro Velasco Astete International Airport",
  },
  {
    iata: "AAJ",
    title: "Cayana Airstrip",
  },
  {
    iata: "KCB",
    title: "Tepoe Airstrip",
  },
  {
    iata: "APU",
    title: "Apucarana Airport",
  },
  {
    iata: "BNU",
    title: "Blumenau Airport",
  },
  {
    iata: "QCN",
    title: "Canela Airport",
  },
  {
    iata: "DOU",
    title: "Dourados Airport",
  },
  {
    iata: "ERM",
    title: "Erechim Airport",
  },
  {
    iata: "ITQ",
    title: "Itaqui Airport",
  },
  {
    iata: "JCB",
    title: "Santa Terezinha Airport",
  },
  {
    iata: "QDB",
    title: "Cachoeira do Sul Airport",
  },
  {
    iata: "QCR",
    title: "Curitibanos Airport",
  },
  {
    iata: "QRE",
    title: "Carazinho Airport",
  },
  {
    iata: "ALQ",
    title: "Alegrete Novo Airport",
  },
  {
    iata: "QMF",
    title: "Mafra Airport",
  },
  {
    iata: "QGF",
    title: "Montenegro Airport",
  },
  {
    iata: "QHV",
    title: "Novo Hamburgo Airport",
  },
  {
    iata: "APX",
    title: "Arapongas Airport",
  },
  {
    iata: "PTO",
    title: "Pato Branco Airport",
  },
  {
    iata: "QAC",
    title: "Castro Airport",
  },
  {
    iata: "CSU",
    title: "Santa Cruz do Sul Airport",
  },
  {
    iata: "UMU",
    title: "Umuarama Airport",
  },
  {
    iata: "VIA",
    title: "Videira Airport",
  },
  {
    iata: "AAG",
    title: "Arapoti Airport",
  },
  {
    iata: "SRA",
    title: "Santa Rosa Airport",
  },
  {
    iata: "PGZ",
    title: "Ponta Grossa Airport",
  },
  {
    iata: "ATI",
    title: "Artigas International Airport",
  },
  {
    iata: "BUV",
    title: "Bella Union Airport",
  },
  {
    iata: "CYR",
    title: "Laguna de Los Patos International Airport",
  },
  {
    iata: "CAR",
    title: "Carmelo International Airport",
  },
  {
    iata: "DZO",
    title: "Santa Bernardina International Airport",
  },
  {
    iata: "PDP",
    title: "Capitan Corbeta CA Curbelo International Airport",
  },
  {
    iata: "MER",
    title: "Ricardo de Tomasi International Airport",
  },
  {
    iata: "MLZ",
    title: "Cerro Largo International Airport",
  },
  {
    iata: "MVD",
    title: "Carrasco International /General C L Berisso Airport",
  },
  {
    iata: "MDO",
    title: "El Jaguel / Punta del Este Airport",
  },
  {
    iata: "PDU",
    title: "Tydeo Larre Borges Airport",
  },
  {
    iata: "RVY",
    title: "Presidente General Don Oscar D. Gestido International Airport",
  },
  {
    iata: "STY",
    title: "Nueva Hesperides International Airport",
  },
  {
    iata: "TAW",
    title: "Tacuarembo Airport",
  },
  {
    iata: "TYT",
    title: "Treinta y Tres Airport",
  },
  {
    iata: "VCH",
    title: "Vichadero Airport",
  },
  {
    iata: "AGV",
    title: "Oswaldo Guevara Mujica Airport",
  },
  {
    iata: "AAO",
    title: "Anaco Airport",
  },
  {
    iata: "LPJ",
    title: "Armando Schwarck Airport",
  },
  {
    iata: "BLA",
    title: "General Jose Antonio Anzoategui International Airport",
  },
  {
    iata: "BNS",
    title: "Barinas Airport",
  },
  {
    iata: "ELR",
    title: "El Libertador Airbase",
  },
  {
    iata: "BRM",
    title: "Barquisimeto International Airport",
  },
  {
    iata: "MYC",
    title: "Escuela Mariscal Sucre Airport",
  },
  {
    iata: "CXA",
    title: "Caicara del Orinoco Airport",
  },
  {
    iata: "CUV",
    title: "Casigua El Cubo Airport",
  },
  {
    iata: "CLZ",
    title: "Calabozo Airport",
  },
  {
    iata: "CAJ",
    title: "Canaima Airport",
  },
  {
    iata: "VCR",
    title: "Carora Airport",
  },
  {
    iata: "isl",
    title: "La Tortuga Punta Delgada Airport",
  },
  {
    iata: "EOR",
    title: "El Dorado Airport",
  },
  {
    iata: "EOZ",
    title: "Elorza Airport",
  },
  {
    iata: "GDO",
    title: "Guasdalito Airport",
  },
  {
    iata: "GUI",
    title: "Guiria Airport",
  },
  {
    iata: "GUQ",
    title: "Guanare Airport",
  },
  {
    iata: "LSP",
    title: "Josefa Camejo International Airport",
  },
  {
    iata: "KAV",
    title: "Kavanayen Airport",
  },
  {
    iata: "LFR",
    title: "La Fria Airport",
  },
  {
    iata: "MAR",
    title: "La Chinita International Airport",
  },
  {
    iata: "MRD",
    title: "Alberto Carnevalli Airport",
  },
  {
    iata: "CBS",
    title: "Oro Negro Airport",
  },
  {
    iata: "PYH",
    title: "Cacique Aramare Airport",
  },
  {
    iata: "PBL",
    title: "General Bartolome Salom International Airport",
  },
  {
    iata: "PDZ",
    title: "Pedernales Airport",
  },
  {
    iata: "PPH",
    title: "Perai Tepuy Airport",
  },
  {
    iata: "SCI",
    title: "Paramillo Airport",
  },
  {
    iata: "PZO",
    title: "General Manuel Carlos Piar International Airport",
  },
  {
    iata: "PTM",
    title: "Palmarito Airport",
  },
  {
    iata: "LRV",
    title: "Gran Roque Airport",
  },
  {
    iata: "SVZ",
    title: "San Antonio Del Tachira Airport",
  },
  {
    iata: "SNV",
    title: "Santa Elena de Uairen Airport",
  },
  {
    iata: "STD",
    title: "Mayor Buenaventura Vivas International Airport",
  },
  {
    iata: "SNF",
    title: "Sub Teniente Nestor Arias Airport",
  },
  {
    iata: "SFD",
    title: "San Fernando De Apure Airport",
  },
  {
    iata: "SOM",
    title: "San Tome Airport",
  },
  {
    iata: "TUV",
    title: "Tucupita Airport",
  },
  {
    iata: "TMO",
    title: "Tumeremo Airport",
  },
  {
    iata: "URM",
    title: "Uriman Airport",
  },
  {
    iata: "VLN",
    title: "Arturo Michelena International Airport",
  },
  {
    iata: "VDP",
    title: "Valle de La Pascua Airport",
  },
  {
    iata: "BAZ",
    title: "Barcelos Airport",
  },
  {
    iata: "RBB",
    title: "Borba Airport",
  },
  {
    iata: "CAF",
    title: "Carauari Airport",
  },
  {
    iata: "CQS",
    title: "Costa Marques Airport",
  },
  {
    iata: "DMT",
    title: "Diamantino Airport",
  },
  {
    iata: "CQA",
    title: "Canarana Airport",
  },
  {
    iata: "GRP",
    title: "Gurupi Airport",
  },
  {
    iata: "IPG",
    title: "Ipiranga Airport",
  },
  {
    iata: "IDO",
    title: "Santa Izabel do Morro Airport",
  },
  {
    iata: "JRN",
    title: "Juruena Airport",
  },
  {
    iata: "CIZ",
    title: "Coari Airport",
  },
  {
    iata: "RVD",
    title: "General Leite de Castro Airport",
  },
  {
    iata: "AQM",
    title: "Nova Vida Airport",
  },
  {
    iata: "BCR",
    title: "Novo Campo Airport",
  },
  {
    iata: "PIN",
    title: "Parintins Airport",
  },
  {
    iata: "PBQ",
    title: "Pimenta Bueno Airport",
  },
  {
    iata: "AAI",
    title: "Arraias Airport",
  },
  {
    iata: "STZ",
    title: "Santa Terezinha Airport",
  },
  {
    iata: "IRZ",
    title: "Tapuruquara Airport",
  },
  {
    iata: "QHN",
    title: "Taguatinga Airport",
  },
  {
    iata: "VLP",
    title: "Vila Rica Airport",
  },
  {
    iata: "MBK",
    title: "Regional Orlando Villas Boas Airport",
  },
  {
    iata: "NOK",
    title: "Xavantina Airport",
  },
  {
    iata: "AHL",
    title: "Aishalton Airport",
  },
  {
    iata: "NAI",
    title: "Annai Airport",
  },
  {
    iata: "BMJ",
    title: "Baramita Airport",
  },
  {
    iata: "GFO",
    title: "Bartica A Airport",
  },
  {
    iata: "GEO",
    title: "Cheddi Jagan International Airport",
  },
  {
    iata: "OGL",
    title: "Ogle Airport",
  },
  {
    iata: "IMB",
    title: "Imbaimadai Airport",
  },
  {
    iata: "KAR",
    title: "Kamarang Airport",
  },
  {
    iata: "KRM",
    title: "Karanambo Airport",
  },
  {
    iata: "KRG",
    title: "Karasabai Airport",
  },
  {
    iata: "KTO",
    title: "Kato Airport",
  },
  {
    iata: "LUB",
    title: "Lumid Pau Airport",
  },
  {
    iata: "LTM",
    title: "Lethem Airport",
  },
  {
    iata: "USI",
    title: "Mabaruma Airport",
  },
  {
    iata: "MHA",
    title: "Mahdia Airport",
  },
  {
    iata: "MYM",
    title: "Monkey Mountain Airport",
  },
  {
    iata: "QSX",
    title: "New Amsterdam Airport",
  },
  {
    iata: "ORJ",
    title: "Orinduik Airport",
  },
  {
    iata: "PRR",
    title: "Paruma Airport",
  },
  {
    iata: "SZN",
    title: "Santa Cruz Island Airport",
  },
  {
    iata: "ANU",
    title: "V.C. Bird International Airport",
  },
  {
    iata: "BBQ",
    title: "Codrington Airport",
  },
  {
    iata: "BGI",
    title: "Sir Grantley Adams International Airport",
  },
  {
    iata: "DCF",
    title: "Canefield Airport",
  },
  {
    iata: "DOM",
    title: "Melville Hall Airport",
  },
  {
    iata: "BBR",
    title: "Baillif Airport",
  },
  {
    iata: "SBH",
    title: "Gustaf III Airport",
  },
  {
    iata: "GBJ",
    title: "Les Bases Airport",
  },
  {
    iata: "LSS",
    title: "Terre-de-Haut Airport",
  },
  {
    iata: "GND",
    title: "Point Salines International Airport",
  },
  {
    iata: "CRU",
    title: "Lauriston Airport",
  },
  {
    iata: "STT",
    title: "Cyril E. King Airport",
  },
  {
    iata: "STX",
    title: "Henry E Rohlsen Airport",
  },
  {
    iata: "ARE",
    title: "Antonio Nery Juarbe Pol Airport",
  },
  {
    iata: "BQN",
    title: "Rafael Hernandez Airport",
  },
  {
    iata: "VQS",
    title: "Vieques Airport",
  },
  {
    iata: "CPX",
    title: "Benjamin Rivera Noriega Airport",
  },
  {
    iata: "FAJ",
    title: "Diego Jimenez Torres Airport",
  },
  {
    iata: "SIG",
    title: "Fernando Luis Ribas Dominicci Airport",
  },
  {
    iata: "MAZ",
    title: "Eugenio Maria De Hostos Airport",
  },
  {
    iata: "PSE",
    title: "Mercedita Airport",
  },
  {
    iata: "SJU",
    title: "Luis Munoz Marin International Airport",
  },
  {
    iata: "SKB",
    title: "Robert L. Bradshaw International Airport",
  },
  {
    iata: "NEV",
    title: "Vance W. Amory International Airport",
  },
  {
    iata: "SLU",
    title: "George F. L. Charles Airport",
  },
  {
    iata: "UVF",
    title: "Hewanorra International Airport",
  },
  {
    iata: "NBE",
    title: "Enfidha Zine El Abidine Ben Ali International Airport",
  },
  {
    iata: "AUA",
    title: "Queen Beatrix International Airport",
  },
  {
    iata: "BON",
    title: "Flamingo International Airport",
  },
  {
    iata: "CUR",
    title: "Hato International Airport",
  },
  {
    iata: "EUX",
    title: "F. D. Roosevelt Airport",
  },
  {
    iata: "SXM",
    title: "Princess Juliana International Airport",
  },
  {
    iata: "SAB",
    title: "Juancho E. Yrausquin Airport",
  },
  {
    iata: "AXA",
    title: "Wallblake Airport",
  },
  {
    iata: "MNI",
    title: "John A. Osborne Airport",
  },
  {
    iata: "TAB",
    title: "Tobago-Crown Point Airport",
  },
  {
    iata: "POS",
    title: "Piarco International Airport",
  },
  {
    iata: "NGD",
    title: "Captain Auguste George Airport",
  },
  {
    iata: "EIS",
    title: "Terrance B. Lettsome International Airport",
  },
  {
    iata: "VIJ",
    title: "Virgin Gorda Airport",
  },
  {
    iata: "BR-",
    title: "Tucuma Airport",
  },
  {
    iata: "BQU",
    title: "J F Mitchell Airport",
  },
  {
    iata: "CIW",
    title: "Canouan Airport",
  },
  {
    iata: "MQS",
    title: "Mustique Airport",
  },
  {
    iata: "UNI",
    title: "Union Island International Airport",
  },
  {
    iata: "SVD",
    title: "E. T. Joshua Airport",
  },
  {
    iata: "CMJ",
    title: "Chi Mei Airport",
  },
  {
    iata: "TWH",
    title: "Two Harbors Amphibious Terminal",
  },
  {
    iata: "BDA",
    title: "L.F. Wade International International Airport",
  },
  {
    iata: "GIT",
    title: "Geita Airport",
  },
  {
    iata: "LUY",
    title: "Lushoto Airport",
  },
  {
    iata: "ALA",
    title: "Almaty Airport",
  },
  {
    iata: "BXH",
    title: "Balkhash Airport",
  },
  {
    iata: "BXJ",
    title: "Boralday Airport",
  },
  {
    iata: "TSE",
    title: "Astana International Airport",
  },
  {
    iata: "KOV",
    title: "Kokshetau Airport",
  },
  {
    iata: "PPK",
    title: "Petropavlosk South Airport",
  },
  {
    iata: "DMB",
    title: "Taraz Airport",
  },
  {
    iata: "UAE",
    title: "Mount Aue Airport",
  },
  {
    iata: "FRU",
    title: "Manas International Airport",
  },
  {
    iata: "OSS",
    title: "Osh Airport",
  },
  {
    iata: "CIT",
    title: "Shymkent Airport",
  },
  {
    iata: "DZN",
    title: "Zhezkazgan Airport",
  },
  {
    iata: "KGF",
    title: "Sary-Arka Airport",
  },
  {
    iata: "KZO",
    title: "Kzyl-Orda Southwest Airport",
  },
  {
    iata: "URA",
    title: "Uralsk Airport",
  },
  {
    iata: "EKB",
    title: "Ekibastuz Airport",
  },
  {
    iata: "UKK",
    title: "Ust-Kamennogorsk Airport",
  },
  {
    iata: "PWQ",
    title: "Pavlodar Airport",
  },
  {
    iata: "DLX",
    title: "Semipalatinsk Airport",
  },
  {
    iata: "SCO",
    title: "Aktau Airport",
  },
  {
    iata: "GUW",
    title: "Atyrau Airport",
  },
  {
    iata: "AKX",
    title: "Aktobe Airport",
  },
  {
    iata: "AYK",
    title: "Arkalyk North Airport",
  },
  {
    iata: "KSN",
    title: "Kostanay West Airport",
  },
  {
    iata: "GYD",
    title: "Heydar Aliyev International Airport",
  },
  {
    iata: "KVD",
    title: "Ganja Airport",
  },
  {
    iata: "NAJ",
    title: "Nakhchivan Airport",
  },
  {
    iata: "GBB",
    title: "Gabala International Airport",
  },
  {
    iata: "ZTU",
    title: "Zaqatala International Airport",
  },
  {
    iata: "LWN",
    title: "Gyumri Shirak Airport",
  },
  {
    iata: "EVN",
    title: "Zvartnots International Airport",
  },
  {
    iata: "ADH",
    title: "Aldan Airport",
  },
  {
    iata: "YKS",
    title: "Yakutsk Airport",
  },
  {
    iata: "CNN",
    title: "Chulman Airport",
  },
  {
    iata: "ULK",
    title: "Lensk Airport",
  },
  {
    iata: "PYJ",
    title: "Polyarny Airport",
  },
  {
    iata: "MJZ",
    title: "Mirny Airport",
  },
  {
    iata: "CKH",
    title: "Chokurdakh Airport",
  },
  {
    iata: "CYX",
    title: "Cherskiy Airport",
  },
  {
    iata: "IKS",
    title: "Tiksi Airport",
  },
  {
    iata: "ENK",
    title: "Zyryanka Airport",
  },
  {
    iata: "OYG",
    title: "Moyo Airport",
  },
  {
    iata: "UGB",
    title: "Ugashik Bay Airport",
  },
  {
    iata: "KUT",
    title: "Kopitnari Airport",
  },
  {
    iata: "BUS",
    title: "Batumi International Airport",
  },
  {
    iata: "SUI",
    title: "Sukhumi Dranda Airport",
  },
  {
    iata: "TBS",
    title: "Tbilisi International Airport",
  },
  {
    iata: "BQS",
    title: "Ignatyevo Airport",
  },
  {
    iata: "GDG",
    title: "Magdagachi Airport",
  },
  {
    iata: "TYD",
    title: "Tynda Airport",
  },
  {
    iata: "KHV",
    title: "Khabarovsk-Novy Airport",
  },
  {
    iata: "KXK",
    title: "Komsomolsk-on-Amur Airport",
  },
  {
    iata: "DYR",
    title: "Ugolny Airport",
  },
  {
    iata: "PVS",
    title: "Provideniya Bay Airport",
  },
  {
    iata: "GDX",
    title: "Sokol Airport",
  },
  {
    iata: "PWE",
    title: "Pevek Airport",
  },
  {
    iata: "BQG",
    title: "Bogorodskoye Airport",
  },
  {
    iata: "OHO",
    title: "Okhotsk Airport",
  },
  {
    iata: "PKC",
    title: "Yelizovo Airport",
  },
  {
    iata: "OHH",
    title: "Okha Airport",
  },
  {
    iata: "EKS",
    title: "Shakhtyorsk Airport",
  },
  {
    iata: "DEE",
    title: "Mendeleyevo Airport",
  },
  {
    iata: "ZZO",
    title: "Zonalnoye Airport",
  },
  {
    iata: "UUS",
    title: "Yuzhno-Sakhalinsk Airport",
  },
  {
    iata: "VVO",
    title: "Vladivostok International Airport",
  },
  {
    iata: "HTA",
    title: "Chita-Kadala Airport",
  },
  {
    iata: "BTK",
    title: "Bratsk Airport",
  },
  {
    iata: "UIK",
    title: "Ust-Ilimsk Airport",
  },
  {
    iata: "IKT",
    title: "Irkutsk Airport",
  },
  {
    iata: "ODO",
    title: "Bodaybo Airport",
  },
  {
    iata: "ERG",
    title: "Yerbogachen Airport",
  },
  {
    iata: "UKX",
    title: "Ust-Kut Airport",
  },
  {
    iata: "UUD",
    title: "Ulan-Ude Airport (Mukhino)",
  },
  {
    iata: "UJE",
    title: "Ujae Atoll Airport",
  },
  {
    iata: "UJN",
    title: "Uljin Airport",
  },
  {
    iata: "KBP",
    title: "Boryspil International Airport",
  },
  {
    iata: "DOK",
    title: "Donetsk International Airport",
  },
  {
    iata: "KRQ",
    title: "Kramatorsk Airport",
  },
  {
    iata: "MPW",
    title: "Mariupol International Airport",
  },
  {
    iata: "SEV",
    title: "Sievierodonetsk Airport",
  },
  {
    iata: "VSG",
    title: "Luhansk International Airport",
  },
  {
    iata: "ERD",
    title: "Berdyansk Airport",
  },
  {
    iata: "DNK",
    title: "Dnipropetrovsk International Airport",
  },
  {
    iata: "OZH",
    title: "Zaporizhzhia International Airport",
  },
  {
    iata: "KWG",
    title: "Kryvyi Rih International Airport",
  },
  {
    iata: "UKS",
    title: "Belbek Airport",
  },
  {
    iata: "SIP",
    title: "Simferopol International Airport",
  },
  {
    iata: "KHC",
    title: "Kerch Airport",
  },
  {
    iata: "UKH",
    title: "Mukhaizna Airport",
  },
  {
    iata: "HRK",
    title: "Kharkiv International Airport",
  },
  {
    iata: "PLV",
    title: "Suprunovka Airport",
  },
  {
    iata: "UMY",
    title: "Sumy Airport",
  },
  {
    iata: "CKC",
    title: "Cherkasy International Airport",
  },
  {
    iata: "KGO",
    title: "Kirovograd Airport",
  },
  {
    iata: "IEV",
    title: "Kiev Zhuliany International Airport",
  },
  {
    iata: "GML",
    title: "Gostomel Airport",
  },
  {
    iata: "UCK",
    title: "Lutsk Airport",
  },
  {
    iata: "HMJ",
    title: "Khmelnytskyi Airport",
  },
  {
    iata: "IFO",
    title: "Ivano-Frankivsk International Airport",
  },
  {
    iata: "LWO",
    title: "Lviv International Airport",
  },
  {
    iata: "CWC",
    title: "Chernivtsi International Airport",
  },
  {
    iata: "RWN",
    title: "Rivne International Airport",
  },
  {
    iata: "TNL",
    title: "Ternopil International Airport",
  },
  {
    iata: "UDJ",
    title: "Uzhhorod International Airport",
  },
  {
    iata: "KHE",
    title: "Chernobayevka Airport",
  },
  {
    iata: "NLV",
    title: "Mykolaiv International Airport",
  },
  {
    iata: "ODS",
    title: "Odessa International Airport",
  },
  {
    iata: "VIN",
    title: "Vinnytsia/Gavyryshivka Airport",
  },
  {
    iata: "ARH",
    title: "Talagi Airport",
  },
  {
    iata: "NNM",
    title: "Naryan Mar Airport",
  },
  {
    iata: "CSH",
    title: "Solovki Airport",
  },
  {
    iata: "CEE",
    title: "Cherepovets Airport",
  },
  {
    iata: "AMV",
    title: "Amderma Airport",
  },
  {
    iata: "ULH",
    title: "Majeed Bin Abdulaziz Airport",
  },
  {
    iata: "KSZ",
    title: "Kotlas Airport",
  },
  {
    iata: "LED",
    title: "Pulkovo Airport",
  },
  {
    iata: "KVK",
    title: "Kirovsk-Apatity Airport",
  },
  {
    iata: "MMK",
    title: "Murmansk Airport",
  },
  {
    iata: "NVR",
    title: "Novgorod Airport",
  },
  {
    iata: "VLU",
    title: "Velikiye Luki Airport",
  },
  {
    iata: "PKV",
    title: "Pskov Airport",
  },
  {
    iata: "PES",
    title: "Petrozavodsk Airport",
  },
  {
    iata: "RVH",
    title: "Rzhevka Airport",
  },
  {
    iata: "VGD",
    title: "Vologda Airport",
  },
  {
    iata: "BQT",
    title: "Brest Airport",
  },
  {
    iata: "GME",
    title: "Gomel Airport",
  },
  {
    iata: "VTB",
    title: "Vitebsk East Airport",
  },
  {
    iata: "KGD",
    title: "Khrabrovo Airport",
  },
  {
    iata: "GNA",
    title: "Hrodna Airport",
  },
  {
    iata: "MHP",
    title: "Minsk 1 Airport",
  },
  {
    iata: "MSQ",
    title: "Minsk International Airport",
  },
  {
    iata: "MVQ",
    title: "Mogilev Airport",
  },
  {
    iata: "ABA",
    title: "Abakan Airport",
  },
  {
    iata: "BAX",
    title: "Barnaul Airport",
  },
  {
    iata: "KEJ",
    title: "Kemerovo Airport",
  },
  {
    iata: "EIE",
    title: "Yeniseysk Airport",
  },
  {
    iata: "KJA",
    title: "Yemelyanovo Airport",
  },
  {
    iata: "ACS",
    title: "Achinsk Airport",
  },
  {
    iata: "KYZ",
    title: "Kyzyl Airport",
  },
  {
    iata: "OVB",
    title: "Tolmachevo Airport",
  },
  {
    iata: "OMS",
    title: "Omsk Central Airport",
  },
  {
    iata: "TOF",
    title: "Bogashevo Airport",
  },
  {
    iata: "NOZ",
    title: "Spichenkovo Airport",
  },
  {
    iata: "DKS",
    title: "Dikson Airport",
  },
  {
    iata: "HTG",
    title: "Khatanga Airport",
  },
  {
    iata: "IAA",
    title: "Igarka Airport",
  },
  {
    iata: "NSK",
    title: "Norilsk-Alykel Airport",
  },
  {
    iata: "AAQ",
    title: "Anapa Airport",
  },
  {
    iata: "EIK",
    title: "Yeysk Airport",
  },
  {
    iata: "GDZ",
    title: "Gelendzhik Airport",
  },
  {
    iata: "KRR",
    title: "Krasnodar International Airport",
  },
  {
    iata: "MCX",
    title: "Uytash Airport",
  },
  {
    iata: "MRV",
    title: "Mineralnyye Vody Airport",
  },
  {
    iata: "NAL",
    title: "Nalchik Airport",
  },
  {
    iata: "OGZ",
    title: "Beslan Airport",
  },
  {
    iata: "IGT",
    title: "Magas Airport",
  },
  {
    iata: "STW",
    title: "Stavropol Shpakovskoye Airport",
  },
  {
    iata: "ROV",
    title: "Rostov-na-Donu Airport",
  },
  {
    iata: "VLK",
    title: "Volgodonsk Airport",
  },
  {
    iata: "AER",
    title: "Sochi International Airport",
  },
  {
    iata: "ASF",
    title: "Astrakhan Airport",
  },
  {
    iata: "ESL",
    title: "Elista Airport",
  },
  {
    iata: "VOG",
    title: "Volgograd International Airport",
  },
  {
    iata: "AHT",
    title: "Amchitka Army Airfield",
  },
  {
    iata: "CEK",
    title: "Chelyabinsk Balandino Airport",
  },
  {
    iata: "MQF",
    title: "Magnitogorsk International Airport",
  },
  {
    iata: "SLY",
    title: "Salekhard Airport",
  },
  {
    iata: "YMK",
    title: "Mys Kamenny Airport",
  },
  {
    iata: "UEN",
    title: "Urengoy Airport",
  },
  {
    iata: "EZV",
    title: "Berezovo Airport",
  },
  {
    iata: "HMA",
    title: "Khanty Mansiysk Airport",
  },
  {
    iata: "IRM",
    title: "Igrim Airport",
  },
  {
    iata: "NYA",
    title: "Nyagan Airport",
  },
  {
    iata: "OVS",
    title: "Sovetskiy Airport",
  },
  {
    iata: "URJ",
    title: "Uray Airport",
  },
  {
    iata: "EYK",
    title: "Beloyarskiy Airport",
  },
  {
    iata: "IJK",
    title: "Izhevsk Airport",
  },
  {
    iata: "KVX",
    title: "Pobedilovo Airport",
  },
  {
    iata: "NYM",
    title: "Nadym Airport",
  },
  {
    iata: "NUX",
    title: "Novy Urengoy Airport",
  },
  {
    iata: "NJC",
    title: "Nizhnevartovsk Airport",
  },
  {
    iata: "RAT",
    title: "Raduzhny Airport",
  },
  {
    iata: "PEE",
    title: "Bolshoye Savino Airport",
  },
  {
    iata: "KGP",
    title: "Kogalym International Airport",
  },
  {
    iata: "NFG",
    title: "Nefteyugansk Airport",
  },
  {
    iata: "NOJ",
    title: "Noyabrsk Airport",
  },
  {
    iata: "SGC",
    title: "Surgut Airport",
  },
  {
    iata: "SVX",
    title: "Koltsovo Airport",
  },
  {
    iata: "TOX",
    title: "Tobolsk Airport",
  },
  {
    iata: "TJM",
    title: "Roshchino International Airport",
  },
  {
    iata: "KRO",
    title: "Kurgan Airport",
  },
  {
    iata: "ASB",
    title: "Ashgabat Airport",
  },
  {
    iata: "KRW",
    title: "Turkmenbashi Airport",
  },
  {
    iata: "MYP",
    title: "Mary Airport",
  },
  {
    iata: "TAZ",
    title: "Da?oguz Airport",
  },
  {
    iata: "CRZ",
    title: "Turkmenabat Airport",
  },
  {
    iata: "DYU",
    title: "Dushanbe Airport",
  },
  {
    iata: "TJU",
    title: "Kulob Airport",
  },
  {
    iata: "LBD",
    title: "Khudzhand Airport",
  },
  {
    iata: "KQT",
    title: "Qurghonteppa International Airport",
  },
  {
    iata: "AZN",
    title: "Andizhan Airport",
  },
  {
    iata: "FEG",
    title: "Fergana Airport",
  },
  {
    iata: "NMA",
    title: "Namangan Airport",
  },
  {
    iata: "NCU",
    title: "Nukus Airport",
  },
  {
    iata: "UGC",
    title: "Urgench Airport",
  },
  {
    iata: "NVI",
    title: "Navoi Airport",
  },
  {
    iata: "BHK",
    title: "Bukhara Airport",
  },
  {
    iata: "KSQ",
    title: "Karshi Khanabad Airport",
  },
  {
    iata: "AFS",
    title: "Sugraly Airport",
  },
  {
    iata: "SKD",
    title: "Samarkand Airport",
  },
  {
    iata: "TMJ",
    title: "Termez Airport",
  },
  {
    iata: "TAS",
    title: "Tashkent International Airport",
  },
  {
    iata: "KMW",
    title: "Kostroma Sokerkino Airport",
  },
  {
    iata: "BKA",
    title: "Bykovo Airport",
  },
  {
    iata: "IWA",
    title: "Ivanovo South Airport",
  },
  {
    iata: "RYB",
    title: "Staroselye Airport",
  },
  {
    iata: "BZK",
    title: "Bryansk Airport",
  },
  {
    iata: "DME",
    title: "Domodedovo International Airport",
  },
  {
    iata: "IAR",
    title: "Tunoshna Airport",
  },
  {
    iata: "SVO",
    title: "Sheremetyevo International Airport",
  },
  {
    iata: "KLD",
    title: "Migalovo Air Base",
  },
  {
    iata: "EGO",
    title: "Belgorod International Airport",
  },
  {
    iata: "URS",
    title: "Kursk East Airport",
  },
  {
    iata: "LPK",
    title: "Lipetsk Airport",
  },
  {
    iata: "VOZ",
    title: "Voronezh International Airport",
  },
  {
    iata: "OEL",
    title: "Oryol Yuzhny Airport",
  },
  {
    iata: "TBW",
    title: "Donskoye Airport",
  },
  {
    iata: "RZN",
    title: "Turlatovo Airport",
  },
  {
    iata: "VKO",
    title: "Vnukovo International Airport",
  },
  {
    iata: "UCT",
    title: "Ukhta Airport",
  },
  {
    iata: "INA",
    title: "Inta Airport",
  },
  {
    iata: "PEX",
    title: "Pechora Airport",
  },
  {
    iata: "USK",
    title: "Usinsk Airport",
  },
  {
    iata: "VKT",
    title: "Vorkuta Airport",
  },
  {
    iata: "UTS",
    title: "Ust-Tsylma Airport",
  },
  {
    iata: "SCW",
    title: "Syktyvkar Airport",
  },
  {
    iata: "GOJ",
    title: "Nizhny Novgorod International Airport",
  },
  {
    iata: "UUA",
    title: "Bugulma Airport",
  },
  {
    iata: "KZN",
    title: "Kazan International Airport",
  },
  {
    iata: "NBC",
    title: "Begishevo Airport",
  },
  {
    iata: "JOK",
    title: "Yoshkar-Ola Airport",
  },
  {
    iata: "CSY",
    title: "Cheboksary Airport",
  },
  {
    iata: "ULV",
    title: "Ulyanovsk Baratayevka Airport",
  },
  {
    iata: "ULY",
    title: "Ulyanovsk East Airport",
  },
  {
    iata: "REN",
    title: "Orenburg Central Airport",
  },
  {
    iata: "OSW",
    title: "Orsk Airport",
  },
  {
    iata: "PEZ",
    title: "Penza Airport",
  },
  {
    iata: "SKX",
    title: "Saransk Airport",
  },
  {
    iata: "BWO",
    title: "Balakovo Airport",
  },
  {
    iata: "RTW",
    title: "Saratov Central Airport",
  },
  {
    iata: "BCX",
    title: "Beloretsk Airport",
  },
  {
    iata: "NEF",
    title: "Neftekamsk Airport",
  },
  {
    iata: "OKT",
    title: "Oktyabrskiy Airport",
  },
  {
    iata: "UFA",
    title: "Ufa International Airport",
  },
  {
    iata: "KUF",
    title: "Kurumoch International Airport",
  },
  {
    iata: "FZB",
    title: "Fray Bentos Airport",
  },
  {
    iata: "RCH",
    title: "Rocha Airport",
  },
  {
    iata: "DIU",
    title: "Diu Airport",
  },
  {
    iata: "AMD",
    title: "Sardar Vallabhbhai Patel International Airport",
  },
  {
    iata: "AKD",
    title: "Akola Airport",
  },
  {
    iata: "IXU",
    title: "Aurangabad Airport",
  },
  {
    iata: "BOM",
    title: "Chhatrapati Shivaji International Airport",
  },
  {
    iata: "PAB",
    title: "Bilaspur Airport",
  },
  {
    iata: "BHJ",
    title: "Bhuj Airport",
  },
  {
    iata: "IXG",
    title: "Belgaum Airport",
  },
  {
    iata: "BDQ",
    title: "Vadodara Airport",
  },
  {
    iata: "BHO",
    title: "Bhopal Airport",
  },
  {
    iata: "BHU",
    title: "Bhavnagar Airport",
  },
  {
    iata: "NMB",
    title: "Daman Airport",
  },
  {
    iata: "GUX",
    title: "Guna Airport",
  },
  {
    iata: "GOI",
    title: "Dabolim Airport",
  },
  {
    iata: "HBX",
    title: "Hubli Airport",
  },
  {
    iata: "IDR",
    title: "Devi Ahilyabai Holkar Airport",
  },
  {
    iata: "JLR",
    title: "Jabalpur Airport",
  },
  {
    iata: "JGA",
    title: "Jamnagar Airport",
  },
  {
    iata: "IXY",
    title: "Kandla Airport",
  },
  {
    iata: "HJR",
    title: "Khajuraho Airport",
  },
  {
    iata: "KLH",
    title: "Kolhapur Airport",
  },
  {
    iata: "IXK",
    title: "Keshod Airport",
  },
  {
    iata: "NDC",
    title: "Nanded Airport",
  },
  {
    iata: "NAG",
    title: "Dr. Babasaheb Ambedkar International Airport",
  },
  {
    iata: "ISK",
    title: "Gandhinagar Airport",
  },
  {
    iata: "PNQ",
    title: "Pune Airport",
  },
  {
    iata: "PBD",
    title: "Porbandar Airport",
  },
  {
    iata: "RTC",
    title: "Ratnagiri Airport",
  },
  {
    iata: "RAJ",
    title: "Rajkot Airport",
  },
  {
    iata: "RPR",
    title: "Raipur Airport",
  },
  {
    iata: "SSE",
    title: "Solapur Airport",
  },
  {
    iata: "STV",
    title: "Surat Airport",
  },
  {
    iata: "UDR",
    title: "Maharana Pratap Airport",
  },
  {
    iata: "CMB",
    title: "Bandaranaike International Colombo Airport",
  },
  {
    iata: "ACJ",
    title: "Anuradhapura Air Force Base",
  },
  {
    iata: "BTC",
    title: "Batticaloa Airport",
  },
  {
    iata: "RML",
    title: "Colombo Ratmalana Airport",
  },
  {
    iata: "GOY",
    title: "Amparai Airport",
  },
  {
    iata: "MNH",
    title: "Hingurakgoda Air Force Base",
  },
  {
    iata: "JAF",
    title: "Kankesanturai Airport",
  },
  {
    iata: "KCT",
    title: "Koggala Airport",
  },
  {
    iata: "GIU",
    title: "Sigiriya Air Force Base",
  },
  {
    iata: "TRR",
    title: "China Bay Airport",
  },
  {
    iata: "WRZ",
    title: "Weerawila International Airport",
  },
  {
    iata: "BBM",
    title: "Battambang Airport",
  },
  {
    iata: "KZC",
    title: "Kampong Chhnang Airport",
  },
  {
    iata: "KKZ",
    title: "Kaoh Kong Airport",
  },
  {
    iata: "KTI",
    title: "Kratie Airport",
  },
  {
    iata: "PNH",
    title: "Phnom Penh International Airport",
  },
  {
    iata: "RBE",
    title: "Ratanakiri Airport",
  },
  {
    iata: "REP",
    title: "Angkor International Airport",
  },
  {
    iata: "TNX",
    title: "Stung Treng Airport",
  },
  {
    iata: "KOS",
    title: "Sihanoukville International Airport",
  },
  {
    iata: "ELX",
    title: "Isla de Tigre  Heliport",
  },
  {
    iata: "LGY",
    title: "Lagunillas Airport",
  },
  {
    iata: "KTV",
    title: "Kamarata Airport",
  },
  {
    iata: "LAG",
    title: "La Guaira Airport",
  },
  {
    iata: "SFX",
    title: "San Felix Airport",
  },
  {
    iata: "SVV",
    title: "San Salvador de Paul Airport",
  },
  {
    iata: "WOK",
    title: "Wonken Airport",
  },
  {
    iata: "IXV",
    title: "Along Airport",
  },
  {
    iata: "IXA",
    title: "Agartala Airport",
  },
  {
    iata: "AJL",
    title: "Tuirial Airport",
  },
  {
    iata: "IXB",
    title: "Bagdogra Airport",
  },
  {
    iata: "RGH",
    title: "Balurghat Airport",
  },
  {
    iata: "SHL",
    title: "Shillong Airport",
  },
  {
    iata: "BBI",
    title: "Biju Patnaik Airport",
  },
  {
    iata: "CCU",
    title: "Netaji Subhash Chandra Bose International Airport",
  },
  {
    iata: "COH",
    title: "Cooch Behar Airport",
  },
  {
    iata: "DBD",
    title: "Dhanbad Airport",
  },
  {
    iata: "DAE",
    title: "Daporijo Airport",
  },
  {
    iata: "GOP",
    title: "Gorakhpur Airport",
  },
  {
    iata: "GAU",
    title: "Lokpriya Gopinath Bordoloi International Airport",
  },
  {
    iata: "GAY",
    title: "Gaya Airport",
  },
  {
    iata: "IMF",
    title: "Imphal Airport",
  },
  {
    iata: "PYB",
    title: "Jeypore Airport",
  },
  {
    iata: "IXW",
    title: "Jamshedpur Airport",
  },
  {
    iata: "JRH",
    title: "Jorhat Airport",
  },
  {
    iata: "IXQ",
    title: "Kamalpur Airport",
  },
  {
    iata: "IXH",
    title: "Kailashahar Airport",
  },
  {
    iata: "IXS",
    title: "Silchar Airport",
  },
  {
    iata: "IXN",
    title: "Khowai Airport",
  },
  {
    iata: "AJL",
    title: "Lengpui Airport",
  },
  {
    iata: "IXI",
    title: "North Lakhimpur Airport",
  },
  {
    iata: "LDA",
    title: "Malda Airport",
  },
  {
    iata: "DIB",
    title: "Dibrugarh Airport",
  },
  {
    iata: "DMU",
    title: "Dimapur Airport",
  },
  {
    iata: "MZU",
    title: "Muzaffarpur Airport",
  },
  {
    iata: "IXT",
    title: "Pasighat Airport",
  },
  {
    iata: "PAT",
    title: "Lok Nayak Jayaprakash Airport",
  },
  {
    iata: "IXR",
    title: "Birsa Munda Airport",
  },
  {
    iata: "RRK",
    title: "Rourkela Airport",
  },
  {
    iata: "RUP",
    title: "Rupsi India Airport",
  },
  {
    iata: "TEZ",
    title: "Tezpur Airport",
  },
  {
    iata: "VTZ",
    title: "Vishakhapatnam Airport",
  },
  {
    iata: "ZER",
    title: "Zero Airport",
  },
  {
    iata: "BZL",
    title: "Barisal Airport",
  },
  {
    iata: "CXB",
    title: "Cox's Bazar Airport",
  },
  {
    iata: "CLA",
    title: "Comilla Airport",
  },
  {
    iata: "CGP",
    title: "Shah Amanat International Airport",
  },
  {
    iata: "IRD",
    title: "Ishurdi Airport",
  },
  {
    iata: "JSR",
    title: "Jessore Airport",
  },
  {
    iata: "LLJ",
    title: "Lalmonirhat Airport",
  },
  {
    iata: "RJH",
    title: "Shah Mokhdum Airport",
  },
  {
    iata: "SPD",
    title: "Saidpur Airport",
  },
  {
    iata: "TKR",
    title: "Thakurgaon Airport",
  },
  {
    iata: "ZHM",
    title: "Shamshernagar Airport",
  },
  {
    iata: "ZYL",
    title: "Osmany International Airport",
  },
  {
    iata: "DAC",
    title: "Dhaka / Hazrat Shahjalal International Airport",
  },
  {
    iata: "HKG",
    title: "Chek Lap Kok International Airport",
  },
  {
    iata: "HKG",
    title: "Hong Kong International Airport Kai Tak",
  },
  {
    iata: "HHP",
    title: "Shun Tak Heliport",
  },
  {
    iata: "SPB",
    title: "Charlotte Amalie Harbor Seaplane Base",
  },
  {
    iata: "SSB",
    title: "Christiansted Harbor Seaplane Base",
  },
  {
    iata: "AGR",
    title: "Agra Airport",
  },
  {
    iata: "IXD",
    title: "Allahabad Airport",
  },
  {
    iata: "ATQ",
    title: "Sri Guru Ram Dass Jee International Airport, Amritsar",
  },
  {
    iata: "BKB",
    title: "Nal Airport",
  },
  {
    iata: "VNS",
    title: "Lal Bahadur Shastri Airport",
  },
  {
    iata: "KUU",
    title: "Kullu Manali Airport",
  },
  {
    iata: "BUP",
    title: "Bhatinda Air Force Station",
  },
  {
    iata: "IXC",
    title: "Chandigarh Airport",
  },
  {
    iata: "DED",
    title: "Dehradun Airport",
  },
  {
    iata: "DEL",
    title: "Indira Gandhi International Airport",
  },
  {
    iata: "DHM",
    title: "Kangra Airport",
  },
  {
    iata: "GWL",
    title: "Gwalior Airport",
  },
  {
    iata: "HSS",
    title: "Hissar Airport",
  },
  {
    iata: "JDH",
    title: "Jodhpur Airport",
  },
  {
    iata: "JAI",
    title: "Jaipur International Airport",
  },
  {
    iata: "JSA",
    title: "Jaisalmer Airport",
  },
  {
    iata: "IXJ",
    title: "Jammu Airport",
  },
  {
    iata: "KNU",
    title: "Kanpur Airport",
  },
  {
    iata: "KTU",
    title: "Kota Airport",
  },
  {
    iata: "LUH",
    title: "Ludhiana Airport",
  },
  {
    iata: "IXL",
    title: "Leh Kushok Bakula Rimpochee Airport",
  },
  {
    iata: "LKO",
    title: "Chaudhary Charan Singh International Airport",
  },
  {
    iata: "IXP",
    title: "Pathankot Air Force Station",
  },
  {
    iata: "PGH",
    title: "Pantnagar Airport",
  },
  {
    iata: "SLV",
    title: "Shimla Airport",
  },
  {
    iata: "SXR",
    title: "Sheikh ul Alam Airport",
  },
  {
    iata: "TNI",
    title: "Satna Airport",
  },
  {
    iata: "AOU",
    title: "Attopeu Airport",
  },
  {
    iata: "OUI",
    title: "Ban Huoeisay Airport",
  },
  {
    iata: "LPQ",
    title: "Luang Phabang International Airport",
  },
  {
    iata: "LXG",
    title: "Luang Namtha Airport",
  },
  {
    iata: "ODY",
    title: "Oudomsay Airport",
  },
  {
    iata: "PKZ",
    title: "Pakse International Airport",
  },
  {
    iata: "ZBY",
    title: "Sayaboury Airport",
  },
  {
    iata: "ZVK",
    title: "Savannakhet Airport",
  },
  {
    iata: "NEU",
    title: "Sam Neua Airport",
  },
  {
    iata: "VNA",
    title: "Saravane Airport",
  },
  {
    iata: "THK",
    title: "Thakhek Airport",
  },
  {
    iata: "VTE",
    title: "Wattay International Airport",
  },
  {
    iata: "XKH",
    title: "Xieng Khouang Airport",
  },
  {
    iata: "VMI",
    title: "Dr Juan Plate Airport",
  },
  {
    iata: "MFM",
    title: "Macau International Airport",
  },
  {
    iata: "VDH",
    title: "Dong Hoi Airport",
  },
  {
    iata: "KON",
    title: "Kontum Airport",
  },
  {
    iata: "BJH",
    title: "Bajhang Airport",
  },
  {
    iata: "BHP",
    title: "Bhojpur Airport",
  },
  {
    iata: "BGL",
    title: "Baglung Airport",
  },
  {
    iata: "BHR",
    title: "Bharatpur Airport",
  },
  {
    iata: "BJU",
    title: "Bajura Airport",
  },
  {
    iata: "BIT",
    title: "Baitadi Airport",
  },
  {
    iata: "BWA",
    title: "Bhairahawa Airport",
  },
  {
    iata: "BDP",
    title: "Bhadrapur Airport",
  },
  {
    iata: "DNP",
    title: "Tulsipur Airport",
  },
  {
    iata: "DHI",
    title: "Dhangarhi Airport",
  },
  {
    iata: "DAP",
    title: "Darchula Airport",
  },
  {
    iata: "DOP",
    title: "Dolpa Airport",
  },
  {
    iata: "SIH",
    title: "Silgadi Doti Airport",
  },
  {
    iata: "GKH",
    title: "Gorkha Airport",
  },
  {
    iata: "JIR",
    title: "Jiri Airport",
  },
  {
    iata: "JUM",
    title: "Jumla Airport",
  },
  {
    iata: "JKR",
    title: "Janakpur Airport",
  },
  {
    iata: "KTM",
    title: "Tribhuvan International Airport",
  },
  {
    iata: "LDN",
    title: "Lamidanda Airport",
  },
  {
    iata: "LUA",
    title: "Lukla Airport",
  },
  {
    iata: "LTG",
    title: "Langtang Airport",
  },
  {
    iata: "NGX",
    title: "Manang Airport",
  },
  {
    iata: "MEY",
    title: "Meghauli Airport",
  },
  {
    iata: "XMG",
    title: "Mahendranagar Airport",
  },
  {
    iata: "KEP",
    title: "Nepalgunj Airport",
  },
  {
    iata: "PKR",
    title: "Pokhara Airport",
  },
  {
    iata: "PPL",
    title: "Phaplu Airport",
  },
  {
    iata: "RJB",
    title: "Rajbiraj Airport",
  },
  {
    iata: "RHP",
    title: "Ramechhap Airport",
  },
  {
    iata: "RUK",
    title: "Rukumkot Airport",
  },
  {
    iata: "RUM",
    title: "Rumjatar Airport",
  },
  {
    iata: "SIF",
    title: "Simara Airport",
  },
  {
    iata: "SKH",
    title: "Surkhet Airport",
  },
  {
    iata: "FEB",
    title: "Sanfebagar Airport",
  },
  {
    iata: "IMK",
    title: "Simikot Airport",
  },
  {
    iata: "TMI",
    title: "Tumling Tar Airport",
  },
  {
    iata: "BIR",
    title: "Biratnagar Airport",
  },
  {
    iata: "LTU",
    title: "Murod Kond Airport",
  },
  {
    iata: "AGX",
    title: "Agatti Airport",
  },
  {
    iata: "BEP",
    title: "Bellary Airport",
  },
  {
    iata: "BLR",
    title: "Bengaluru International Airport",
  },
  {
    iata: "VGA",
    title: "Vijayawada Airport",
  },
  {
    iata: "CJB",
    title: "Coimbatore International Airport",
  },
  {
    iata: "COK",
    title: "Cochin International Airport",
  },
  {
    iata: "CCJ",
    title: "Calicut International Airport",
  },
  {
    iata: "CDP",
    title: "Cuddapah Airport",
  },
  {
    iata: "CBD",
    title: "Car Nicobar Air Force Station",
  },
  {
    iata: "HYD",
    title: "Rajiv Gandhi International Airport, Shamshabad",
  },
  {
    iata: "IXM",
    title: "Madurai Airport",
  },
  {
    iata: "IXE",
    title: "Mangalore International Airport",
  },
  {
    iata: "MAA",
    title: "Chennai International Airport",
  },
  {
    iata: "MYQ",
    title: "Mysore Airport",
  },
  {
    iata: "IXZ",
    title: "Vir Savarkar International Airport",
  },
  {
    iata: "PNY",
    title: "Pondicherry Airport",
  },
  {
    iata: "HYD",
    title: "Rajiv Gandhi Airport",
  },
  {
    iata: "RJA",
    title: "Rajahmundry Airport",
  },
  {
    iata: "SXV",
    title: "Salem Airport",
  },
  {
    iata: "TJV",
    title: "Tanjore Air Force Base",
  },
  {
    iata: "TIR",
    title: "Tirupati Airport",
  },
  {
    iata: "TRZ",
    title: "Tiruchirapally Civil Airport Airport",
  },
  {
    iata: "TRV",
    title: "Trivandrum International Airport",
  },
  {
    iata: "WGC",
    title: "Warangal Airport",
  },
  {
    iata: "PBH",
    title: "Paro Airport",
  },
  {
    iata: "FVM",
    title: "Fuvahmulah Airport",
  },
  {
    iata: "GAN",
    title: "Gan International Airport",
  },
  {
    iata: "HAQ",
    title: "Hanimaadhoo Airport",
  },
  {
    iata: "KDO",
    title: "Kadhdhoo Airport",
  },
  {
    iata: "KDM",
    title: "Kaadedhdhoo Airport",
  },
  {
    iata: "VAM",
    title: "Villa Airport",
  },
  {
    iata: "DMK",
    title: "Don Mueang International Airport",
  },
  {
    iata: "KKM",
    title: "Sa Pran Nak Airport",
  },
  {
    iata: "KKM",
    title: "Khok Kathiam Airport",
  },
  {
    iata: "TDX",
    title: "Trat Airport",
  },
  {
    iata: "BKK",
    title: "Suvarnabhumi Airport",
  },
  {
    iata: "UTP",
    title: "U-Tapao International Airport",
  },
  {
    iata: "CNX",
    title: "Chiang Mai International Airport",
  },
  {
    iata: "HGN",
    title: "Mae Hong Son Airport",
  },
  {
    iata: "PYY",
    title: "Mae Hong Son Airport",
  },
  {
    iata: "LPT",
    title: "Lampang Airport",
  },
  {
    iata: "NNT",
    title: "Nan Airport",
  },
  {
    iata: "PRH",
    title: "Phrae Airport",
  },
  {
    iata: "CEI",
    title: "Chiang Rai International Airport",
  },
  {
    iata: "BAO",
    title: "Udorn Air Base",
  },
  {
    iata: "PHY",
    title: "Phetchabun Airport",
  },
  {
    iata: "HHQ",
    title: "Hua Hin Airport",
  },
  {
    iata: "TKH",
    title: "Takhli Airport",
  },
  {
    iata: "MAQ",
    title: "Mae Sot Airport",
  },
  {
    iata: "THS",
    title: "Sukhothai Airport",
  },
  {
    iata: "PHS",
    title: "Phitsanulok Airport",
  },
  {
    iata: "TKT",
    title: "Tak Airport",
  },
  {
    iata: "UTR",
    title: "Uttaradit Airport",
  },
  {
    iata: "URT",
    title: "Surat Thani Airport",
  },
  {
    iata: "NAW",
    title: "Narathiwat Airport",
  },
  {
    iata: "CJM",
    title: "Chumphon Airport",
  },
  {
    iata: "NST",
    title: "Nakhon Si Thammarat Airport",
  },
  {
    iata: "KBV",
    title: "Krabi Airport",
  },
  {
    iata: "SGZ",
    title: "Songkhla Airport",
  },
  {
    iata: "PAN",
    title: "Pattani Airport",
  },
  {
    iata: "USM",
    title: "Samui Airport",
  },
  {
    iata: "NST",
    title: "Cha Ian Airport",
  },
  {
    iata: "HKT",
    title: "Phuket International Airport",
  },
  {
    iata: "UNN",
    title: "Ranong Airport",
  },
  {
    iata: "HDY",
    title: "Hat Yai International Airport",
  },
  {
    iata: "TST",
    title: "Trang Airport",
  },
  {
    iata: "UTH",
    title: "Udon Thani Airport",
  },
  {
    iata: "SNO",
    title: "Sakon Nakhon Airport",
  },
  {
    iata: "KKC",
    title: "Khon Kaen Airport",
  },
  {
    iata: "LOE",
    title: "Loei Airport",
  },
  {
    iata: "BFV",
    title: "Buri Ram Airport",
  },
  {
    iata: "NAK",
    title: "Nakhon Ratchasima Airport",
  },
  {
    iata: "UBP",
    title: "Ubon Ratchathani Airport",
  },
  {
    iata: "ROI",
    title: "Roi Et Airport",
  },
  {
    iata: "KOP",
    title: "Nakhon Phanom Airport",
  },
  {
    iata: "VUU",
    title: "Mvuu Camp Airport",
  },
  {
    iata: "BMV",
    title: "Buon Ma Thuot Airport",
  },
  {
    iata: "VCL",
    title: "Chu Lai International Airport",
  },
  {
    iata: "HPH",
    title: "Cat Bi International Airport",
  },
  {
    iata: "CXR",
    title: "Cam Ranh Airport",
  },
  {
    iata: "VCS",
    title: "Co Ong Airport",
  },
  {
    iata: "DIN",
    title: "Dien Bien Phu Airport",
  },
  {
    iata: "DLI",
    title: "Lien Khuong Airport",
  },
  {
    iata: "DAD",
    title: "Da Nang International Airport",
  },
  {
    iata: "VVN",
    title: "Malvinas Airport",
  },
  {
    iata: "HAN",
    title: "Noi Bai International Airport",
  },
  {
    iata: "SQH",
    title: "Na-San Airport",
  },
  {
    iata: "NHA",
    title: "Nha Trang Air Base",
  },
  {
    iata: "HUI",
    title: "Phu Bai Airport",
  },
  {
    iata: "UIH",
    title: "Phu Cat Airport",
  },
  {
    iata: "PXU",
    title: "Pleiku Airport",
  },
  {
    iata: "PQC",
    title: "Phu Quoc Airport",
  },
  {
    iata: "PHA",
    title: "Phan Rang Airport",
  },
  {
    iata: "PHH",
    title: "Phan Thiet Airport",
  },
  {
    iata: "VKG",
    title: "Rach Gia Airport",
  },
  {
    iata: "TBB",
    title: "Dong Tac Airport",
  },
  {
    iata: "SGN",
    title: "Tan Son Nhat International Airport",
  },
  {
    iata: "VII",
    title: "Vinh Airport",
  },
  {
    iata: "VTG",
    title: "Vung Tau Airport",
  },
  {
    iata: "NYU",
    title: "Bagan Airport",
  },
  {
    iata: "BMO",
    title: "Banmaw Airport",
  },
  {
    iata: "TVY",
    title: "Dawei Airport",
  },
  {
    iata: "NYT",
    title: "Naypyidaw Airport",
  },
  {
    iata: "GAW",
    title: "Gangaw Airport",
  },
  {
    iata: "GWA",
    title: "Gwa Airport",
  },
  {
    iata: "HEH",
    title: "Heho Airport",
  },
  {
    iata: "HOX",
    title: "Hommalinn Airport",
  },
  {
    iata: "TIO",
    title: "Tilin Airport",
  },
  {
    iata: "KET",
    title: "Kengtung Airport",
  },
  {
    iata: "KHM",
    title: "Kanti Airport",
  },
  {
    iata: "KMV",
    title: "Kalay Airport",
  },
  {
    iata: "KYP",
    title: "Kyaukpyu Airport",
  },
  {
    iata: "KAW",
    title: "Kawthoung Airport",
  },
  {
    iata: "KYT",
    title: "Kyauktu Airport",
  },
  {
    iata: "LIW",
    title: "Loikaw Airport",
  },
  {
    iata: "LSH",
    title: "Lashio Airport",
  },
  {
    iata: "MDL",
    title: "Mandalay International Airport",
  },
  {
    iata: "MGZ",
    title: "Myeik Airport",
  },
  {
    iata: "MYT",
    title: "Myitkyina Airport",
  },
  {
    iata: "MNU",
    title: "Mawlamyine Airport",
  },
  {
    iata: "MGU",
    title: "Manaung Airport",
  },
  {
    iata: "MOE",
    title: "Momeik Airport",
  },
  {
    iata: "MOG",
    title: "Mong Hsat Airport",
  },
  {
    iata: "MGK",
    title: "Mong Tong Airport",
  },
  {
    iata: "MWQ",
    title: "Magway Airport",
  },
  {
    iata: "NMS",
    title: "Namsang Airport",
  },
  {
    iata: "NMT",
    title: "Namtu Airport",
  },
  {
    iata: "PAA",
    title: "Hpa-N Airport",
  },
  {
    iata: "PAU",
    title: "Pauk Airport",
  },
  {
    iata: "BSX",
    title: "Pathein Airport",
  },
  {
    iata: "PPU",
    title: "Hpapun Airport",
  },
  {
    iata: "PBU",
    title: "Putao Airport",
  },
  {
    iata: "PKK",
    title: "Pakhokku Airport",
  },
  {
    iata: "PRU",
    title: "Pyay Airport",
  },
  {
    iata: "AKY",
    title: "Sittwe Airport",
  },
  {
    iata: "SNW",
    title: "Thandwe Airport",
  },
  {
    iata: "THL",
    title: "Tachileik Airport",
  },
  {
    iata: "XYE",
    title: "Ye Airport",
  },
  {
    iata: "RGN",
    title: "Yangon International Airport",
  },
  {
    iata: "FBS",
    title: "Friday Harbor Seaplane Base",
  },
  {
    iata: "UPG",
    title: "Hasanuddin International Airport",
  },
  {
    iata: "MJU",
    title: "Tampa Padang Airport",
  },
  {
    iata: "BIK",
    title: "Frans Kaisiepo Airport",
  },
  {
    iata: "ONI",
    title: "Moanamani Airport",
  },
  {
    iata: "WET",
    title: "Wagethe Airport",
  },
  {
    iata: "NBX",
    title: "Nabire Airport",
  },
  {
    iata: "ILA",
    title: "Illaga Airport",
  },
  {
    iata: "KOX",
    title: "Kokonau Airport",
  },
  {
    iata: "ZRI",
    title: "Serui Airport",
  },
  {
    iata: "TIM",
    title: "Moses Kilangin Airport",
  },
  {
    iata: "EWI",
    title: "Enarotali Airport",
  },
  {
    iata: "AMI",
    title: "Selaparang Airport",
  },
  {
    iata: "BMU",
    title: "Muhammad Salahuddin Airport",
  },
  {
    iata: "DPS",
    title: "Ngurah Rai (Bali) International Airport",
  },
  {
    iata: "LOP",
    title: "Bandara International Lombok Airport",
  },
  {
    iata: "SWQ",
    title: "Sumbawa Besar Airport",
  },
  {
    iata: "TMC",
    title: "Tambolaka Airport",
  },
  {
    iata: "WGP",
    title: "Waingapu Airport",
  },
  {
    iata: "ARJ",
    title: "Arso Airport",
  },
  {
    iata: "BUI",
    title: "Bokondini Airport",
  },
  {
    iata: "ZRM",
    title: "Sarmi Airport",
  },
  {
    iata: "DJJ",
    title: "Sentani Airport",
  },
  {
    iata: "LHI",
    title: "Lereh Airport",
  },
  {
    iata: "LII",
    title: "Mulia Airport",
  },
  {
    iata: "OKL",
    title: "Oksibil Airport",
  },
  {
    iata: "WAR",
    title: "Waris Airport",
  },
  {
    iata: "SEH",
    title: "Senggeh Airport",
  },
  {
    iata: "UBR",
    title: "Ubrub Airport",
  },
  {
    iata: "WMX",
    title: "Wamena Airport",
  },
  {
    iata: "MDP",
    title: "Mindiptana Airport",
  },
  {
    iata: "BXD",
    title: "Bade Airport",
  },
  {
    iata: "MKQ",
    title: "Mopah Airport",
  },
  {
    iata: "OKQ",
    title: "Okaba Airport",
  },
  {
    iata: "KEI",
    title: "Kepi Airport",
  },
  {
    iata: "TMH",
    title: "Tanah Merah Airport",
  },
  {
    iata: "TJS",
    title: "Tanjung Harapan Airport",
  },
  {
    iata: "DTD",
    title: "Datadawai Airport",
  },
  {
    iata: "BEJ",
    title: "Barau(Kalimaru) Airport",
  },
  {
    iata: "BPN",
    title: "Sepinggan International Airport",
  },
  {
    iata: "TRK",
    title: "Juwata Airport",
  },
  {
    iata: "SRI",
    title: "Temindung Airport",
  },
  {
    iata: "TSX",
    title: "Tanjung Santan Airport",
  },
  {
    iata: "BYQ",
    title: "Bunyu Airport",
  },
  {
    iata: "GLX",
    title: "Gamarmalamo Airport",
  },
  {
    iata: "GTO",
    title: "Jalaluddin Airport",
  },
  {
    iata: "NAH",
    title: "Naha Airport",
  },
  {
    iata: "TLI",
    title: "Toli Toli Airport",
  },
  {
    iata: "GEB",
    title: "Gebe Airport",
  },
  {
    iata: "KAZ",
    title: "Kao Airport",
  },
  {
    iata: "PLW",
    title: "Mutiara Airport",
  },
  {
    iata: "MDC",
    title: "Sam Ratulangi Airport",
  },
  {
    iata: "MNA",
    title: "Melangguane Airport",
  },
  {
    iata: "PSJ",
    title: "Kasiguncu Airport",
  },
  {
    iata: "OTI",
    title: "Pitu Airport",
  },
  {
    iata: "TTE",
    title: "Sultan Khairun Babullah Airport",
  },
  {
    iata: "LUW",
    title: "Bubung Airport",
  },
  {
    iata: "UOL",
    title: "Buol Airport",
  },
  {
    iata: "BTW",
    title: "Batu Licin Airport",
  },
  {
    iata: "PKN",
    title: "Iskandar Airport",
  },
  {
    iata: "KBU",
    title: "Stagen Airport",
  },
  {
    iata: "MTW",
    title: "Beringin Airport",
  },
  {
    iata: "TJG",
    title: "Warukin Airport",
  },
  {
    iata: "BDJ",
    title: "Syamsudin Noor Airport",
  },
  {
    iata: "PKY",
    title: "Tjilik Riwut Airport",
  },
  {
    iata: "SMQ",
    title: "Sampit(Hasan) Airport",
  },
  {
    iata: "AHI",
    title: "Amahai Airport",
  },
  {
    iata: "DOB",
    title: "Dobo Airport",
  },
  {
    iata: "MAL",
    title: "Mangole Airport, Falabisahaya",
  },
  {
    iata: "NRE",
    title: "Namrole Airport",
  },
  {
    iata: "LAH",
    title: "Oesman Sadik Airport, Labuha",
  },
  {
    iata: "SXK",
    title: "Saumlaki Airport",
  },
  {
    iata: "BJK",
    title: "Nangasuri Airport",
  },
  {
    iata: "LUV",
    title: "Dumatumbun Airport",
  },
  {
    iata: "SQN",
    title: "Emalamo Sanana Airport",
  },
  {
    iata: "AMQ",
    title: "Pattimura Airport, Ambon",
  },
  {
    iata: "NAM",
    title: "Namlea Airport",
  },
  {
    iata: "TAX",
    title: "Taliabu Island Airport",
  },
  {
    iata: "MLG",
    title: "Abdul Rachman Saleh Airport",
  },
  {
    iata: "CPF",
    title: "Cepu Airport",
  },
  {
    iata: "JOG",
    title: "Adi Sutjipto International Airport",
  },
  {
    iata: "SOC",
    title: "Adi Sumarmo Wiryokusumo Airport",
  },
  {
    iata: "SUB",
    title: "Juanda International Airport",
  },
  {
    iata: "SRG",
    title: "Achmad Yani Airport",
  },
  {
    iata: "SUP",
    title: "Trunojoyo Airport",
  },
  {
    iata: "NTI",
    title: "Stenkol Airport",
  },
  {
    iata: "RSK",
    title: "Abresso Airport",
  },
  {
    iata: "KEQ",
    title: "Kebar Airport",
  },
  {
    iata: "FKQ",
    title: "Fakfak Airport",
  },
  {
    iata: "INX",
    title: "Inanwatan Airport",
  },
  {
    iata: "KNG",
    title: "Kaimana Airport",
  },
  {
    iata: "RDE",
    title: "Merdei Airport",
  },
  {
    iata: "BXB",
    title: "Babo Airport",
  },
  {
    iata: "MKW",
    title: "Rendani Airport",
  },
  {
    iata: "SOQ",
    title: "Sorong (Jefman) Airport",
  },
  {
    iata: "TXM",
    title: "Teminabuan Airport",
  },
  {
    iata: "WSR",
    title: "Wasior Airport",
  },
  {
    iata: "BJW",
    title: "Bajawa Padhameleda Airport",
  },
  {
    iata: "MOF",
    title: "Maumere(Wai Oti) Airport",
  },
  {
    iata: "ENE",
    title: "Ende (H Hasan Aroeboesman) Airport",
  },
  {
    iata: "RTG",
    title: "Satar Tacik Airport",
  },
  {
    iata: "ARD",
    title: "Mali Airport",
  },
  {
    iata: "LBJ",
    title: "Komodo (Mutiara II) Airport",
  },
  {
    iata: "KOE",
    title: "El Tari Airport",
  },
  {
    iata: "BUW",
    title: "Betoambari Airport",
  },
  {
    iata: "MXB",
    title: "Andi Jemma Airport",
  },
  {
    iata: "SQR",
    title: "Soroako Airport",
  },
  {
    iata: "TTR",
    title: "Pongtiku Airport",
  },
  {
    iata: "KDI",
    title: "Wolter Monginsidi Airport",
  },
  {
    iata: "BTU",
    title: "Bintulu Airport",
  },
  {
    iata: "BLG",
    title: "Belaga Airport",
  },
  {
    iata: "LSM",
    title: "Long Semado Airport",
  },
  {
    iata: "LGL",
    title: "Long Lellang Airport",
  },
  {
    iata: "KCH",
    title: "Kuching International Airport",
  },
  {
    iata: "ODN",
    title: "Long Seridan Airport",
  },
  {
    iata: "LMN",
    title: "Limbang Airport",
  },
  {
    iata: "MKM",
    title: "Mukah Airport",
  },
  {
    iata: "LKH",
    title: "Long Akah Airport",
  },
  {
    iata: "MUR",
    title: "Marudi Airport",
  },
  {
    iata: "BSE",
    title: "Sematan Airport",
  },
  {
    iata: "KPI",
    title: "Kapit Airport",
  },
  {
    iata: "BKM",
    title: "Bakalalan Airport",
  },
  {
    iata: "MYY",
    title: "Miri Airport",
  },
  {
    iata: "SBW",
    title: "Sibu Airport",
  },
  {
    iata: "TGC",
    title: "Tanjung Manis Airport",
  },
  {
    iata: "LSU",
    title: "Long Sukang Airport",
  },
  {
    iata: "LWY",
    title: "Lawas Airport",
  },
  {
    iata: "SGG",
    title: "Simanggang Airport",
  },
  {
    iata: "BBN",
    title: "Bario Airport",
  },
  {
    iata: "SMM",
    title: "Semporna Airport",
  },
  {
    iata: "LDU",
    title: "Lahad Datu Airport",
  },
  {
    iata: "TEL",
    title: "Telupid Airport",
  },
  {
    iata: "KGU",
    title: "Keningau Airport",
  },
  {
    iata: "SXS",
    title: "Sahabat [Sahabat 16] Airport",
  },
  {
    iata: "BKI",
    title: "Kota Kinabalu International Airport",
  },
  {
    iata: "LBU",
    title: "Labuan Airport",
  },
  {
    iata: "TMG",
    title: "Tomanggong Airport",
  },
  {
    iata: "GSA",
    title: "Long Pasia Airport",
  },
  {
    iata: "SPE",
    title: "Sepulot Airport",
  },
  {
    iata: "PAY",
    title: "Pamol Airport",
  },
  {
    iata: "RNU",
    title: "Ranau Airport",
  },
  {
    iata: "SDK",
    title: "Sandakan Airport",
  },
  {
    iata: "KUD",
    title: "Kudat Airport",
  },
  {
    iata: "TWU",
    title: "Tawau Airport",
  },
  {
    iata: "MZV",
    title: "Mulu Airport",
  },
  {
    iata: "BWN",
    title: "Brunei International Airport",
  },
  {
    iata: "TKG",
    title: "Radin Inten II (Branti) Airport",
  },
  {
    iata: "PKU",
    title: "Sultan Syarif Kasim Ii (Simpang Tiga) Airport",
  },
  {
    iata: "DUM",
    title: "Pinang Kampai Airport",
  },
  {
    iata: "RKO",
    title: "Rokot Airport",
  },
  {
    iata: "SEQ",
    title: "Sungai Pakning Bengkalis Airport",
  },
  {
    iata: "TJB",
    title: "Tanjung Balai Airport",
  },
  {
    iata: "BDO",
    title: "Husein Sastranegara International Airport",
  },
  {
    iata: "CBN",
    title: "Penggung Airport",
  },
  {
    iata: "TSY",
    title: "Cibeureum Airport",
  },
  {
    iata: "BTH",
    title: "Hang Nadim Airport",
  },
  {
    iata: "PPR",
    title: "Pasir Pangaraan Airport",
  },
  {
    iata: "TNJ",
    title: "Kijang Airport",
  },
  {
    iata: "SIQ",
    title: "Dabo Airport",
  },
  {
    iata: "HLP",
    title: "Halim Perdanakusuma International Airport",
  },
  {
    iata: "CXP",
    title: "Tunggul Wulung Airport",
  },
  {
    iata: "PCB",
    title: "Pondok Cabe Air Base",
  },
  {
    iata: "CGK",
    title: "Soekarno-Hatta International Airport",
  },
  {
    iata: "LLG",
    title: "Silampari Airport",
  },
  {
    iata: "GNS",
    title: "Binaka Airport",
  },
  {
    iata: "AEG",
    title: "Aek Godang Airport",
  },
  {
    iata: "PDG",
    title: "Tabing Airport",
  },
  {
    iata: "MES",
    title: "Polonia International Airport",
  },
  {
    iata: "TJQ",
    title: "Buluh Tumbang (H A S Hanandjoeddin) Airport",
  },
  {
    iata: "NPO",
    title: "Nanga Pinoh I Airport",
  },
  {
    iata: "KTG",
    title: "Ketapang(Rahadi Usman) Airport",
  },
  {
    iata: "MWK",
    title: "Tarempa Airport",
  },
  {
    iata: "NTX",
    title: "Ranai Airport",
  },
  {
    iata: "PNK",
    title: "Supadio Airport",
  },
  {
    iata: "PSU",
    title: "Pangsuma Airport",
  },
  {
    iata: "SQG",
    title: "Sintang(Susilo) Airport",
  },
  {
    iata: "DJB",
    title: "Sultan Thaha Airport",
  },
  {
    iata: "PGK",
    title: "Pangkal Pinang (Depati Amir) Airport",
  },
  {
    iata: "BKS",
    title: "Padang Kemiling (Fatmawati Soekarno) Airport",
  },
  {
    iata: "PLM",
    title: "Sultan Mahmud Badaruddin Ii Airport",
  },
  {
    iata: "PDO",
    title: "Pendopo Airport",
  },
  {
    iata: "RGT",
    title: "Japura Airport",
  },
  {
    iata: "PDG",
    title: "Minangkabau Airport",
  },
  {
    iata: "MPC",
    title: "Muko Muko Airport",
  },
  {
    iata: "KLQ",
    title: "Keluang Airport",
  },
  {
    iata: "TPK",
    title: "Teuku Cut Ali Airport",
  },
  {
    iata: "SBG",
    title: "Maimun Saleh Airport",
  },
  {
    iata: "MEQ",
    title: "Seunagan Airport",
  },
  {
    iata: "LSX",
    title: "Lhok Sukon Airport",
  },
  {
    iata: "LSW",
    title: "Malikus Saleh Airport",
  },
  {
    iata: "BTJ",
    title: "Sultan Iskandarmuda Airport",
  },
  {
    iata: "SXT",
    title: "Sungai Tiang Airport",
  },
  {
    iata: "MEP",
    title: "Mersing Airport",
  },
  {
    iata: "SWY",
    title: "Sitiawan Airport",
  },
  {
    iata: "TPG",
    title: "Taiping (Tekah) Airport",
  },
  {
    iata: "TOD",
    title: "Pulau Tioman Airport",
  },
  {
    iata: "AOR",
    title: "Sultan Abdul Halim Airport",
  },
  {
    iata: "BWH",
    title: "Butterworth Airport",
  },
  {
    iata: "KBR",
    title: "Sultan Ismail Petra Airport",
  },
  {
    iata: "KUA",
    title: "Kuantan Airport",
  },
  {
    iata: "KTE",
    title: "Kerteh Airport",
  },
  {
    iata: "IPH",
    title: "Sultan Azlan Shah Airport",
  },
  {
    iata: "JHB",
    title: "Senai International Airport",
  },
  {
    iata: "KUL",
    title: "Kuala Lumpur International Airport",
  },
  {
    iata: "LGK",
    title: "Langkawi International Airport",
  },
  {
    iata: "MKZ",
    title: "Malacca Airport",
  },
  {
    iata: "TGG",
    title: "Sultan Mahmud Airport",
  },
  {
    iata: "PEN",
    title: "Penang International Airport",
  },
  {
    iata: "PKG",
    title: "Pulau Pangkor Airport",
  },
  {
    iata: "RDN",
    title: "LTS Pulau Redang Airport",
  },
  {
    iata: "SZB",
    title: "Sultan Abdul Aziz Shah International Airport",
  },
  {
    iata: "AUT",
    title: "Atauro Airport",
  },
  {
    iata: "UAI",
    title: "Suai Airport",
  },
  {
    iata: "DIC",
    title: "Dili City Heliport",
  },
  {
    iata: "DIL",
    title: "Presidente Nicolau Lobato International Airport",
  },
  {
    iata: "BCH",
    title: "Cakung Airport",
  },
  {
    iata: "MPT",
    title: "Maliana Airport",
  },
  {
    iata: "OEC",
    title: "Oecussi Airport",
  },
  {
    iata: "VIQ",
    title: "Viqueque Airport",
  },
  {
    iata: "ABU",
    title: "Haliwen Airport",
  },
  {
    iata: "BJW",
    title: "Padhameleda Airport",
  },
  {
    iata: "LKA",
    title: "Gewayentana Airport",
  },
  {
    iata: "SAU",
    title: "Sawu Airport",
  },
  {
    iata: "SGQ",
    title: "Sanggata Airport",
  },
  {
    iata: "LBW",
    title: "Long Bawan Airport",
  },
  {
    iata: "BXT",
    title: "Bontang Airport",
  },
  {
    iata: "NNX",
    title: "Nunukan Airport",
  },
  {
    iata: "TNB",
    title: "Tanah Grogot Airport",
  },
  {
    iata: "LPU",
    title: "Long Apung Airport",
  },
  {
    iata: "SZH",
    title: "Senipah Airport",
  },
  {
    iata: "QPG",
    title: "Paya Lebar Air Base",
  },
  {
    iata: "TGA",
    title: "Tengah Air Base",
  },
  {
    iata: "XSP",
    title: "Seletar Airport",
  },
  {
    iata: "SIN",
    title: "Singapore Changi International Airport",
  },
  {
    iata: "WWT",
    title: "Newtok Seaplane Base",
  },
  {
    iata: "BCD",
    title: "Bacolod City Domestic Airport",
  },
  {
    iata: "MNI",
    title: "W. H. Bramble Airport",
  },
  {
    iata: "SKL",
    title: "Skye Bridge Ashaig Airport",
  },
  {
    iata: "MUC",
    title: "Munich-Reim Airport",
  },
  {
    iata: "ALH",
    title: "Albany Airport",
  },
  {
    iata: "ABG",
    title: "Abingdon Downs Airport",
  },
  {
    iata: "AWN",
    title: "Alton Downs Airport",
  },
  {
    iata: "AUD",
    title: "Augustus Downs Airport",
  },
  {
    iata: "MRP",
    title: "Marla Airport",
  },
  {
    iata: "AXL",
    title: "Alexandria Homestead Airport",
  },
  {
    iata: "AXC",
    title: "Aramac Airport",
  },
  {
    iata: "ADO",
    title: "Andamooka Airport",
  },
  {
    iata: "AMX",
    title: "Ammaroo Airport",
  },
  {
    iata: "AMT",
    title: "Amata Airport",
  },
  {
    iata: "AYL",
    title: "Anthony Lagoon Airport",
  },
  {
    iata: "ABH",
    title: "Alpha Airport",
  },
  {
    iata: "ARY",
    title: "Ararat Airport",
  },
  {
    iata: "GYL",
    title: "Argyle Airport",
  },
  {
    iata: "ARM",
    title: "Armidale Airport",
  },
  {
    iata: "AAB",
    title: "Arrabury Airport",
  },
  {
    iata: "AUU",
    title: "Aurukun Airport",
  },
  {
    iata: "AWP",
    title: "Austral Downs Airport",
  },
  {
    iata: "AVG",
    title: "Auvergne Airport",
  },
  {
    iata: "AYQ",
    title: "Ayers Rock Connellan Airport",
  },
  {
    iata: "AYR",
    title: "Ayr Airport",
  },
  {
    iata: "ACF",
    title: "Brisbane Archerfield Airport",
  },
  {
    iata: "ABM",
    title: "Bamaga Injinoo Airport",
  },
  {
    iata: "BCI",
    title: "Barcaldine Airport",
  },
  {
    iata: "ASP",
    title: "Alice Springs Airport",
  },
  {
    iata: "BDD",
    title: "Badu Island Airport",
  },
  {
    iata: "BBE",
    title: "Big Bell Airport",
  },
  {
    iata: "BNE",
    title: "Brisbane International Airport",
  },
  {
    iata: "OOL",
    title: "Gold Coast Airport",
  },
  {
    iata: "BKQ",
    title: "Blackall Airport",
  },
  {
    iata: "CNS",
    title: "Cairns International Airport",
  },
  {
    iata: "CTL",
    title: "Charleville Airport",
  },
  {
    iata: "BXG",
    title: "Bendigo Airport",
  },
  {
    iata: "BVI",
    title: "Birdsville Airport",
  },
  {
    iata: "BTX",
    title: "Betoota Airport",
  },
  {
    iata: "BQW",
    title: "Balgo Hill Airport",
  },
  {
    iata: "BHQ",
    title: "Broken Hill Airport",
  },
  {
    iata: "HTI",
    title: "Hamilton Island Airport",
  },
  {
    iata: "BEU",
    title: "Bedourie Airport",
  },
  {
    iata: "BRK",
    title: "Bourke Airport",
  },
  {
    iata: "BUC",
    title: "Burketown Airport",
  },
  {
    iata: "BLN",
    title: "Benalla Airport",
  },
  {
    iata: "LCN",
    title: "Balcanoona Airport",
  },
  {
    iata: "BLS",
    title: "Bollon Airport",
  },
  {
    iata: "BQB",
    title: "Busselton Regional Airport",
  },
  {
    iata: "ISA",
    title: "Mount Isa Airport",
  },
  {
    iata: "MCY",
    title: "Sunshine Coast Airport",
  },
  {
    iata: "MKY",
    title: "Mackay Airport",
  },
  {
    iata: "BNK",
    title: "Ballina Byron Gateway Airport",
  },
  {
    iata: "BSJ",
    title: "Bairnsdale Airport",
  },
  {
    iata: "GIC",
    title: "Boigu Airport",
  },
  {
    iata: "OKY",
    title: "Oakey Airport",
  },
  {
    iata: "BQL",
    title: "Boulia Airport",
  },
  {
    iata: "BMP",
    title: "Brampton Island Airport",
  },
  {
    iata: "PPP",
    title: "Proserpine Whitsunday Coast Airport",
  },
  {
    iata: "ROK",
    title: "Rockhampton Airport",
  },
  {
    iata: "BOX",
    title: "Borroloola Airport",
  },
  {
    iata: "BME",
    title: "Broome International Airport",
  },
  {
    iata: "BZD",
    title: "Balranald Airport",
  },
  {
    iata: "BWQ",
    title: "Brewarrina Airport",
  },
  {
    iata: "BHS",
    title: "Bathurst Airport",
  },
  {
    iata: "BRT",
    title: "Bathurst Island Airport",
  },
  {
    iata: "TSV",
    title: "Townsville Airport",
  },
  {
    iata: "BLT",
    title: "Blackwater Airport",
  },
  {
    iata: "BDB",
    title: "Bundaberg Airport",
  },
  {
    iata: "BUY",
    title: "Bunbury Airport",
  },
  {
    iata: "ZBO",
    title: "Bowen Airport",
  },
  {
    iata: "WEI",
    title: "Weipa Airport",
  },
  {
    iata: "BWB",
    title: "Barrow Island Airport",
  },
  {
    iata: "BVZ",
    title: "Beverley Springs Airport",
  },
  {
    iata: "CGV",
    title: "Caiguna Airport",
  },
  {
    iata: "CLH",
    title: "Coolah Airport",
  },
  {
    iata: "CVQ",
    title: "Carnarvon Airport",
  },
  {
    iata: "CSI",
    title: "Casino Airport",
  },
  {
    iata: "CAZ",
    title: "Cobar Airport",
  },
  {
    iata: "COJ",
    title: "Coonabarabran Airport",
  },
  {
    iata: "CBY",
    title: "Canobie Airport",
  },
  {
    iata: "CBI",
    title: "Cape Barren Island Airport",
  },
  {
    iata: "CPD",
    title: "Coober Pedy Airport",
  },
  {
    iata: "CRB",
    title: "Collarenebri Airport",
  },
  {
    iata: "CCL",
    title: "Chinchilla Airport",
  },
  {
    iata: "CNC",
    title: "Coconut Island Airport",
  },
  {
    iata: "CNJ",
    title: "Cloncurry Airport",
  },
  {
    iata: "CBX",
    title: "Condobolin Airport",
  },
  {
    iata: "CUD",
    title: "Caloundra Airport",
  },
  {
    iata: "CED",
    title: "Ceduna Airport",
  },
  {
    iata: "CVC",
    title: "Cleve Airport",
  },
  {
    iata: "CFI",
    title: "Camfield Airport",
  },
  {
    iata: "LLG",
    title: "Chillagoe Airport",
  },
  {
    iata: "CXT",
    title: "Charters Towers Airport",
  },
  {
    iata: "CKI",
    title: "Croker Island Airport",
  },
  {
    iata: "CTN",
    title: "Cooktown Airport",
  },
  {
    iata: "CMQ",
    title: "Clermont Airport",
  },
  {
    iata: "CMA",
    title: "Cunnamulla Airport",
  },
  {
    iata: "CML",
    title: "Camooweal Airport",
  },
  {
    iata: "NIF",
    title: "Camp Nifty Airport",
  },
  {
    iata: "CES",
    title: "Cessnock Airport",
  },
  {
    iata: "CNB",
    title: "Coonamble Airport",
  },
  {
    iata: "ODL",
    title: "Cordillo Downs Airport",
  },
  {
    iata: "CUQ",
    title: "Coen Airport",
  },
  {
    iata: "OOM",
    title: "Cooma Snowy Mountains Airport",
  },
  {
    iata: "CDA",
    title: "Cooinda Airport",
  },
  {
    iata: "CWW",
    title: "Corowa Airport",
  },
  {
    iata: "CYG",
    title: "Corryong Airport",
  },
  {
    iata: "CDQ",
    title: "Croydon Airport",
  },
  {
    iata: "KCE",
    title: "Collinsville Airport",
  },
  {
    iata: "CMD",
    title: "Cootamundra Airport",
  },
  {
    iata: "CUG",
    title: "Cudal Airport",
  },
  {
    iata: "CUY",
    title: "Cue Airport",
  },
  {
    iata: "CWR",
    title: "Cowarie Airport",
  },
  {
    iata: "CCW",
    title: "Cowell Airport",
  },
  {
    iata: "CWT",
    title: "Cowra Airport",
  },
  {
    iata: "DJR",
    title: "Dajarra Airport",
  },
  {
    iata: "DBY",
    title: "Dalby Airport",
  },
  {
    iata: "DRN",
    title: "Dirranbandi Airport",
  },
  {
    iata: "DNB",
    title: "Dunbar Airport",
  },
  {
    iata: "DRB",
    title: "Derby Airport",
  },
  {
    iata: "DFP",
    title: "Drumduff Airport",
  },
  {
    iata: "DLK",
    title: "Dulkaninna Airport",
  },
  {
    iata: "DDN",
    title: "Delta Downs Airport",
  },
  {
    iata: "DLV",
    title: "Delissaville Airport",
  },
  {
    iata: "DMD",
    title: "Doomadgee Airport",
  },
  {
    iata: "DVR",
    title: "Daly River Airport",
  },
  {
    iata: "NLF",
    title: "Darnley Island Airport",
  },
  {
    iata: "DRD",
    title: "Dorunda Airport",
  },
  {
    iata: "DVP",
    title: "Davenport Downs Airport",
  },
  {
    iata: "DPO",
    title: "Devonport Airport",
  },
  {
    iata: "DHD",
    title: "Durham Downs Airport",
  },
  {
    iata: "DRR",
    title: "Durrie Airport",
  },
  {
    iata: "DKV",
    title: "Docker River Airport",
  },
  {
    iata: "DYA",
    title: "Dysart Airport",
  },
  {
    iata: "WDA",
    title: "Wadi Ain Airport",
  },
  {
    iata: "ECH",
    title: "Echuca Airport",
  },
  {
    iata: "EUC",
    title: "Eucla Airport",
  },
  {
    iata: "ETD",
    title: "Etadunna Airport",
  },
  {
    iata: "ENB",
    title: "Eneabba Airport",
  },
  {
    iata: "EIH",
    title: "Einasleigh Airport",
  },
  {
    iata: "ELC",
    title: "Elcho Island Airport",
  },
  {
    iata: "EMD",
    title: "Emerald Airport",
  },
  {
    iata: "ERB",
    title: "Ernabella Airport",
  },
  {
    iata: "EPR",
    title: "Esperance Airport",
  },
  {
    iata: "EVD",
    title: "Eva Downs Airport",
  },
  {
    iata: "EVH",
    title: "Evans Head Aerodrome",
  },
  {
    iata: "EXM",
    title: "Exmouth Airport",
  },
  {
    iata: "FRB",
    title: "Forbes Airport",
  },
  {
    iata: "KFE",
    title: "Fortescue - Dave Forrest Aerodrome",
  },
  {
    iata: "FLY",
    title: "Finley Airport",
  },
  {
    iata: "FLS",
    title: "Flinders Island Airport",
  },
  {
    iata: "FVL",
    title: "Flora Valley Airport",
  },
  {
    iata: "FIK",
    title: "Finke Airport",
  },
  {
    iata: "FOS",
    title: "Forrest Airport",
  },
  {
    iata: "FOT",
    title: "Forster (Wallis Is) Airport",
  },
  {
    iata: "FIZ",
    title: "Fitzroy Crossing Airport",
  },
  {
    iata: "GAH",
    title: "Gayndah Airport",
  },
  {
    iata: "GBL",
    title: "South Goulburn Is Airport",
  },
  {
    iata: "GUH",
    title: "Gunnedah Airport",
  },
  {
    iata: "GOO",
    title: "Goondiwindi Airport",
  },
  {
    iata: "GDD",
    title: "Gordon Downs Airport",
  },
  {
    iata: "GGD",
    title: "Gregory Downs Airport",
  },
  {
    iata: "GTS",
    title: "Granite Downs Airport",
  },
  {
    iata: "GET",
    title: "Geraldton Airport",
  },
  {
    iata: "GFN",
    title: "Grafton Airport",
  },
  {
    iata: "GBV",
    title: "Gibb River Airport",
  },
  {
    iata: "GLT",
    title: "Gladstone Airport",
  },
  {
    iata: "GUL",
    title: "Goulburn Airport",
  },
  {
    iata: "GLG",
    title: "Glengyle Airport",
  },
  {
    iata: "GEX",
    title: "Geelong Airport",
  },
  {
    iata: "GLI",
    title: "Glen Innes Airport",
  },
  {
    iata: "GLM",
    title: "Glenormiston Airport",
  },
  {
    iata: "GVP",
    title: "Greenvale Airport",
  },
  {
    iata: "GPN",
    title: "Garden Point Airport",
  },
  {
    iata: "GTE",
    title: "Groote Eylandt Airport",
  },
  {
    iata: "GFF",
    title: "Griffith Airport",
  },
  {
    iata: "GTT",
    title: "Georgetown Airport",
  },
  {
    iata: "GEE",
    title: "Georgetown (Tas) Airport",
  },
  {
    iata: "GYP",
    title: "Gympie Airport",
  },
  {
    iata: "HWK",
    title: "Wilpena Pound Airport",
  },
  {
    iata: "HXX",
    title: "Hay Airport",
  },
  {
    iata: "HVB",
    title: "Hervey Bay Airport",
  },
  {
    iata: "HUB",
    title: "Humbert River Airport",
  },
  {
    iata: "HIP",
    title: "Headingly Airport",
  },
  {
    iata: "HID",
    title: "Horn Island Airport",
  },
  {
    iata: "HCQ",
    title: "Halls Creek Airport",
  },
  {
    iata: "HMG",
    title: "Hermannsburg Airport",
  },
  {
    iata: "HLT",
    title: "Hamilton Airport",
  },
  {
    iata: "HOK",
    title: "Hooker Creek Airport",
  },
  {
    iata: "MHU",
    title: "Mount Hotham Airport",
  },
  {
    iata: "HTU",
    title: "Hopetoun Airport",
  },
  {
    iata: "HSM",
    title: "Horsham Airport",
  },
  {
    iata: "HGD",
    title: "Hughenden Airport",
  },
  {
    iata: "IDK",
    title: "Indulkana Airport",
  },
  {
    iata: "IFL",
    title: "Innisfail Airport",
  },
  {
    iata: "IFF",
    title: "Iffley Airport",
  },
  {
    iata: "IGH",
    title: "Ingham Airport",
  },
  {
    iata: "IKP",
    title: "Inkerman Airport",
  },
  {
    iata: "INJ",
    title: "Injune Airport",
  },
  {
    iata: "INM",
    title: "Innamincka Airport",
  },
  {
    iata: "IVW",
    title: "Inverway Airport",
  },
  {
    iata: "ISI",
    title: "Isisford Airport",
  },
  {
    iata: "IVR",
    title: "Inverell Airport",
  },
  {
    iata: "JAB",
    title: "Jabiru Airport",
  },
  {
    iata: "JUN",
    title: "Jundah Airport",
  },
  {
    iata: "QJD",
    title: "Jindabyne Airport",
  },
  {
    iata: "JCK",
    title: "Julia Creek Airport",
  },
  {
    iata: "JUR",
    title: "Jurien Bay Airport",
  },
  {
    iata: "UBU",
    title: "Kalumburu Airport",
  },
  {
    iata: "KAX",
    title: "Kalbarri Airport",
  },
  {
    iata: "KBY",
    title: "Streaky Bay Airport",
  },
  {
    iata: "KCS",
    title: "Kings Creek Airport",
  },
  {
    iata: "KRA",
    title: "Kerang Airport",
  },
  {
    iata: "KNS",
    title: "King Island Airport",
  },
  {
    iata: "KBB",
    title: "Kirkimbie Station Airport",
  },
  {
    iata: "KFG",
    title: "Kalkgurung Airport",
  },
  {
    iata: "KKP",
    title: "Koolburra Airport",
  },
  {
    iata: "KRB",
    title: "Karumba Airport",
  },
  {
    iata: "KML",
    title: "Kamileroi Airport",
  },
  {
    iata: "KPS",
    title: "Kempsey Airport",
  },
  {
    iata: "KNI",
    title: "Katanning Airport",
  },
  {
    iata: "KWM",
    title: "Kowanyama Airport",
  },
  {
    iata: "KGY",
    title: "Kingaroy Airport",
  },
  {
    iata: "KGC",
    title: "Kingscote Airport",
  },
  {
    iata: "KUG",
    title: "Kubin Airport",
  },
  {
    iata: "LWH",
    title: "Lawn Hill Airport",
  },
  {
    iata: "LGH",
    title: "Leigh Creek Airport",
  },
  {
    iata: "LNO",
    title: "Leonora Airport",
  },
  {
    iata: "LEL",
    title: "Lake Evella Airport",
  },
  {
    iata: "LDH",
    title: "Lord Howe Island Airport",
  },
  {
    iata: "IRG",
    title: "Lockhart River Airport",
  },
  {
    iata: "LTP",
    title: "Lyndhurst Airport",
  },
  {
    iata: "LDC",
    title: "Lindeman Island Airport",
  },
  {
    iata: "LSY",
    title: "Lismore Airport",
  },
  {
    iata: "LOC",
    title: "Lock Airport",
  },
  {
    iata: "LOA",
    title: "Lorraine Airport",
  },
  {
    iata: "LTV",
    title: "Lotus Vale Airport",
  },
  {
    iata: "LUU",
    title: "Laura Airport",
  },
  {
    iata: "LHG",
    title: "Lightning Ridge Airport",
  },
  {
    iata: "LRE",
    title: "Longreach Airport",
  },
  {
    iata: "LUT",
    title: "New Laura Airport",
  },
  {
    iata: "LER",
    title: "Leinster Airport",
  },
  {
    iata: "LVO",
    title: "Laverton Airport",
  },
  {
    iata: "TGN",
    title: "Latrobe Valley Airport",
  },
  {
    iata: "LZR",
    title: "Lizard Island Airport",
  },
  {
    iata: "UBB",
    title: "Mabuiag Island Airport",
  },
  {
    iata: "AVV",
    title: "Avalon Airport",
  },
  {
    iata: "ABX",
    title: "Albury Airport",
  },
  {
    iata: "MRG",
    title: "Mareeba Airport",
  },
  {
    iata: "MBB",
    title: "Marble Bar Airport",
  },
  {
    iata: "XMC",
    title: "Mallacoota Airport",
  },
  {
    iata: "MFP",
    title: "Manners Creek Airport",
  },
  {
    iata: "MLR",
    title: "Millicent Airport",
  },
  {
    iata: "DGE",
    title: "Mudgee Airport",
  },
  {
    iata: "MQA",
    title: "Mandora Airport",
  },
  {
    iata: "MKR",
    title: "Meekatharra Airport",
  },
  {
    iata: "MEB",
    title: "Melbourne Essendon Airport",
  },
  {
    iata: "MIM",
    title: "Merimbula Airport",
  },
  {
    iata: "SXE",
    title: "RAAF Base East Sale",
  },
  {
    iata: "MGT",
    title: "Milingimbi Airport",
  },
  {
    iata: "MNG",
    title: "Maningrida Airport",
  },
  {
    iata: "GSN",
    title: "Mount Gunson Airport",
  },
  {
    iata: "MGV",
    title: "Margaret River (Station) Airport",
  },
  {
    iata: "MQZ",
    title: "Margaret River Airport",
  },
  {
    iata: "HBA",
    title: "Hobart International Airport",
  },
  {
    iata: "MHO",
    title: "Mount House Airport",
  },
  {
    iata: "MCV",
    title: "McArthur River Mine Airport",
  },
  {
    iata: "MQL",
    title: "Mildura Airport",
  },
  {
    iata: "XML",
    title: "Minlaton Airport",
  },
  {
    iata: "MIH",
    title: "Mitchell Plateau Airport",
  },
  {
    iata: "MTQ",
    title: "Mitchell Airport",
  },
  {
    iata: "MJP",
    title: "Manjimup Airport",
  },
  {
    iata: "LST",
    title: "Launceston Airport",
  },
  {
    iata: "MBW",
    title: "Melbourne Moorabbin Airport",
  },
  {
    iata: "MEL",
    title: "Melbourne International Airport",
  },
  {
    iata: "MMM",
    title: "Middlemount Airport",
  },
  {
    iata: "MTL",
    title: "Maitland Airport",
  },
  {
    iata: "WME",
    title: "Mount Keith Airport",
  },
  {
    iata: "ONR",
    title: "Monkira Airport",
  },
  {
    iata: "OXY",
    title: "Morney Airport",
  },
  {
    iata: "MMG",
    title: "Mount Magnet Airport",
  },
  {
    iata: "OOR",
    title: "Mooraberree Airport",
  },
  {
    iata: "MRZ",
    title: "Moree Airport",
  },
  {
    iata: "MET",
    title: "Moreton Airport",
  },
  {
    iata: "MIN",
    title: "Minnipa Airport",
  },
  {
    iata: "MQE",
    title: "Marqua Airport",
  },
  {
    iata: "MOV",
    title: "Moranbah Airport",
  },
  {
    iata: "RRE",
    title: "Marree Airport",
  },
  {
    iata: "MWB",
    title: "Morawa Airport",
  },
  {
    iata: "MYA",
    title: "Moruya Airport",
  },
  {
    iata: "MTD",
    title: "Mount Sanford Station Airport",
  },
  {
    iata: "UTB",
    title: "Muttaburra Airport",
  },
  {
    iata: "MGB",
    title: "Mount Gambier Airport",
  },
  {
    iata: "ONG",
    title: "Mornington Island Airport",
  },
  {
    iata: "MNQ",
    title: "Monto Airport",
  },
  {
    iata: "MUQ",
    title: "Muccan Station Airport",
  },
  {
    iata: "MNE",
    title: "Mungeranie Airport",
  },
  {
    iata: "MYI",
    title: "Murray Island Airport",
  },
  {
    iata: "MVK",
    title: "Mulka Airport",
  },
  {
    iata: "MXU",
    title: "Mullewa Airport",
  },
  {
    iata: "MXD",
    title: "Marion Downs Airport",
  },
  {
    iata: "MBH",
    title: "Maryborough Airport",
  },
  {
    iata: "RTY",
    title: "Merty Merty Airport",
  },
  {
    iata: "NMR",
    title: "Nappa Merrie Airport",
  },
  {
    iata: "NRA",
    title: "Narrandera Airport",
  },
  {
    iata: "NAA",
    title: "Narrabri Airport",
  },
  {
    iata: "RPM",
    title: "Ngukurr Airport",
  },
  {
    iata: "NBH",
    title: "Nambucca Heads Airport",
  },
  {
    iata: "NLS",
    title: "Nicholson Airport",
  },
  {
    iata: "NAC",
    title: "Naracoorte Airport",
  },
  {
    iata: "QRM",
    title: "Narromine Airport",
  },
  {
    iata: "RVT",
    title: "Ravensthorpe Airport",
  },
  {
    iata: "NSV",
    title: "Noosa Airport",
  },
  {
    iata: "NSM",
    title: "Norseman Airport",
  },
  {
    iata: "NTN",
    title: "Normanton Airport",
  },
  {
    iata: "NUR",
    title: "Nullabor Motel Airport",
  },
  {
    iata: "NLL",
    title: "Nullagine Airport",
  },
  {
    iata: "NUB",
    title: "Numbulwar Airport",
  },
  {
    iata: "ZNE",
    title: "Newman Airport",
  },
  {
    iata: "NYN",
    title: "Nyngan Airport",
  },
  {
    iata: "OPI",
    title: "Oenpelli Airport",
  },
  {
    iata: "YOI",
    title: "Opinaca Aerodrome",
  },
  {
    iata: "XCO",
    title: "Colac Airport",
  },
  {
    iata: "OLP",
    title: "Olympic Dam Airport",
  },
  {
    iata: "ODD",
    title: "Oodnadatta Airport",
  },
  {
    iata: "MOO",
    title: "Moomba Airport",
  },
  {
    iata: "RBS",
    title: "Orbost Airport",
  },
  {
    iata: "OAG",
    title: "Orange Airport",
  },
  {
    iata: "ODR",
    title: "Ord River Airport",
  },
  {
    iata: "OSO",
    title: "Osborne Mine Airport",
  },
  {
    iata: "OYN",
    title: "Ouyen Airport",
  },
  {
    iata: "ADL",
    title: "Adelaide International Airport",
  },
  {
    iata: "PUG",
    title: "Port Augusta Airport",
  },
  {
    iata: "PMK",
    title: "Palm Island Airport",
  },
  {
    iata: "PBO",
    title: "Paraburdoo Airport",
  },
  {
    iata: "CCK",
    title: "Cocos (Keeling) Islands Airport",
  },
  {
    iata: "PDE",
    title: "Pandie Pandie Airport",
  },
  {
    iata: "DRW",
    title: "Darwin International Airport",
  },
  {
    iata: "PRD",
    title: "Pardoo Airport",
  },
  {
    iata: "BEO",
    title: "Aeropelican Airport",
  },
  {
    iata: "GOV",
    title: "Gove Airport",
  },
  {
    iata: "PPI",
    title: "Port Pirie Airport",
  },
  {
    iata: "JAD",
    title: "Perth Jandakot Airport",
  },
  {
    iata: "KTA",
    title: "Karratha Airport",
  },
  {
    iata: "KGI",
    title: "Kalgoorlie Boulder Airport",
  },
  {
    iata: "PKE",
    title: "Parkes Airport",
  },
  {
    iata: "PKT",
    title: "Port Keats Airport",
  },
  {
    iata: "KNX",
    title: "Kununurra Airport",
  },
  {
    iata: "PLO",
    title: "Port Lincoln Airport",
  },
  {
    iata: "LEA",
    title: "Learmonth Airport",
  },
  {
    iata: "EDR",
    title: "Pormpuraaw Airport",
  },
  {
    iata: "PQQ",
    title: "Port Macquarie Airport",
  },
  {
    iata: "PTJ",
    title: "Portland Airport",
  },
  {
    iata: "PHE",
    title: "Port Hedland International Airport",
  },
  {
    iata: "PER",
    title: "Perth International Airport",
  },
  {
    iata: "PEA",
    title: "Penneshaw Airport",
  },
  {
    iata: "KTR",
    title: "Tindal Airport",
  },
  {
    iata: "UMR",
    title: "Woomera Airfield",
  },
  {
    iata: "XCH",
    title: "Christmas Island Airport",
  },
  {
    iata: "UIR",
    title: "Quirindi Airport",
  },
  {
    iata: "ULP",
    title: "Quilpie Airport",
  },
  {
    iata: "UEE",
    title: "Queenstown Airport",
  },
  {
    iata: "RMK",
    title: "Renmark Airport",
  },
  {
    iata: "RCM",
    title: "Richmond Airport",
  },
  {
    iata: "RAM",
    title: "Ramingining Airport",
  },
  {
    iata: "ROH",
    title: "Robinhood Airport",
  },
  {
    iata: "RBU",
    title: "Roebourne Airport",
  },
  {
    iata: "RBC",
    title: "Robinvale Airport",
  },
  {
    iata: "RMA",
    title: "Roma Airport",
  },
  {
    iata: "RSB",
    title: "Roseberth Airport",
  },
  {
    iata: "RTS",
    title: "Rottnest Island Airport",
  },
  {
    iata: "RTP",
    title: "Rutland Plains Airport",
  },
  {
    iata: "RHL",
    title: "Roy Hill Station Airport",
  },
  {
    iata: "NDS",
    title: "Sandstone Airport",
  },
  {
    iata: "BWU",
    title: "Sydney Bankstown Airport",
  },
  {
    iata: "CBR",
    title: "Canberra International Airport",
  },
  {
    iata: "CFS",
    title: "Coffs Harbour Airport",
  },
  {
    iata: "CDU",
    title: "Camden Airport",
  },
  {
    iata: "NSO",
    title: "Scone Airport",
  },
  {
    iata: "SQC",
    title: "Southern Cross Airport",
  },
  {
    iata: "DBO",
    title: "Dubbo City Regional Airport",
  },
  {
    iata: "SGO",
    title: "St George Airport",
  },
  {
    iata: "SIX",
    title: "Singleton Airport",
  },
  {
    iata: "ZGL",
    title: "South Galway Airport",
  },
  {
    iata: "SGP",
    title: "Shay Gap Airport",
  },
  {
    iata: "DNM",
    title: "Shark Bay Airport",
  },
  {
    iata: "JHQ",
    title: "Shute Harbour Airport",
  },
  {
    iata: "SHT",
    title: "Shepparton Airport",
  },
  {
    iata: "SBR",
    title: "Saibai Island Airport",
  },
  {
    iata: "SIO",
    title: "Smithton Airport",
  },
  {
    iata: "SHU",
    title: "Smith Point Airport",
  },
  {
    iata: "STH",
    title: "Strathmore Airport",
  },
  {
    iata: "SNB",
    title: "Snake Bay Airport",
  },
  {
    iata: "NLK",
    title: "Norfolk Island International Airport",
  },
  {
    iata: "NOA",
    title: "Nowra Airport",
  },
  {
    iata: "SNH",
    title: "Stanthorpe Airport",
  },
  {
    iata: "SCG",
    title: "Spring Creek Airport",
  },
  {
    iata: "SHQ",
    title: "Southport Airport",
  },
  {
    iata: "KSV",
    title: "Springvale Airport",
  },
  {
    iata: "SRN",
    title: "Strahan Airport",
  },
  {
    iata: "SYD",
    title: "Sydney Kingsford Smith International Airport",
  },
  {
    iata: "HLS",
    title: "St Helens Airport",
  },
  {
    iata: "TMW",
    title: "Tamworth Airport",
  },
  {
    iata: "WGA",
    title: "Wagga Wagga City Airport",
  },
  {
    iata: "SWH",
    title: "Swan Hill Airport",
  },
  {
    iata: "SWC",
    title: "Stawell Airport",
  },
  {
    iata: "XTR",
    title: "Tara Airport",
  },
  {
    iata: "TBL",
    title: "Tableland Homestead Airport",
  },
  {
    iata: "XTO",
    title: "Taroom Airport",
  },
  {
    iata: "TAQ",
    title: "Tarcoola Airport",
  },
  {
    iata: "TBK",
    title: "Timber Creek Airport",
  },
  {
    iata: "TDR",
    title: "Theodore Airport",
  },
  {
    iata: "TEF",
    title: "Telfer Airport",
  },
  {
    iata: "TEM",
    title: "Temora Airport",
  },
  {
    iata: "TAN",
    title: "Tangalooma Airport",
  },
  {
    iata: "XTG",
    title: "Thargomindah Airport",
  },
  {
    iata: "TYG",
    title: "Thylungra Airport",
  },
  {
    iata: "TYB",
    title: "Tibooburra Airport",
  },
  {
    iata: "TKY",
    title: "Turkey Creek Airport",
  },
  {
    iata: "TUM",
    title: "Tumut Airport",
  },
  {
    iata: "TYP",
    title: "Tobermorey Airport",
  },
  {
    iata: "THG",
    title: "Thangool Airport",
  },
  {
    iata: "TCA",
    title: "Tennant Creek Airport",
  },
  {
    iata: "TCW",
    title: "Tocumwal Airport",
  },
  {
    iata: "TRO",
    title: "Taree Airport",
  },
  {
    iata: "YTU",
    title: "Tasu Water Aerodrome",
  },
  {
    iata: "TWB",
    title: "Toowoomba Airport",
  },
  {
    iata: "UDA",
    title: "Undara Airport",
  },
  {
    iata: "CZY",
    title: "Cluny Airport",
  },
  {
    iata: "USL",
    title: "Useless Loop Airport",
  },
  {
    iata: "VCD",
    title: "Victoria River Downs Airport",
  },
  {
    iata: "VNR",
    title: "Vanrook Station Airport",
  },
  {
    iata: "WLA",
    title: "Wallal Airport",
  },
  {
    iata: "WAV",
    title: "Wave Hill Airport",
  },
  {
    iata: "WMB",
    title: "Warrnambool Airport",
  },
  {
    iata: "SYU",
    title: "Warraber Island Airport",
  },
  {
    iata: "WIO",
    title: "Wilcannia Airport",
  },
  {
    iata: "WLC",
    title: "Walcha Airport",
  },
  {
    iata: "WAZ",
    title: "Warwick Airport",
  },
  {
    iata: "WND",
    title: "Windarra Airport",
  },
  {
    iata: "WNR",
    title: "Windorah Airport",
  },
  {
    iata: "WGT",
    title: "Wangaratta Airport",
  },
  {
    iata: "WYA",
    title: "Whyalla Airport",
  },
  {
    iata: "WIT",
    title: "Wittenoom Airport",
  },
  {
    iata: "WKB",
    title: "Warracknabeal Airport",
  },
  {
    iata: "WGE",
    title: "Walgett Airport",
  },
  {
    iata: "NTL",
    title: "Newcastle Airport",
  },
  {
    iata: "WUN",
    title: "Wiluna Airport",
  },
  {
    iata: "WPK",
    title: "Wrotham Park Airport",
  },
  {
    iata: "WDI",
    title: "Wondai Airport",
  },
  {
    iata: "WOL",
    title: "Wollongong Airport",
  },
  {
    iata: "QRR",
    title: "Warren Airport",
  },
  {
    iata: "WLO",
    title: "Waterloo Airport",
  },
  {
    iata: "WIN",
    title: "Winton Airport",
  },
  {
    iata: "WUD",
    title: "Wudinna Airport",
  },
  {
    iata: "WEW",
    title: "Wee Waa Airport",
  },
  {
    iata: "WRW",
    title: "Warrawagine Airport",
  },
  {
    iata: "WWI",
    title: "Woodie Woodie Airport",
  },
  {
    iata: "WYN",
    title: "Wyndham Airport",
  },
  {
    iata: "BWT",
    title: "Wynyard Airport",
  },
  {
    iata: "YLG",
    title: "Yalgoo Airport",
  },
  {
    iata: "OKR",
    title: "Yorke Island Airport",
  },
  {
    iata: "KYF",
    title: "Yeelirrie Airport",
  },
  {
    iata: "XMY",
    title: "Yam Island Airport",
  },
  {
    iata: "YUE",
    title: "Yuendumu Airport",
  },
  {
    iata: "NGA",
    title: "Young Airport",
  },
  {
    iata: "ORR",
    title: "Yorketown Airport",
  },
  {
    iata: "KYI",
    title: "Yalata Mission Airport",
  },
  {
    iata: "HPR",
    title: "Pretoria Central Heliport",
  },
  {
    iata: "ULX",
    title: "Ulusaba Airport",
  },
  {
    iata: "TDT",
    title: "Tanda Tula Airport",
  },
  {
    iata: "HZV",
    title: "Hazyview Airport",
  },
  {
    iata: "KHO",
    title: "Khoka Moya Airport",
  },
  {
    iata: "MBM",
    title: "Mkambati Airport",
  },
  {
    iata: "INY",
    title: "Inyati Airport",
  },
  {
    iata: "TSD",
    title: "Tshipise Airport",
  },
  {
    iata: "KIG",
    title: "Koingnaas Airport",
  },
  {
    iata: "PEK",
    title: "Beijing Capital International Airport",
  },
  {
    iata: "CIF",
    title: "Chifeng Airport",
  },
  {
    iata: "CIH",
    title: "Changzhi Airport",
  },
  {
    iata: "DSN",
    title: "Ordos Ejin Horo Airport",
  },
  {
    iata: "DAT",
    title: "Datong Airport",
  },
  {
    iata: "ERL",
    title: "Erenhot Saiwusu International Airport",
  },
  {
    iata: "HDG",
    title: "Handan Airport",
  },
  {
    iata: "HET",
    title: "Baita International Airport",
  },
  {
    iata: "HLD",
    title: "Dongshan Airport",
  },
  {
    iata: "NAY",
    title: "Beijing Nanyuan Airport",
  },
  {
    iata: "BAV",
    title: "Baotou Airport",
  },
  {
    iata: "SHP",
    title: "Shanhaiguan Airport",
  },
  {
    iata: "SJW",
    title: "Shijiazhuang Daguocun International Airport",
  },
  {
    iata: "TSN",
    title: "Tianjin Binhai International Airport",
  },
  {
    iata: "TGO",
    title: "Tongliao Airport",
  },
  {
    iata: "HLH",
    title: "Ulanhot Airport",
  },
  {
    iata: "XIL",
    title: "Xilinhot Airport",
  },
  {
    iata: "YCU",
    title: "Yuncheng Guangong Airport",
  },
  {
    iata: "TYN",
    title: "Taiyuan Wusu Airport",
  },
  {
    iata: "BHY",
    title: "Beihai Airport",
  },
  {
    iata: "CGD",
    title: "Changde Airport",
  },
  {
    iata: "HJJ",
    title: "Zhijiang Airport",
  },
  {
    iata: "DYG",
    title: "Dayong Airport",
  },
  {
    iata: "CAN",
    title: "Guangzhou Baiyun International Airport",
  },
  {
    iata: "CSX",
    title: "Changsha Huanghua Airport",
  },
  {
    iata: "HNY",
    title: "Hengyang Airport",
  },
  {
    iata: "KWL",
    title: "Guilin Liangjiang International Airport",
  },
  {
    iata: "MXZ",
    title: "Meixian Airport",
  },
  {
    iata: "NNG",
    title: "Nanning Wuxu Airport",
  },
  {
    iata: "SWA",
    title: "Shantou Waisha Airport",
  },
  {
    iata: "ZUH",
    title: "Zhuhai Airport",
  },
  {
    iata: "SZX",
    title: "Shenzhen Bao'an International Airport",
  },
  {
    iata: "WUZ",
    title: "Changzhoudao Airport",
  },
  {
    iata: "XIN",
    title: "Xingning Airport",
  },
  {
    iata: "LZH",
    title: "Bailian Airport",
  },
  {
    iata: "ZHA",
    title: "Zhanjiang Airport",
  },
  {
    iata: "AYN",
    title: "Anyang Airport",
  },
  {
    iata: "CGO",
    title: "Xinzheng Airport",
  },
  {
    iata: "ENH",
    title: "Enshi Airport",
  },
  {
    iata: "LHK",
    title: "Guangzhou MR Air Base",
  },
  {
    iata: "WUH",
    title: "Wuhan Tianhe International Airport",
  },
  {
    iata: "LYA",
    title: "Luoyang Airport",
  },
  {
    iata: "NNY",
    title: "Nanyang Airport",
  },
  {
    iata: "SHS",
    title: "Shashi Airport",
  },
  {
    iata: "XFN",
    title: "Xiangfan Airport",
  },
  {
    iata: "YIH",
    title: "Yichang Airport",
  },
  {
    iata: "ZIZ",
    title: "Zamzama Heliport",
  },
  {
    iata: "HAK",
    title: "Haikou Meilan International Airport",
  },
  {
    iata: "SYX",
    title: "Sanya Phoenix International Airport",
  },
  {
    iata: "FNJ",
    title: "Sunan International Airport",
  },
  {
    iata: "AKA",
    title: "Ankang Airport",
  },
  {
    iata: "LHW",
    title: "Lanzhou City Airport",
  },
  {
    iata: "DNH",
    title: "Dunhuang Airport",
  },
  {
    iata: "GOQ",
    title: "Golmud Airport",
  },
  {
    iata: "GYU",
    title: "Guyuan Liupanshan Airport",
  },
  {
    iata: "HZG",
    title: "Hanzhong Airport",
  },
  {
    iata: "INC",
    title: "Yinchuan Airport",
  },
  {
    iata: "JNG",
    title: "Jining Qufu Airport",
  },
  {
    iata: "JGN",
    title: "Jiayuguan Airport",
  },
  {
    iata: "ZGC",
    title: "Lanzhou Zhongchuan Airport",
  },
  {
    iata: "IQN",
    title: "Qingyang Airport",
  },
  {
    iata: "SIA",
    title: "Xiguan Airport",
  },
  {
    iata: "XNN",
    title: "Xining Caojiabu Airport",
  },
  {
    iata: "XIY",
    title: "Xi'an Xianyang International Airport",
  },
  {
    iata: "ENY",
    title: "Yan'an Airport",
  },
  {
    iata: "UYN",
    title: "Yulin Airport",
  },
  {
    iata: "CGJ",
    title: "Chingola Airport",
  },
  {
    iata: "AVK",
    title: "Arvaikheer Airport",
  },
  {
    iata: "LTI",
    title: "Altai Airport",
  },
  {
    iata: "BYN",
    title: "Bayankhongor Airport",
  },
  {
    iata: "UGA",
    title: "Bulgan Airport",
  },
  {
    iata: "UGT",
    title: "Bulagtai Resort Airport",
  },
  {
    iata: "HBU",
    title: "Bulgan Sum Airport",
  },
  {
    iata: "UUN",
    title: "Baruun Urt Airport",
  },
  {
    iata: "COQ",
    title: "Choibalsan Airport",
  },
  {
    iata: "DLZ",
    title: "Dalanzadgad Airport",
  },
  {
    iata: "HVD",
    title: "Khovd Airport",
  },
  {
    iata: "ULN",
    title: "Chinggis Khaan International Airport",
  },
  {
    iata: "ULG",
    title: "Ulgii Mongolei Airport",
  },
  {
    iata: "DLU",
    title: "Dali Airport",
  },
  {
    iata: "DIG",
    title: "Diqing Airport",
  },
  {
    iata: "JHG",
    title: "Xishuangbanna Gasa Airport",
  },
  {
    iata: "LJG",
    title: "Lijiang Airport",
  },
  {
    iata: "LUM",
    title: "Mangshi Airport",
  },
  {
    iata: "KMG",
    title: "Kunming Wujiaba International Airport",
  },
  {
    iata: "SYM",
    title: "Simao Airport",
  },
  {
    iata: "ZAT",
    title: "Zhaotong Airport",
  },
  {
    iata: "XMN",
    title: "Xiamen Gaoqi International Airport",
  },
  {
    iata: "AQG",
    title: "Anqing Airport",
  },
  {
    iata: "CZX",
    title: "Changzhou Airport",
  },
  {
    iata: "KHN",
    title: "Nanchang Changbei International Airport",
  },
  {
    iata: "FOC",
    title: "Fuzhou Changle International Airport",
  },
  {
    iata: "KOW",
    title: "Ganzhou Airport",
  },
  {
    iata: "HGH",
    title: "Hangzhou Xiaoshan International Airport",
  },
  {
    iata: "JDZ",
    title: "Jingdezhen Airport",
  },
  {
    iata: "JIU",
    title: "Jiujiang Lushan Airport",
  },
  {
    iata: "TNA",
    title: "Yaoqiang Airport",
  },
  {
    iata: "JUZ",
    title: "Quzhou Airport",
  },
  {
    iata: "LCX",
    title: "Longyan Guanzhishan Airport",
  },
  {
    iata: "LYG",
    title: "Lianyungang Airport",
  },
  {
    iata: "HYN",
    title: "Huangyan Luqiao Airport",
  },
  {
    iata: "LYI",
    title: "Shubuling Airport",
  },
  {
    iata: "NGB",
    title: "Ningbo Lishe International Airport",
  },
  {
    iata: "NKG",
    title: "Nanjing Lukou Airport",
  },
  {
    iata: "HFE",
    title: "Hefei Luogang International Airport",
  },
  {
    iata: "PVG",
    title: "Shanghai Pudong International Airport",
  },
  {
    iata: "TAO",
    title: "Liuting Airport",
  },
  {
    iata: "JJN",
    title: "Quanzhou Airport",
  },
  {
    iata: "RUG",
    title: "Rugao Air Base",
  },
  {
    iata: "SHA",
    title: "Shanghai Hongqiao International Airport",
  },
  {
    iata: "SZV",
    title: "Guangfu Airport",
  },
  {
    iata: "TXN",
    title: "Tunxi International Airport",
  },
  {
    iata: "WEF",
    title: "Weifang Airport",
  },
  {
    iata: "WEH",
    title: "Weihai Airport",
  },
  {
    iata: "WHU",
    title: "Wuhu Air Base",
  },
  {
    iata: "WUX",
    title: "Sunan Shuofang International Airport",
  },
  {
    iata: "WUS",
    title: "Nanping Wuyishan Airport",
  },
  {
    iata: "WNZ",
    title: "Wenzhou Yongqiang Airport",
  },
  {
    iata: "XUZ",
    title: "Xuzhou Guanyin Airport",
  },
  {
    iata: "YNZ",
    title: "Yancheng Airport",
  },
  {
    iata: "YNT",
    title: "Yantai Laishan Airport",
  },
  {
    iata: "YIW",
    title: "Yiwu Airport",
  },
  {
    iata: "HSN",
    title: "Zhoushan Airport",
  },
  {
    iata: "NGQ",
    title: "Ngari Gunsa Airport",
  },
  {
    iata: "AVA",
    title: "Anshun Huangguoshu Airport",
  },
  {
    iata: "BPX",
    title: "Qamdo Bangda Airport",
  },
  {
    iata: "CKG",
    title: "Chongqing Jiangbei International Airport",
  },
  {
    iata: "DAX",
    title: "Dachuan Airport",
  },
  {
    iata: "GYS",
    title: "Guangyuan Airport",
  },
  {
    iata: "KWE",
    title: "Longdongbao Airport",
  },
  {
    iata: "JZH",
    title: "Jiuzhai Huanglong Airport",
  },
  {
    iata: "LIA",
    title: "Liangping Airport",
  },
  {
    iata: "LXA",
    title: "Lhasa Gonggar Airport",
  },
  {
    iata: "LZO",
    title: "Luzhou Airport",
  },
  {
    iata: "MIG",
    title: "Mianyang Airport",
  },
  {
    iata: "NAO",
    title: "Nanchong Airport",
  },
  {
    iata: "LZY",
    title: "Nyingchi Airport",
  },
  {
    iata: "TCZ",
    title: "Tengchong Tuofeng Airport",
  },
  {
    iata: "CTU",
    title: "Chengdu Shuangliu International Airport",
  },
  {
    iata: "WXN",
    title: "Wanxian Airport",
  },
  {
    iata: "XIC",
    title: "Xichang Qingshan Airport",
  },
  {
    iata: "YBP",
    title: "Yibin Caiba Airport",
  },
  {
    iata: "ACX",
    title: "Xingyi Airport",
  },
  {
    iata: "AKU",
    title: "Aksu Airport",
  },
  {
    iata: "BPL",
    title: "Alashankou Bole (Bortala) airport",
  },
  {
    iata: "IQM",
    title: "Qiemo Airport",
  },
  {
    iata: "HMI",
    title: "Hami Airport",
  },
  {
    iata: "KCA",
    title: "Kuqa Airport",
  },
  {
    iata: "KRL",
    title: "Korla Airport",
  },
  {
    iata: "KRY",
    title: "Karamay Airport",
  },
  {
    iata: "KHG",
    title: "Kashgar Airport",
  },
  {
    iata: "SXJ",
    title: "Shanshan Airport",
  },
  {
    iata: "TCG",
    title: "Tacheng Airport",
  },
  {
    iata: "HTN",
    title: "Hotan Airport",
  },
  {
    iata: "YIN",
    title: "Yining Airport",
  },
  {
    iata: "AOG",
    title: "Anshan Air Base",
  },
  {
    iata: "CGQ",
    title: "Longjia Airport",
  },
  {
    iata: "CNI",
    title: "Changhai Airport",
  },
  {
    iata: "CHG",
    title: "Chaoyang Airport",
  },
  {
    iata: "HRB",
    title: "Taiping Airport",
  },
  {
    iata: "HEK",
    title: "Heihe Airport",
  },
  {
    iata: "JIL",
    title: "Jilin Airport",
  },
  {
    iata: "JMU",
    title: "Jiamusi Airport",
  },
  {
    iata: "JNZ",
    title: "Jinzhou Airport",
  },
  {
    iata: "YUS",
    title: "Yushu Batang Airport",
  },
  {
    iata: "MDG",
    title: "Mudanjiang Hailang International Airport",
  },
  {
    iata: "OHE",
    title: "Gu-Lian Airport",
  },
  {
    iata: "NDG",
    title: "Qiqihar Sanjiazi Airport",
  },
  {
    iata: "DLC",
    title: "Zhoushuizi Airport",
  },
  {
    iata: "SHE",
    title: "Taoxian Airport",
  },
  {
    iata: "YNJ",
    title: "Yanji Chaoyangchuan Airport",
  },
];
